/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605eb0d3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605eb0d3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"452c3006-8d8e-4612-8c3b-2cf3208e7f59","title":"Докладніше про принтер","link":"finding-information-about-printer-topic.html","desc":"Пошук інформації про принтер Ресурси","descFull":"Пошук інформації про принтер Ресурси та де їх можна знайти Що ви шукаєте? Знайдіть це тут Вказівки щодо початкового налаштування Перегляньте документацію, що постачалася з принтером. Програмне забезпечення принтера Драйвер принтера чи факсу Мікропрограма принтера Утиліта Перейдіть на сторінку  www.lexmark.com/downloads , знайдіть модель свого принтера, а тоді в меню Type (Тип) виберіть потрібний драйвер, мікропрограму чи утиліту. Вибір і зберігання паперу та спеціальні носії Завантаження паперу Налаштування параметрів принтера Перегляд і друк документів і фотографій Налаштування принтера в мережі Догляд і обслуговування принтера усунення проблем і вирішення проблем Інформаційний центр: перейдіть на сторінку  https://infoserve.lexmark.com . Навчальні відео: перейдіть на сторінку  https://infoserve.lexmark.com/idv/ . Довідкова інформація для використання програмного забезпечення принтера. Довідка щодо операційних систем Microsoft Windows чи Macintosh: відкрийте програмне забезпечення принтера чи додаток, а тоді натисніть  Help .(Довідка). Натисніть  , щоб переглянути інформацію в контексті. Довідка автоматично встановлена разом із програмним забезпеченням принтера. Залежно від вашої операційної системи, програмне забезпечення принтера зберігається в папці програми принтера або на робочому столі. Документація Підтримка в чаті Підтримка електронною поштою Голосова підтримка Перейдіть на сайт  https://support.lexmark.com . Виберіть країну чи регіон, а тоді виберіть свій виріб, щоб переглянути відповідний сайт підтримки. Контактну інформацію служби підтримки для своєї країни або регіону можна знайти на вебсайті або в роздрукованому гарантійному талоні, який постачається разом із принтером. Звертаючись у службу підтримки, підготуйте наведену нижче інформацію. Місце та дата придбання. Тип і серійний номер пристрою Щоб дізнатися більше, див.  . Інформація про безпеку Нормативна інформація Інформація про гарантію Екологічна інформація Інформація про гарантію залежить від країни чи регіону. У США : перегляньте Заяву про обмежену гарантію, що постачається разом із принтером, або перейдіть на сторінку  https://support.lexmark.com . В інших країнах або регіонах : див. надруковану гарантію, яка постачається разом із принтером. Посібник з інформацією про продукт : див. документацію, яка постачається разом із принтером, або перейдіть на сторінку  https://support.lexmark.com . Інформація про цифровий паспорт Lexmark Перейдіть на сторінку  https://csr.lexmark.com/digital-passport.php . пошук інформації про принтер"},{"UUID":"dc34cb91-82c7-4c49-acbc-8f4b4f7d5cc9","title":"Докладніше про принтер","link":"finding-printer-serial-number-topic.html","desc":"Пошук серійного номера принтера Відкрийте","descFull":"Пошук серійного номера принтера Відкрийте дверцята А. Знайдіть серійний номер. серійний номер принтера серійного номера принтера серійний номер, принтер пошук"},{"UUID":"cb4038bc-ad03-4755-ad0a-85ca5b411015","title":"Докладніше про принтер","link":"printer-configurations-topic.html","desc":"Налаштування принтера Для встановлення одного","descFull":"Налаштування принтера Для встановлення одного або кількох додаткових пристроїв на принтері чи БФП може знадобитися підставка з коліщатками, меблі чи інші допоміжні засоби, щоб запобігти нестабільності, яка може спричинити травму. Щоб дізнатися більше про підтримувані конфігурації, див. сторінку  www.lexmark.com/multifunctionprinters . Для встановлення одного або кількох додаткових пристроїв на принтері чи БФП може знадобитися підставка з коліщатками, меблі чи інші допоміжні засоби, щоб запобігти нестабільності, яка може спричинити травму. Щоб дізнатися більше про підтримувані конфігурації, зверніться в місце, де ви придбали принтер. Щоб зменшити ризик нестабільності обладнання, завантажуйте кожен лоток окремо. Усі інші лотки мають бути закриті, доки вони не знадобляться. Ви можете налаштувати свій принтер, додавши до трьох додаткових лотків на 250 або 550 аркушів. Щоб дізнатися більше, див.  . Компоненти принтера 1 Автоматичний подавач документів (АПД) 2 Лоток пристрою АПД 3 Відсік пристрою АПД 4 Панель керування 5 Стандартний відсік 6 Багатоцільовий подавач 7 Стандартний лоток на 550 аркушів 8 Додатковий лоток на 250 або 550 аркушів налаштування принтера"},{"UUID":"f2773ee8-be97-41e5-92d5-a0d83e404ee5","title":"Докладніше про принтер","link":"using-control-panel-topic.html","desc":"Використання панелі керування Частини панелі","descFull":"Використання панелі керування Частини панелі керування та їх функції Частина панелі керування Функція 1 Кнопка живлення Ввімкніть або вимкніть принтер Щоб вимкнути принтер, натисніть та утримуйте кнопку живлення впродовж п’яти секунд. Переведіть принтер у режим сну або гібернації. Виведіть принтер із режиму сну або глибокого сну. 2 Дисплей Перегляньте повідомлення принтера та стан витратних матеріалів. Налаштування та експлуатація принтера. 3 Світловий індикатор Перевірте статус принтера панель керування використання використання панелі керування"},{"UUID":"c958ea8d-2557-4b61-8af0-78af0d4935e7","title":"Докладніше про принтер","link":"understanding-status-of-power-button-and-indicator-light-topic.html","desc":"Розуміння статусу світлового індикатора Колір","descFull":"Розуміння статусу світлового індикатора Колір світлового індикатора й відповідний стан принтера. Світловий індикатор Стан принтера Вимкнено Принтер вимкнено. Постійний синій Принтер готовий. Миготливий синій Принтер друкує або обробляє дані. Миготливий червоний Принтер потребує втручання користувача. Постійний жовтий Принтер перебуває в режимі сну. Миготливий жовтий Принтер перебуває в режимі гібернації. світловий індикатор розуміння статусу стан принтера"},{"UUID":"04ec1197-c19f-47cc-a31d-e0620369a04b","title":"Вибір паперу","link":"selecting-paper-group.html","desc":"Інструкції щодо паперу Використовуйте відповідний","descFull":"Інструкції щодо паперу Використовуйте відповідний папір, щоб запобігти зминанням і забезпечити безперебійний друк. Завжди використовуйте новий, непошкоджений папір. Перш ніж завантажувати папір, ознайомтеся з рекомендованою стороною паперу для друку. Ця інформація зазвичай вказується на упаковці паперу. Не використовуйте папір, який був розрізаний або обрізаний вручну. Не змішуйте розміри, типи або щільність паперу в одному лотку; змішування призводить до утворення затискань. Не використовуйте крейдований папір, якщо він не призначений спеціально для електрофотографічного друку. Додаткову інформацію див. у  посібнику з паперу та спеціальних носіїв . папір вибір інструкції з паперу"},{"UUID":"d662d850-177f-46d2-bcac-e515128fe00a","title":"Вибір паперу","link":"selecting-paper-group.html","desc":"Характеристики паперу Наведені нижче характеристики","descFull":"Характеристики паперу Наведені нижче характеристики паперу впливають на якість і надійність друку. Враховуйте ці чинники, перш ніж друкувати на такому папері. Щільність У лотки можна подавати папір різної щільності. Папір щільністю до 60 г/м 2  (16 фунт.) може бути недостатньо жорстким для належної подачі та може спричиняти зминання. Щоб дізнатися більше, див. тему «Підтримувана щільність паперу». Скручування Скручування — це схильність паперу згортатися по краях. Надмірне скручування може спричинити проблеми з подаванням паперу. Скручування може виникнути після проходження паперу через принтер, де він піддається впливу високих температур. Зберігання паперу без упаковки в гарячих, вологих, холодних або сухих умовах може призвести до скручування паперу перед друком і спричинити проблеми з подаванням. Гладкість Гладкість паперу безпосередньо впливає на якість друку. Якщо папір надто шорсткий, тонер не може належним чином закріпитися на ньому. Якщо папір занадто гладкий, це може спричинити проблеми з подаванням паперу або погіршити якість друку. Ми рекомендуємо використовувати папір із 50 балами Шеффілда. Вміст вологи Кількість вологи в папері впливає як на якість друку, так і на здатність принтера правильно подавати папір. Зберігайте папір в оригінальному пакуванні до використання. Вплив на папір змін вологи може погіршити його якість. Перед друком зберігайте папір в оригінальній упаковці від 24 до 48 годин. Середовище, у якому зберігається папір, має бути таким самим, як місце, де розташований принтер. Передбачте довший період, якщо середовище зберігання чи транспортування паперу дуже відрізняється від середовища зберігання принтера. Для товстого паперу також може знадобитися триваліший період витримки. Напрямок зернистості Зернистість означає вирівнювання волокон паперу в аркуші паперу. Зернистість — це або  довге зерно , яке проходить за довжиною паперу, або  коротке зерно , яке проходить за шириною паперу. Щоб дізнатися рекомендовану зернистість, див. тему «Підтримувана щільність паперу». Вміст волокон Більшість високоякісного ксерографічного паперу виготовлено зі 100-відсоткової хімічно обробленої целюлозної деревини. Цей вміст забезпечує високу стабільність паперу, що призводить до меншої кількості проблем із подаванням і кращої якості друку. Папір, що містить волокна, такі як бавовна, може негативно вплинути на обробку паперу. характеристики паперу"},{"UUID":"164623de-483d-42a8-b4e3-51cb23fe26b9","title":"Вибір паперу","link":"selecting-paper-group.html","desc":"Неприйнятний папір Наведені типи паперу","descFull":"Неприйнятний папір Наведені типи паперу не рекомендовані для використання з принтером: Хімічно оброблений папір, який використовується для створення копій без копіювального паперу. Вони також відомі як самокопіювальний папір, самокопіювальний папір (CCP) або папір без вуглецю (NCR). Надрукований папір із хімічними речовинами, які можуть забруднити принтер. Попередньо надрукований папір, на який може впливати температура термофіксатора принтера. Типографські бланки, для яких потрібне точне розташування друку на аркуші (з точністю, вищою за ±2,3 мм), наприклад бланки для оптичного розпізнавання символів. У деяких випадках для успішного друку таких бланків можна налаштувати функцію суміщення в програмному забезпеченні. Папір із покриттям (папір, що стирається), синтетичний папір або термопапір. Папір із нерівними краями, шершавий, занадто структурований або скручений папір. Папір, що не відповідає стандарту EN12281:2002 (Європейський стандарт). Папір зі щільністю менш як 60 г/м 2  (16 фунт.). Форми або документи, що складаються з кількох частин. неприйнятний папір"},{"UUID":"5827af7e-ca38-410f-9cfb-287bf556d65a","title":"Вибір паперу","link":"selecting-paper-group.html","desc":"Зберігання паперу Використовуйте наведені нижче","descFull":"Зберігання паперу Використовуйте наведені нижче рекомендації щодо зберігання паперу, щоб уникнути заминання й нерівномірної якості друку. Зберігайте папір в оригінальній упаковці в тому ж приміщенні, що й принтер, протягом 24–48 год до друку. Передбачте довший період, якщо середовище зберігання чи транспортування паперу дуже відрізняється від середовища зберігання принтера. Для товстого паперу також може знадобитися триваліший період витримки. Для найкращих результатів зберігайте папір за температури 21 °﻿C (70°﻿F) і відносної вологості 40%. Більшість виробників міток рекомендують друк за температури 18–24 °﻿C (65–75 °﻿F) і відносної вологості 40–60%. Зберігайте папір у коробках, на палеті чи полиці, а не на підлозі. Зберігайте окремі пачки на плоскій поверхні. Не зберігайте нічого на окремих пачках паперу. Виймайте парі із коробки чи пакування, лише коли будете готові завантажити його принтер. Коробка та пакування допомагають зберігати папір чистим, сухим і рівним. зберігання паперу"},{"UUID":"68e202c9-0ed8-48c6-95fa-cd0e521a7c91","title":"Вибір паперу","link":"selecting-paper-group.html","desc":"Вибір попередньо надрукованих форм і","descFull":"Вибір попередньо надрукованих форм і бланків Використовуйте довгий зернистий папір. Використовуйте лише форми та фірмові бланки, надруковані за допомогою процесу офсетної літографії чи гравіювання. Уникайте використання паперу з жорсткою чи дуже текстурованою поверхнею. Використовуйте чорнило, на яке не впливає смола в тонері. Цим вимогам зазвичай відповідає чорнило, що окислюється, або чорнило на масляній основі, але латексне чорнило може бути несумісним. Перш ніж купувати великі партії, роздрукуйте зразки на попередньо надрукованих формах і бланках. Ця дія визначає, чи впливає чорнило в попередньо надрукованій формі чи на фірмовому бланку на чорнило. Якщо маєте сумніви, зверніться до постачальника паперу. Друкуючи на фірмовому бланку, завантажте папір у правильній орієнтації для свого принтера. Щоб дізнатися більше, див.  Посібник щодо паперу та спеціальних носіїв . Друкуючи на фірмовому бланку, завантажте папір у правильній орієнтації для свого принтера. папір Попередньо надруковані форми Попередньо надруковані форми вибір папір фірмовий бланк фірмовий бланк вибір"},{"UUID":"a5c8a1ca-8542-43bc-a511-6ef9f7f9d714","title":"Вибір паперу","link":"selecting-paper-group.html","desc":"Підтримувані розміри паперу Підтримувані розміри","descFull":"Підтримувані розміри паперу Підтримувані розміри паперу Розмір паперу Стандартний лоток на 550 аркушів Додатковий лоток на 250 або 550 аркушів Багатоцільовий подавач Двосторонній друк Скло сканера Автоматичний подавач документів 1  За замовчуванням підтримується подавання за коротким краєм. 2  Якщо вибрано «Universal», сторінка форматується до розмірів 215,90 x 355,60 мм (8,5 x 14 дюймів), якщо інші параметри не зазначено програмою. 3  Папір має бути щонайменше 210 мм (8,27 дюйма) завширшки та 279,4 мм (11 дюймів) завдовжки для двостороннього друку. A4 210 x 297 мм (8,27 x 11,7 дюйма) A5 Портретна орієнтація (SEF) 148 x 210 мм (5,83 x 8,27 дюйма) X A5 Альбомна орієнтація (LEF) 1 210 x 148 мм (8,27 x 5,83 дюймів) X X A6 105 x 148 мм (4,13 x 5,83 дюйма) X X JIS B5 182 x 257 мм (7,17 x 10,1 дюйма) X Oficio (Mexico) 216 x 340 мм (8,5 x 13,4 дюйма) Hagaki 100 x 148 мм (3,93 x 5,83 дюйма) X X X X Statement 139,7 x 215,9 мм (5,5 x 8,5 дюйма) X Executive 184,2 x 266,7 мм (7,25 x 10,5 дюйма) X Letter 215,9 x 279,4 мм (8,5 x 11 дюймів) Legal 215,9 x 355,6 мм (8,5 x 14 дюймів) Folio 215,9 x 330,2 мм (8,5 x 13 дюймів) Universal 2 від 105 x 148 мм до 215,9 x 359,92 мм (від 4,13 x 5,83 дюйма до 8,5 x 14,17 дюйма) X 3 X Universal 2 від 76,2 x 127 мм до 215,9 x 359,92 мм (від 3 x 5,83 дюйма до 8,5 x 14,17 дюйма) X X X X X Universal 2 від 25,4 x 25,4 мм до 215,9 x 355,6 мм (від 1 x 1 дюйма до 8,5 x 14 дюйма) X X X X X Конверт 7 3/4 98,4 x 190,5 мм (3,875 x 7,5 дюйма) X X X X Конверт 9 98,4 x 225,4 мм (3,875 x 8,9 дюйма) X X X X Конверт 10 104,8 x 241,3 мм (4,12 x 9,5 дюйма) X X X X Конверт DL 110 x 220 мм (4,33 x 8,66 дюйма) X X X X Конверт C5 162 x 229 мм (6,38 x 9,01 дюйма) X X X X Конверт B5 176 x 250 мм (6,93 x 9,84 дюйма) X X X X Інші конверти від 76,2 x 127 мм до 215,9 x 359,92 мм (від 3 x 5,83 дюйма до 8,5 x 14,17 дюйма) X X X X підтримувані розміри паперу розміри паперу, підтримувані"},{"UUID":"0e2453dc-bc65-407b-be1d-2b7b4a747d22","title":"Вибір паперу","link":"selecting-paper-group.html","desc":"Підтримувані типи паперу Підтримувані типи","descFull":"Підтримувані типи паперу Підтримувані типи паперу Тип паперу Стандартний лоток на 550 аркушів Додатковий лоток на 250 або 550 аркушів Багатоцільовий подавач Двосторонній друк Автоматичний подавач документів * Односторонні паперові етикетки підтримуються для поодинокого використання (до 20 сторінок на місяць). Вінілові, аптечні чи двосторонні етикетки не підтримуються. Простий папір Картки X X X X Перероблений папір Паперові етикетки * X X Високоякісний папір Фірмовий бланк Попередньо надрукований Кольоровий папір Тонкий папір Цупкий папір Жорсткий/бавовняний папір Конверт X X X X Жорсткий конверт X X X X підтримувані типи паперу типи паперу, підтримувані"},{"UUID":"61b8ebbc-0751-44ac-9f9a-5bdc07c421ee","title":"Вибір паперу","link":"selecting-paper-group.html","desc":"Підтримувана щільність паперу Підтримувана щільність","descFull":"Підтримувана щільність паперу Підтримувана щільність паперу Підтримувана щільність паперу Стандартний лоток на 550 аркушів Додатковий лоток на 250 або 550 аркушів Багатоцільовий подавач Двосторонній друк* Автоматичний подавач документів * Не підтримує картки, етикетки та конверти. 60–120 г/м 2 (високоякісний папір 16–32 фунти) 60–120 г/м 2 (високоякісний папір 16–32 фунти) 60–216 г/м 2 (високоякісний папір 16–58 фунти) 60–120 г/м 2 (високоякісний папір 16–32 фунти) 52–120 г/м 2 (високоякісний папір 14–32 фунти) підтримувана щільність паперу щільність паперу, підтримувана"},{"UUID":"7819f835-5a6d-437e-8a24-c7e36531b6bd","title":"Налаштування, установлення та конфігурування","link":"selecting-location-printer-topic.html","desc":"Вибір місця розташування для принтера","descFull":"Вибір місця розташування для принтера Залиште достатньо місця для відкривання лотків, кришок і дверцят, а також для встановлення додаткового обладнання. Встановіть принтер поблизу електричної розетки. Щоб уникнути ризику пожежі чи ураження електричним струмом, під’єднайте кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. Щоб уникнути ризику ураження електричним струмом, не розміщуйте цей виріб поряд із водою чи у вологому місці. Переконайтеся, що повітряний потік у кімнаті відповідає останній редакції стандарту ASHRAE 62 або стандарту Технічного комітету CEN 156. Забезпечте рівну, міцну та стійку поверхню. Зберігайте принтер: чистим, сухим, без пилу; подалі від випадкових скоб і скріпок; подалі від прямого повітряного потоку кондиціонерів, обігрівачів або вентиляторів; без впливу прямих сонячних променів і екстремальної вологості. Дотримуйтесь рекомендованих температур і уникайте коливань Рекомендовані температури Температура навколишнього середовища Температура зберігання Забезпечте таку рекомендовану кількість простору навколо принтера для належної вентиляції: Рекомендований простір навколо принтера 1 Зверху 2 Позаду 3 Праворуч 4 Спереду 5 Зліва принтер вибір місця розташування для вибір місця розташування для принтера принтер мінімальні зазори переміщення принтера"},{"UUID":"2c9871da-4e1d-4910-94c4-6eef75049ced","title":"Налаштування, установлення та конфігурування","link":"attaching-cables-topic.html","desc":"Приєднання кабелів Щоб уникнути ризику","descFull":"Приєднання кабелів Щоб уникнути ризику ураження електричним струмом, не встановлюйте цей вибір і не працюйте з електричним і кабельним підключенням, як-от мережевим кабелем, факсом чи телефоном, під час грози. Щоб уникнути ризику пожежі чи ураження електричним струмом, під’єднайте кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. Щоб уникнути ризику пожежі чи ураження електричним струмом, використовуйте лише кабель живлення, що постачався в комплекті з цим виробом або авторизовану виробником заміну. Щоб зменшити ризик виникнення пожежі, підключайте цей виріб до телефонної мережі загального користування лише телекомунікаційним кабелем 26 AWG або більший (RJ-11). Для користувачів в Австралії: кабель має бути схвалено Австралійським управлінням зв’язку та ЗМІ. Щоб уникнути втрати даних або несправності принтера, не торкайтеся USB-кабелю, адаптера бездротової мережі або принтера в показаних областях під час активного друку. Порти принтера та їхні функції Порт принтера Функція 1 Розетка шнура живлення Підключіть принтер до правильно заземленої електричної розетки. 2 Порт Ethernet Підключіть принтер до мережі. 3 Порт USB Підключіть клавіатуру чи скористайтеся будь-яким відповідним варіантом. 4 USB-порт принтера Підключіть принтер до комп’ютера. 5 Порт EXT Підключіть інші пристрої (телефон або автовідповідач) до принтера та телефонної лінії. Використовуйте цей порт, якщо у вас немає виділеної лінії факсу для принтера та якщо цей спосіб підключення підтримується у вашій країні чи регіоні. 6 Порт LINE Підключіть принтер до активної телефонної лінії через стандартну настінну розетку (RJ‑11), фільтр DSL, адаптер VoIP або будь-який інший адаптер, який дає вам доступ до телефонної лінії для надсилання та отримання факсів. приєднання кабелів USB-порт принтера порт Ethernet порт LINE порт EXT розетка шнура живлення"},{"UUID":"5c528170-e8b8-438c-ae98-65d30e0ea318","title":"Налаштування та використання програм головного екрана","link":"using-home-screen-topic.html","desc":"Використання головного екрана Ваш головний","descFull":"Використання головного екрана Ваш головний екран може відрізнятися залежно від параметрів налаштування, адміністративних налаштувань та активних вбудованих рішень. Піктограми головного екрана та їхні функції # Піктограма Функція 1 Кнопка «Зупинити» або «Скасувати» Припинити поточне завдання. 2 Copy (Копіювання) Створення копій. 3 Change Language (Змінити мову) Зміна мови на дисплеї принтера. 4 E‑mail (Електронна пошта) Надсилання повідомлень електронної пошти. 5 Settings (Параметри) Доступ до меню принтера. 6 Fax (Факс) Надсилання факсу. 7 Address Book (Адресна книга) Доступ до контактів і їх створення та впорядкування. 8 Status/Supplies (Стан/Витратні матеріали) Показувати попередження або повідомлення про помилку принтера щоразу, коли принтер потребує втручання, щоб продовжити обробку. Перегляньте додаткові відомості про попередження або повідомлення принтера та про те, як їх очистити. Доступ до цього параметра можна також отримати, торкнувшись верхньої частини головного екрана. 9 Held Jobs (Відкладені завдання) Показати всі поточні відкладені завдання друку 10 Job Queue (Черга завдань) Показати всі поточні завдання друку. Доступ до цього параметра можна також отримати, торкнувшись верхньої частини головного екрана. 11 USB Drive (USB-накопичувач) Переглядайте, вибирайте або друкуйте фотографії та документи з флешнакопичувача. 12 Scan Profiles (Профілі сканування) Скануйте та зберігайте документи безпосередньо на комп'ютері. 13 FTP Скануйте та зберігайте документи безпосередньо на FTP-сервері. 14 Bookmarks (Закладки) Упорядкування всіх закладок. 15 Hard Disk (Жорсткий диск) Переглядайте, вибирайте документи з жорсткого диска або інтелектуального накопичувача та керуйте ними. 16 Network Folder (Мережева папка) Сканування в мережеву папку або мережеве розташування. 17 Кнопка «Старт» Розпочніть завдання залежно від вибраного режиму. 18 Екранна клавіатура Введіть кількість символів у полі вводу. використання головного екрана головний екран використання"},{"UUID":"056bcec9-0ead-49cd-9c86-c0b0b3467812","title":"Налаштування та використання програм головного екрана","link":"using-home-screen-topic.html","desc":"Налаштування головного екрана Відкрийте вебпереглядач","descFull":"Налаштування головного екрана Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані принтера. IP-адреса відображається як чотири набори цифр, розділених крапкою, як-от 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Settings Device Home Screen Customization . Виконайте одну з дій нижче. Щоб додати значок на головний екран, натисніть  , виберіть назву додатка, а тоді натисніть  Add . Щоб видалити значок головного екрана, виберіть назву додатка й натисніть  Remove . Щоб налаштувати назву додатка, виберіть назву додатка й натисніть  Edit , а тоді призначте ім’я. Щоб відновити назву додатка, виберіть назву додатка, натисніть  Edit , а тоді виберіть  Restore app label . Щоб додати пробіл між додатками, натисніть  , виберіть  BLANK SPACE , а тоді натисніть  Add . Щоб змінити порядок додатків, перетягніть назви додатків у бажаному порядку. Щоб відновити головний екрана за замовчуванням, натисніть  Restore home screen . Застосуйте зміни. значки головного екрана відображення значки на головному екрані показ головний екран налаштування відображення програм на головному екрані додавання програм на головний екран"},{"UUID":"89335e6a-3ae8-4b6a-be29-b57ab223d602","title":"Налаштування та використання програм головного екрана","link":"using-home-screen-topic.html","desc":"Підтримувані програми Програми та моделі","descFull":"Підтримувані програми Програми та моделі принтерів, що їх підтримують Програма Моделі принтера Scan Center  (Центр сканування) MX532, MX632, XM3350 Shortcut Center  (Центр ярликів) MX532, MX632, XM3350 Card Copy  (Копія картки) MX532, MX632, XM3350 Display Customization  (Персоналізація дисплея) MX532, MX632, XM3350 Customer Support  (Служба підтримки клієнтів) XM3350 Device Quotas  (Квоти на пристрій) XM3350 підтримувані програми програми принтера"},{"UUID":"23a61747-4697-41bf-997d-80e3153335c0","title":"Налаштування та використання програм головного екрана","link":"using-home-screen-topic.html","desc":"Налаштування Центру сканування На головному","descFull":"Налаштування Центру сканування На головному екрані торкніться параметра  Scan Center . Виберіть і створіть цільове розташування, а тоді налаштуйте параметри. Створюючи нове мережеве розташування, обов’язково перевірте й відкоригуйте параметри, доки не перестануть з’являтися помилки. Зберігаються лише цільові розташування, створені в Embedded Web Server. Щоб дізнатися більше, див. документацію, яка постачалася разом із рішенням. Застосуйте зміни. Центр сканування налаштування"},{"UUID":"a9c3b5b6-26ce-4ab5-b75b-6cd90c17912e","title":"Налаштування та використання програм головного екрана","link":"using-home-screen-topic.html","desc":"Створення ярлика На головному екрані","descFull":"Створення ярлика На головному екрані торкніться  Shortcut Center . Піктограма та назва могли бути змінені. Для отримання додаткової інформації зверніться до свого адміністратора. Виберіть функцію принтера та торкніться  Create Shortcut . Функція безпечної електронної пошти не підтримується. Налаштуйте параметри та торкніться  Save . Введіть унікальну назву ярлика. Щоб уникнути обрізаних імен на головному екрані, вводьте лише до 25 символів. Торкніться  OK . Програма автоматично генерує унікальний номер швидкого доступу. Щоб запустити ярлик, торкніться  , торкніть  # , а потім введіть номер ярлика. створення ярликів ярлики створення ярлик Копіювати ярлик Електронна пошта ярлик Факс ярлик FTP"},{"UUID":"90e5edfc-ef64-42c7-88c2-2304c251b267","title":"Налаштування та використання програм головного екрана","link":"using-home-screen-topic.html","desc":"Налаштування копії картки Відкрийте вебпереглядач","descFull":"Налаштування копії картки Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані принтера. IP-адреса відображається у вигляді чотирьох наборів чисел, розділених крапками, наприклад 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Apps Card Copy Configure . Переконайтеся, що ввімкнено  Display Icon . Переконайтеся, що налаштовано  E‑mail Settings  і  Network Share Settings . Під час сканування картки переконайтеся, що роздільна здатність сканування не перевищує 200 dpi для кольорового та 400 dpi для чорно-білого. Під час сканування кількох карток переконайтеся, що роздільна здатність сканування не перевищує 150 dpi для кольорового та 300 dpi для чорно-білого. Застосуйте всі зміни. Для сканування кількох карток вам потрібен жорсткий диск принтера або інтелектуальний накопичувач. Card Copy налаштування"},{"UUID":"0b62f081-08de-43e8-8e09-947b67fb1558","title":"Налаштування та використання програм головного екрана","link":"using-home-screen-topic.html","desc":"Використання персоналізації дисплея Перед використанням","descFull":"Використання персоналізації дисплея Перед використанням програми обов’язково ввімкніть і налаштуйте заставку, слайд-шоу та шпалери на вбудованому веб-сервері. Керування зображеннями екранної заставки та слайдшоу На Embedded Web Server натисніть  Apps  (Програми) Display Customization  (Персоналізація дисплея) Configure  (Налаштувати). У розділі Screen Saver and Slideshow Images (Заставка та слайдшоу) можна додавати, редагувати чи видаляти зображення. Можна додати до 10 зображень. Якщо цей параметр увімкнено, значки стану відображаються на заставці, лише коли наявні помилки, застереження чи хмарні сповіщення. Застосуйте зміни. Зміна зображення фонового малюнка На головному екрані торкніться  Change Wallpaper  (Змінити шпалери). Виберіть зображення. Застосуйте зміни. Запуск слайдшоу з флешнакопичувача Вставте флешнакопичувач у передній порт USB. На головному екрані торкніться  Slideshow  (Слайдшоу). Ви можете вийняти флешнакопичувач після початку слайдшоу, але зображення не зберігаються на принтері. Якщо слайдшоу припиниться, вставте флешнакопичувач знову, щоб переглянути зображення. Персоналізація дисплея використання використання персоналізації дисплея персоналізація дисплея зміна фонового малюнка запуск слайдшоу керування екранною заставкою"},{"UUID":"d7b0d129-c012-4694-b92c-ab36affc5232","title":"Налаштування та використання програм головного екрана","link":"using-home-screen-topic.html","desc":"Використання служби підтримки Цю програму","descFull":"Використання служби підтримки Цю програму підтримують лише деякі моделі принтерів. Щоб дізнатися більше, див.  . Цю програму підтримують лише деякі моделі принтерів. Щоб дізнатися більше про те, як налаштувати параметри програми, див.  Посібник адміністратора щодо служби підтримки клієнтів . На головному екрані торкніться параметра  Customer Support . Надрукуйте інформацію або надішліть її електронною поштою. Customer Support за допомогою за допомогою  Customer Support"},{"UUID":"646cfbef-25e9-4769-91b4-2e5a8654e171","title":"Налаштування та використання програм головного екрана","link":"using-home-screen-topic.html","desc":"Налаштування квот на пристрої Цю","descFull":"Налаштування квот на пристрої Цю програму підтримують лише деякі моделі принтерів. Щоб дізнатися більше, див.  . Цю програму підтримують лише деякі моделі принтерів. Щоб дізнатися більше про те, як налаштувати параметри програми, див.  Посібник адміністратора щодо квот на пристрої . Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані принтера. IP-адреса відображається як чотири набори цифр, розділених крапкою, як-от 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Apps Device Quotas Configure . У розділі  User Accounts  додайте або змініть користувача, а тоді встановіть користувацьку квоту. Застосуйте зміни. налаштування  Device Quotas Device Quotas налаштування"},{"UUID":"b8086e7c-e328-4f92-acbe-786fbafa0e66","title":"Керування закладками","link":"using-home-screen-topic.html","desc":"Створення закладок Використовуйте закладки, щоб","descFull":"Створення закладок Використовуйте закладки, щоб друкувати документи, які часто використовуються та зберігаються на серверах чи в інтернеті. Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані принтера. IP-адреса відображається у вигляді чотирьох наборів цифр, розділених крапками, наприклад 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Bookmarks  (Закладки) Add Bookmark  (Додати закладку), а тоді введіть назву закладки. Виберіть тип протоколу Address (Адреса), а тоді виберіть одну з опцій нижче. Для HTTP і HTTPS: введіть URL-адресу, яку хочете додати в закладки. Для HTTPS: обов’язково використовуйте ім’я хосту замість IP-адреси. Наприклад, введіть  myWebsite.com/sample.pdf  замість  123.﻿123.123.123/sample.pdf . Переконайтеся, що ім’я хосту збігається зі значенням стандартної назви (CN) в сертифікаті сервера. Щоб дізнатися більше про те, як отримати значення CN у сертифікаті сервера, перегляньте довідкову інформацію для свого вебпереглядача. Для FTP: введіть адресу FTP. Наприклад,  myServer/myDirectory . Введіть порт FTP. Для надсилання команд портом за замовчуванням є порт 21. Для SMB: введіть адресу мережевої папки. Наприклад,  myServer/myShare/myFile.pdf . Введіть доменне ім’я мережі. Якщо потрібно, виберіть тип автентифікації для FTP і SMB. Щоб обмежити доступ до закладок, введіть PIN-код. Програма підтримує такі типи файлів: PDF, JPEG, TIFF і веб-сторінки на основі HTML. Деякі моделі пристроїв підтримують інші типи файлів, як-от DOCX і XLXS. Натисніть  Save  (Зберегти). закладки закладок створення закладок"},{"UUID":"62196a97-3646-4558-a263-5f2c25902ece","title":"Керування закладками","link":"using-home-screen-topic.html","desc":"Створення папок Відкрийте вебпереглядач і","descFull":"Створення папок Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані принтера. IP-адреса відображається як чотири набори цифр, розділених крапкою, як-от 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Bookmarks Add Folder , а тоді введіть назву папки. Щоб обмежити доступ до папки, введіть PIN-код. Натисніть  Save . Ви можете створити папки чи закладки всередині папки. Щоб створити закладку, див.  . закладки створення папок для створення папок для закладок"},{"UUID":"832e258a-ec33-428b-8e71-2e7c5d636b4f","title":"Налаштування та використання програм головного екрана","link":"using-home-screen-topic.html","desc":"Address Book Керування контактами На","descFull":"Address Book Керування контактами На головному екрані торкніться пункту  Address Book. Виконайте одну з дій нижче. Щоб додати контакт, торкніться значка   угорі екрана, а тоді торкніться пункту  Create Contact . За потреби вкажіть спосіб входу, щоб надати додатку дозвіл. Щоб видалити контакт, торкніться значка   угорі екрана, а тоді торкніться пункту  Delete Contacts  і виберіть контакт. Щоб редагувати контактну інформацію, торкніться імені контакту. Щоб створити групу, торкніться значка   угорі екрана й торкніться пункту  Create Group . За потреби вкажіть спосіб входу, щоб надати додатку дозвіл. Щоб видалити групу, торкніться значка   угорі екрана, торкніться пункту  Delete Groups , а тоді виберіть групу. Щоб відредагувати групу, торкніться пункту  GROUPS  виберіть назву групи   виберіть дію, яку потрібно виконати. Застосуйте зміни. додавання контактів видалення контактів додавання груп контактів видалення груп контактів редагування контактів Address Book використання"},{"UUID":"06806e6d-d01d-4918-8310-48690e19659c","title":"Налаштування та використання спеціальних можливостей","link":"activating-voice-guidance-topic.html","desc":"Активація голосових підказок З головного","descFull":"Активація голосових підказок З головного екрана Одним рухом, використовуючи один палець, повільно гортайте пальцем ліворуч, а потім угору на дисплеї, доки не почуєте голосове повідомлення. Для моделей принтерів, які не мають вбудованого динаміка, використовуйте навушники, щоб почути повідомлення. Двома пальцями торкніться пункту  OK . Якщо жест не працює, застосуйте більше тиску. З клавіатури Натисніть і утримуйте клавішу  5 , доки не почуєте голосове повідомлення. Для моделей принтерів, які не мають вбудованого динаміка, використовуйте навушники, щоб почути повідомлення. Натисніть  Tab , щоб навести курсор на кнопку «OK», а тоді натисніть  Enter . Коли голосові підказки активовано, завжди використовуйте два пальці, щоб вибрати будь-який елемент на дисплеї. Голосові підказки підтримують обмежену кількість мов. Voice Guidance (Голосові підказки) активація активація Voice Guidance (Голосові підказки)"},{"UUID":"d0ad092c-9787-4dea-9751-1877cbc523b6","title":"Налаштування та використання спеціальних можливостей","link":"activating-voice-guidance-topic.html","desc":"Деактивація голосових підказок Одним рухом,","descFull":"Деактивація голосових підказок Одним рухом, використовуючи один палець, повільно гортайте пальцем ліворуч, а потім угору на дисплеї, доки не почуєте голосове повідомлення. Для моделей принтерів, які не мають вбудованого динаміка, використовуйте навушники, щоб почути повідомлення. Двома пальцями виконайте одну з дій нижче. Торкніться пункту  Voice Guidance , а тоді виберіть  OK . Торкніться  Cancel . Якщо жест не працює, застосуйте більше тиску. Ви також можете деактивувати голосові підказки, виконавши одну з дій нижче. Двома пальцями двічі торкніться головного екрана. Натисніть кнопку живлення, щоб перевести принтер у режим сну або гібернації. Voice Guidance (Голосові підказки) деактивація деактивація Voice Guidance (Голосові підказки)"},{"UUID":"3f215538-d576-483d-aa92-5276844f1f12","title":"Налаштування та використання спеціальних можливостей","link":"activating-voice-guidance-topic.html","desc":"Навігація екраном за допомогою жестів","descFull":"Навігація екраном за допомогою жестів Більшість жестів застосовуються, лише коли активовано голосові підказки. Увімкніть збільшення, щоб використовувати жести масштабування та панорамування. Використовуйте фізичну клавіатуру, щоб ввести символи й налаштувати певні параметри. Жести та їх функції Жест Функція Проведення одним пальцем ліворуч Запускає режим спеціальних можливостей. Використовуйте той самий жест, щоб вийти з режиму спеціальних можливостей. Цей жест застосовується, коли принтер перебуває у звичайному режимі. Подвійний дотик одним пальцем Вибирає опцію або елемент на екрані. Подвійний дотик до значка головного екрана двома пальцями Деактивує режим спеціальних можливостей. Потрійний дотик одним пальцем Збільшує або зменшує масштаб тексту й зображень Проведення пальцем праворуч або вниз одним пальцем Перехід до наступного елемента на екрані. Проведення одним пальцем ліворуч або вгору Перехід до попереднього елемента на екрані. Проведення одним пальцем угору, а потім униз Перехід до першого елемента на екрані. Панорамування Переглядайте частини збільшеного зображення, які виходять за межі екрана. Потягніть збільшене зображення двома пальцями. Проведення одним пальцем угору, а потім праворуч Збільшує гучність. Цей жест застосовується, коли принтер перебуває у звичайному режимі. Проведення одним пальцем униз, а потім праворуч Зменшує гучність. Цей жест застосовується, коли принтер перебуває у звичайному режимі. Проведення одним пальцем угору, а потім ліворуч Вихід із програми та повернення на головний екран. Проведення одним пальцем униз, а потім ліворуч Повертає до попереднього параметра. навігація екраном використання жестів навігація екраном за допомогою жестів"},{"UUID":"6b21f0ba-a3d3-470d-a367-aaea08c908d7","title":"Налаштування та використання спеціальних можливостей","link":"activating-voice-guidance-topic.html","desc":"Використання екранної клавіатури Коли з’явиться","descFull":"Використання екранної клавіатури Коли з’явиться екранна клавіатура, виконайте одну з дій нижче. Торкніться клавіші, щоб озвучити, і введіть символ у поле. Проведіть пальцем по різних символах, щоб озвучити їх, і введіть символ у поле. Торкніться текстового поля двома пальцями, щоб озвучити символи в полі. Торкніться клавіші  Backspace , щоб видалити символи. екранна клавіатура використання"},{"UUID":"a7ad589c-51ab-4a10-8a34-fd93a1131e02","title":"Налаштування та використання спеціальних можливостей","link":"activating-voice-guidance-topic.html","desc":"Увімкнення режиму збільшення Одним рухом,","descFull":"Увімкнення режиму збільшення Одним рухом, використовуючи один палець, повільно гортайте пальцем ліворуч, а потім угору на дисплеї, доки не почуєте голосове повідомлення. Для моделей принтерів, які не мають вбудованого динаміка, використовуйте навушники, щоб почути повідомлення. Двома пальцями виконайте дію нижче. Торкніться  Magnification mode . Торкніться  OK . Якщо жест не працює, застосуйте більше тиску. Щоб дізнатися більше про навігацію на збільшеному екрані, див. сторінку  . Режим збільшення увімкнення увімкнення режиму збільшення"},{"UUID":"cd7391b6-70cd-4db0-a596-72fcc76278dd","title":"Налаштування та використання спеціальних можливостей","link":"activating-voice-guidance-topic.html","desc":"Налаштування темпу мовлення голосових підказок","descFull":"Налаштування темпу мовлення голосових підказок На головному екрані торкніться меню  Settings Device Accessibility Speech Rate . Виберіть темп мовлення. Voice Guidance (Голосові підказки) темп мовлення регулювання швидкості озвучення голосових підказок коригування регулювання темпу мовлення Voice Guidance (Голосові підказки)"},{"UUID":"bdf9d20e-975a-4209-b632-9016b1834fb8","title":"Налаштування та використання спеціальних можливостей","link":"activating-voice-guidance-topic.html","desc":"Регулювання гучності навушників за замовчуванням","descFull":"Регулювання гучності навушників за замовчуванням На головному екрані торкніться меню  Settings Device Accessibility . Відрегулювати гучність навушників. Коли користувач виходить із режиму спеціальних можливостей або коли принтер активується з режиму сну чи гібернації, гучність скидається до значень за замовчуванням. гучність навушників за замовчуванням регулювання регулювання гучності навушників навушники"},{"UUID":"20609f98-8770-4cee-a265-b75212b69354","title":"Налаштування та використання спеціальних можливостей","link":"activating-voice-guidance-topic.html","desc":"Регулювання гучності вбудованого динаміка за","descFull":"Регулювання гучності вбудованого динаміка за замовчуванням На головному екрані торкніться значка  . Відрегулюйте гучність. Якщо ввімкнено режим без звуку, звукові сповіщення вимкнено. Цей параметр також сповільнює роботу принтера. Коли користувач виходить із режиму спеціальних можливостей або коли принтер активується з режиму сну чи гібернації, гучність скидається до значень за замовчуванням. гучність динаміка за замовчуванням регулювання регулювання гучності навушників динамік"},{"UUID":"b5c5913c-5deb-4efd-8d55-4ad72fa8e550","title":"Налаштування та використання спеціальних можливостей","link":"activating-voice-guidance-topic.html","desc":"Увімкнення промовляння паролів чи особистих","descFull":"Увімкнення промовляння паролів чи особистих ідентифікаційних номерів На головному екрані торкніться меню  Settings Device Accessibility Speak Passwords/PINs . Увімкніть параметр. промовляння паролів увімкнення персональні ідентифікаційні номери увімкнення увімкнення промовляння паролів увімкнення персональних ідентифікаційних номерів"},{"UUID":"a31844ae-57b3-4c1a-8de2-223e7ca23a32","title":"Налаштування передавання факсів на принтері","link":"setting-up-printer-to-fax-group.html","desc":"Підтримуваний факс Моделі принтерів та","descFull":"Підтримуваний факс Моделі принтерів та підтримувані ними факси Модель принтера Аналоговий факс etherFAX 1 Сервер факсу Факс через IP (FoIP) 2 1  Потрібна передплата. Для отримання додаткової інформації перейдіть на вебсторінку  https://www.etherfax.net/lexmark  або зверніться за місцем покупки принтера. 2  Потрібен установлений пакет ліцензій. Для отримання додаткової інформації зверніться за місцем покупки принтера. MX532adwe MX632adwe XM3350 підтримуваний факс"},{"UUID":"be720a3c-df9f-46a7-a8cb-609b6d97a9f9","title":"Налаштування передавання факсів на принтері","link":"setting-up-printer-to-fax-group.html","desc":"Налаштування функції факсу за допомогою","descFull":"Налаштування функції факсу за допомогою аналогового факсу Деякі методи підключення застосовні лише в деяких країнах або регіонах. Якщо функцію факсу ввімкнено та не повністю налаштовано, індикатор може блимати червоним. Якщо у вас немає середовища TCP/IP, скористайтеся панеллю керування, щоб налаштувати факс. Щоб уникнути втрати даних або несправності принтера, не торкайтеся кабелів або принтера в показаній області під час надсилання або отримання факсу. Використання панелі керування На головному екрані торкніться  Settings Fax Fax Setup General Fax Settings  (Налаштування > Факс > Налаштування факсу > Основні налаштування факсу). Налаштуйте параметри. Використання вбудованого вебсервера Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані. IP-адреса відображається як чотири набори цифр, розділених крапкою, як-от 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Settings Fax Fax Setup General Fax Settings  (Налаштування > Факс > Налаштування факсу > Основні налаштування факсу). Налаштуйте параметри. Застосуйте всі зміни. аналоговий факс налаштування налаштування аналогового факсу"},{"UUID":"ed6bfd42-7285-4488-807b-97f274a77d97","title":"Налаштування передавання факсів на принтері","link":"setting-up-printer-to-fax-group.html","desc":"Налаштування функції факсу за допомогою","descFull":"Налаштування функції факсу за допомогою etherFAX Мікропрограму принтера потрібно оновити до останньої версії. Щоб дізнатися більше, див.  . На принтері має бути встановлено належний пакет ліцензій. Щоб дізнатися більше, зверніться до etherFAX. Переконайтеся, що ви зареєстрували принтер на порталі etherFAX. Щоб дізнатися більше, перейдіть на сторінку  https://www.etherfax.net/lexmark . Під час реєстрації потрібен серійний номер пристрою. Щоб знайти серійний номер, див.  . Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані. IP-адреса відображається у вигляді чотирьох наборів цифр, розділених крапками, наприклад 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Settings  (Параметри) Fax  (Факс) Fax Setup  (Налаштування факсу) General Fax Settings  (Загальні параметри факсу). Пункт  Fax Setup  (Налаштування факсу) відображаються тільки в тому разі, якщо для параметра  Fax Mode  (Режим факсу) встановлено значення  Fax  (Факс). У полі  Fax Name  (Назва факсу) введіть унікальне ім’я. У полі  Fax Number  (Номер факсу) введіть номер факсу, наданий etherFAX. У меню  Fax Transport  (Транспорт факсу) натисніть  etherFAX . Це меню відображається, лише коли доступно кілька передавань факсу. Якщо на принтері встановлено лише etherFAX, тоді його налаштовано автоматично. Застосуйте зміни. etherFAX налаштування функції факсу налаштування функції факсу використання etherFAX"},{"UUID":"12090add-fdf5-43f6-864a-7cfa916721fb","title":"Налаштування передавання факсів на принтері","link":"setting-up-printer-to-fax-group.html","desc":"Налаштування функції факсу за допомогою","descFull":"Налаштування функції факсу за допомогою сервера факсу Ця функція дає змогу надсилати факсові повідомлення постачальнику послуг факсу, який підтримує отримання електронних листів. Ця функція підтримує лише вихідні факсові повідомлення. Щоб підтримувати отримання факсів, переконайтеся, що у вашому принтері налаштовано факс на основі пристрою, наприклад аналоговий факс, etherFAX або факс через IP (FoIP). Ця функція підтримує лише вихідні факсові повідомлення. Для забезпечення отримання факсів, переконайтеся, що в принтері налаштовано факс на основі пристрою, як-от аналоговий факс або факс через IP (FoIP). Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані. IP-адреса відображається як чотири набори цифр, розділені крапкою, як-от 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Settings Fax  (Параметри > Факс). У меню  Fax Mode  (Режим факсу) виберіть пункт  Fax Server  (Сервер факсу), після чого натисніть  Save  (Зберегти). Натисніть  Fax Server Setup  (Налаштування сервера факсу). У полі  To Format  (У формат) введіть  [#]@myfax.com , де  [#]  – це номер факсу, а  myfax.com  – домен постачальника послуг факсу. Якщо необхідно, виконайте налаштування для полів  Reply Address  (Зворотна адреса),  Subject  (Тема) та  Message  (Повідомлення). Щоб дозволити принтеру отримувати факсові повідомлення, увімкніть параметр отримання факсу на основі пристрою. Переконайтеся, що налаштовано факс на основі пристрою. Натисніть  Save  (Зберегти). Натисніть  Fax Server E‑mail Settings  (Параметри електронних листів сервера факсу) і виконайте одну з наведених нижче дій. Увімкніть параметр  Use E‑mail SMTP Server  (Використовувати SMTP-сервер електронної пошти). Якщо параметри електронної пошти через SMTP не налаштовано, див.  . Налаштуйте параметри SMTP. Щоб дізнатися більше, зверніться до постачальника послуг електронної пошти. Застосуйте зміни. сервер факсу, використання налаштування функції факсу налаштування функції факсу за допомогою сервера факсу"},{"UUID":"fd99684e-adc7-4d89-b717-0641be88a972","title":"Налаштування передавання факсів на принтері","link":"setting-up-printer-to-fax-group.html","desc":"Налаштування факсу за допомогою стандартної","descFull":"Налаштування факсу за допомогою стандартної телефонної лінії Ці вказівки застосовуються лише до принтерів, що підтримують аналоговий факс. Щоб дізнатися більше, див.  . Ці вказівки застосовуються лише до принтерів, що підтримують аналоговий факс. Щоб уникнути ризику ураження електричним струмом, не встановлюйте цей виріб і не виконуйте електричних або кабельних зʼєднань (живлення, факсу або телефонних ліній), під час грози. Щоб уникнути ризику ураження електричним струмом, не використовуйте функцію факсу під час грози. Щоб зменшити ризик виникнення пожежі, підключайте цей виріб до телефонної мережі загального користування лише телекомунікаційним кабелем 26 AWG або більший (RJ-11). Для користувачів в Австралії: кабель має бути схвалено Австралійським управлінням зв’язку та ЗМІ. Налаштування 1. Принтер підключено до виділеної факсової лінії Підключіть один кінець телефонного кабелю до лінійного порту принтера. Підключіть інший кінець кабелю до активного аналогового телефонного роз’єму. Принтер можна налаштувати на автоматичне отримання факсів (установіть для параметра  Auto Answer  (Автоматична відповідь) значення  On  (Увімк.)) або вручну (установіть для параметра  Auto Answer  (Автоматична відповідь) значення  Off  (Вимк.)). Якщо ви хочете отримувати факс автоматично, налаштуйте принтер відповідати після зазначеної кількості гудків. Налаштування 2. Принтер має спільну лінію з автовідповідачем Якщо ви підписалися на послугу розрізнення дзвінків, переконайтеся, що ви встановили правильний шаблон дзвінка для принтера. Інакше принтер не отримуватиме факс, навіть якщо ви налаштували його на автоматичне його отримання. Підключено до різних телефонних розʼємів Підключіть один кінець телефонного кабелю до лінійного порту принтера. Підключіть інший кінець кабелю до активного аналогового телефонного роз’єму. Якщо на вашій лінії лише один номер телефону, налаштуйте принтер на автоматичне отримання факсу. Налаштуйте принтер відповідати на виклики через два дзвінки після автовідповідача. Наприклад, якщо автовідповідач відповідає на виклик після чотирьох дзвінків, тоді налаштуйте для параметра  Rings to Answer  (Кількість дзвінків для відповіді) на принтері значення  6 . налаштування факсу підключення стандартної телефонної лінії налаштування факсу підключення стандартної телефонної лінії автовідповідач налаштування"},{"UUID":"e2a6653e-b5fc-483f-853c-d04452aebed1","title":"Налаштування передавання факсів на принтері","link":"setting-up-printer-to-fax-group.html","desc":"Налаштування факсу в країнах чи","descFull":"Налаштування факсу в країнах чи регіонах із відмінними телефонними роз’ємами та штепсельним вилками Ці вказівки застосовуються лише до принтерів, що підтримують аналоговий факс. Щоб дізнатися більше, див.  . Ці вказівки застосовуються лише до принтерів, що підтримують аналоговий факс. Щоб уникнути ризику ураження електричним струмом, не встановлюйте цей виріб і не виконуйте електричних або кабельних зʼєднань (живлення, факсу або телефонних ліній), під час грози. Щоб уникнути ризику ураження електричним струмом, не використовуйте функцію факсу під час грози. Щоб зменшити ризик виникнення пожежі, підключайте цей виріб до телефонної мережі загального користування лише телекомунікаційним кабелем 26 AWG або більший (RJ-11). Для користувачів в Австралії: кабель має бути схвалено Австралійським управлінням зв’язку та ЗМІ. Стандартний роз’єм, прийнятий у більшості країн або регіонів, — RJ‑11. Якщо роз’єм чи обладнання у вашому закладі несумісні з цим типом підключення, скористайтеся телефонним адаптером. Адаптер для вашої країни чи регіону може не постачатися разом із принтером, тож вам, можливо, доведеться придбати його окремо. У телефонному порті принтера може бути встановлено штекер адаптера. Не виймайте штекер адаптера з телефонного порту принтера, якщо ви підключаєтеся до послідовної або каскадної телефонної системи. Номер деталі штекера адаптера Назва деталі Номер деталі штекер адаптера Lexmark 40X8519 Підключення принтера до іншого роз’єму (не RJ‑11) Підключіть один кінець телефонного кабелю до лінійного порту принтера. Підключіть інший кінець кабелю до адаптера RJ‑11, а потім підключіть адаптер до роз’єму. Якщо ви хочете підключити інший пристрій зі з’єднувачем, відмінним від RJ-11, до того самого роз'єму, підключіть його безпосередньо до телефонного адаптера. налаштування факсу використання різних телефонних роз’ємів налаштування факсу використання різних штекерів налаштування факсу використання різних телефонних роз’ємів налаштування факсу використання різних штекерів адаптер RJ‑11"},{"UUID":"76b87be0-e48e-4269-8152-af820832c9d8","title":"Налаштування передавання факсів на принтері","link":"setting-up-printer-to-fax-group.html","desc":"Підключення до служби розрізнення дзвінків","descFull":"Підключення до служби розрізнення дзвінків Служба розрізнення дзвінків дозволяє мати кілька телефонних номерів на одній телефонній лінії. Кожному номеру телефону призначається інша модель дзвінка. Ці вказівки застосовуються лише до принтерів, що підтримують аналоговий факс. Щоб дізнатися більше, див.  . Ці вказівки застосовуються лише до принтерів, що підтримують аналоговий факс. На головному екрані торкніться  Settings  (Параметри) Fax  (Факс) Fax Setup  (Налаштування факсу) Fax Receive Settings  (Параметри отримання факсів) Admin Controls  (Елементи керування адміністратора) Answer On  (Увімкнути відповідь). Виберіть шаблон дзвінка. розрізнення дзвінків налаштування факсу увімкнення розрізнення дзвінків призначення принтеру моделі дзвінка"},{"UUID":"03a66225-02a1-4a5a-939f-de34cb5127d7","title":"Налаштування передавання факсів на принтері","link":"setting-up-printer-to-fax-group.html","desc":"Налаштування дати й часу факсу","descFull":"Налаштування дати й часу факсу Переконайтеся, що факс налаштовано. Додаткову інформацію див. у розділі  Налаштування принтера для факсу . На головному екрані торкніться меню  Settings Device Preferences Date and Time Configure . Налаштуйте параметри. надсилання факсу налаштування дати й часу дата й час параметри факсу"},{"UUID":"4c2b2b09-f975-4d6d-9b5c-f9cd16e7354c","title":"Налаштування передавання факсів на принтері","link":"setting-up-printer-to-fax-group.html","desc":"Налаштування переходу на літній час","descFull":"Налаштування переходу на літній час Переконайтеся, що факс налаштовано. Додаткову інформацію див. у розділі  Налаштування принтера для факсу . На головному екрані торкніться  Settings Device Preferences Date and Time Configure . У меню  Time Zone  торкніться  (UTC+user) Custom . Торкніться  UTC (GMT) Offset  і налаштуйте параметри. налаштування переходу на літній час перехід на літній час налаштування"},{"UUID":"1bc204d9-432a-4563-b37c-a0e0e2e86582","title":"Налаштування передавання факсів на принтері","link":"setting-up-printer-to-fax-group.html","desc":"Налаштування параметрів динаміка факсу Переконайтеся,","descFull":"Налаштування параметрів динаміка факсу Переконайтеся, що факс налаштовано. Додаткову інформацію див. у розділі  Налаштування принтера для факсу . На головному екрані торкніться меню  Settings Fax Fax Setup Speaker Settings . Виконайте дії нижче. Установіть для параметра  Speaker Mode  значення  Always On . Установіть для параметра  Speaker Volume  значення  High . Увімкніть параметр  Ringer Volume . налаштування параметрів динаміка факсу параметри динаміка факсу налаштування"},{"UUID":"d34c43b9-bf19-4260-9e80-e906d2be1813","title":"Налаштування, установлення та конфігурування","link":"configuring-smtp-server-for-e-mail-topic.html","desc":"Налаштування параметрів SMTP електронної пошти","descFull":"Налаштування параметрів SMTP електронної пошти Налаштуйте параметри простого протоколу передачі пошти (SMTP), щоб надіслати сканований документ електронною поштою. Налаштування залежать від постачальника послуг електронної пошти. Перш ніж почати, переконайтеся, що принтер підключено до мережі та мережу підключено до інтернету. Використання Embedded Web Server Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані принтера. IP-адреса відображається у вигляді чотирьох наборів цифр, розділених крапками, наприклад 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Settings  (Параметри) E‑mail  (Електронна пошта). Налаштуйте параметри в розділі  E‑mail Setup  (Налаштування електронної пошти). Додаткову інформацію див. у списку  постачальників послуг електронної пошти . Для постачальників послуг електронної пошти, яких немає в списку, зверніться до свого постачальника та попросіть налаштування. Натисніть  Save  (Зберегти). Використання меню  Settings  (Параметри) на принтері На головному екрані торкніться  Settings  (Параметри) E‑mail  (Електронна пошта) E‑mail Setup  (Налаштування електронної пошти). Налаштуйте параметри. Додаткову інформацію див. у списку  постачальників послуг електронної пошти . Для постачальників послуг електронної пошти, яких немає в списку, зверніться до свого постачальника та попросіть налаштування. Постачальники послуг електронної пошти Пошта AOL Пошта Comcast Gmail Пошта iCloud Mail.com Пошта NetEase (mail.126.com) Пошта NetEase (mail.163.com) Пошта NetEase (mail.yeah.net) Outlook Live або Microsoft 365 Пошта QQ Пошта Sina Пошта Sohu Пошта Yahoo! Пошта Zoho Якщо під час використання наданих параметрів виникають помилки, зверніться до свого постачальника послуг електронної пошти. Для постачальників послуг електронної пошти, яких немає в списку, зверніться до свого постачальника. Пошта AOL Налаштування для пошти AOL Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.aol.com Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 587 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Пароль програми Щоб створити пароль програми, перейдіть на сторінку  AOL Account Security  (Безпека облікового запису AOL), увійдіть у свій обліковий запис і натисніть  Generate app password  (Створити пароль програми). Пошта Comcast Налаштування для пошти Comcast Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.comcast.net Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 587 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Пароль облікового запису Переконайтеся, що у вашому обліковому записі ввімкнено налаштування безпеки стороннього доступу. Щоб дізнатися більше, перейдіть на  сторінку довідки Comcast Xfinity Connect . Gmail Переконайтеся, що у вашому обліковому записі Google увімкнено двоетапну перевірку. Щоб увімкнути двоетапну перевірку, перейдіть на сторінку  Google Account Security  (Безпека облікового запису Google), увійдіть у свій обліковий запис і натисніть  2‑Step Verification  (Двоетапна перевірка) у розділі « Signing in to Google » (Вхід у Google). Параметри SMTP для Gmail Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.gmail.com Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 587 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Пароль програми Щоб створити пароль програми, перейдіть на сторінку  Google Account Security  (Безпека облікового запису Google), увійдіть у свій обліковий запис і натисніть  App passwords  (Паролі програм) у розділі « Signing in to Google » (Вхід у Google). Елемент « App passwords » (Паролі програм) відображається, лише якщо ввімкнено двоетапну перевірку. Пошта iCloud Переконайтеся, що у вашому обліковому записі увімкнено двоетапну перевірку. Налаштування для пошти iCloud Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.mail.me.com Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 587 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Пароль програми Щоб створити пароль програми, перейдіть на сторінку  Керування обліковим записом iCloud , увійдіть у свій обліковий запис і натисніть  Generate Password  (Створити пароль) у розділі  Security  (Безпека). Mail.com Параметри для Mail.com Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.mail.com Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 587 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Пароль облікового запису Пошта NetEase (mail.126.com) Переконайтеся, що у вашому обліковому записі увімкнено службу SMTP. Щоб увімкнути цю службу, на головній сторінці пошти NetEase натисніть  Settings  (Параметри) POP3/SMTP/IMAP , а потім увімкніть або службу  IMAP/SMTP , або службу  POP3/SMTP . Параметри для пошти NetEase (mail.126.com) Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.126.com Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 465 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Пароль для авторизації Пароль для авторизації надається після ввімкнення служби  IMAP/SMTP service  (Служба IMAP/SMTP) або  POP3/SMTP service  (Служба POP3/SMTP). Пошта NetEase (mail.163.com) Переконайтеся, що у вашому обліковому записі увімкнено службу SMTP. Щоб увімкнути цю службу, на головній сторінці пошти NetEase натисніть  Settings  (Параметри) POP3/SMTP/IMAP , а потім увімкніть або службу  IMAP/SMTP , або службу  POP3/SMTP . Параметри для пошти NetEase (mail.163.com) Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.163.com Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 465 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Пароль для авторизації Пароль для авторизації надається після ввімкнення служби  IMAP/SMTP service  (Служба IMAP/SMTP) або  POP3/SMTP service  (Служба POP3/SMTP). Пошта NetEase (mail.yeah.net) Переконайтеся, що у вашому обліковому записі увімкнено службу SMTP. Щоб увімкнути цю службу, на головній сторінці пошти NetEase натисніть  Settings  (Параметри) POP3/SMTP/IMAP , а потім увімкніть або службу  IMAP/SMTP , або службу  POP3/SMTP . Параметри для пошти NetEase (mail.yeah.com) Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.yeah.net Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 465 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Пароль для авторизації Пароль для авторизації надається після ввімкнення служби  IMAP/SMTP service  (Служба IMAP/SMTP) або  POP3/SMTP service  (Служба POP3/SMTP). Outlook Live або Microsoft 365 Ці налаштування застосовуються до доменів електронної пошти outlook.com і hotmail.com, а також облікових записів Microsoft 365. Параметри для Outlook Live або Microsoft 365 Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.office365.com Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 587 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Пароль облікового запису або пароль програми Для облікових записів з вимкненою двоетапною перевіркою використовуйте пароль свого облікового запису. Для облікових записів outlook.com або hotmail.com із увімкненою двоетапною перевіркою використовуйте пароль програми. Щоб створити пароль програми, перейдіть на сторінку  Керування обліковим записом Outlook Live , а потім увійдіть у свій обліковий запис. Щоб отримати додаткові параметри налаштування для бізнесу за допомогою Microsoft 365, перейдіть на сторінку  довідки Microsoft 365 . Пошта QQ Переконайтеся, що у вашому обліковому записі увімкнено службу SMTP. Щоб увімкнути цю службу, на головній сторінці пошти QQ натисніть  Settings  (Параметри) Account  (Обліковий запис). У розділі  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV Service  (Служба POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV) увімкніть або службу  POP3/SMTP , або службу  IMAP/SMTP . Параметри для пошти QQ Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.qq.com Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 587 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Код авторизації Щоб створити код авторизації, на головній сторінці пошти QQ натисніть  Settings  (Параметри) Account  (Обліковий запис), а потім у розділі  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV Service  (Служба POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV) натисніть  Generate authorization code  (Створити код авторизації). Пошта Sina Переконайтеся, що у вашому обліковому записі увімкнено службу POP3/ SMTP. Щоб увімкнути цю службу, на головній сторінці пошти Sina натисніть  Settings  (Параметри) More settings  (Інші параметри) POP/IMAP/SMTP з боку користувача , а потім увімкніть службу  POP3/SMTP . Параметри для пошти Sina Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.sina.com Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 587 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Код авторизації Щоб створити код авторизації, на головній сторінці електронної пошти натисніть  Settings  (Параметри) More settings  (Інші параметри) POP/IMAP/SMTP з боку користувача , а потім увімкніть  Authorization code status  (Статус коду авторизації). Пошта Sohu Переконайтеся, що у вашому обліковому записі увімкнено службу SMTP. Щоб увімкнути цю службу, на головній сторінці пошти Sohu натисніть  Options  (Опції) Settings  (Параметри) POP3/SMTP/IMAP , а потім увімкніть або службу  IMAP/SMTP , або службу  POP3/SMTP . Параметри для пошти Sohu Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.sohu.com Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 465 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Незалежний пароль Незалежний пароль надається після увімкнення служби  IMAP/SMTP service  (Служба IMAP/SMTP) або  POP3/SMTP service  (Служба POP3/SMTP). Yahoo! Пошта Параметри для Yahoo! Пошта Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.mail.yahoo.com Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 587 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Пароль програми Щоб створити пароль програми, перейдіть на сторінку  Yahoo Account Security  (Безпека облікового запису Yahoo), увійдіть у свій обліковий запис і натисніть  Generate app password  (Створити пароль програми). Пошта Zoho Параметри для пошти Zoho Параметри Значення Primary SMTP Gateway  (Основний шлюз SMTP) smtp.zoho.com Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 587 Use SSL/TLS  (Використовувати SSL/TLS) Required  (Вимагається) Require Trusted Certificate  (Вимагати довірений сертифікат) Disabled  (Вимкнено) Reply Address  (Зворотна адреса) Ваша адреса електронної пошти SMTP Server Authentication  (Автентифікація на сервері SMTP) Login / Plain  (Вхід/звичайний) Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Device UserID  (Ідентифікатор користувача пристрою) Ваша адреса електронної пошти Device Password  (Пароль до пристрою) Пароль облікового запису або пароль програми Для облікових записів з вимкненою двоетапною перевіркою використовуйте пароль свого облікового запису. Для облікових записів із увімкненою двоетапною перевіркою використовуйте пароль програми. Щоб створити пароль програми, перейдіть на сторінку  Zoho Mail Account Security  (Безпека облікового запису пошти Zoho), увійдіть у свій обліковий запис і натисніть  Generate New Password  (Створити новий пароль) у розділі  Application‑Specific Passwords  (Паролі до конкретних програм). постачальники послуг електронної пошти налаштування параметрів сервера електронної пошти Параметри SMTP налаштування функції електронної пошти налаштування сповіщення електронною поштою налаштування"},{"UUID":"03775b15-d4bc-46f4-a8af-19ddbb27c935","title":"Завантаження паперу та спеціальних носіїв","link":"setting-paper-size-and-type-topic.html","desc":"Установлення розміру й типу паперу","descFull":"Установлення розміру й типу паперу На головному екрані натисніть  Settings Paper Tray Configuration Paper Size/Type  (Налаштування > Папір > Конфігурація лотка > Розмір/тип паперу) і виберіть джерело паперу. Установіть розмір і тип паперу. установлення розміру паперу установлення типу паперу"},{"UUID":"d6097e6d-3226-42de-bfca-c30d5960d892","title":"Завантаження паперу та спеціальних носіїв","link":"setting-paper-size-and-type-topic.html","desc":"Налаштування параметрів універсального паперу На","descFull":"Налаштування параметрів універсального паперу На головному екрані торкніться меню  Settings Paper Media Configuration Universal Setup . Налаштуйте параметри. папір налаштування універсального розміру налаштування універсального розміру паперу Універсальний розмір паперу налаштування"},{"UUID":"b1add67d-5ec5-46d1-b8b0-1da921a5f980","title":"Завантаження паперу та спеціальних носіїв","link":"setting-paper-size-and-type-topic.html","desc":"Завантаження лотків Щоб зменшити ризик","descFull":"Завантаження лотків Щоб зменшити ризик нестабільності обладнання, завантажуйте кожен лоток окремо. Усі інші лотки мають бути закриті, доки вони не знадобляться. Зніміть лоток. Щоб уникнути зминання паперу, не виймайте лоток, поки принтер зайнятий. Відрегулюйте напрямні відповідно до розміру паперу, який ви завантажуєте. Відігніть, розгорніть і вирівняйте кути паперу перед завантаженням. Завантажте стос паперу стороною для друку донизу, а потім переконайтеся, що напрямні щільно прилягають до паперу. Для одностороннього друку завантажте фірмові бланки лицьовою стороною донизу заголовком до передньої частини лотка. Для двостороннього друку завантажте фірмові бланки лицьовою стороною догори, заголовком до задньої частини лотка. Не засовуйте папір у лоток. Для запобігання зминанню паперу переконайтеся, що висота стосу нижча за індикатор максимального заповнення папером. Вставте лоток. За потреби встановіть розмір і тип паперу на панелі керування відповідно до завантаженого паперу. завантаження лотків завантаження паперу завантаження фірмового бланка"},{"UUID":"7a0f9e97-b6a6-4647-b730-491507223714","title":"Завантаження паперу та спеціальних носіїв","link":"setting-paper-size-and-type-topic.html","desc":"Завантаження багатоцільового подавача Відкрийте багатоцільовий","descFull":"Завантаження багатоцільового подавача Відкрийте багатоцільовий подавач. Відігніть, розгорніть і вирівняйте кути паперу перед завантаженням. Завантажте папір стороною для друку догори. Для одностороннього друку завантажте фірмовий бланк лицьовою стороною догори заголовком у напрямку до задньої частини принтера. Для двостороннього друку завантажте фірмовий бланк лицьовою стороною донизу заголовком до передньої принтер. Завантажуйте конверти клапаном донизу ліворуч. Не використовуйте конверти з марками, застібками, кнопками, віконцями, вкладками з покриттям або самоклеючими матеріалами. Відрегулюйте напрямні відповідно до розміру паперу, який ви завантажуєте. На панелі керування встановіть розмір і тип паперу відповідно до завантаженого паперу. багатоцільовий подавач завантаження завантаження фірмового бланка в багатоцільовому подавачі завантаження конвертів в багатоцільовому подавачі"},{"UUID":"108003cb-a3ad-4ba4-b93c-030f3a4f20d7","title":"Завантаження паперу та спеціальних носіїв","link":"setting-paper-size-and-type-topic.html","desc":"Пов’язування лотків На головному екрані","descFull":"Пов’язування лотків На головному екрані торкніться меню  Settings Paper Tray Configuration  виберіть джерело паперу. Налаштуйте той самий розмір і тип паперу для лотків, які пов’язуєте. На головному екрані торкніться меню  Settings Device Maintenance Configuration Menu Tray Configuration Tray Linking . Торкніться  Automatic . Щоб від’єднати лотки, переконайтеся, що для всіх лотків вказано різні параметри розміру та типу паперу. Температура термофіксатора різниться, залежно від указаного типу паперу. Щоб уникнути проблем із друком, параметр типу паперу на принтері має відповідати паперу, завантаженому в лоток. відв’язування лотків пов’язування лотків лотки пов’язування лотки відв’язування"},{"UUID":"130b9cc2-7d3f-4cf9-8d39-ca9fdf057d21","title":"Установлення та оновлення програмного забезпечення, драйверів та мікропрограм","link":"installing-printer-software-topic.html","desc":"Установлення програмного забезпечення принтера Драйвер","descFull":"Установлення програмного забезпечення принтера Драйвер принтера міститься в інсталяційному пакеті програмного забезпечення. На комп’ютерах Macintosh з macOS версії 10.7 або новішої не потрібно встановлювати драйвер, щоб друкувати на принтері з підтримкою AirPrint. Якщо вам потрібні користувацькі функції друку, завантажте драйвер принтера. Отримайте копію інсталяційного пакета програмного забезпечення. З CD-диска з програмним забезпеченням, який постачався з принтером. Перейдіть на сторінку  www.lexmark.com/downloads . Перейдіть на сторінку  www.dell.com/support/printers . З вебсайту чи місця, де ви придбали принтер. Запустіть засіб установлення, а тоді виконайте вказівки на екрані комп’ютера. установлення програмного забезпечення принтера програмне забезпечення принтера установлення установлення драйвера принтера драйвер принтера установлення"},{"UUID":"46b00c46-56a5-4729-b653-0fe6d6fac439","title":"Установлення та оновлення програмного забезпечення, драйверів та мікропрограм","link":"installing-printer-software-topic.html","desc":"Установлення драйвера факсу Перейдіть на","descFull":"Установлення драйвера факсу Перейдіть на сторінку  www.lexmark.com/downloads , знайдіть модель свого принтера, а тоді завантажте потрібний інсталяційний пакет. Перейдіть на вебсайт або в місце, де ви придбали принтер, а тоді отримайте інсталяційний пакет. Перейдіть на сторінку  www.dell.com/support  і завантажте потрібний інсталяційний пакет. На комп’ютері натисніть  Printer Properties (Властивості принтера) , а тоді перейдіть на вкладку  Configuration (Конфігурація) . Запустіть інсталятор, а тоді виконайте вказівки на екрані комп’ютера. Виберіть  Fax (Факс) , а потім натисніть  Apply (Застосувати) . установлення драйвера факсу установлення драйвера факсу"},{"UUID":"43a7f732-a304-44b7-a1fc-cf8c2f08f421","title":"Установлення та оновлення програмного забезпечення, драйверів та мікропрограм","link":"installing-printer-software-topic.html","desc":"Додавання принтерів на комп’ютер Перш","descFull":"Додавання принтерів на комп’ютер Перш ніж почати, виконайте одну з дій нижче. Підключіть принтер і комп’ютер до однієї мережі. Щоб дізнатися більше про підключення принтера до мережі, див.  . Підключіть комп’ютер до принтера. Щоб дізнатися більше, див.  . Підключіть принтер до комп’ютера за допомогою кабелю USB. Щоб дізнатися більше, див.  . Кабель USB продається окремо. Для користувачів Windows Установіть драйвер принтера на комп’ютері. Щоб дізнатися більше, див.  . Відкрийте папку з принтерами й натисніть  Add a printer or scanner  (Додати принтер або сканер). Залежно від підключення принтера, виконайте одну з дій нижче. Виберіть принтер. зі списку, а тоді натисніть  Add device  (Додати пристрій). Натисніть  Show Wi‑Fi Direct printers  (Відобразити принтери Wi‑Fi Direct), виберіть принтер і натисніть  Add device  (Додати пристрій). Натисніть  The printer that I want isn’t listed  (Немає необхідного принтера), після чого у вікні  Add Printer  (Додати принтер) виконайте наведені нижче дії. Виберіть  Add a printer using a TCP/IP address or hostname  (Додати принтер за допомогою TCP-/IP-адреси або імені хоста) і натисніть  Next  (Далі). У полі « Hostname or IP address » (Ім’я хоста або IP-адреса) введіть IP-адресу принтера й натисніть  Next  (Далі). Перегляньте IP-адресу принтера на головному екрані принтера. IP-адреса відображається як чотири набори цифр, розділених крапкою, як-от 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Виберіть драйвер принтера й натисніть  Next  (Далі). Виберіть  Use the print driver that is currently installed (recommended)  (Використовувати драйвер принтера, який наразі встановлено (рекомендовано)) і натисніть  Next  (Далі). Введіть ім’я принтера, а тоді натисніть  Next  (Далі). Виберіть варіант доступу до принтера й натисніть  Next  (Далі). Натисніть  Finish  (Завершити). Для користувачів Macintosh Відкрийте на комп’ютері розділ  Printers & Scanners  (Принтери та сканери). Натисніть значок   і виберіть принтер. У меню  Use  (Використовувати) виберіть драйвер принтера. Щоб використовувати драйвер принтера Macintosh, виберіть  AirPrint  або  Secure AirPrint  (Захищений AirPrint). Якщо вам потрібні користувацькі функції друку, виберіть драйвер принтера Lexmark. Щоб установити драйвер, див.  . Якщо вам потрібні користувацькі функції друку, виберіть виробника драйвера принтера. Щоб установити драйвер, див.  . Додайте принтер. додавання принтерів на комп’ютер"},{"UUID":"d18b1536-0222-4754-ab6c-48d34080587d","title":"Установлення та оновлення програмного забезпечення, драйверів та мікропрограм","link":"installing-printer-software-topic.html","desc":"Оновлення мікропрограми Щоб підвищити продуктивність","descFull":"Оновлення мікропрограми Щоб підвищити продуктивність принтера й вирішити проблеми, регулярно оновлюйте мікропрограму принтера. Щоб дізнатися більше по оновлення мікропрограми, зверніться до представника Lexmark. Щоб дізнатися більше по оновлення мікропрограми, зверніться до представника Dell. Щоб дізнатися більше по оновлення мікропрограми, зверніться до торгового представника. Щоб отримати останнє оновлення, перейдіть на сторінку  www.lexmark.com/downloads , після чого знайдіть модель принтера. Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані принтера. IP-адреса відображається як чотири набори цифр, розділених крапкою, як-от 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Settings Device Update Firmware  (Налаштування > Пристрій > Оновити мікропрограму). Виконайте одну з дій нижче. Натисніть  Check for updates now I agree, start update  (Перевірити наявність оновлень > Я погоджуюся. Почати оновлення). Оновіть файл мікропрограми. Перейдіть до файлу мікропрограми. Переконайтеся, що ви видобули файл zip мікропрограми. Натисніть  Upload Start  (Завантажити > Почати). оновлення мікропрограми мікропрограма, оновлення"},{"UUID":"b07c2b8f-5ee6-485f-ac44-6bf8b94d742f","title":"Установлення та оновлення програмного забезпечення, драйверів та мікропрограм","link":"installing-printer-software-topic.html","desc":"Експорт чи імпорт файлу конфігурації","descFull":"Експорт чи імпорт файлу конфігурації Ви можете експортувати параметри конфігурації свого принтера в текстовий файл, а тоді імпортувати файл, щоб застосувати параметри до всіх інших принтерів. Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані принтера. IP-адреса відображається як чотири набори цифр, розділених крапкою, як-от 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. На вбудованому вебсервері натисніть  Export Configuration  or  Import Configuration . Дотримуйтеся вказівок на екрані. Якщо принтер підтримує додатки, виконайте дії нижче. Натисніть  Додатки  виберіть додаток  Налаштувати . Натисніть  Експортувати  або  Імпортувати . експорт файлу конфігурації використання вбудованого вебсервера імпорт файлу конфігурації використання вбудованого вебсервера"},{"UUID":"6a5d03b9-9f9d-44eb-926c-828517d45a89","title":"Установлення та оновлення програмного забезпечення, драйверів та мікропрограм","link":"installing-printer-software-topic.html","desc":"Додавання доступних засобів у драйвері","descFull":"Додавання доступних засобів у драйвері принтера Для користувачів Windows Відкрийте папку з принтерами. Виберіть принтер, який хочете оновити, а тоді виконайте одну з дій нижче. Для користувачів Windows 7 або пізнішої версії: виберіть  Printer properties . Для користувачів попередніх версій: виберіть  Properties . Перейдіть на вкладку «Конфігурація», а тоді виберіть  Update Now ‑ Ask Printer . Застосуйте зміни. Для користувачів Macintosh У параметрах системи в меню Apple перейдіть до свого принтера, а тоді виберіть  Options & Supplies . Перейдіть до списку засобів апаратного забезпечення й додайте встановлені. Застосуйте зміни. додавання засобів апаратного забезпечення драйвер принтера драйвер принтера засоби апаратного забезпечення, додавання додавання внутрішніх опцій драйвер принтера засоби апаратного забезпечення, додавання драйвер принтера внутрішні опції, додавання драйвер принтера"},{"UUID":"e44b53ef-f641-4b25-b397-df58951d6bd1","title":"Установлення апаратних опцій","link":"available-internal-options-topic.html","desc":"Доступні внутрішні опції Інтелектуальний накопичувач","descFull":"Доступні внутрішні опції Інтелектуальний накопичувач Шрифти Спрощена китайська Традиційна китайська Японська Корейська Арабська Запам’ятовувальний пристрій Жорсткий диск Ліцензовані функції IPDS Штрих-код Внутрішній порт для рішень Карта послідовного інтерфейсу RS-232C Карта паралельного інтерфейсу 1284-B Оптоволоконний кабель Ethernet  MarkNet  N8230 Сервер бездротового друку  MarkNet  N8450 Модуль довіреної платформи Для активації об’єднання форм і деяких функцій IPDS потрібен інтелектуальний накопичувач або жорсткий диск. Для активації об’єднання форм і деяких функцій IPDS потрібен інтелектуальний накопичувач або жорсткий диск. Деякі параметри доступні тільки на деяких моделях принтерів. Для отримання додаткової інформації зверніться за місцем покупки принтера. Для активації об’єднання форм і деяких функцій IPDS потрібен інтелектуальний накопичувач або жорсткий диск. Деякі параметри доступні тільки на деяких моделях принтерів. Для отримання додаткової інформації зверніться до свого дилера. внутрішні опції карта з мікропрограмою додаткові карти жорсткий диск інтелектуальний накопичувач"},{"UUID":"5884498d-5968-4cfb-9d90-d5101c1a9d20","title":"Установлення апаратних опцій","link":"available-internal-options-topic.html","desc":"Установка додаткових лотків Щоб уникнути","descFull":"Установка додаткових лотків Щоб уникнути ризику ураження електричним струмом, якщо ви отримуєте доступ до плати контролера чи встановлення додаткового необов’язкового апаратного забезпечення або пристроїв пам’яті через деякий час після налаштування принтера, вимкніть принтер і вийміть кабель живлення з електричної розетки, перш ніж продовжувати. Якщо до принтера підключені інші пристрої, вимкніть їх і від’єднайте всі кабелі, що ведуть до принтера. Вимкніть принтер Від’єднайте кабель живлення від електричної розетки, а потім від принтера. Розпакуйте додатковий лоток, а потім видаліть увесь пакувальний матеріал. Вирівняйте принтер із додатковим лотком, а потім опустіть принтер на місце. Якщо вага принтера перевищує 20 кг (44 фунти), щоб безпечно підняти його, може знадобитися двоє або більше людей. Підключіть шнур живлення до принтера, а потім до електричної розетки. Щоб уникнути ризику пожежі чи ураження електричним струмом, під’єднайте кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. Увімкніть принтер. Додайте лоток у драйвер принтера, щоб зробити його доступним для завдань друку. Щоб дізнатися більше, див.  . установлення лотків лотки установлення параметри апаратного забезпечення лотки"},{"UUID":"2cd06fcc-d289-4ca0-9f9b-0cf09ff04aa4","title":"Установлення апаратних опцій","link":"available-internal-options-topic.html","desc":"Установка інтелектуального накопичувача Щоб уникнути","descFull":"Установка інтелектуального накопичувача Щоб уникнути ризику ураження електричним струмом, якщо ви отримуєте доступ до плати контролера чи встановлення додаткового необов’язкового апаратного забезпечення або пристроїв пам’яті через деякий час після налаштування принтера, вимкніть принтер і вийміть кабель живлення з електричної розетки, перш ніж продовжувати. Якщо до принтера підключені інші пристрої, вимкніть їх і від’єднайте всі кабелі, що ведуть до принтера. Вимкніть принтер. Від’єднайте кабель живлення від електричної розетки, а потім від принтера. За допомогою викрутки з плоскою головкою відкрийте кришку доступу до плати контролера. Електронні компоненти плати контролера легко пошкоджуються статичною електрикою. Перш ніж торкатися будь-яких компонентів плати контролера або роз’ємів, торкніться металевої поверхні принтера. Вийміть факсимільну карту. Розпакуйте інтелектуальний накопичувач. Не торкайтеся точок з’єднання вздовж краю накопичувача. Знайдіть роз’єм для ISD. Вставте ISD у призначений для нього роз’єм. Установіть факсимільну карту, а потім закріпіть її гвинтом. Закрийте кришку доступу до плати контролера, а потім закріпіть її гвинтом. Підключіть шнур живлення до принтера, а потім до електричної розетки. Щоб уникнути ризику пожежі чи електричного ураження, підключіть кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. Увімкніть принтер. інтелектуальний накопичувач установлення установлення внутрішніх опцій інтелектуальний накопичувач"},{"UUID":"02cf414a-c7c2-4588-b003-949ab812a44b","title":"Установлення апаратних опцій","link":"available-internal-options-topic.html","desc":"Установлення жорсткого диска принтера Ці","descFull":"Установлення жорсткого диска принтера Ці вказівки застосовуються лише до принтерів, що підтримують жорсткі диски для принтерів. Щоб уникнути ризику ураження електричним струмом, якщо ви отримуєте доступ до плати контролера чи встановлення додаткового необов’язкового апаратного забезпечення або пристроїв пам’яті через деякий час після налаштування принтера, вимкніть принтер і вийміть кабель живлення з електричної розетки, перш ніж продовжувати. Якщо до принтера підключені інші пристрої, вимкніть їх і від’єднайте всі кабелі, що ведуть до принтера. Вимкніть принтер. Від’єднайте кабель живлення від електричної розетки, а потім від принтера. За допомогою викрутки з плоскою головкою відкрийте кришку доступу до плати контролера. Електронні компоненти плати контролера легко пошкоджуються статичною електрикою. Перш ніж торкатися будь-яких компонентів плати контролера або роз’ємів, торкніться металевої поверхні принтера. Розпакуйте жорсткий диск. Приєднайте жорсткий диск до плати контролера, а потім закріпіть конструкцію гвинтами. Не торкайтеся центральної частини жорсткого диска та не натискайте на неї. Приєднайте інтерфейсний кабель жорсткого диска до плати контролера. Закрийте кришку доступу до плати контролера, а потім закріпіть її гвинтом. Підключіть шнур живлення до принтера, а потім до електричної розетки. Щоб уникнути ризику пожежі чи електричного ураження, підключіть кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. Увімкніть принтер. установлення жорсткого диска принтера установлення опцій жорсткий диск принтера внутрішні опції жорсткий диск принтера"},{"UUID":"6d3540d4-d150-4a0c-839f-4a6b58bad84e","title":"Установлення апаратних опцій","link":"available-internal-options-topic.html","desc":"Установлення внутрішнього порту для рішень","descFull":"Установлення внутрішнього порту для рішень Щоб уникнути ризику ураження електричним струмом, якщо ви отримуєте доступ до плати контролера чи встановлення додаткового необов’язкового апаратного забезпечення або пристроїв пам’яті через деякий час після налаштування принтера, вимкніть принтер і вийміть кабель живлення з електричної розетки, перш ніж продовжувати. Якщо до принтера підключені інші пристрої, вимкніть їх і від’єднайте всі кабелі, що ведуть до принтера. Вимкніть принтер. Від’єднайте кабель живлення від електричної розетки, а потім від принтера. Розпакуйте комплект внутрішнього порту для рішень (ISP). Вміст комплекту ISP 1 Внутрішній порт для рішень (ISP) Карта послідовного інтерфейсу RS-232C Карта паралельного інтерфейсу 1284-B Оптоволоконний кабель Ethernet  MarkNet  N8230 2 Подовжувальний кабель ISP 3 Монтажний кронштейн 4 Гвинти 5 Корпус Від’єднайте попередньо встановлений інтерфейсний кабель від порту ISP. Установіть порт ISP в корпус. Зафіксуйте порт ISP на місці, а потім під’єднайте подовжувальний кабель ISP. За допомогою викрутки з плоскою головкою зніміть кришку доступу до плати контролера. Електронні компоненти плати контролера легко пошкоджуються статичною електрикою. Перш ніж торкатися будь-яких електронних компонентів плати контролера або роз’ємів, торкніться металевої поверхні принтера. Приєднайте до принтера комплект ISP. Закрийте комплект ISP, а потім закріпіть конструкцію гвинтом. Підключіть шнур живлення до принтера, а потім до електричної розетки. Щоб уникнути ризику пожежі чи електричного ураження, підключіть кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. Увімкніть принтер. внутрішній порт для рішень установлення установлення внутрішніх опцій внутрішній порт для рішень"},{"UUID":"c7712b93-412e-438e-ba7f-a8f9cbf0a139","title":"Установлення апаратних опцій","link":"available-internal-options-topic.html","desc":"Установлення напівавтоматичного степлера Вимкніть принтер.","descFull":"Установлення напівавтоматичного степлера Вимкніть принтер. Від’єднайте кабель живлення від електричної розетки, а потім від принтера. Розпакуйте напівавтоматичний степлер. Зніміть кришки стійки. Не викидайте кришки стійки. Установіть блок живлення, протягнувши його кабель через роз’єм у принтері, і під’єднайте його до напівавтоматичного степлера. Щоб не допустити пошкодження напівавтоматичного степлера, використовуйте лише блок живлення, що постачається з ним у комплекті. Установіть напівавтоматичний степлер. Розташуйте блок живлення належним чином. Приєднайте кришку стійки. Зафіксуйте блок живлення належним чином. Під’єднайте один кінець кабелю живлення степлера до блока живлення, а інший кінець — до електричної розетки. Під’єднайте один кінець кабелю живлення принтера до принтера, а інший кінець — до електричної розетки. Щоб уникнути ризику пожежі чи електричного ураження, підключіть кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. Увімкніть принтер. напівавтоматичний степлер установлення установлення напівавтоматичного степлера"},{"UUID":"36766ebd-2717-406f-929a-5fccae18e54e","title":"Мережа","link":"wireless-support-topic.html","desc":"Підтримка бездротової технології Моделі принтерів","descFull":"Підтримка бездротової технології Моделі принтерів та підтримка ними бездротової технології Модель принтера Тип приладу Номер моделі Wireless (Бездротовий зв’язок) MX532adwe 7020 476 X 486 MX635adwe 676 X 686 XM3350 689 підтримка бездротової технології"},{"UUID":"0aa9ec59-d296-4a5d-8f16-c118d083adc8","title":"Мережа","link":"wireless-support-topic.html","desc":"Під’єднання принтера до мережі Wi‑Fi","descFull":"Під’єднання принтера до мережі Wi‑Fi Переконайтеся, що для параметра  Active Adapter  налаштовано значення  Auto . На головному екрані торкніться меню  Settings Network/Ports Network Overview Active Adapter . Використання панелі керування На головному екрані торкніться меню  Settings Network/Ports Wireless Setup On Printer Panel Choose Network . Виберіть мережу Wi‑Fi, а тоді введіть пароль мережі. Для моделей принтерів із підтримкою мережі Wi‑Fi під час початкового налаштування з’являється запит на налаштування мережі Wi‑Fi. Використання Lexmark Mobile Assistant Залежно від вашого мобільного пристрою, завантажте додаток Lexmark Mobile Assistant із магазину  Google Play  або App Store. На екрані принтера торкніться меню  Settings Network/Ports Wireless Setup Using Mobile App Printer ID . На мобільному пристрої запустіть додаток, а тоді прийміть Умови використання. Якщо потрібно, надайте дозволи. Натисніть  Connect to Printer Go to Wi‑Fi Settings . Підключіть мобільний пристрій до бездротової мережі принтера. Поверніться в додаток, а тоді торкніться опції  Setup Wi-Fi Connection Виберіть мережу Wi-Fi, а тоді введіть пароль мережі. Натисніть  Done . бездротова мережа підключення принтера до підключення принтера до бездротової мережі бездротова мережа"},{"UUID":"9354c112-ce9a-42ce-8113-6b6ab6e4ef44","title":"Мережа","link":"wireless-support-topic.html","desc":"Підключення принтера до бездротової мережі","descFull":"Підключення принтера до бездротової мережі за допомогою стандарту Wi‑Fi Protected Setup (WPS) Перш ніж почати, переконайтеся, що виконано умови нижче. Точка доступу (бездротовий маршрутизатор) має WPS‑сертифікацію та сумісна з WPS. Щоб дізнатися більше, див. документацію, яка постачалася разом із точкою доступу. На вашому принтері встановлено адаптер бездротова мережі. Щоб дізнатися більше, див. вказівки, яка постачалася разом з адаптером. Для параметра  Active Adapter  встановлено значення  Auto . На головному екрані торкніться меню  Settings Network/Ports Network Overview Active Adapter . Використання методу кнопки На головному екрані торкніться меню  Settings Network/Ports Wireless Wi‑Fi Protected Setup Start Push Button Method . Дотримуйтеся вказівок на дисплеї. Використання методу особистого ідентифікаційного номера (PIN-коду) На головному екрані торкніться меню  Settings Network/Ports Wireless Wi‑Fi Protected Setup Start PIN Method . Скопіюйте восьмизначний PIN-код WPS. Відкрийте вебпереглядач і введіть IP-адресу точки доступу в адресному рядку. Щоб дізнатися IP-адресу, див. документацію, яка постачалася разом із точкою доступу. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Відкрийте параметри WPS. Щоб дізнатися більше, див. документацію, яка постачалася разом із точкою доступу. Введіть восьмизначний PIN-код, а тоді збережіть зміни. Wi‑Fi Protected Setup бездротова мережа бездротова мережа Wi‑Fi Protected Setup підключення до бездротової мережі з використанням PIN-коду метод персонального ідентифікаційного номера підключення до бездротової мережі з використанням методу кнопки метод кнопки"},{"UUID":"e3b8f7ae-006c-4a50-b75f-2bffbb337763","title":"Мережа","link":"wireless-support-topic.html","desc":"Налаштування Wi‑Fi Direct Wi-Fi Direct","descFull":"Налаштування Wi‑Fi Direct Wi-Fi Direct  – це однорангова технологія на основі Wi-Fi, яка дає змогу бездротовим пристроям підключатися безпосередньо до принтера з підтримкою Wi-Fi Direct без використання точки доступу (бездротового маршрутизатора). Переконайтеся, що для параметра  Active Adapter  (Активний адаптер) установлено значення  Auto  (Автоматично). На головному екрані торкніться  Settings Network/Ports Network Overview Active Adapter  (Налаштування > Мережа/порти > Перегляд мережі > Активний адаптер). На головному екрані торкніться  Settings Network/Ports Wi-Fi Direct  (Налаштування > Мережа/порти > Wi-Fi Direct). Налаштуйте параметри. Enable Wi‑Fi Direct  (Увімкнути Wi‑Fi Direct): дає змогу принтеру транслювати власну мережу Wi‑Fi Direct. Wi‑Fi Direct Name  (Ім’я Wi‑Fi Direct): призначає ім’я мережі Wi‑Fi. Wi‑Fi Direct Password  (Пароль Wi‑Fi Direct): призначає пароль для узгодження бездротової безпеки під час використання однорангового з’єднання. Show Password on Setup Page  (Відобразити пароль на сторінці параметрів): відображає пароль на сторінці параметрів мережі. Auto-Accept Push Button Requests  (Автоматично приймати запити кнопок): дає принтеру автоматично приймати запити підключення. Автоматичне прийняття запитів кнопок не захищено. За замовчуванням пароль мережі Wi-Fi Direct невидимий на дисплеї принтера. Щоб показати пароль, увімкніть значок відображення пароля. На головному екрані торкніться  Settings Security Miscellaneous Enable Password/PIN Reveal  (Налаштування > Безпека > Різне > Увімкнути показ пароля/PIN-коду). Пароль мережі Wi‑Fi Direct можна відобразити, не показуючи його на дисплеї принтера. На головному екрані торкніться  Settings Reports Network Network Setup Page  (Налаштування > Звіти > Мережа > Сторінка параметрів мережі). Wi‑Fi Direct налаштування налаштування Wi‑Fi Direct"},{"UUID":"5319cf06-cf40-4ead-8a49-3b65f52ff315","title":"Мережа","link":"wireless-support-topic.html","desc":"Підключення мобільного пристрою до принтера","descFull":"Підключення мобільного пристрою до принтера Перш ніж підключати комп’ютер, переконайтеся, що Wi‑Fi Direct налаштовано. Щоб дізнатися більше, див.  . Підключення за допомогою Wi‑Fi Direct Ці вказівки застосовуються лише до мобільних пристроїв Android. На мобільному пристрої перейдіть у меню параметрів. Увімкніть  Wi‑Fi  і натисніть  Wi‑Fi Direct . Виберіть ім’я мережі Wi-Fi Direct принтера. Підтвердьте з’єднання принтера з панеллю керування принтера. Підключення за допомогою Wi‑Fi На мобільному пристрої перейдіть у меню параметрів. Натисніть  Wi‑Fi , а тоді виберіть назву мережі Wi-Fi Direct принтера. Перед назвою Wi‑Fi Direct додається рядок DIRECT-xy (де x та y — два випадкові символи). Введіть пароль Wi-Fi Direct. підключення мобільного пристрою до принтера мобільний пристрій Підключення до принтера Wi‑Fi Direct увімкнення увімкнення Wi‑Fi Direct"},{"UUID":"766c660e-42e4-488e-9a67-f00714fcd373","title":"Мережа","link":"wireless-support-topic.html","desc":"Wi‑Fi Direct Підключення комп’ютера до","descFull":"Wi‑Fi Direct Підключення комп’ютера до принтера Перш ніж підключати комп’ютер, переконайтеся, що Wi‑Fi Direct налаштовано. Щоб дізнатися більше, див.  . Для користувачів Windows Відкрийте папку з принтерами й натисніть  Add a printer or scanner  (Додати принтер або сканер). Натисніть  Show Wi-Fi Direct printers  (Відобразити принтери Wi‑Fi Direct), після чого виберіть ім’я принтера Wi‑Fi Direct. На дисплеї принтера зверніть увагу на восьмизначний PIN-код принтера. Введіть PIN-код на комп’ютері. Якщо драйвер принтера ще не встановлено, тоді Windows завантажить відповідний драйвер. Для користувачів Macintosh Натисніть значок бездротового зв’язку, а тоді виберіть ім’я принтера Wi‑Fi Direct. Перед іменем Wi‑Fi Direct додається рядок DIRECT-xy (де x та y — два випадкові символи). Введіть пароль Wi‑Fi Direct. Перемкніть комп’ютер назад на попередню мережі після відключення від мережі Wi‑Fi Direct. комп’ютер підключення до принтера підключення комп’ютера до принтера"},{"UUID":"052fad75-ee28-46e3-bdcf-20f37a2e35f3","title":"Мережа","link":"wireless-support-topic.html","desc":"Деактивація мережі Wi‑Fi На головному","descFull":"Деактивація мережі Wi‑Fi На головному екрані торкніться меню  Settings Network/Ports Network Overview Active Adapter Standard Network . Дотримуйтеся вказівок на дисплеї. мережа Wi‑Fi деактивація деактивація мережі Wi‑Fi"},{"UUID":"bdeb03d9-790b-49d4-907c-e6f1b21b1334","title":"Мережа","link":"wireless-support-topic.html","desc":"Перевірка підключення принтера На головному","descFull":"Перевірка підключення принтера На головному екрані торкніться меню  Settings Reports Network Network Setup Page . Перегляньте перший розділ сторінки налаштування мережі й підтвердьте статус підключення. Якщо статус «Не підключено», тоді мережа LAN може бути неактивна або мережевий кабель несправний. Зверніться до адміністратора по допомогу. друк сторінка налаштування мережі друк сторінки налаштування мережі сторінка налаштування мережі друк"},{"UUID":"e0e9b3bd-ba79-47c9-baca-bf1326ce3ff9","title":"Захист принтера","link":"locating-security-slot-topic.html","desc":"Розташування гнізда безпеки На принтері","descFull":"Розташування гнізда безпеки На принтері є функція замка безпеки. Додайте замок безпеки, сумісний із більшістю ноутбуків, у показаному місці, щоб зафіксувати принтер. гніздо безпеки розташування розташування гнізда безпеки"},{"UUID":"4472f6d8-7c74-43c6-b3b6-5b13e268caf4","title":"Захист принтера","link":"erasing-printer-memory-topic.html","desc":"Стирання пам'яті принтера Щоб стерти","descFull":"Стирання пам'яті принтера Щоб стерти енергозалежну пам’ять або буферизовані дані на принтері, вимкніть принтер. Щоб стерти енергонезалежну пам’ять, налаштування пристрою та мережі, налаштування безпеки та вбудовані рішення, виконайте такі дії: На головному екрані торкніться  Settings Device Maintenance Out of Service Erase . Установіть прапорець  Sanitize all information on nonvolatile memory  і торкніться  ERASE . Торкніться  Start initial setup wizard  або  Leave printer offline  і торкніться  Next . Розпочніть роботу. Цей процес також знищує ключ шифрування, який використовується для захисту даних користувача. Знищення ключа шифрування робить дані невідновними. енергозалежна пам'ять стирання енергонезалежна пам'ять стирання пам’ять принтера стирання стирання пам’ять принтера"},{"UUID":"bdcdcee6-35bd-4d57-acaf-c079942f60dc","title":"Захист принтера","link":"erasing-printer-storage-drive-topic.html","desc":"Стирання накопичувача принтера На головному","descFull":"Стирання накопичувача принтера На головному екрані торкніться  Settings  (Параметри) Device  (Пристрій) Maintenance  (Обслуговування) Out of Service Erase  (Стирання для виведення з експлуатації). Залежно від накопичувача, встановленого на вашому принтері, виконайте одну з наведених дій. Для жорсткого диска: торкніться прапорця  Sanitize all information on hard disk  (Очистити всю інформацію на жорсткому диску), торкніться  ERASE  (Стерти), а потім виберіть спосіб стирання даних Процес очищення жорсткого диска може тривати від кількох хвилин до більше години, що робить принтер недоступним для інших завдань. Для інтелектуального накопичувача (ISD): торкніться  Erase Intelligent Storage Drive  (Стерти інтелектуальний накопичувач), а потім торкніться  ERASE  (Стерти), щоб стерти всі дані користувача. Розпочніть роботу. накопичувач стирання стирання накопичувача принтера жорсткий диск стирання інтелектуальний накопичувач стирання"},{"UUID":"678337bf-ba99-4f82-9d31-eee68b725b40","title":"Захист принтера","link":"restoring-factory-default-settings-topic.html","desc":"Відновлення заводських параметрів за замовчуванням","descFull":"Відновлення заводських параметрів за замовчуванням На головному екрані торкніться меню  Settings Device Restore Factory Defaults . Торкніться параметра  Restore Settings  виберіть параметри, які потрібно відновити  RESTORE . Розпочніть роботу. заводські параметри за замовчуванням відновлення параметри принтера відновлення заводських параметрів за замовчуванням"},{"UUID":"929ec9dc-d03c-4cff-a207-11a1c97ba987","title":"Захист принтера","link":"statement-of-volatility-topic.html","desc":"Заява про енергозалежність Види пам’яті","descFull":"Заява про енергозалежність Види пам’яті та їх опис Типи пам’яті Опис енергозалежна пам'ять Принтер використовує стандартну оперативну пам’ять (RAM) для тимчасової буферизації даних користувача під час простих завдань друку та копіювання. Енергонезалежна пам'ять Принтер може використовувати дві форми енергонезалежної пам’яті: EEPROM і NAND (флеш-пам’ять). Обидва типи зберігають інформацію про операційну систему, параметри принтера та інформацію про мережу. Вони також зберігають налаштування сканера та закладок, а також вбудовані рішення. Накопичувач на жорсткому диску Деякі принтери можуть мати встановлений жорсткий диск. Жорсткий диск принтера призначений для роботи з конкретними функціями принтера. Жорсткий диск дає змогу принтеру зберігати буферизовані дані користувача зі складних завдань друку, дані форм і дані шрифтів. Інтелектуальний накопичувач (ISD) Деякі принтери можуть мати встановлений ISD. ISD використовує енергонезалежну флеш-пам’ять для зберігання даних користувача зі складних завдань друку, даних форм і даних шрифтів. Видаліть вміст будь-якої встановленої пам’яті принтера за наведених обставин. Принтер виведено з експлуатації. Замінено жорсткий диск принтера або ISD. Принтер переміщено в інший відділ або місце. Принтер обслуговується сторонніми особами. Принтер вилучено з вашого приміщення для обслуговування. Принтер проданий іншій організації. Щоб утилізувати накопичувач, дотримуйтеся правил і процедур вашої організації. заява про енергозалежність енергозалежна пам'ять енергонезалежна пам’ять накопичувач на жорсткому диску інтелектуальний накопичувач стирання пам'яті принтера захист даних принтера"},{"UUID":"5cef1a0c-2ff8-48c0-a355-d9666bd8488e","title":"Друк","link":"printing-from-computer-h2-topic.html","desc":"Друк із комп’ютера Перш ніж","descFull":"Друк із комп’ютера Перш ніж друкувати документ, для міток, карток і конвертів налаштуйте відповідний розмір і тип паперу на принтері. У документі, який ви намагаєтеся надрукувати, відкрийте діалогове вікно «Друк». Якщо потрібно, змініть параметри. Надрукуйте документ. друк з комп’ютера документи, друк з комп’ютера друк із комп’ютера"},{"UUID":"04966a78-5fc8-460c-a8f9-433d3b1cabd6","title":"Друк із мобільного пристрою","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Друк із мобільного пристрою за","descFull":"Друк із мобільного пристрою за допомогою Lexmark Mobile Print Друк із мобільного пристрою за допомогою Lexmark Mobile Print Lexmark  Mobile Print дає змогу надсилати документи й зображення безпосередньо на підтримуваний принтер Lexmark. Відкрийте документ і надішліть документ або надайте доступ до нього через Lexmark Mobile Print. Деякі програми сторонніх розробників можуть не підтримувати функцію надсилання та надання доступу. Щоб дізнатися більше, див. документацію, яку було надано разом із програмою. Виберіть принтер. Надрукуйте документ. Lexmark Mobile Print використання документи, друк з мобільного пристрою мобільний пристрій друк із"},{"UUID":"2f44c94c-1370-410d-bece-09ed8f9dd7af","title":"Друк із мобільного пристрою","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Друк з мобільного пристрою за","descFull":"Друк з мобільного пристрою за допомогою принтера Lexmark Lexmark  Print — це рішення для мобільного друку для мобільних пристроїв під керуванням  Android  6.0 або пізнішої версії. Він дає змогу надсилати документи на зображення на підключені до мережі принтери та сервери керування друком. Переконайтеся, що ви завантажили програму Lexmark Print з магазину  Google Play  і активували його на мобільному пристрої. Переконайтеся, що принтер і комп’ютер підключено до однієї мережі. На мобільному пристрої виберіть документ із файлового менеджера. Надішліть або поділіться документом у Lexmark Print Деякі програми сторонніх розробників можуть не підтримувати функцію надсилання та надання доступу. Щоб дізнатися більше, див. документацію, яку було надано разом із програмою. Виберіть принтер, а потім налаштуйте параметри, якщо необхідно. Надрукуйте документ. Lexmark Print використання документи, друк з мобільного пристрою мобільний пристрій друк із"},{"UUID":"ec5b90ac-97ae-4e40-b0f0-92fb6aeedda7","title":"Друк із мобільного пристрою","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Друк із мобільного пристрою за","descFull":"Друк із мобільного пристрою за допомогою Mopria Print Service Mopria Print Service  — це рішення для друку з мобільних пристрої з ОС  Android  версії 5.0 або новішої. Цей додаток дає змогу друкувати безпосередньо на сертифікований Mopria принтер. Завантажте Mopria Print Service із магазину  Google Play  і ввімкніть додаток на мобільному пристрої. На мобільному пристрої Android запустіть сумісний додаток чи виберіть документ у диспетчері файлів. Натисніть  Print . Виберіть принтер, а потім налаштуйте параметри, якщо необхідно. Натисніть  . Mopria Print Service друк з мобільного пристрою мобільний пристрій друк із друк використання Mopria Print Service"},{"UUID":"0708fb7a-1c4c-4a32-888b-8cc7990365d2","title":"Друк із мобільного пристрою","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Друк із мобільного пристрою за","descFull":"Друк із мобільного пристрою за допомогою AirPrint Програмне забезпечення AirPrint — це рішення для друку з мобільного пристрою, яке дає змогу друкувати безпосередньо з пристроїв Apple на принтер, сертифікований для AirPrint. Переконайтеся, що пристрій Apple і принтер підключені до однієї мережі. Якщо мережа має кілька бездротових станцій, переконайтеся, що обидва пристрої підключені до однієї підмережі. Цей додаток підтримують лише деякі пристрої Apple. На мобільному пристрої виберіть документ із диспетчера файлів або запустіть сумісний додаток. Натисніть  Print . Виберіть принтер, а потім налаштуйте параметри, якщо необхідно. Надрукуйте документ. AirPrint використання друк з мобільного пристрою мобільний пристрій друк із"},{"UUID":"b07f23ca-5af5-494d-90e3-e11a9cf68d7e","title":"Друк із мобільного пристрою","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Друк із мобільного пристрою за","descFull":"Друк із мобільного пристрою за допомогою Wi‑Fi Direct® Wi‑Fi Direct  — це служба друку, яка дає змогу друкувати фото на будь-якому принтері з підтримкою Wi‑Fi Direct. Переконайтеся, що мобільний пристрій підключено до бездротової мережі принтера. Щоб дізнатися більше, див.  . На мобільному пристрої запустіть сумісний додаток чи виберіть документ у диспетчері файлів. Залежно від мобільного пристрою, виконайте одну з дій нижче. Натисніть  Print . Натисніть  Print . Натисніть  Print . Виберіть принтер, а потім налаштуйте параметри, якщо необхідно. Надрукуйте документ. Wi‑Fi Direct друк із мобільного пристрою друк з мобільного пристрою мобільний пристрій друк із друк використання Wi‑Fi Direct"},{"UUID":"b943e7c7-aa24-4e26-adb1-63c060a49b42","title":"Друк","link":"printing-from-flash-drive-topic.html","desc":"Друк із флешнакопичувача Вставте флешнакопичувач.","descFull":"Друк із флешнакопичувача Вставте флешнакопичувач. Якщо вставити флешнакопичувач, коли відображається повідомлення про помилку, принтер ігноруватиме флешнакопичувач. Якщо вставити флешнакопичувач, коли принтер обробляє завдання друку, на дисплеї з’явиться повідомлення  Busy  («Працює»). На дисплеї торкніться документа, який потрібно надрукувати. За потреби налаштуйте параметри друку. Надрукуйте документ. Щоб надрукувати інший документ, торкніться параметра  USB Drive . Щоб уникнути втрати даних чи несправності принтера, не торкайтеся флешнакопичувача чи принтера в показаній ділянці під час активного друку, зчитування з пристрої пам’яті або записування на нього. друк з флешнакопичувача флешнакопичувач друк із"},{"UUID":"81b7103d-6479-40c5-ae7b-cf1746cc7d7e","title":"Друк","link":"supported-flash-drives-and-file-types-topic.html","desc":"Підтримувані флешнакопичувачі та типи файлів","descFull":"Підтримувані флешнакопичувачі та типи файлів Флешнакопичувачі Флешнакопичувачі, які підтримують стандарт USB 2.0 або нижче. Флешнакопичувачі, які підтримують файлову систему нової технології (NFTS) і файлову систему у вигляді таблиці розміщення файлів (FAT32). Типи файлів Підтримувані типи файлів Документи Зображення PDF (версія 1.7 або старіша) Формати файлів Microsoft (DOC, DOCX, XLS, XLSX, PPT, PPTX) JPEG або JPG TIFF або TIF GIF BMP PNG PCX DCX підтримувані флешнакопичувачі підтримувані типи файлів"},{"UUID":"d37e35be-7940-4df7-9cfe-2549048a57c9","title":"Друк","link":"configuring-confidential-jobs-topic.html","desc":"Налаштування конфіденційних завдань На головному","descFull":"Налаштування конфіденційних завдань На головному екрані натисніть  Settings Security Confidential Print Setup . Налаштуйте параметри. Пункти меню  Confidential Print Setup  та їхній опис Параметри Опис Max Invalid PIN Установіть обмеження на введення неправильного PIN-коду. Коли межу досягнуто, завдання на друк для імені цього користувача видаляються. Confidential Job Expiration Встановіть окремий термін дії для кожного затриманого завдання, перш ніж воно буде автоматично видалено з пам’яті принтера, жорсткого диска чи інтелектуального накопичувача. Затримане завдання є  Confidential ,  Repeat ,  Reserve  або  Verify . Repeat Job Expiration Встановіть термін дії для завдань друку, які потрібно повторити. Verify Job Expiration Установіть час закінчення друку копії завдання, щоб перевірити його якість перед друком решти копій. Reserve Job Expiration Встановіть термін дії для завдань, які ви хочете зберегти на принтері для друку пізніше. Require All Jobs to be Held Налаштуйте принтер на збереження всіх завдань друку. Keep duplicate documents Налаштуйте принтер на збереження всіх документів з однаковою назвою файлу. конфіденційні завдання друку налаштування відкладені завдання установлення терміну придатності зберігання завдань друку повторити завдання друку підтвердження завдань друку"},{"UUID":"6a228b91-e142-4e1c-b41e-a614e67b4218","title":"Друк","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"Друк конфіденційних та інших відкладених","descFull":"Друк конфіденційних та інших відкладених завдань Для користувачів Windows Відкрийте документ і натисніть  File Print . Виберіть принтер і натисніть  Properties ,  Preferences ,  Options  або  Setup . Натисніть  Print and Hold . Виберіть  Use Print and Hold , а тоді призначте ім’я користувача. Виберіть тип завдання друку (Confidential, Repeat, Reserve, or Verify). Якщо вибираєте  Confidential , захистіть завдання друку особистим ідентифікаційним номером (PIN-кодом). Натисніть  OK  або  Print . На домашньому екрані принтера випустіть завдання друку. У випадку конфіденційного завдання друку торкніться пункту  Held jobs  виберіть своє ім’я користувача  Confidential  введіть PIN-код   виберіть завдання друку   налаштуйте параметри  Print . Для інших завдань друку торкніться пункту  Held jobs  виберіть ім’я користувача   виберіть завдання друку   налаштуйте параметри  Print . Для користувачів Macintosh За допомогою AirPrint Відкрийте документ і виберіть  File Print . Виберіть принтер, а тоді в спадному меню після меню  Orientation  виберіть  PIN Printing . Увімкніть параметр  Print with PIN  і введіть чотиризначний PIN-код. Натисніть  Print . На домашньому екрані принтера випустіть завдання друку. Торкніться параметра  Held jobs  виберіть ім’я комп’ютера  Confidential  введіть PIN-код   виберіть завдання друку  Print . За допомогою драйвера принтера Відкрийте документ і виберіть  File Print . Виберіть принтер, а тоді в спадному меню після меню  Orientation  виберіть  Print and Hold . Виберіть  Confidential Print , а тоді введіть чотиризначний PIN-код. Натисніть  Print . На домашньому екрані принтера випустіть завдання друку. Торкніться пункту  Held jobs  виберіть ім’я комп’ютера  Confidential  виберіть завдання друку   введіть PIN-код  Print . друк відкладені завдання друк конфіденційні завдання друку конфіденційні завдання друку друк відкладені завдання друк"},{"UUID":"69bc652f-052a-4ad9-80f5-5224fb031a66","title":"Друк","link":"printing-font-sample-list-h2-topic.html","desc":"Друк списку зразків шрифтів На","descFull":"Друк списку зразків шрифтів На головному екрані торкніться меню  Settings  Reports Print Print Fonts . Торкніться пункту  PCL Fonts  або  PS Fonts . друк список зразків шрифтів друк списку зразків шрифтів список зразків шрифтів друк"},{"UUID":"b3dc392d-bafc-462f-a5df-cd0dbf000c8b","title":"Друк","link":"printing-directory-list-h2-topic.html","desc":"Друк списку каталогів На головній","descFull":"Друк списку каталогів На головній сторінці торкніться  Settings  (Параметри) Reports  (Звіти) Print  (Друк) Print Directory  (Друк каталогів). друк список каталогів друк списку каталогів список каталогів друк"},{"UUID":"50b914f8-1aa4-47de-90f3-94b874e2a28b","title":"Друк","link":"placing-separator-sheets-topic.html","desc":"Розміщення аркушів-розділювачів між копіями На","descFull":"Розміщення аркушів-розділювачів між копіями На головному екрані торкніться меню  Settings Print Layout Separator Sheets Between Copies . Надрукуйте документ. аркуші-розділювачі розміщення розміщення аркушів-розділювачів"},{"UUID":"bd3f0908-3906-40f4-bff1-c7b373debe2d","title":"Друк","link":"canceling-print-job-topic.html","desc":"Скасування завдання друку На головному","descFull":"Скасування завдання друку На головному екрані торкніться  . Виберіть завдання, яке потрібно скасувати. Ви можете також скасувати завдання, торкнувшись  Job Queue . завдання друку скасування скасування завдання друку"},{"UUID":"ef43f803-2ed0-437e-81d5-7708cadb748e","title":"Друк","link":"adjusting-toner-darkness-topic.html","desc":"Коригування щільності тонера На головному","descFull":"Коригування щільності тонера На головному екрані торкніться  Settings  (Параметри) Print  (Друк) Quality  (Якість) Toner Darkness  (Щільність тонера). Відкоригуйте параметри. щільність тонера коригування коригування щільності тонера"},{"UUID":"fc9297f3-996a-4ea9-925b-61aa11a0c413","title":"Копіювання","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"Використання автоматичного подавача документів і","descFull":"Використання автоматичного подавача документів і скла сканера Завантаження паперу в лоток пристрою АПД або на скло сканера Автоматичний подавач документів (АПД) Скло сканера Використовуйте АПД для документів із кількох сторінок або двосторонніх документів. Завантажте оригінальний документ лицевою стороною вгору. Для документів із кількох сторінок вирівняйте основний край перед завантаженням. Обов’язково відрегулюйте механізми скерування АПД відповідно до ширини паперу, який ви завантажуєте. Використовуйте скло сканера для односторінкових документів, сторінок книг, невеликих предметів (наприклад, листівок або фотографій), прозорих плівок, фотопаперу або тонких носіїв (наприклад, вирізок із журналів). Розмістіть документ лицевою стороною вниз у куті зі стрілкою. копіювання використання пристрою автоматичної подачі документів (АПД) копіювання використання скла сканера"},{"UUID":"29495570-68ba-43e7-b6a6-fa18a9670a85","title":"Копіювання","link":"making-copies-topic.html","desc":"Виготовлення копій Завантажте оригінальний документ","descFull":"Виготовлення копій Завантажте оригінальний документ у лоток пристрою АПД або на скло сканера. Щоб уникнути обрізання зображення, переконайтеся, що вихідний документ і вихідний мають однаковий розмір паперу. На головному екрані торкніться  Copy , а потім вкажіть кількість копій. За потреби відрегулюйте параметри копіювання. Виконайте копіювання документу. Щоб зробити копію з головної сторінки, торкніться  . виготовлення копій використання пристрою АПД копіювання використання скла сканера копіювання копіювання з вибраний лоток копіювання різних розмірів паперу різний розмір паперу, копіювання"},{"UUID":"20c7a5f1-6e16-43ec-8373-336d53448107","title":"Копіювання","link":"copying-photos-topic.html","desc":"Копіювання фотографій Розташуйте фотографію на","descFull":"Копіювання фотографій Розташуйте фотографію на склі сканера. На головному екрані торкніться  Copy Settings Content Content Type Photo . Торкніться  Content Source  і потім виберіть параметр, що найкраще відповідає оригінальному фото. Зробіть копію фотографії. копіювання фотографії фотографії, копіювання"},{"UUID":"dfcef18b-d27e-4e77-8fc3-5e5f49826618","title":"Копіювання","link":"copying-transparencies-or-letterhead-topic.html","desc":"Копіювання на фірмовому бланку Завантажте","descFull":"Копіювання на фірмовому бланку Завантажте оригінальний документ у лоток пристрою АПД або на скло сканера. На головному екрані торкніться  Copy Copy From виберіть розмір оригінального документа. Торкніться  Copy To , і виберіть джерело паперу, що містить фірмовий бланк. Якщо ви завантажили фірмовий бланк у багатоцільовий подавач, торкніться  Copy To Multipurpose Feeder виберіть розмір паперу Letterhead . Виконайте копіювання документу. копіювання на фірмовому бланку фірмовий бланк копіювання на"},{"UUID":"08f9bc19-1f8d-4feb-a62a-b9057ea88b36","title":"Копіювання","link":"copying-on-both-sides-of-paper-topic.html","desc":"Копіювання на обох сторонах паперу","descFull":"Копіювання на обох сторонах паперу Завантажте оригінальний документ у лоток пристрою АПД або на скло сканера. На головному екрані натисніть  Copy Settings Sides . Торкніться  1 sided to 2 sided  або  2 sided to 2 sided . Виконайте копіювання документу. копіювання на обох сторонах паперу двостороннє копіювання"},{"UUID":"78ac2b3d-5d8b-4580-b08f-1f6de350750f","title":"Копіювання","link":"reducing-enlarging-copies-topic.html","desc":"Зменшення або збільшення розміру копії","descFull":"Зменшення або збільшення розміру копії Завантажте оригінальний документ у лоток пристрою АПД або на скло сканера. На головному екрані торкніться  Copy Settings Scale і виберіть значення масштабу. Зміна розміру вихідного документа або вихідного документа після налаштування  Scale  повертає значення масштабу на  Auto . Виконайте копіювання документу. зменшення розміру копії збільшення розміру копії"},{"UUID":"b25d3d5e-4261-4f38-ad99-56812a0e0dcc","title":"Копіювання","link":"collating-copies-topic.html","desc":"Розбирання за копіями Завантажте оригінальний","descFull":"Розбирання за копіями Завантажте оригінальний документ у лоток пристрою АПД або на скло сканера. На головному екрані торкніться  Copy  (Копіювання) Collate  (Розбирання за копіями) On [1,2,1,2,1,2]  (Увімк. [1,2,1,2,1,2]). Виконайте копіювання документу. pозбирання за копіями pозбирання за копіями кількох копій"},{"UUID":"a7ba65e7-095d-45c4-a207-4bbc0133dc75","title":"Копіювання","link":"placing-separator-sheets-between-copies-topic.html","desc":"Розміщення аркушів-розділювачів між копіями Завантажте","descFull":"Розміщення аркушів-розділювачів між копіями Завантажте оригінальний документ у лоток пристрою АПД або на скло сканера. На панелі керування перейдіть до меню: Copy  (Копіювання) Settings  (Параметри) Separator Sheets (Аркуші-розділювачі) відкоригуйте параметри Виконайте копіювання документу. копіювання роздільні аркуші між копіями розміщення аркушів-розділювачів між копіями"},{"UUID":"1e9b049e-7788-44fb-a04f-ea4100d3e8ed","title":"Копіювання","link":"saving-paper-topic.html","desc":"Копіювання кількох сторінок на один","descFull":"Копіювання кількох сторінок на один аркуш Завантажте оригінальний документ у лоток пристрою АПД або на скло сканера. На головному екрані натисніть  Copy Settings Pages per Side . Увімкніть параметри та виберіть кількість сторінок на одну сторону аркуша та орієнтацію паперу. Виконайте копіювання документу. копіювання кількох сторінок на один аркуш економія паперу"},{"UUID":"e2eed34f-034a-45d6-b4c6-b88e64c9454d","title":"Копіювання","link":"copying-cards-topic.html","desc":"Копіювання карток Розмістіть картку на","descFull":"Копіювання карток Розмістіть картку на склі сканера. На головному екрані торкніться  Card Copy  (Копія картки). За потреби змініть параметри сканування. Торкніться  Scan  (Сканувати). Якщо ви хочете отримати кілька копій картки, торкніться  Print a Copy  (Надрукувати копію). копіювання карток налаштування"},{"UUID":"dc128ae4-c9f3-4389-8cc6-a3bed4c1fdb6","title":"Копіювання","link":"creating-copy-shortcut-topic.html","desc":"Створення ярлика копіювання На головному","descFull":"Створення ярлика копіювання На головному екрані торкніться параметра  Copy . Налаштуйте параметри, а тоді торкніться  . Створіть ярлик. створення ярлика копіювання додавання ярлика копіювання ярлик, створення копіювання"},{"UUID":"8fc1f9bf-a20c-42ce-8b9f-cf1ca68cfd8c","title":"Електронна пошта","link":"using-ADF-and-scanner-glass-e-mail-topic.html","desc":"Використання автоматичного подавача документів і","descFull":"Використання автоматичного подавача документів і скла сканера Завантаження паперу в лоток пристрою АПД або на скло сканера Автоматичний подавач документів (АПД) Скло сканера Використовуйте АПД для документів із кількох сторінок або двосторонніх документів. Завантажте оригінальний документ лицевою стороною вгору. Для документів із кількох сторінок вирівняйте основний край перед завантаженням. Обов’язково відрегулюйте механізми скерування АПД відповідно до ширини паперу, який ви завантажуєте. Використовуйте скло сканера для односторінкових документів, сторінок книг, невеликих предметів (наприклад, листівок або фотографій), прозорих плівок, фотопаперу або тонких носіїв (наприклад, вирізок із журналів). Розмістіть документ лицевою стороною вниз у куті зі стрілкою. надсилання електронних листів використання пристрою автоматичної подачі документів (АПД) надсилання електронних листів використання скла сканера"},{"UUID":"e7891560-67b5-4aec-a491-f2ec37d51141","title":"Електронна пошта","link":"sending-email-topic.html","desc":"Надсилання електронної пошти Перш ніж","descFull":"Надсилання електронної пошти Перш ніж почати, переконайтеся, що параметри SMTP налаштовано. Щоб дізнатися більше, див.  . Завантажте оригінальний документ у лоток пристрою АПД або на скло сканера. На головному екрані торкніться опції  E-mail , а тоді введіть потрібну інформацію. За потреби відрегулюйте параметри сканування. Надсилання електронної пошти. електронна пошта надсилання надсилання електронної пошти"},{"UUID":"bb14f632-a621-4a54-bce0-7c31522437c1","title":"Електронна пошта","link":"creating-email-shortcut-topic.html","desc":"Створення ярлика електронного листа На","descFull":"Створення ярлика електронного листа На головному екрані торкніться параметра  E‑mail . Налаштуйте параметри, а тоді торкніться  . Створіть ярлик. створення ярлика електронний лист додавання ярлика електронний лист ярлик, створення електронний лист ярлик електронного листа створення"},{"UUID":"51bf7c79-42ce-4753-b10a-7e491e6221ec","title":"Факс","link":"using-ADF-and-scanner-glass-fax-topic.html","desc":"Використання автоматичного подавача документів і","descFull":"Використання автоматичного подавача документів і скла сканера Завантаження паперу в лоток пристрою АПД або на скло сканера Автоматичний подавач документів (АПД) Скло сканера Використовуйте АПД для документів із кількох сторінок або двосторонніх документів. Завантажте оригінальний документ лицевою стороною вгору. Для документів із кількох сторінок вирівняйте основний край перед завантаженням. Обов’язково відрегулюйте механізми скерування АПД відповідно до ширини паперу, який ви завантажуєте. Використовуйте скло сканера для односторінкових документів, сторінок книг, невеликих предметів (наприклад, листівок або фотографій), прозорих плівок, фотопаперу або тонких носіїв (наприклад, вирізок із журналів). Розмістіть документ лицевою стороною вниз у куті зі стрілкою. надсилання факсу використання пристрою автоматичної подачі документів (АПД) надсилання факсу використання скла сканера"},{"UUID":"8ad20eca-f69f-437b-aa12-ccf98dec8b3e","title":"Факс","link":"sending-fax-topic.html","desc":"Надсилання факсу Переконайтеся, що факс","descFull":"Надсилання факсу Переконайтеся, що факс налаштовано. Додаткову інформацію див. у розділі  Налаштування принтера для факсу . Використання панелі керування Завантажте оригінальний документ у лоток пристрою АПД або на скло сканера. На головному екрані торкніться опції  Fax , а тоді введіть потрібну інформацію. Якщо потрібно, змініть параметри. Надішліть факс. Використання комп’ютера Перш ніж почати, переконайтеся, що встановлено драйвер факсу. Щоб дізнатися більше, див.  . Для користувачів Windows У документі, який ви намагаєтеся надіслати факсом, відкрийте діалогове вікно  Print . Виберіть принтер і натисніть  Properties ,  Preferences ,  Options , or  Setup . Натисніть меню  Fax Enable fax Always display settings prior to faxing , а тоді введіть номер отримувача. За потреби налаштуйте інші параметри факсу. Надішліть факс. Для користувачів Macintosh Відкрийте документ і виберіть  File Print . Виберіть принтер, до назви якого додано слово  ‑ Fax . У полі  To  введіть номер отримувача. За потреби налаштуйте інші параметри факсу. Надішліть факс. надсилання факсу факс надсилання"},{"UUID":"eaaac002-57d5-4ebb-86d5-b8929cbb6ea1","title":"Факс","link":"scheduling-fax-topic.html","desc":"Планування факсу Переконайтеся, що факс","descFull":"Планування факсу Переконайтеся, що факс налаштовано. Додаткову інформацію див. у розділі  Налаштування принтера для факсу . Завантажте оригінальний документ у лоток пристрою АПД або на скло сканера. На головному екрані натисніть  Fax To щоб увести номер факсу Done . Торкніться  Send Time , налаштуйте дату й час і торкніться  Done . Надішліть факс. планування факсу планування факсів"},{"UUID":"cf56af16-8043-4c21-85f1-616ffd93ca64","title":"Факс","link":"creating-fax-destination-shortcut-topic.html","desc":"Створення ярлика адресата факсу Переконайтеся,","descFull":"Створення ярлика адресата факсу Переконайтеся, що факс налаштовано. Додаткову інформацію див. у розділі  Налаштування принтера для факсу . На головному екрані торкніться параметра  Fax To . Введіть номер отримувача, а тоді торкніться параметра  Done . Налаштуйте параметри, а тоді торкніться  . Створіть ярлик. створення ярлика адресат факсу додавання ярлика адресат факсу ярлик, створення адресат факсу ярлик адресата факсу створення"},{"UUID":"7638b013-e22f-4bef-92ed-470f02d04a62","title":"Факс","link":"changing-fax-resolution-topic.html","desc":"Зміна роздільної здатності факсу Переконайтеся,","descFull":"Зміна роздільної здатності факсу Переконайтеся, що факс налаштовано. Додаткову інформацію див. у розділі  Налаштування принтера для факсу . Завантажте оригінальний документ у лоток пристрою АПД або на скло сканера. На головному екрані торкніться опції  Fax , а тоді введіть потрібну інформацію. Торкніться  Settings Resolution і виберіть параметри. Надішліть факс. роздільна здатність факсу зміна зміна роздільної здатності факсу"},{"UUID":"5d5e5174-1481-4704-9c25-4da6ee34ae82","title":"Факс","link":"adjusting-fax-darkness-topic.html","desc":"Регулювання затемнення факсу Переконайтеся, що","descFull":"Регулювання затемнення факсу Переконайтеся, що факс налаштовано. Додаткову інформацію див. у розділі  Налаштування принтера для факсу . Завантажте оригінальний документ у лоток пристрою АПД або на скло сканера. На головному екрані торкніться опції  Fax , а тоді введіть потрібну інформацію. Торкніться  Settings Darkness і відрегулюйте параметри. Надішліть факс. регулювання затемнення факсу затемнення факсу регулювання"},{"UUID":"fd2683d6-792a-406d-b343-b870394bd5b2","title":"Факс","link":"printing-fax-log-topic.html","desc":"Друк журналу факсів Переконайтеся, що","descFull":"Друк журналу факсів Переконайтеся, що факс або etherFAX налаштовано. Додаткову інформацію див. у розділі  Налаштування передавання факсів на принтері . Переконайтеся, що факс налаштовано. Додаткову інформацію див. у розділі  Налаштування передавання факсів на принтері . На головному екрані торкніться  Settings  (Параметри) Reports  (Звіти) Fax  (Факс). Торкніться  Fax Job Log  (Журнал факсимільних завдань) або  Fax Call Log  (Журнал факсимільних викликів). журнал факсів друк друк журнал факсів"},{"UUID":"d289635f-c636-4235-aec1-b1befb39651e","title":"Факс","link":"blocking-junk-faxes-topic.html","desc":"Блокування не6ажаних факсів Переконайтеся, що","descFull":"Блокування не6ажаних факсів Переконайтеся, що факс або etherFAX налаштовано. Додаткову інформацію див. у розділі  Налаштування передавання факсів на принтері . Переконайтеся, що факс налаштовано. Додаткову інформацію див. у розділі  Налаштування передавання факсів на принтері . На головному екрані торкніться  Settings  (Параметри) Fax  (Факс) Fax Setup  (Налаштування факсу) Fax Receive Settings  (Параметри отримання факсів) Admin Controls  (Елементи керування адміністратора). Установіть для параметра  Block No Name Fax  (Блокувати факси від невідомих відправників) значення  On  (Увімк.). небажані факси блокування блокування небажаних факсів"},{"UUID":"3fe71cbe-202b-4d08-a7a9-da3bdf0a53e0","title":"Факс","link":"holding-faxes-topic.html","desc":"Відкладення факсів Переконайтеся, що факс","descFull":"Відкладення факсів Переконайтеся, що факс або etherFAX налаштовано. Додаткову інформацію див. у розділі  Налаштування передавання факсів на принтері . Переконайтеся, що факс налаштовано. Додаткову інформацію див. у розділі  Налаштування передавання факсів на принтері . На головному екрані торкніться  Settings  (Параметри) Fax  (Факс) Fax Setup  (Налаштування факсу) Fax Receive Settings  (Параметри отримання факсів) Holding Faxes  (Відкладення факсів). Виберіть режим. відкладення факсів отримані факси відкладення"},{"UUID":"569568d2-f13a-43d0-bac9-8a67a7b37c56","title":"Факс","link":"forwarding-fax-topic.html","desc":"Пересилання факсу Переконайтеся, що факс","descFull":"Пересилання факсу Переконайтеся, що факс або etherFAX налаштовано. Додаткову інформацію див. у розділі  Налаштування передавання факсів на принтері . Переконайтеся, що факс налаштовано. Додаткову інформацію див. у розділі  Налаштування передавання факсів на принтері . Створення ярлика цільового розташування. Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані. IP-адреса відображається у вигляді чотирьох наборів цифр, розділених крапками, наприклад 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Shortcuts  (Ярлики) Add Shortcut  (Додати ярлик). Виберіть тип ярлика, а тоді налаштуйте параметри. Зверніть увагу на номер ярлика. Застосуйте зміни. Натисніть  Settings  (Параметри) Fax  (Факс) Fax Setup  (Налаштування факсу) Fax Receive Settings  (Параметри отримання факсів) Admin Controls  (Елементи керування адміністратора). У меню  Fax Forwarding  (Пересилання факсів) виберіть  Forward  (Переслати) або  Print and Forward  (Роздрукувати й переслати). У меню  Forward to  (Переслати до) виберіть тип адресата й введіть номер ярлика. Застосуйте зміни. пересилання факсу"},{"UUID":"b946ca71-5f79-451b-8fdf-96dbcaab174b","title":"Сканування","link":"using-ADF-and-scanner-glass-scan-topic.html","desc":"Використання автоматичного подавача документів і","descFull":"Використання автоматичного подавача документів і скла сканера Завантаження паперу в лоток пристрою АПД або на скло сканера Автоматичний подавач документів (АПД) Скло сканера Використовуйте АПД для документів із кількох сторінок або двосторонніх документів. Завантажте оригінальний документ лицевою стороною вгору. Для документів із кількох сторінок вирівняйте основний край перед завантаженням. Обов’язково відрегулюйте механізми скерування АПД відповідно до ширини паперу, який ви завантажуєте. Використовуйте скло сканера для односторінкових документів, сторінок книг, невеликих предметів (наприклад, листівок або фотографій), прозорих плівок, фотопаперу або тонких носіїв (наприклад, вирізок із журналів). Розмістіть документ лицевою стороною вниз у куті зі стрілкою. сканування використання пристрою автоматичної подачі документів (АПД) сканування використання скла сканера"},{"UUID":"da955e6b-9814-437d-9ae4-6e0028a86e3f","title":"Сканування","link":"scanning-to-computer-topic.html","desc":"Сканування на комп’ютер Перед тим,","descFull":"Сканування на комп’ютер Перед тим, як почати, переконайтеся, що принтер і комп’ютер підключено до однієї мережі. Для користувачів Windows Використання утиліти Lexmark ScanBack На комп’ютері запустіть утиліту Lexmark ScanBack, а потім натисніть  Next  (Далі). Щоб завантажити утиліту, перейдіть на сайт  www.lexmark.com/downloads . Натисніть  Setup  (Налаштування) і додайте IP-адресу принтера. Перегляньте IP-адресу принтера на головному екрані принтера. IP-адреса відображається як чотири набори цифр, розділених крапкою, як-от 123.123.123.123. Натисніть  Close Next  (Закрити > Далі). Виберіть розмір оригінального документа й натисніть  Next  (Далі). Виберіть формат файлу та роздільну здатність для сканування і натисніть  Next  (Далі). Введіть унікальне ім’я профілю сканування та натисніть  Next  (Далі). Перейдіть до місця, де потрібно зберегти відсканований документ, створіть ім’я файлу й натисніть  Next  (Далі). Для повторного використання профілю сканування ввімкніть параметр  Create Shortcut  (Створити ярлик) і потім створіть унікальне ім’я ярлика. Натисніть  Finish  (Завершити). Завантажте оригінальний документ в автоматичний подавач паперу або на скло сканера. На головному екрані торкніться  Scan Profiles Scan to Computer  (Профіль сканування > Сканувати на комп’ютер) і виберіть профіль сканування. Для користувачів Windows Використання служби «Факси й сканування Windows» Переконайтеся, щоб принтер був доданий до комп’ютера. Щоб дізнатися більше, див.  . Завантажте оригінальний документ в автоматичний подавач паперу або на скло сканера. На комп’ютері відкрийте службу  Факси й сканування Windows . Натисніть  New Scan  (Нове сканування) і виберіть джерело сканування. За потреби змініть параметри сканування. Відскануйте документ. Натисніть  Save as  (Зберегти як), введіть ім’я файлу й натисніть  Save  (Зберегти). Для користувачів Macintosh Переконайтеся, щоб принтер був доданий до комп’ютера. Щоб дізнатися більше, див.  . Завантажте оригінальний документ в автоматичний подавач паперу або на скло сканера. На комп’ютері виконайте одну з наведених дій. Відкрийте програму  Image Capture  (Фотоприймач). Відкрийте параметри  Printers & Scanners  (Принтери та сканери) і виберіть принтер. Натисніть  Scan Open Scanner  (Сканування > Відкрити сканер). У вікні  Scanner  (Сканер) виконайте одну або кілька з наведених нижче дій. Виберіть розташування, де ви хочете зберігати відскановані документи. Виберіть розмір оригінального документу. Для сканування з пристрою АПД, виберіть  Document Feeder  (Пристрій автоматичного подавання документів) у меню  Scan Menu  (Меню сканування) або ввімкніть параметр  Use Document Feeder  (Використовувати пристрій автоматичного подавання документів). За потреби відрегулюйте параметри сканування. Натисніть  Scan  (Сканування). сканування на комп’ютер комп’ютер, сканування на Утиліта Lexmark ScanBack"},{"UUID":"2f782dc1-7f21-4516-ae9e-e17568beb3fd","title":"Сканування","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"Сканування на сервер FTP Вставте","descFull":"Сканування на сервер FTP Вставте оригінальний документ у лоток АПД або на скло для сканування. На головному екрані торкніться опції  FTP , а тоді введіть потрібну інформацію. За потреби налаштуйте інші параметри FTP. Надішліть завдання FTP. сканування на FTP-сервер за допомогою панелі керування сканування на сервер FTP сканування на сервер FTP за допомогою панелі керування"},{"UUID":"25cb3447-5d7d-4722-8201-82afe9006e7f","title":"Сканування","link":"creating-FTP-shortcut-topic.html","desc":"Створення ярлика FTP На головному","descFull":"Створення ярлика FTP На головному екрані торкніться параметра  FTP . Введіть адресу сервера FTP, а тоді торкніться  . Створіть ярлик. створення ярлика адреса FTP додавання ярлика адреса FTP адреса FTP створення ярлика ярлик, створення адреса FTP"},{"UUID":"699296fd-f0cd-458e-b5d2-9573470b98d0","title":"Сканування","link":"s2a-scanning-to-network-folders-topic.html","desc":"Сканування в мережеву папку Завантажте","descFull":"Сканування в мережеву папку Завантажте документ у лоток ADF або помістіть на скло для сканування. На головному екрані торкніться параметра  Scan Center . Піктограма та назва могли бути змінені. Для отримання додаткової інформації зверніться до свого адміністратора. Виконайте одну з дій нижче. Виберіть цільове розташування. Для протоколу SFTP налаштуйте номер порту  22 . Використовуйте ярлик. Для цього торкніться значка  , а тоді виберіть ярлик зі списку. Відскануйте документ. сканування в мережеву папку SMB сканування"},{"UUID":"aaae4a7f-7713-4953-91da-da881b269c0c","title":"Сканування","link":"creating-network-folder-shortcut-topic.html","desc":"Створення ярлика мережевої папки Відкрийте","descFull":"Створення ярлика мережевої папки Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані принтера. IP-адреса відображається як чотири набори цифр, розділених крапкою, як-от 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Shortcuts Add Shortcut . У меню «Тип ярлика» виберіть  Network Folder , а тоді налаштуйте параметри. Застосуйте зміни. мережева папка створення ярлика створення ярлика мережева папка"},{"UUID":"fcef888e-1b2f-4737-8145-3aa167aecec1","title":"Сканування","link":"scanning-to-flash-drive-topic.html","desc":"Сканування на флешнакопичувач Завантажте оригінальний","descFull":"Сканування на флешнакопичувач Завантажте оригінальний документ у лоток пристрою АПД або на скло сканера. Вставте флешнакопичувач. Торкніться параметра  Scan to USB  і за потреби коригуйте параметри. Щоб зберегти відсканований документ у папку, торкніться параметра  Scan to , виберіть папку та торкніться пункту  Scan Here . Якщо екран  USB Drive  не відображається, торкніться параметра  USB Drive  на панелі керування. Відскануйте документ. Щоб уникнути втрати даних чи несправності принтера, не торкайтеся флешнакопичувача чи принтера в показаній ділянці під час активного друку, зчитування з пристрої пам’яті або записування на нього. сканування на флешнакопичувач флешнакопичувач сканування на"},{"UUID":"b0c84869-fb25-4463-9ba1-fe4d5b2e5497","title":"Використання меню принтера","link":"menu-map-mfp-topic.html","desc":"Карта меню 1  З’являється","descFull":"Карта меню 1  З’являється лише в Embedded Web Server. 2  З’являється, лише якщо встановлено жорсткий диск або інтелектуальний накопичувач. Device  (Пристрій) Preferences  (Налаштування) Eco‑Mode  (Еко-режим) Remote Operator Panel  (Віддалена панель оператора) Notifications  (Сповіщення) Power Management  (Керування живленням) Anonymous Data Collection  (Збір анонімних даних) Accessibility  (Cпеціальні можливості) Restore Factory Defaults  (Відновлення заводських налаштувань) Maintenance  (Обслуговування) Home Screen Customization 1  (Налаштування головного екрана 1) Update Firmware  (Оновлення мікропрограми) About this Printer  (Відомості про цей принтер) Print  (Друк) Layout  (Макет) Setup  (Налаштування) Quality  (Якість) Job Accounting  (Звіт щодо завдання) PDF PostScript PCL Image  (Зображення) Paper  (Папір) Tray Configuration  (Конфігурація лотків) Media Configuration  (Конфігурація носіїв) Copy  (Копіювання) Copy Defaults  (Параметри копіювання за замовчуванням) Fax  (Факс) Fax Defaults  (Параметри факсу за замовчуванням) E‑mail  (Електронна пошта) E‑mail Setup  (Налаштування електронної пошти) E‑mail Defaults  (Параметри електронної пошти за замовчуванням) Web Link Setup  (Налаштування вебпосилання) FTP FTP Defaults  (Параметри FTP за замовчуванням) USB Drive  (USB-накопичувач) Flash Drive Scan  (Сканування флешнакопичувача) Flash Drive Print  (Друк із флешнакопичувача) Network/Ports  (Мережа/порти) Network Overview  (Огляд мережі) Wireless  (Бездротовий зв’язок) Wi‑Fi Direct AirPrint Mobile Services Management  (Керування мобільними службами) Ethernet TCP/IP SNMP IPSec 802.1x LPD Configuration  (Конфігурація LPD) HTTP/FTP Settings  (Налаштування HTTP/FTP) ThinPrint USB Restrict external network access  (Обмеження доступу до зовнішньої мережі) Security  (Безпека) Login Methods  (Способи входу) Schedule USB Devices  (Планування USB-пристроїв) Security Audit Log  (Журнал аудиту безпеки) Login Restrictions  (Обмеження входу) Confidential Print Setup  (Налаштування конфіденційного друку) Disk Encryption  (Шифрування диска) Erase Temporary Data Files  (Стерти тимчасові файли даних) Solutions LDAP Settings  (Параметри LDAP рішень) Miscellaneous  (Різне) Cloud Services  (Хмарні служби) Cloud Services Enrollment  (Реєстрація в хмарних службах) Reports  (Звіти) Menu Settings Page  (Сторінка налаштувань меню) Device  (Пристрій) Print  (Друк) Shortcuts  (Ярлики) Fax  (Факс) Network  (Мережа) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку) Cleaning the Scanner  (Очищення сканера) Forms Merge 2  (Злиття форм 2) Forms Merge  (Злиття форм) меню принтера"},{"UUID":"99579b1f-b097-48f7-a9aa-710d550bd2d8","title":"Пристрій","link":"preferences-topic.html","desc":"Preferences  (Налаштування) Елементи меню","descFull":"Preferences  (Налаштування) Елементи меню  Preferences   (Налаштування) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Display Language  (Мова відображення) [Список мов] Встановіть мову тексту, що відображається на дисплеї. Country/Region  (Країна/регіон) [Список країн або регіонів] Визначте країну або регіон, де принтер налаштований для роботи. Run initial setup  (Запуск початкового налаштування) Off * (Вимк.) On  (Увімк.) Запустіть майстер налаштування. Keyboard  (Клавіатура) Keyboard Type  (Тип клавіатури) [Список мов] Виберіть мову як тип клавіатури. Усі значення  Keyboard Type  (Типу клавіатури) можуть не відображатися, або для відображення може знадобитися спеціальне обладнання. Displayed information  (Відображена інформація) Display Text 1  (Текст відображення 1) ( IP Address *) (IP-адреса) Display Text 2  (Текст відображення 2) ( Date/Time *) (Дата/час) Custom Text 1  (Настроюваний текст 1) Custom Text 2  (Настроюваний текст 1) Вкажіть інформацію, яка має відображатися на головному екрані. Date and Time  (Дата й час) Configure  (Налаштувати) Current Date and Time  (Поточні дата й час) Manually Set Date and Time  (Вручну встановіть дату й час) Date Format  (Формат дати) (MM‑ДД‑РРРР*) Time Format  (Формат часу) (12 годин A.M./P.M.*) Time Zone  (Часовий пояс) UTC (GMT) Offset  (UTC (GMT) зміщення) DST Start  (Початок DST) DST End  (Завершення DST) DST Offset  (Зміщення DST) Network Time Protocol  (Протокол часу мережі) Enable NTP  (Увімкнути DHCP) ( On *) (Увімк.) NTP Server  (Сервер NTP) Enable Authentication  (Увімкнути автентифікацію)( None * (Немає)) Key ID  (Ключовий ідентифікатор) Password  (Пароль) Налаштуйте дату й час принтера та мережевий протокол часу. Заводське налаштування за замовчуванням для США —  MM‑ DD‑YYYY  (MM‑ДД‑РРРР). Міжнародне заводське значення за замовчуванням —  DD-MM-YYYY  (ДД-ММ-РРРР). UTC (GMT) Offset  (Зміщення UTC (GMT)),  DST Start  (Початок DST),  DST End  (Завершення DST) і  DST Offset  (Зміщення DST) відображаються, тільки якщо для параметра  Time Zone  (Часовий пояс) встановлено значення  (UTC+user) Custom  (Користувацький (UTC+користувач)). Параметри  Key ID  (Ключовий ідентифікатор) і  Password  (Пароль) відображаються, тільки якщо для параметра  Enable Authentication  (Увімкнути автентифікацію) встановлено значення  MD5 key  (Ключ MD5). Paper Sizes  (Розміри паперу) U.S. * (США) Metric  (Метрична система) Укажіть одиниці вимірювання розмірів паперу. Країна або регіон, вибраний у майстрі початкового налаштування, визначає початковий параметр розміру паперу. Screen Brightness  (Яскравість екрана) 20–100% (100*) Відрегулюйте яскравість дисплея. Flash Drive Access  (Доступ до флешнакопичувача) Disabled  (Вимкнено) Enabled * (Увімкнено)* Увімкніть доступ до флешнакопичувача. Allow Background Removal  (Дозволити видалення фону) Off  (Вимк.) On * (Увімк.) Укажіть, чи дозволено видаляти фон. Allow Custom Job scans  (Дозволити сканування користувацьких завдань) Off  (Вимк.) On * (Увімк.) Укажіть, чи відображатиметься параметр  Custom Job Scanning  (Сканування користувацьких завдань) для копіювання, сканування та факсу. Цей пункт меню з’являється, лише якщо встановлено жорсткий диск або інтелектуальний накопичувач. One Page Flatbed Scanning  (Односторінкове сканування на планшетному сканері) Off * (Вимк.) On  (Увімк.) Налаштуйте принтер на сканування будь-якого типу завдання зі склом сканера як однієї сторінки. Принтер повертається на головний екран після виконання одного планшетного сканування замість відображення підказок. Device Sounds  (Звуки пристрою) Mute All Sounds  (Вимкнути всі звуки) ( Off * (Вимк.)) Button Feedback  (Відповідь кнопки) ( On * (Увімк.)) Volume  (Гучність) (5*) ADF Loaded Beep  (Сигнал завантаження АПД) ( On * (Увімк.)) Alarm Control  (Керування сповіщенням) ( Single * (Один раз)) Cartridge Alarm  (Сповіщення картриджа) ( Off * (Вимк.)) Speaker Mode  (Режим динаміка) ( Always Off *) (Завжди вимк.)* Ringer Volume  (Гучність набору) ( Off *) (Вимк.) Налаштуйте параметри звуку принтера. Screen Timeout  (Час очікування екрана) 5–300 секунд (60*) Встановіть час простою в секундах до того, як на дисплеї відобразиться головний екран або до того, як принтер автоматично вийде з облікового запису користувача. меню Preferences  (Налаштування)"},{"UUID":"8b9fc35e-7c7b-4efe-9f8a-72fb2124e1d0","title":"Пристрій","link":"preferences-topic.html","desc":"Eco-Mode (Еко-режим) Елементи меню ","descFull":"Eco-Mode (Еко-режим) Елементи меню  Eco-Mode  (Еко-режим) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Print  (Друк) Sides  (Боки) 1‑Sided * (1 бік) 2‑Sided  (2 боки) Укажіть, чи потрібно друкувати на одному чи обох боках паперу. Print  (Друк) Pages per Side  (Сторінок на одному боці) Off * (Вимк.) 2 pages per side  (2 сторінки на одному боці) 3 pages per side  (3 сторінки на одному боці) 4 pages per side  (4 сторінки на одному боці) 6 pages per side  (6 сторінок на одному боці) 9 pages per side  (9 сторінок на одному боці) 12 pages per side  (12 сторінок на одному боці) 16 pages per side  (16 сторінок на одному боці) Надрукуйте зображення кількох сторінок на одному боці аркуша паперу. Print  (Друк) Toner Darkness  (Щільність тонера) 1–10 (8*) Визначте освітленість або затемненість текстових зображень. Copy  (Копіювання) Sides  (Боки) 1 sided to 1 sided * (1 бік на 1 бік) 1 sided to 2 sided  (1 бік на 2 боки) 2 sided to 1 sided  (2 боки на 1 бік) 2 sided to 2 sided  (2 боки на 2 боки) Укажіть параметри сканування залежно від оригінального документа. Copy  (Копіювання) Pages per Side  (Сторінок на одному боці) Off * (Вимк.) 2 Portrait pages  (2 портретні сторінки) 4 Portrait pages  (4 портретні сторінки) 2 Landscape pages  (2 альбомні сторінки) 4 Landscape pages  (4 альбомні сторінки) Укажіть параметри сканування залежно від оригінального документа. Copy  (Копіювання) Darkness  (Щільність) 1–9 (5*) Визначте щільність друку зображень у відсканованому тексті. меню Eco‑Mode  (Еко-режим)"},{"UUID":"d11d39d4-b83e-4c6b-b745-b4850449cc2c","title":"Пристрій","link":"preferences-topic.html","desc":"Remote Operator Panel Пункти меню","descFull":"Remote Operator Panel Пункти меню  Remote Operator Panel  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. External VNC Connection Don’t Allow * Allow Під’єднати зовнішній клієнт протоколу Virtual Network Computing (VNC) до віддаленої панелі керування. Authentication Type None * Standard Authentication Під час отримання доступу до сервера клієнта VNC установіть тип автентифікації. VNC Password Указати пароль, щоб під’єднатися до сервера клієнта VNC. Цей пункт меню відображається, лише якщо для параметра  Authentication Type  встановлено значення  Standard Authentication . меню Віддалена панель оператора"},{"UUID":"2260db6e-f42d-4e04-8f7b-09659e93004c","title":"Пристрій","link":"preferences-topic.html","desc":"Notifications  (Сповіщення) Елементи меню","descFull":"Notifications  (Сповіщення) Елементи меню  Notifications  (Сповіщення) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. ADF Loaded Beep  (Сигнал завантаження АПД) Off  (Вимк.) On * (Увімк.) Увімкніть звук під час завантаження паперу в АПД. Alarm Control  (Керування звуковими сигналами) Off  (Вимк.) Single * (Одноразово) Continuous  (Повторювано) Установіть кількість звукових сигналів, коли принтер потребує втручання користувача. Supplies  (Витратні матеріали) Show Supply Estimates  (Показувати приблизну кількість витратних матеріалів) Show estimates * (Показувати приблизну кількість) Do not show estimates  (Не показувати приблизну кількість) Показати приблизний стан запасів. Supplies  (Витратні матеріали) Cartridge Alarm  (Звуковий сигнал картриджа) Off * (Вимк.) Single  (Одноразово) Continuous  (Повторювано) Установіть кількість звукових сигналів, коли картридж із тонером порожній. Supplies  (Витратні матеріали) Custom Supply Notifications  (Користувацькі сповіщення про витратні матеріали) Налаштуйте параметри сповіщень, коли принтер вимагає втручання користувача. Цей пункт меню з’являється лише у Embedded Web Server. E‑mail Alerts Setup  (Налаштування сповіщень електронної пошти) Primary SMTP Gateway  (Основний шлюз SMTP) Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) (25*) Secondary SMTP Gateway  (Допоміжний шлюз SMTP-сервера) Secondary SMTP Gateway Port  (Порт додаткового шлюзу SMTP-сервера) (25*) SMTP Timeout  (Тайм-аут SMTP-сервера) (30 секунд*) Reply Address  (Зворотна адреса) Always use SMTP default Reply Address  (Завжди використовувати стандартну адресу SMTP-сервера для відповіді) ( Off *) (Вимк.) Use SSL/TLS  (Використовувати SSL/TLS) ( Disabled *) (Вимк.) Require Trusted Certificate  (Вимагати довірений сертифікат) ( On *) (Увімк.) SMTP Server Authentication  (Автентифікація на сервері SMTP) ( No authentication required *) (Автентифікація не потрібна) Device‑Initiated E‑mail  (Електронна пошта, ініційована пристроєм) ( None *) (Немає) User‑Initiated E‑mail  (Електронна пошта, ініційована користувачем) ( None *) (немає) Use Active Directory Device Credentials  (Використовувати облікові дані активного каталогу) ( Off *) (Вимк.) Device Userid  (Ідентифікатор користувача пристрою) Device Password  (Пароль до пристрою) Kerberos 5 REALM NTLM Domain  (NTLM-домен) Disable “SMTP server not set up” error  (Вимкнути помилку «SMTP-сервер не налаштовано».) ( Off *) (Вимк.) Налаштувати принтер на надсилання сповіщень електронною поштою списку контактів, коли принтер потребує втручання користувача. E‑mail Alerts Setup  (Налаштування сповіщень електронної пошти) Setup E‑mail Lists and Alerts  (Налаштування списків електронних листів та сповіщень) E‑mail List 1  (Список електронних листів 1) E‑mail List 2  (Список електронних листів 2) Subject Text  (Текст теми) E‑mail Events  (Події електронної пошти) Укажіть адреси електронної пошти та ввімкніть події сповіщень електронною поштою. Цей пункт меню з’являється лише у Embedded Web Server. Error Prevention  (Запобігання помилкам) Jam Assist  (Допомога при зминанні) Off  (Вимк.) On * (Увімк.) Налаштуйте принтер на автоматичне очищення порожніх сторінок або сторінок із частковим друком після видалення зім’ятої сторінки. Error Prevention  (Запобігання помилкам) Auto Continue  (Автоматичне продовження) Enabled  (Увімкнено) 5–255 (5*) Дозвольте принтеру автоматично продовжувати обробку або друк завдання після очищення певних умов відвідування. Error Prevention  (Запобігання помилкам) Auto Reboot  (Автоматичне перезавантаження) Auto Reboot  (Автоматичне перезавантаження) Reboot when idle  (Перезавантажити під час простою) Reboot always * (Перезавантажувати в будь-який час) Reboot never  (Ніколи не перезавантажувати) Налаштуйте принтер на перезапуск у разі виникнення помилки. Error Prevention  (Запобігання помилкам) Auto Reboot  (Автоматичне перезавантаження) Max Auto Reboots  (Максимальна кількість автоматичних перезавантажень) 1–20 (2*) Встановіть кількість автоматичних перезавантажень, які може виконувати принтер. Error Prevention  (Запобігання помилкам) Auto Reboot  (Автоматичне перезавантаження) Auto Reboot Window  (Вікно автоматичного перезавантаження) 1–525600 (720*) Встановіть кількість секунд до автоматичного перезавантаження принтера. Error Prevention  (Запобігання помилкам) Auto Reboot  (Автоматичне перезавантаження) Auto Reboot Counter  (Лічильник автоматичного перезавантаження) Показати доступну лише для читання інформацію лічильника перезавантаження. Error Prevention  (Запобігання помилкам) Auto Reboot  (Автоматичне перезавантаження) Reset Auto Reboot Counter  (Скинути лічильник автоматичного перезавантаження) Cancel  (Скасувати) Continue  (Продовжити) Скинути значення  Auto Reboot Counter  (Лічильника автоматичного перезавантаження). Error Prevention  (Запобігання помилкам) Display Short Paper Error  (Відображати помилку короткого паперу) On  (Увімк.) Auto‑clear * (Автоматичне очищення) Налаштуйте принтер на відображення повідомлення, коли виникає помилка короткого паперу. Короткий папір означає розмір завантаженого паперу. Error Prevention  (Запобігання помилкам) Page Protect  (Захист сторінки) Off * (Вимк.) On  (Увімк.) Налаштуйте принтер на обробку всієї сторінки в пам’яті перед її друком. Jam Content Recovery  (Відновлення вмісту зім’ятої сторінки) Jam Recovery  (Відновлення після зминання) Off  (Вимк.) On  (Увімк.) Auto * (Автоматично) Налаштуйте принтер на повторний друк зім’ятих сторінок. Jam Content Recovery  (Відновлення вмісту зім’ятої сторінки) Scanner Jam Recovery  (Усунення зминання сканера) Job level  (Рівень завдання) Page level * (Рівень сторінки) Укажіть, як перезапустити завдання сканування після усунення зминання паперу. меню Notifications  (Сповіщення)"},{"UUID":"d234e95a-94d1-42e6-9876-fa892f74462d","title":"Пристрій","link":"preferences-topic.html","desc":"Power Management Пункти меню ","descFull":"Power Management Пункти меню  Power Management  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Sleep Mode Profile Print from Sleep Mode Stay awake after printing Enter Sleep Mode after printing * Налаштувати принтер залишатись активним чи переходити в режим сну після друку. Sleep Mode Profile Touch to Wake from Deep Sleep Off On * Активувати принтер із глибокого сну дотиком до дисплею принтера. Timeouts Sleep Mode 1–114 хвилин (15*) Установити час неактивності, перш ніж принтер почне роботу в режимі сну. Timeouts Hibernate Timeout Disabled 1 hour 2 hours 3 hours 6 hours 1 day 2 days 3 days * 1 week 2 weeks 1 month Установити час до вимкнення принтера. Timeouts Hibernate Timeout on Connection Hibernate Do Not Hibernate * Установити параметр  Hibernate Timeout , щоб вимикати принтер за наявності активного з’єднання Ethernet. Schedule Power Modes Schedules Add New Schedule Запланувати перехід принтера в режим сну або гібернації. меню Power Management"},{"UUID":"b444b25e-469d-4b1b-ba5e-42b229f7b7e6","title":"Пристрій","link":"preferences-topic.html","desc":"Anonymous Data Collection  (Збір","descFull":"Anonymous Data Collection  (Збір анонімних даних) Елементи меню  Anonymous Data Collection  (Збір анонімних даних) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Anonymous Data Collection  (Збір анонімних даних) Device Usage and Performance Information  (Інформація про використання пристрою та його продуктивність) None * (Немає) Надсилайте інформацію про використання та продуктивність принтера в Lexmark. Надсилайте інформацію про використання та продуктивність принтера виробнику. Anonymous Data Send Time  (Час надсилання анонімних даних) відображається лише в тому разі, якщо для параметра  Anonymous Data Collection  (Збір анонімних даних) установлено значення  Device Usage and Performance Information  (Інформація про використання пристрою та його продуктивність). Anonymous Data Send Time  (Час надсилання анонімних даних) Start Time  (Час початку) Stop Time  (Час припинення) меню Anonymous Data Collection  (Збір анонімних даних)"},{"UUID":"6474317d-b517-490d-b8e4-bf86488841ce","title":"Пристрій","link":"preferences-topic.html","desc":"Accessibility  (Cпеціальні можливості) Пункти","descFull":"Accessibility  (Cпеціальні можливості) Пункти меню спеціальних можливостей та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Duplicate Key Strike Interval  (Інтервал між повторним натисканням клавіші) 0–5 (0*) Налаштувати інтервал у секундах, протягом якого принтер ігноруватиме подвійні натискання клавіші на приєднаній клавіатурі. Key Repeat Initial Delay  (Початкова затримка перед повтором клавіші) 0,25–5 (1*) Налаштувати інтервал тривалості затримки в секундах, перш ніж клавіша повтору почне повторювати. Key Repeat Rate  (Частота повтору клавіші) 0,5–30 (30*) Налаштувати кількість натискань на секунду для клавіші повтору. Prolong Screen Timeout  (Продовжити час очікування екрана) Off * (Вимк.) On  (Увімк.) Дозволити користувачу залишатися в тому самому місці та скинути таймер  Screen Timeout  (Час очікування екрана), коли час спливе, щоб не повертатися на головний екран. Headphone Volume  (Гучність навушників) 1–10 (5*) Відрегулювати гучність навушників. Enable Voice Guidance When Headphone Is Attached  (Увімкнути голосові підказки, коли до принтера приєднано навушники) Off * (Вимк.) On  (Увімк.) Увімкнути голосові підказки, коли до принтера приєднано навушники. Speak Passwords/PINs  (Озвучувати паролі/PIN-коди) Off * (Вимк.) On  (Увімк.) Налаштувати принтер зачитувати паролі й персональні ідентифікаційні номери. Speech Rate  (Темп мовлення) Very Slow  (Дуже повільний) Slow  (Повільний) Normal * (Звичайний) Fast  (Швидкий) Faster  (Пришвидшений) Very Fast  (Дуже швидкий) Rapid  (Стрімкий) Very Rapid  (Дуже стрімкий) Fastest  (Найшвидший) Налаштувати швидкість озвучення голосових підказок меню Accessibility  (Cпеціальні можливості)"},{"UUID":"22b6602e-302d-4393-a66e-8538443012ff","title":"Пристрій","link":"preferences-topic.html","desc":"Restore Factory Defaults Пункт меню","descFull":"Restore Factory Defaults Пункт меню  Restore Factory Defaults  і його опис Елемент меню Опис Restore Settings Restore all settings Restore printer settings Restore network settings Restore fax settings Restore app settings Відновити заводські параметри принтера. меню Restore Factory Defaults"},{"UUID":"9226df1e-845e-4443-b44e-6283b5b6fade","title":"Технічне обслуговування","link":"preferences-topic.html","desc":"Configuration Menu (Меню конфігурації) Configuration","descFull":"Configuration Menu (Меню конфігурації) Configuration Menu  (Меню конфігурації) Елементи  Configuration Menu  (Меню конфігурації) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. USB Configuration  (Конфігурація USB) USB PnP 1* 2 Змінити режим USB-драйвера принтера, щоб покращити його сумісність із персональним комп’ютером. USB Configuration  (Конфігурація USB) USB Scan to Local  (Сканування USB на локальний) On * (Увімк.) Off  (Вимк.) Указати, чи драйвер USB-пристрою числиться як простий USB-пристрій (один інтерфейс) чи як USB-складений пристрій (кілька інтерфейсів). USB Configuration  (Конфігурація USB) USB Speed  (Швидкість USB) Full  (Повна) Auto * (Автоматично) Налаштуйте порт USB на повну швидкість і вимкніть його високошвидкісні можливості. Tray Configuration  (Конфігурація лотків) Tray Linking  (Зв’язування лотків) Automatic * (Автоматично) Off  (Вимк.) Налаштувати принтер на з’єднання лотків із однаковими параметрами типу та розміру паперу. Tray Configuration  (Конфігурація лотків) Show Tray Insert Message  (Показати повідомлення про вставляння лотка) Off  (Вимк.) Only for unknown sizes * (Лише для невідомих розмірів) Always  (Завжди) Відобразити повідомлення, яке дає змогу користувачу змінити параметри розміру та типу паперу після вставлення лотка. Tray Configuration  (Конфігурація лотків) A5 Loading  (Завантаження A5) Short Edge * (Короткий край) Long Edge  (Довгий край) Визначити стандартну орієнтацію завантаження паперу розміру A5 у всіх джерелах паперу. Tray Configuration  (Конфігурація лотків) Paper Prompts  (Запити паперу) Auto * (Автоматично) Multipurpose Feeder  (Багатоцільовий подавач) Manual Paper  (Ручне завантаження паперу) Встановити джерело паперу, яке користувач заповнює, коли з’являється запит на завантаження паперу. Щоб пункт  Multipurpose Feeder  (Багатоцільовий подавач) з’явився в меню  Paper  (Папір), установіть для параметра  Configure MP  (Налаштувати MP) значення  Cassette  (Касета). Tray Configuration  (Конфігурація лотків) Envelope Prompts  (Запити конвертів) Auto * (Автоматично) Multipurpose Feeder  (Багатоцільовий подавач) Manual Envelope  (Ручне завантаження конверта) Установіть джерело паперу, яке користувач заповнює, коли з’являється запит на завантаження конверта. Щоб пункт  Multipurpose Feeder  (Багатоцільовий подавач) з’явився в меню  Paper  (Папір), установіть для параметра  Configure MP  (Налаштувати MP) значення  Cassette  (Касета). Tray Configuration  (Конфігурація лотків) Action for Prompts  (Дії для запитів) Prompt user * (Запит користувача) Continue  (Продовжити) Use current  (Використовувати поточний) Налаштуйте принтер на реагування на запити щодо змін, пов’язаних із папером або конвертом. Tray Configuration  (Конфігурація лотків) Multiple Universal Sizes  (Кілька універсальних розмірів) Off * (Вимк.) On  (Увімк.) Налаштувати лоток на підтримку декількох універсальних розмірів паперу. Reports  (Звіти) Menu Settings Page  (Сторінка налаштувань меню) Event Log  (Журнал подій) Event Log Summary  (Зведення журналу подій) Друк звітів про параметри меню принтера, стан і журнали подій. Supply Usage And Counters  (Використання витратних матеріалів і лічильники) Clear Supply Usage History  (Очистити історію використання витратних матеріалів) Скинути історію використання витратних матеріалів, наприклад, кількості сторінок і днів, що залишилися, до заводського рівня. Supply Usage And Counters  (Використання витратних матеріалів і лічильники) Reset Maintenance Counter  (Скинути лічильник обслуговування) Обнулити лічильник після встановлення нового комплекту для обслуговування. Printer Emulations  (Емуляції принтера) PPDS Emulation  (Емуляція PPDS) Off * (Вимк.) On  (Увімк.) Налаштувати принтер на розпізнавання та використання потоку даних PPDS. Printer Emulations  (Емуляції принтера) PS Emulation  (Емуляції PS) Off  (Вимк.) On * (Увімк.) Налаштувати принтер на розпізнавання та використання потоку даних PS. Printer Emulations  (Емуляції принтера) Use Native ISD Fonts  (Використовувати рідні шрифти ISD) Off * (Вимк.) On  (Увімк.) Дозвольте принтеру використовувати власні або безкоштовні шрифти в інтелектуальному накопичувачі (ISD) для друку. Printer Emulations  (Емуляції принтера) Enable Formsmerge  (Увімкнути злиття форм) Off  (Вимк.) On * (Увімк.) Активуйте злиття форм, щоб зберігати форми на жорсткому диску або інтелектуальному накопичувачі (ISD). Необхідно встановити ліцензію на злиття форм. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Printer Emulations  (Емуляції принтера) Enable Prescribe  (Увімкнути вказівки) Off * (Вимк.) On  (Увімк.) Активувати функцію Prescribe. Необхідно встановити ліцензію Prescribe. Printer Emulations  (Емуляції принтера) Emulator Security  (Безпека емулятора) Page Timeout  (Час очікування сторінки) 0–60 (60*) Установити час очікування сторінки під час емуляції. Printer Emulations  (Емуляції принтера) Emulator Security  (Безпека емулятора) Reset Emulator After Job  (Скинути емулятор після завершення завдання) Off * (Вимк.) On  (Увімк.) Скидання емулятора після завдання друку. Printer Emulations  (Емуляції принтера) Emulator Security  (Безпека емулятора) Disable Printer Message Access  (Вимкнути доступ до повідомлень принтера) Off  (Вимк.) On * (Увімк.) Вимкнення доступу до повідомлення принтера під час емуляції. Fax Configuration  (Конфігурація факсу) Fax Low Power Support  (Підтримка низької потужності факсу) Disable Sleep  (Вимкнути режим сну) Permit Sleep  (Дозволити режим сну) Auto * (Автоматично) Налаштувати факс для переходу в сплячий режим щоразу, коли принтер визначає, що це потрібно. Fax Configuration  (Конфігурація факсу) Fax Storage Location  (Розташування сховища факсу) NAND Disk * (Диск) Встановити місце зберігання для всіх факсів. Цей пункт меню з’являється, лише якщо встановлено інтелектуальний накопичувач (ISD). Print Configuration  (Конфігурація принтера) Font Sharpening  (Збільшення різкості шрифту) 0–150 (24*) Установити значення розміру тексту в пунктах, нижче якого використовуватимуться високочастотні екрани під час друку даних шрифту. Наприклад, якщо значення дорівнює 24, тоді всі шрифти розміром 24 пунктів або менше використовують високочастотні екрани. Print Configuration  (Конфігурація принтера) Print Density  (Щільність друку) Disabled  (Вимкнено) 1–5 (3*) Відрегулювати щільність тонера під час друку документів. Print Configuration  (Конфігурація принтера) Copy Density  (Щільність копії) Disabled  (Вимкнено) 1–5 (3*) Відрегулювати щільність тонера під час копіювання документів. Device Operations  (Операції принтера) Quiet Mode  (Тихий режим) Off * (Вимк.) On  (Увімк.) Установити принтер на роботу у режимі  Quiet Mode  (Тихий режим). Увімкнення цього параметра сповільнює загальну продуктивність принтера. Device Operations  (Операції принтера) Safe Mode  (Безпечний режим) Off * (Вимк.) On  (Увімк.) Налаштувати принтер на роботу в спеціальному режимі, в якому він намагатиметься продовжувати пропонувати якомога більше функцій, незважаючи на відомі проблеми. Наприклад, якщо встановлено  On  (Увімк.) і двигун дуплексного блока не працює, принтер виконує односторонній друк документів навіть за наявності завдання двостороннього друку. Device Operations  (Операції принтера) Minimum Copy Memory  (Мінімальна пам'ять для копій) 20 Мб* 30 Мб 50 Мб 80 Мб 100 Мб Установити мінімальний розподіл пам’яті для збереження завдань копіювання. Device Operations  (Операції принтера) Clear Custom Status  (Очистити користувацький статус) Стерти визначені користувачем рядки для користувацьких повідомлень  Default  (За замовчуванням) або  Alternate  (Альтернативні). Device Operations  (Операції принтера) Clear all remotely‑installed messages  (Очистити всі віддалено встановлені повідомлення) Видаляти повідомлення, що було встановлено віддалено. Device Operations  (Операції принтера) Automatically Display Error Screens  (Автоматично відображати екрани з помилками) Off  (Вимк.) On * (Увімк.) Відображати наявні повідомлення про помилки на дисплеї після того, як принтер залишається неактивним на головному екрані протягом тривалого часу. Device Operations  (Операції принтера) Honor orientation on fast path copy  (Зважати на орієнтацію на швидке копіювання) Off * (Вимк.) On  (Увімк.) Увімкнути принтер для використання налаштування орієнтації в меню  Copy  (Копіювання) під час надсилання завдань швидкого копіювання. App Configuration  (Конфігурація програми) LES Applications  (Програми LES) Off  (Вимк.) On * (Увімк.) Увімкнути програми Lexmark Embedded Solutions (LES). Scanner Configuration  (Конфігурація сканера) Scanner Manual Registration  (Ручна реєстрація сканера) Print Quick Test  (Швидка перевірка друку) Роздрукувати цільову сторінку швидкого тесту. Переконатися, що інтервали полів на цільовій сторінці однакові по всьому об’єму. Якщо ні, тоді поля принтера потрібно скинути. Scanner Configuration  (Конфігурація сканера) Scanner Manual Registration  (Ручна реєстрація сканера) Front ADF Registration  (Реєстрація переднього пристрою АПД) Rear ADF Registration  (Реєстрація заднього пристрою АПД) Flatbed Registration  (Реєстрація планшетного сканера) Зареєструвати планшетний сканер і пристрій АПД вручну після заміни АПД, скла сканера або плати контролера. Scanner Configuration  (Конфігурація сканера) Reset Maintenance Counter  (Скинути лічильник обслуговування) Скинути лічильник після заміни набору для обслуговування пристрою АПД. Scanner Configuration  (Конфігурація сканера) Edge Erase  (Стирати краї) Flatbed Edge Erase  (Стирати краї планшетного сканера) (3*) ADF Edge Erase  (Стирати краї пристрою АПД) (3*) Установити розмір (у міліметрах) зони, що не друкується, навколо завдання сканування пристрою АПД або планшетного сканера. Scanner Configuration  (Конфігурація сканера) Disable Scanner  (Вимкнути сканер) No * (Ні) Yes  (Так) ADF Only  (Лише пристрій АПД) Вимкнути сканер, якщо він не працює належним чином. Scanner Configuration  (Конфігурація сканера) Tiff Byte Order  (Порядок байтів Tiff) CPU Endianness * (Порядок байтів ЦП) Little Endian  (Малий порядок байтів) Big Endian  (Великий порядок байтів) Установити порядок байтів результату сканування у форматі TIFF. Scanner Configuration  (Конфігурація сканера) Exact Tiff Rows Per Strip  (Точна кількість рядків Tiff на смугу) On * (Увімк.) Off  (Вимк.) Установити значення тегу RowsPerStrip для результату сканування у форматі TIFF. меню Configuration Menu  (Меню конфігурації)"},{"UUID":"2e2748a4-626b-4214-81d1-9767d6959095","title":"Технічне обслуговування","link":"preferences-topic.html","desc":"Out of Service Erase ","descFull":"Out of Service Erase   (Стирання для виведення з експлуатації) Пункти меню  Out of Service Erase   (Стирання для виведення з експлуатації) та їхній опис Елемент меню Опис Out of Service Erase   (Стирання для виведення з експлуатації) Memory Last Sanitized  (Останнє очищення пам’яті) Hard Disk Last Sanitized  (Останнє очищення жорсткого диска) ISD last erased  (Останнє стирання ISD) Відображати доступну лише для читання інформацію про те, коли востаннє було очищено пам’ять принтера чи накопичувач. Hard Disk Last Sanitized  (Останнє очищення жорсткого диска) і  ISD last erased  (Останнє стирання ISD) відображаються лише тоді, коли встановлено накопичувач. Out of Service Erase   (Стирання для виведення з експлуатації) Sanitize all information on nonvolatile memory  (Очистити всю інформацію в енергонезалежній пам’яті) Erase all printer and network settings  (Стерти всі параметри принтера та мережі) Erase all apps and app settings  (Стерти всі програми та параметри програм) Erase all shortcuts and shortcut settings  (Стерти всі ярлики та параметри ярликів) Sanitize all information on hard disk  (Очистити всю інформацію на жорсткому диску) Erase downloads (Erase all macros, fonts, PFOs, etc.)  (Стерти завантаження: усі макроси, шрифти, PFO тощо) Erase buffered jobs  (Стерти буферизовані завдання) Erase Held jobs  (Стерти відкладені завдання) Erase Intelligent Storage Drive  (Стерти дані інтелектуального накопичувача) Очистити всю інформацію з енергонезалежної пам’яті та накопичувача. Sanitize all information on hard disk  (Очистити всю інформацію на жорсткому диску) і  Erase Intelligent Storage Drive  (Стерти дані інтелектуального накопичувача) відображаються лише тоді, коли встановлено накопичувач. меню Out of Service Erase   (Стирання для виведення з експлуатації)"},{"UUID":"8ed7deaa-23e7-46aa-961c-5e2ffae59199","title":"Пристрій","link":"preferences-topic.html","desc":"Home Screen Customization  (Налаштування","descFull":"Home Screen Customization  (Налаштування головного екрана) Це меню з’являється лише у Embedded Web Server. Пункт меню  Home Screen Customization  (Налаштування головного екрана) і його опис. Меню Опис Copy  (Копіювання) E-mail  (Електронна пошта) Fax  (Факс) Held Faxes  (Відкладені факси) Release Held Faxes  (Випустити відкладені факси) Status/Supplies  (Стан/Витратні матеріали) Job Queue  (Черга завдань) Settings  (Параметри) Change Language  (Змінити мову) Address Book  (Адресна книга) Bookmarks  (Закладки) Held Jobs  (Відкладені завдання) USB Drive  (USB-накопичувач) FTP Scan Profiles  (Профілі сканування) Lock Device  (Блокувати пристрій) Scan Center  (Центр сканування) Card Copy  (Копія картки) Shortcut Center  (Центр ярликів) Вкажіть піктограми, які мають відображатися на головному екрані. меню Home Screen Customization  (Налаштування головного екрана)"},{"UUID":"074cf16e-4095-471b-8242-b86fd4d67946","title":"Пристрій","link":"preferences-topic.html","desc":"Update firmware  (Оновлення мікропрограми)","descFull":"Update firmware  (Оновлення мікропрограми) Елементи меню  Update firmware  (Оновлення мікропрограми) і їхній опис Елемент меню Опис Current Version  (поточна версія) Показати поточну версію мікропрограми, встановленої на принтері. Check for updates now  (Перевірити на наявність оновлень) Перевірити на наявність оновлення мікропрограми. Auto check for updates  (Автоматична перевірка наявності оновлень) Налаштуйте принтер на автоматичну перевірку наявності оновлень мікропрограми. меню Update Firmware  (Оновлення мікропрограми)"},{"UUID":"3636e354-7093-4113-a1e7-c08721a30f43","title":"Пристрій","link":"preferences-topic.html","desc":"About this Printer Пункти меню","descFull":"About this Printer Пункти меню  About this Printer  та їхній опис Елемент меню Опис Asset Tag Указати ідентифікаційну інформацію принтера. Максимальна довжина — 32 символи. Printer’s Location Указати розташування принтера. Максимальна довжина — 63 символи. Contact Указати контактні дані принтера. Максимальна довжина — 63 символи. Firmware Version Показувати версію мікропрограми, встановленої на принтері. Engine Показувати номер двигуна принтера. Serial Number Показувати серійний номер принтера. Export Configuration File to USB Експортувати файл конфігурації на флешнакопичувач. Export Compressed Logs to USB Експортувати стиснуті файли журналу на флешнакопичувач. Send Logs Надіслати інформацію з журналу принтера компанії Lexmark. меню About this Printer"},{"UUID":"fba6bdd1-a654-4489-b89b-3e1cfcec3d93","title":"Друк","link":"layout-topic.html","desc":"Layout  (Макет) Елементи меню","descFull":"Layout  (Макет) Елементи меню  Layout  (Макет) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Sides  (Боки) 1‑Sided * (1 бік) 2‑Sided  (2 боки) Укажіть, чи друкувати на одному чи на обох боках паперу. Flip Style  (Стиль перевертання) Long Edge * (Довгий край) Short Edge  (Короткий край) Визначте, який бік паперу скріплюється під час виконання двостороннього друку. Blank Pages  (Пусті сторінки) Print  (Друк) Do Not Print * (Не друкувати) Друкувати пусті сторінки, які включено в завдання друку. Collate  (Розбирання за копіями) Off (1,1,1,2,2,2)  (Вимк. 1,1,1,2,2,2) On (1,2,1,2,1,2) * (Увімк. 1,2,1,2,1,2) Стежте за тим, щоб сторінки завдання друку складалися послідовно, особливо під час друку кількох копій завдання. Separator Sheets  (Аркуші-розділювачі) None * (Немає) Between Copies  (Між копіями) Between Jobs  (Між завданнями) Between Pages  (Між сторінками) Вставляти пусті аркуші-розділювачі під час друку. Separator Sheet Source  (Джерело аркуша-розділювача) Tray  (Лоток) [x] (1*) Multipurpose Feeder  (Багатоцільовий подавач) Укажіть джерело паперу для аркуша-розділювача Pages per Side  (Сторінок на одному боці) Off * (Вимк.) 2 pages per side  (2 сторінки на одному боці) 3 pages per side  (3 сторінки на одному боці) 4 pages per side  (4 сторінки на одному боці) 6 pages per side  (6 сторінок на одному боці) 9 pages per side  (9 сторінок на одному боці) 12 pages per side  (12 сторінок на одному боці) 16 pages per side  (16 сторінок на одному боці) Надрукуйте зображення кількох сторінок на одному боці аркуша паперу. Pages per Side Ordering  (Упорядкування сторінок на одному боці) Horizontal * (Горизонтальне) Reverse Horizontal  (Зворотне горизонтальне) Vertical  (Вертикальне) Reverse Vertical  (Зворотне вертикальне) Укажіть розташування зображень кількох сторінок під час використання меню  Pages per Side  (Сторінок на стороні). Pages per Side Orientation  (Орієнтація сторінок на одному боці) Auto * (Автоматично) Landscape  (Альбомна) Portrait  (Портретна) Укажіть орієнтацію зображень кількох сторінок під час використання меню  Pages per Side  (Сторінок на одному боці). Pages per Side Border  (Сторінок на бічне поле) None * (Немає) Solid  (Суцільно) Друкуйте поле навколо кожного зображення сторінки під час використання меню  Pages per Side  (Сторінок на одному боці). Copies  (Копії) 1–9999 (1*) Указати кількість копій для кожного завдання друку. Print Area  (Область друку) Normal * (Звичайна) Whole Page  (Ціла сторінка) Налаштувати область друку на аркуші паперу. меню Layout  (Макет)"},{"UUID":"aef93a47-ba8c-48bd-9a5d-1cef016a9236","title":"Друк","link":"layout-topic.html","desc":"Setup  (Налаштування) Елементи меню","descFull":"Setup  (Налаштування) Елементи меню  Setup  (Налаштування) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Printer Language  (Мова принтера) PCL Emulation  (Емуляція PCL) PS Emulation  (Емуляції PS) Установити мову принтера. Установлення мови принтера за замовчуванням не заважає програмі надсилати завдання друку, які використовують іншу мову принтера. Job Waiting  (Очікування завдання) Off * (Вимк.) On  (Увімк.) Зберігайте завдання друку, для яких потрібні витратні матеріали, щоб можна було друкувати завдання, для яких не потрібні витратні матеріали. Це меню з’являється, лише якщо встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Job Hold Timeout  (Час очікування відкладення завдання) 0 – 255  ( 30 *) Установіть час у секундах, протягом якого принтер очікує втручання користувача, перш ніж відкласти завдання, які потребують недоступних ресурсів. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Download Target  (Завантажити ціль) RAM * (Оперативна пам’ять) Disk  (Диск) Укажіть, де зберігати всі постійні ресурси, завантажені на принтер. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Resource Save  (Збереження ресурсу) Off * (Вимк.) On  (Увімк.) Визначте, що принтер робить із завантаженими ресурсами, коли отримує завдання, яке потребує більше місця, ніж доступна пам’ять. Якщо встановлено значення  Off  (Вимк.), принтер зберігає завантажені ресурси лише доти, доки не знадобиться пам’ять. Ресурси, пов’язані з неактивною мовою принтера, видаляються. Якщо встановлено значення  On  (Увімк.), принтер зберігає всі постійні завантажені ресурси для всіх перемикачів мови. За потреби принтер показує повідомлення про заповнення пам’яті замість видалення постійних ресурсів. Print All Order  (Друкувати всю послідовність) Alphabetical * (В алфавітному порядку) Newest First  (Спочатку найновіші) Oldest First  (Спочатку найдавніші) Укажіть порядок, коли ви вибираєте друк усіх відкладених і конфіденційних завдань. меню Setup  (Налаштування)"},{"UUID":"e87b5fa8-1b0a-442a-9e29-c8bbcf4c79d7","title":"Друк","link":"layout-topic.html","desc":"Quality  (Якість) Елементи меню","descFull":"Quality  (Якість) Елементи меню  Quality  (Якість) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Print Resolution  (Роздільна здатність друку) 600 dpi 1200 зображення Q * 2400 зображення Q 1200 dpi 300 dpi Установіть роздільну здатність для друку. Pixel Boost  (Підсилення пікселів) Off * (Вимк.) Fonts * (Шрифти) Horizontally  (Горизонтально) Vertically  (Вертикально) Both directions  (Обидва напрямки) Увімкніть більше пікселів для друку в кластерах для чіткості, покращення зображень по горизонталі чи вертикалі або покращення шрифтів. Toner Darkness  (Щільність тонера) Від 1 до 10 (8*) Визначте освітленість або затемненість текстових зображень. Halftone  (Напівтон) Normal * (Звичайний) Detail  (Деталізація) Покращуйте друкований результат, щоб отримати плавніші лінії з гострішими краями. Brightness  (Яскравість) Від ‑6 до 6 (0*) Коригуйте результат друку, освітливши або затемнивши його. Contrast  (Контрастність) Від 0 до 5 (0*) Відрегулюйте контрастність надрукованих об’єктів. Gray Correction  (Корекція сірого) Off  (Вимк.) Auto * (Автоматично) Увімкніть алгоритм корекції сірого кольору на принтері для надрукованих зображень із середнім рівнем сірого. меню Quality  (Якість)"},{"UUID":"86722e99-6cbb-4c49-b2ab-da8c5fbb501d","title":"Друк","link":"layout-topic.html","desc":"Job Accounting  (Звіт щодо","descFull":"Job Accounting  (Звіт щодо завдання) Елементи меню  Job Accounting  (Звіт щодо завдання) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Job Accounting  (Звіт щодо завдання) Off * (Вимк.) On  (Увімк.) Налаштуйте принтер на створення журналу завдань друку, які він отримує. Accounting Log Frequency  (Частота журналу звітів) Daily  (Щодня) Weekly  (Щотижня) Monthly * (Щомісяця) Укажіть, як часто принтер створюватиме файл журналу. Log Action at End of Frequency  (Дії журналу наприкінці періоду частоти) None * (Немає) E‑mail Current Log  (Надіслати електронною поштою поточний журнал) E‑mail & Delete Current Log  (Надіслати електронною поштою та видалити поточний журнал) Post Current Log  (Опублікувати поточний журнал) Post & Delete Current Log  (Опублікувати та видалити поточний журнал) Укажіть, як принтер реагує, коли досягається порогове значення частоти. Значення, визначене в  Accounting Log Frequency  (Частота журналу звітів) визначає, коли запускається ця дія. Log Near Full Level  (Журнал при майже повному заповненні) Off  (Вимк.) On * (Увімк.) (5) Укажіть максимальний розмір файлу журналу, перш ніж принтер виконає дію  Log Action at Near Full  (Журнал при майже повному заповненні). Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Log Action at Near Full  (Дія журналу при майже повному заповненні) None * (Немає) E‑mail Current Log  (Надіслати електронною поштою поточний журнал) E‑mail & Delete Current Log  (Надіслати електронною поштою та видалити поточний журнал) E‑mail & Delete Oldest Log  (Надіслати електронною поштою та видалити найдавніший журнал) Post Current Log  (Опублікувати поточний журнал) Post & Delete Current Log  (Опублікувати та видалити поточний журнал) Post & Delete Oldest Log  (Опублікувати та видалити найдавніший журнал) Delete Current Log  (Видалити поточний журнал) Delete Oldest Log  (Видалити найдавніший журнал) Delete All But Current  (Видалити всі, крім поточного) Delete All Logs  (Видалити всі журнали) Укажіть, як принтер реагує, коли жорсткий диск або ISD майже заповнені. Значення, визначене в  Log Near Full Level (Журнал при майже повному заповненні) , визначає, коли запускається ця дія. Log Action at Full  (Дія журналу при повному заповненні) None * (Немає) E‑mail & Delete Current Log  (Надіслати електронною поштою та видалити поточний журнал) E‑mail & Delete Oldest Log  (Надіслати електронною поштою та видалити найдавніший журнал) Post & Delete Current Log  (Опублікувати та видалити поточний журнал) Post & Delete Oldest Log  (Опублікувати та видалити найдавніший журнал) Delete Current Log  (Видалити поточний журнал) Delete Oldest Log  (Видалити найдавніший журнал) Delete All But Current  (Видалити всі, крім поточного) Delete All Logs  (Видалити всі журнали) Укажіть, як принтер реагує, коли використання жорсткого диска або ISD досягає максимального ліміту (100 МБ). URL to Post Log  (URL-адреса для публікації журналу) Укажіть, куди принтер публікує журнали обліку завдань. E‑mail Address to Send Logs  (Адреса електронної пошти для надсилання електронних листів) Укажіть адресу електронної пошти, на яку принтер надсилає журнали обліку завдань. Log File Prefix  (Префікс файлу журналу) Вкажіть префікс для файлів журналу. Поточне ім’я хоста, визначене в меню  TCP/IP , використовується як префікс файлу журналу за замовчуванням. меню Job Accounting  (Звіт щодо завдання)"},{"UUID":"6bfaeaad-5f55-4134-a524-eff723f4cfe7","title":"Друк","link":"layout-topic.html","desc":"PDF Пункти меню  PDF","descFull":"PDF Пункти меню  PDF  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Scale To Fit Off * On Масштабувати вміст сторінки, щоб він відповідав вибраному розміру паперу. Annotations Print Do Not Print * Указувати, чи друкувати примітки у файлах PDF. Print PDF Error Off On * Увімкнути друк помилки PDF. меню PDF"},{"UUID":"a1d601e1-5c31-4ab0-940a-ff99eb5bfa37","title":"Друк","link":"layout-topic.html","desc":"PostScript Елементи меню  PostScript","descFull":"PostScript Елементи меню  PostScript  і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Print PS Error  (Друк інформації про помилки PostScript) Off * (Вимк.) On  (Увімк.) Друк сторінки з описом помилки PostScript®. Коли виникає помилка, обробка завдання припиняється, принтер друкує повідомлення про помилку, а решта завдання друку очищується. Minimum Line Width  (Мінімальна ширина лінії) 1–30 (2*) Встановіть мінімальну ширину штриха. Завдання, надруковані з роздільною здатністю 1200 dpi, використовують значення напряму. Lock PS Startup Mode  (Блокування режиму запуску PostScript) Off  (Вимк.) On * (Увімк.) Вимкніть файл SysStart. Увімкнення файлу SysStart загрожує безпеці вашого принтера або мережі. Font Priority  (Пріоритетність шрифтів) Resident * (Вбудовані) Flash/Disk  (Флеш-пам’ять/диск) Встановіть порядок пошуку шрифтів. Елемент  Resident  (Вбудовані) налаштовує принтер на пошук потрібного шрифту в пам’яті принтера перед пошуком на жорсткому диску або інтелектуальному накопичувачі (ISD). Елемент  Flash/Disk  (Флеш-пам’ять/диск) налаштовує принтер на пошук потрібного шрифту на жорсткому диску або ISD перед пошуком у пам’яті принтера. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Wait Timeout  (Час очікування) Off  (Вимк.) On * (Увімк.) ( 40 seconds  (40 секунд)) Увімкніть принтер для очікування додаткових даних перед скасуванням завдання друку. меню PostScript"},{"UUID":"d6f8c819-9bc6-4a19-bf5c-5fef2dbefc0b","title":"Друк","link":"layout-topic.html","desc":"PCL Елементи меню  PCL","descFull":"PCL Елементи меню  PCL  і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Font Source  (Джерело шрифту) Resident * (Вбудовані) Disk  (Диск) Download  (Завантажити) Flash  (Флешнакопичувач) Font Card  (Карта шрифту) All  (Усі) Виберіть джерело, яке містить стандартний шрифт. Меню  Disk  (Диск) і  Flash  (Флешнакопичувач) з’являються, лише якщо встановлено жорсткий диск або інтелектуальний накопичувач (ISD), що містить шрифти. Меню  Download  (Завантажити) відображається, лише якщо в пам’ять принтера завантажено шрифти. Font Card  (Карта шрифту) з’являється, лише якщо встановлено інтелектуальний накопичувач (ISD). Font Name  (Назва шрифту) [Список доступних шрифтів] ( Courier *) Виберіть шрифт з указаного джерела шрифтів. Symbol Set  (Набір символів) [Список доступних наборів символів] (10U PC‑8*) Указати набір символів для назви кожного шрифту. Набір символів — це набір буквено-цифрових символів, знаків пунктуації та спеціальних символів. Набори символів підтримують різні мови чи спеціальні програми, як-от математичні символи для наукового тексту. Pitch  (Крок) 0,08–100,00 (10,00*) Указати крок для шрифтів із фіксованою або моношириною. Pitch  (Крок) — це кількість символів із фіксованою шириною в горизонтальному дюймі надрукованого тексту. Orientation  (Орієнтація) Portrait * (Портретна) Landscape  (Альбомна) Reverse Portrait  (Перевернута портретна) Reverse Landscape  (Перевернута альбомна) Вкажіть орієнтацію тексту та графічних зображень на сторінці. Lines per Page  (Рядків на сторінку) 1–255 Указати кількість рядків тексту на кожній сторінці, надрукованій через потік даних PCL®. Цей пункт меню активує вертикальну ширину, що спричиняє вибрану кількість запитуваних рядків для друку між полями сторінки за замовчуванням. Заводське налаштування за замовчуванням для США — 60. Міжнародне заводське значення за замовчуванням — 64. PCL5 Minimum Line Width  (Мінімальна ширина лінії PCL5) 1–30 (2*) Установити початкову мінімальну ширину штриха. PCLXL Minimum Line Width  (Мінімальна ширина лінії PCLXL) 1–30 (2*) A4 Width  (Ширина А4) 198мм* 203мм Установити ширину логічної сторінки на папері формату A4. Логічна сторінка — це простір на фізичній сторінці, де надруковані дані. Auto CR after LF  (Авто CR після LF) On  (Увімк.) Off * (Вимк.) Налаштувати принтер на виконання команди повернення каретки після команди керування переходом рядка. Повернення каретки — це механізм, який дає принтеру команду змістити положення курсора до першої позиції в тому ж рядку. Auto LF after CR  (Авто CR після LF) On  (Увімк.) Off * (Вимк.) Налаштувати принтер на переведення рядка після команди керування поверненням каретки. Tray Renumber  (Перенумерація лотка) Assign MP Feeder  (Призначити подавач MP) Assign Tray  (Призначити лоток) [x] Assign Manual Paper  (Призначити папір вручну) Assign Manual Envelope  (Ручне призначення конверта) Налаштувати принтер для роботи з іншим драйвером принтера або спеціальною програмою, яка використовує інший набір призначень джерела для запиту певного джерела паперу Виберіть варіанти нижче. Off * (Вимк.) — принтер використовує заводські стандартні призначення джерела паперу. None  (Немає) — джерело паперу ігнорує команду «Вибрати подавач паперу». 0–199: виберіть числове значення, щоб призначити користувацьке значення джерелу паперу. Tray Renumber  (Перенумерація лотка) View Factory Defaults  (Перегляд заводських налаштувань) Показувати заводське значення за замовчуванням, призначене кожному джерелу паперу. Tray Renumber  (Перенумерація лотка) Restore Defaults  (Відновити значення за замовчуванням) Відновити заводські значення перенумерації лотків. Print Timeout  (Час очікування принтера) Off  (Вимк.) On*  (Увімк.) (90 секунд) Налаштувати принтер так, щоб він завершував завдання друку після періоду неактивності протягом указаного часу. Print Timeout Time  (Час очікування принтера) відображається, тільки якщо ввімкнено параметр  Print Timeout  (Час очікування принтера). меню PCL"},{"UUID":"0047d9ae-7b9c-4f03-b666-9361bd15929e","title":"Друк","link":"layout-topic.html","desc":"Image Пункти меню  Image","descFull":"Image Пункти меню  Image  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Auto Fit On Off * Вибрати найкращий доступний розмір паперу й параметри орієнтації зображення. Якщо вибрано параметр  On , цей пункт меню перезаписує параметри масштабу й орієнтації зображення. Invert Off * On Інвертувати двотонові монохромні зображення. Цей пункт меню не застосовується до форматів зображення GIF або JPEG. Scaling Anchor Top Left Best Fit * Anchor Center Fit Height/Width Fit Height Fit Width Відкоригувати зображення, щоб воно вміщалося в область друку. Коли для параметра  Auto Fit  встановлено значення  On , для параметра  Scaling  автоматично вибрано значення  Best Fit . Orientation Portrait * Landscape Reverse Portrait Reverse Landscape Вкажіть орієнтацію тексту та графічних зображень на сторінці. меню Image"},{"UUID":"417e4c6f-8f47-47b9-8f55-aeb4d8ced7a7","title":"Папір","link":"tray-configuration-topic.html","desc":"Tray Configuration Пункти меню ","descFull":"Tray Configuration Пункти меню  Tray Configuration  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Default Source Tray  [x] (1*) Multipurpose Feeder Manual Paper Manual Envelope Налаштувати джерело паперу для всіх завдань друку. Paper Size/Type Tray  [x] Multipurpose Feeder Manual Paper Manual Envelope Указати розмір чи тип паперу, завантаженого в кожне джерело паперу. Substitute Size Off Letter/A4 All Listed * Налаштувати принтер так, щоб він замінював указаний розмір паперу, якщо запитаний розмір не завантажено в жодне джерело паперу. Off : запит до користувача завантажити потрібний розмір паперу. All Listed : дозволяє всі доступні заміни. Configure MP Cassette * Manual First Визначити поведінку багатоцільового подавача. Cassette : налаштовує багатоцільовий подавач як автоматичне джерело паперу. Manual : встановлює багатоцільовий подавач паперу лише для завдань друку, де папір завантажується вручну. First : налаштовує багатоцільовий подавач як основне джерело паперу. меню Tray Configuration"},{"UUID":"3322b94a-8b0a-4e2c-a9c9-42256cbb2aa2","title":"Конфігурація носія","link":"tray-configuration-topic.html","desc":"Universal Setup  (Універсальні налаштування)","descFull":"Universal Setup  (Універсальні налаштування) Елементи меню  Universal Setup  (Універсальні налаштування) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Units of Measure  (Одиниці вимірювання) Inches  (Дюйми) Millimeters  (Міліметри) Указати одиницю вимірювання для універсального паперу. Заводське налаштування за замовчуванням для США —  Inches  (Дюйми).  Millimeters   (Міліметри) є міжнародними заводським налаштуванням за замовчуванням. Portrait Width  (Портретна ширина) 3,5–19 дюймів (8,5*) 88,9–482,6 мм (216*) Установити ширину універсального паперу в портретній орієнтації. Portrait Height  (Портретна висота) 3,5–19 дюймів (14*) 88,9–482,6 мм (356*) Установити висоту універсального паперу в портретній орієнтації. Feed Direction  (Напрям подачі) Short Edge * (Короткий край) Long Edge  (Довгий край) Налаштувати принтер так, щоб він брав папір за короткий або довгий край. Long Edge  (Довгий край) відображається, лише коли найдовший край коротший за максимальну підтримувану ширину. Multiple Universal Sizes  (Кілька універсальних розмірів) Tray [x]  (Лоток [x]) Multipurpose Feeder  (Багатоцільовий подавач) Призначте унікальний розмір для кількох універсальних розмірів, які завантажуються в кожне джерело паперу. Цей параметр відображається, лише якщо його ввімкнено в меню  Device  (Пристрій). На головному екрані торкніться  Settings  (Параметри) Device  (Пристрій) Maintenance  (Обслуговування) Configuration Menu  (Меню конфігурацій) Tray Configuration  (Конфігурація лотка) Multiple Universal Sizes  (Кілька універсальних розмірів). меню Universal Setup  (Універсальні налаштування)"},{"UUID":"7d82e36f-4df8-4a8c-b6c9-14794d69e110","title":"Конфігурація носія","link":"tray-configuration-topic.html","desc":"Custom Scan Sizes Пункти меню","descFull":"Custom Scan Sizes Пункти меню  Custom Scan Sizes  та їхній опис Елемент меню Опис Custom Scan Size  [x] Scan Size Name Width 1-8,5 дюйм. (8,5*) 25,4-215,9 мм (215,9*) Height 1-25 дюйм. (11*) 25,4-635 мм (279,4*) Orientation Portrait * Landscape 2 scans per side Off * On Призначити назву розміру сканування й налаштуйте параметри сканування. меню Custom Scan Sizes"},{"UUID":"bed6594d-b4e2-4b56-b4cf-4a1d14073ba6","title":"Конфігурація носія","link":"tray-configuration-topic.html","desc":"Media Types  (Типи носіїв)","descFull":"Media Types  (Типи носіїв) Елемент меню  Media Types  (Типи носіїв) і його опис. Елемент меню Опис Plain Paper  (Простий папір) Card Stock  (Картки) Recycled  (Перероблений папір) Labels  (Етикетки) Bond  (Високоякісний папір) Envelope  (Конверт) Rough Envelope  (Жорсткий конверт) Letterhead  (Фірмовий бланк) Preprinted  (Попередньо надрукований) Colored Paper  (Кольоровий папір) Light Paper  (Тонкий папір) Heavy Paper  (Цупкий папір) Rough/Cotton  (Жорсткий/бавовняний папір) Custom Type  (Користувацький тип) [X] Указати текстуру, вагу й орієнтацію паперу. меню Media Types  (Типи носіїв)"},{"UUID":"cc88adcc-9d61-414c-8284-b1ee48195e7a","title":"Копіювання","link":"copy-defaults-topic.html","desc":"Copy Defaults  (Параметри копіювання","descFull":"Copy Defaults  (Параметри копіювання за замовчуванням) Елементи меню  Copy Defaults  (Параметри копіювання за замовчуванням) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Content Type  (Тип вмісту) Text  (Текст) Text/Photo * (Текст/фото) Photo  (Фотографія) Graphics  (Графіка) Покращте вихідний результат залежно від вмісту оригінального документа. Content Source  (Джерело вмісту) Black and White Laser * (Чорно-білий лазерний) Color Laser  (Кольоровий лазерний) Inkjet  (Струминний) Photo/Film  (Фото/фільм) Magazine  (Журнал) Newspaper  (Газета) Press  (Преса) Other  (Інше) Покращте вихідний результат залежно від джерела оригінального документа. Sides  (Боки) 1 sided to 1 sided * (1 бік на 1 бік) 1 sided to 2 sided  (1 бік на 2 боки) 2 sided to 1 sided  (2 боки на 1 бік) 2 sided to 2 sided  (2 боки на 2 боки) Укажіть параметри сканування залежно від оригінального документа. Separator Sheets  (Аркуші-розділювачі) None * (Немає) Between Copies  (Між копіями) Between Jobs  (Між завданнями) Between Pages  (Між сторінками) Укажіть, чи вставляти чисті розділові аркуші під час друку. Separator Sheet Source  (Джерело аркуша-розділювача) Tray  (Лоток) [x] (1*) Multipurpose Feeder  (Багатоцільовий подавач) Укажіть джерело паперу для аркуша-розділювача Color  (Кольоровий) Off  (Вимк.) On * (Увімк.) Auto  (Автоматично) Налаштуйте принтер на створення кольорового результату із завдання сканування. Pages per Side  (Сторінок на одному боці) Off * (Вимк.) 2 Portrait pages  (2 портретні сторінки) 4 Portrait pages  (4 портретні сторінки) 2 Landscape pages  (2 альбомні сторінки) 4 Landscape pages  (4 альбомні сторінки) Укажіть кількість зображень сторінок для друку на одному боці аркуша паперу. Print Page Borders  (Друкувати межі сторінки) Off * (Вимк.) On  (Увімк.) Розмістіть рамку навколо кожного зображення, якщо друкуєте кілька сторінок на одній сторінці. Collate  (Розбирання за копіями) Off [1,1,1,2,2,2]  (Вимк. 1,1,1,2,2,2) On [1,2,1,2,1,2] * (Ввімк. [1,2,1,2,1,2]) Надрукуйте кілька копій поспіль. “Copy from” Size [Список розмірів паперу] Установіть розмір паперу оригінального документа. Заводське налаштування за замовчуванням для США —  Letter  (Лист). A4  є міжнародним заводським налаштуванням за замовчуванням. “Copy to” Source  (Копіювати до «Джерела») Tray  (Лоток) [x] (1*) Multipurpose Feeder  (Багатоцільовий подавач) Auto Size Match  (Автоматичний підбір розміру) Укажіть джерело паперу для завдання копіювання. Temperature  (Температура) Від ‑4 до 4 (0*) Укажіть, чи генерувати холодніший або тепліший відтінок копії. Darkness  (Щільність) 1–9 (5*) Відрегулюйте щільність друку відсканованого зображення. Number of Copies  (Кількість копій) 1–9999 (1*) Вкажіть кількість копій. Header/Footer  (Верхній/нижній колонтитул) Left Header  (Лівий колонтитул) Middle Header  (Середній верхній колонтитул) Right Header  (Правий верхній колонтитул) Left Footer  (Лівий ніжний колонтитул) Middle Footer  (Середній нижній колонтитул) Right Footer  (Правий нижній колонтитул) Укажіть інформацію про верхній або нижній колонтитул сканованого зображення. Overlay  (Накладання) Confidential  (Конфіденційно) Copy  (Копіювання) Draft  (Чернетка) Urgent  (Терміново) Custom  (Користувацький) Off * (Вимк.) Укажіть накладений текст для друку на кожній копії. Custom overlay  (Користувацьке накладання) Введіть текст для значення  Custom  (Користувацьке) в меню  Overlay  (Накладання). Advanced Imaging  (Покращене зображення) Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Color Balance  (Колірний баланс) Cyan ‑ Red (0*)  (Блакитний - червоний (0*)) Magenta ‑ Green (0*)  (Пурпурний - зелений (0*)) Yellow ‑ Blue (0*)  (Жовтий - синій (0*)) Відрегулюйте інтенсивність кольору для блакитного, пурпурового та жовтого кольорів. Color Dropout  (Вилучення кольору) Color Dropout  (Вилучення кольору) ( None *) (Немає*) Default Red Threshold (128*)  (Червоний поріг за замовчуванням (128*)) Default Green Threshold (128*)  (Зелений поріг за замовчуванням (128*)) Default Blue Threshold (128*)  (Синій поріг за замовчуванням (128*)) Укажіть, який колір вилучати під час сканування, і налаштуйте параметр вилучення для цього кольору. Auto Color Detect  (Автоматичне визначення кольору) Color Sensitivity  (5*) (Чутливість кольору (5*)) Area Sensitivity (5*)  (Чутливість області (5*)) Налаштуйте параметр автоматичного визначення кольору. Contrast  (Контрастність) Best for content * (Найкраща для вмісту) 0–5 Відрегулюйте контрастність відсканованого зображення. Background Removal  (Видалення фону) Background Detection ( Content‑based *) (Виявлення фону: на основі вмісту) Level   (0*) (Рівень (0*)) Видаліть фоновий колір або шум зображення з оригінального документа. Content-based  (на основі вмісту) видаляє колір фону з оригінального документа. Fixed  (Фіксований) видаляє шум із фото. Auto Center  (Автоматичний центр) Off * (Вимк.) On  (Увімк.) Вирівняйте вміст по центру сторінки. Mirror Image  (Дзеркальне зображення) Off * (Вимк.) On  (Увімк.) Створити дзеркальне зображення оригінального документа. Negative Image  (Негативне зображення) Off * (Вимк.) On  (Увімк.) Створити негативне зображення оригінального документа. Shadow Detail  (Деталізація тіней) Від ‑4 до 4 (0*) Відкоригуйте деталізацію тіні в оригінальному документі. Scan Edge to Edge  (Сканувати від краю до краю) Off * (Вимк.) On  (Увімк.) Відскануйте оригінальний документ від краю до краю. Sharpness  (Різкість) 1–5 (3*) Відрегулюйте різкість відсканованого зображення. Admin Controls  (Елементи керування адміністратора) Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Allow Color Copies  (Дозволити кольорові копії) Off  (Вимк.) On * (Увімк.) Друкувати копії в кольорі. Allow Priority Copies  (Дозволити пріоритетні копії) Off  (Вимк.) On * (Увімк.) Перервати завдання друку, щоб зробити копії. Custom Job Scanning  (Сканування користувацького завдання) Off * (Вимк.) On  (Увімк.) Налаштуйте принтер на сканування першого набору оригінальних документів із зазначеними налаштуваннями, а потім на сканування наступного набору з тими самими або іншими налаштуваннями. Це меню з’являється, лише якщо встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Allow Save as Shortcut  (Дозволити збереження як ярлика) Off  (Вимк.) On * (Увімк.) Збережіть налаштування копіювання як ярлик. Adjust ADF Skew  (Коригувати перекошування пристрою АПД) Off  (Вимк.) On * (Увімк.) Налаштуйте принтер на коригування перекошених зображень із документів, які скануються з АПД. Sample copy  (Приклад копії) Off * (Вимк.) On  (Увімк.) Надрукуйте пробну копію, щоб перевірити якість перед друком решти копій. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). меню Copy Defaults  (Параметри копіювання за замовчуванням)"},{"UUID":"7a20d135-9671-4e43-9e92-6e23b91c19dc","title":"Параметри факсу за замовчуванням","link":"fax-defaults-subgroup.html","desc":"Fax Mode Пункт меню ","descFull":"Fax Mode Пункт меню  Fax Mode  і його опис Елемент меню Опис Fax Mode Fax * Fax Server Disabled Виберіть режим факсу. меню Fax Mode"},{"UUID":"9e53e80a-82e5-40fb-9b73-b581a8f616d3","title":"Параметри факсу за замовчуванням","link":"fax-defaults-subgroup.html","desc":"Fax Setup  (Налаштування факсу)","descFull":"Fax Setup  (Налаштування факсу) General Fax Settings  (Загальні параметри факсу) Елементи меню  General Fax Settings  (Загальні параметри факсу) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Fax Name  (Ім’я факсу) Зазначте ідентифікатор вашого факсу. Fax Number  (Номер факсу) Зазначте номер вашого факсу. Fax ID  (Ідентифікатор факсу) Fax Name  (Ім’я факсу) Fax Number * (Номер факсу)* Установіть ідентифікатор факсу для використання під час передачі факсу Увімкнути ручний режим факсу Off * (Вимк.) On  (Увімк.) Увімкнути ручний режим факсу на принтері. Цей пункт меню потребує пристрою розділення каналів та телефонної трубки. Використовуйте звичайну телефонну лінію, щоб відповідати на вхідний факс та набирати номер факсу. Щоб відразу перейти до ручного режиму факсу, торкніться  #  і  0  на клавіатурі. Memory Use  (Використання пам’яті) All receive  (Уся на отримання) Mostly receive  (Більшість на отримання) Equal * (Порівну)* Mostly send  (Більшість на надсилання) All send  (Уся на надсилання) Встановіть обсяг внутрішньої пам’яті принтера, виділеної для надсилання факсів. Цей пункт меню попереджає умови буфера пам’яті та невдалі факси. Cancel Faxes  (Скасувати факси) Allow * (Дозволити)* Don't Allow  (Не дозволяти) Скасувати вихідні або вхідні факси. Fax Number Masking  (Маскування номера факсу) Off * (Вимк.) From Left  (Зліва) From Right  (Справа) Зазначте формат маскування номера вихідного факсу. Digits to Mask  (Цифри для маскування) 0–58 (0*) Зазначте кількість цифр для маскування номера вихідного факсу. Enable Line Connected Detection  (Увімкнути виявлення підключеної лінії) Off  (Вимк.) On * (Увімк.) Перевірте, чи під’єднано до принтера телефонну лінію. Події виявляються негайно. Увімкнути виявлення неправильного гнізда лінії Off  (Вимк.) On * (Увімк.) Перевірте, чи телефонну лінію підключено до правильного порту на принтері. Події виявляються негайно. Увімкнути підтримку додаткового номера Off  (Вимк.) On * (Увімк.) Визначте, чи використовується телефонна лінія іншим пристроєм, наприклад іншим телефоном на тій самій лінії. Події виявляються негайно. Optimize Fax Compatibility  (Оптимізація сумісності факсів) Налаштуйте функцію факсу принтера для оптимальної сумісності з іншими факсимільними апаратами. Fax Transport  (Транспортування факсу) T.38 Analog  (Аналоговий) G.711 etherFAX Налаштуйте спосіб передачі факсу. Цей пункт меню з’являється лише якщо на принтері встановлено пакет ліцензій etherFAX або Fax over IP (FoIP). Цей пункт меню з’являється, лише якщо на принтері встановлено пакет ліцензій Fax over IP (FoIP). HTTPS Fax Settings  (Параметри факсу HTTPS) Це меню відображається, лише якщо для параметра  Fax Transport  (Передавання факсу) встановлено значення  etherFAX . Елементи меню  HTTPS Fax Settings  (Параметри факсу HTTPS) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. HTTPS service URL  (URL-адреса служби HTTPS) Зазначте URL-адресу служби etherFAX. HTTPS Proxy  (Проксі-сервер HTTPS) Зазначте URL-адресу проксі-сервера. HTTPS Proxy User  (Користувач проксі-сервера HTTPS) Вкажіть ім’я користувача та пароль для проксі-сервера. HTTPS Proxy Password   (Пароль проксі-сервера HTTPS) Fax Send Encryption  (Шифрування надсилання факсу) Disabled  (Вимкнено) Enabled * (Увімкнено)* Required  (Вимагається) Увімкніть шифрування для вихідних факсимільних повідомлень. Fax Receive Encryption  (Шифрування отримання факсу) Disabled  (Вимкнено) Enabled * (Увімкнено)* Required  (Вимагається) Увімкніть шифрування для вхідних факсимільних повідомлень. HTTPS Fax Status  (Статус факсу HTTPS) Показати статус зв’язку etherFAX. Fax Send Settings  (Параметри надсилання факсу) Елементи меню  Fax Send Settings  (Параметри надсилання факсу) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Resolution  (Роздільна здатність) Standard * (Стандартна)* Fine  (Гарна) Super Fine  (Дуже гарна) Ultra Fine  (Надзвичайно гарна) Відрегулюйте роздільну здатність відсканованого зображення. Вища роздільна здатність збільшує час передавання факсу та потребує більше пам’яті. Original Size  (Оригінальний розмір) [Список розмірів паперу]] (Змішані розміри*) Зазначте розмір оригінального документа. Orientation  (Орієнтація) Portrait * (Портретна) Landscape  (Альбомна) Виберіть орієнтацію оригінального документа. Sides  (Боки) Off * (Вимк.) Short Edge  (Короткий край) Long Edge  (Довгий край) Вкажіть орієнтацію оригінального документа в разі сканування з обох боків документа. Content Type  (Тип вмісту) Text * (Текст)* Text/Photo  (Текст/фото) Photo  (Фотографія) Graphics  (Графіка) Покращте вихідний результат залежно від вмісту оригінального документа. Джерело вмісту Black and White Laser * (Чорно-білий лазерний) Color Laser  (Кольоровий лазерний) Inkjet  (Струминний) Photo/Film  (Фото/фільм) Magazine  (Журнал) Newspaper  (Газета) Press  (Преса) Other  (Інше) Покращте вихідний результат залежно від джерела оригінального документа. Darkness  (Щільність) 1–9 (5*) Відрегулюйте щільність друку відсканованого зображення. Behind a PABX  (За PABX) On  (Увімк.) Off * (Вимк.) Налаштуйте принтер на набір номера факсу, не чекаючи розпізнавання тонального сигналу. Private Automated Branch Exchange (PABX) — це телефонна мережа, яка дає змогу за одним номером доступу пропонувати декілька ліній зовнішнім абонентам. Dial Mode  (Режим набору) Tone * (Тоновий) Pulse  (Імпульсний) Зазначте режим набору для вхідних і вихідних факсимільних повідомлень. Advanced Imaging  (Покращене зображення) Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Color Balance  (Колірний баланс) Cyan ‑ Red (0*)  (Блакитний - червоний (0*)) Magenta ‑ Green (0*)  (Пурпурний - зелений (0*)) Yellow ‑ Blue (0*)  (Жовтий - синій (0*)) Відкоригуйте інтенсивність кольору під час сканування. Color Dropout  (Вилучення кольору) Color Dropout  (Вилучення кольору) ( None *) (Немає*) Default Red Threshold (128*)  (Червоний поріг за замовчуванням (128*)) Default Green Threshold (128*)  (Зелений поріг за замовчуванням (128*)) Default Blue Threshold (128*)  (Синій поріг за замовчуванням (128*)) Укажіть, який колір вилучати під час сканування, і налаштуйте параметр вилучення для цього кольору. Contrast  (Контрастність) Best for content * (Найкраща для вмісту) 0 1 2 3 4 5 Установіть контрастність. Background Removal  (Видалення фону) Level  (Рівень) Від ‑4 до 4 (0*) Налаштуйте, наскільки тло буде видиме на відсканованому зображенні. Mirror Image  (Дзеркальне зображення) Off * (Вимк.) On  (Увімк.) Створити дзеркальне зображення оригінального документа. Negative Image  (Негативне зображення) Off * (Вимк.) On  (Увімк.) Створити негативне зображення оригінального документа. Shadow Detail  (Деталізація тіней) Від ‑4 до 4 (0*) Налаштуйте обсяг деталізації тіні, видимої на відсканованому зображенні. Scan Edge to Edge  (Сканувати від краю до краю) On  (Увімк.) Off * (Вимк.) Дозволити сканування оригінального документа від краю до краю. Sharpness  (Різкість) 1–5 (3*) Відрегулюйте різкість відсканованого зображення. Temperature  (Температура) Від ‑4 до 4 (0*) Укажіть, чи генерувати холодніший або тепліший відтінок копії. Admin Controls  (Елементи керування адміністратора) Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Automatic Redial  (Автоматичний повторний набір) 0–9 (5*) Зазначте кількість повторних спроб принтера, перш ніж скасувати надсилання факсу вказаному адресату. Redial Frequency  (Частота повторного набору) 1–200 хвилин (3*) Збільште час між спробами повторного набору, щоб підвищити ймовірність успішного надсилання факсу. Enable ECM  (Увімкнути DDNS) On * (Увімк.) Off  (Вимк.) Активуйте режим виправлення помилок (ECM) для завдань факсу. ECM виявляє та виправляє помилки в процесі передачі факсу, викликані шумом телефонної лінії та слабкою силою сигналу. Enable Fax Scans  (Увімкнути сканування факсу) On * (Увімк.) Off  (Вимк.) Передавання факсом відсканованих документів. Driver to Fax  (Драйвер на факс) On * (Увімк.) Off  (Вимк.) Дозвольте драйверу принтера надсилати факси. Allow Save as Shortcut  (Дозволити збереження як ярлика) On * (Увімк.) Off  (Вимк.) Збережіть номери факсів як ярлики на принтері. Max Speed  (Максимальна швидкість) 33600 * 14400 9600 4800 2400 Встановіть максимальну швидкість для надсилання факсу. Custom Job Scanning  (Сканування користувацького завдання) Off * (Вимк.) On  (Увімк.) Увімкніть сканування спеціальних завдань за замовчуванням. Це меню з’являється, лише якщо встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Scan Preview  (Попередній перегляд результату сканування) Off * (Вимк.) On  (Увімк.) Показати попередній перегляд відсканованого зображення на дисплеї. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Adjust ADF Skew  (Коригувати перекошування пристрою АПД) Off  (Вимк.) On * (Увімк.) Виправте невеликий перекіс сканованого зображення. Enable Color Fax Scans  (Увімкнути кольорове сканування факсу) Off by Default * (Вимк. за замовчуванням)* On by Default  (Увімк. за замовчуванням) Never Use  (Ніколи не використовувати) Always Use  (Завжди використовувати) Увімкніть кольорове сканування для факсу. Auto Convert Color Faxes to Mono Faxes  (Автоматичне перетворення кольорових факсів на монохромні) On * (Увімк.) Off  (Вимк.) Перетворіть усі вихідні кольорові факси на чорно-білі. Confirm Fax Number  (Підтвердити номер факсу) Off * (Вимк.) On  (Увімк.) Попросіть користувача підтвердити номер факсу. Dial Prefix  (Префікс набору) Установіть префікс набору. Dialing Prefix Rules  (Правила префіксів набору) Установіть правило префікса набору. Fax Receive Settings  (Параметри прийому факсу) Елементи меню  Fax Receive Settings  (Параметри прийому факсу) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Fax Job Waiting  (Очікування завдання факсу) None * (Немає) Toner  (Тонер) Toner and Supplies  (Тонер і витратні матеріали) Видаліть із черги друку факсимільні завдання, які вимагають певних недоступних ресурсів. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск. Rings to Answer  (Дзвінки для відповіді) 1–25 (3*) Установіть необхідну кількість викликів, перш ніж принтер відповість на вхідні виклики. Auto Reduction  (Автоматичне зменшення) On * (Увімк.) Off  (Вимк.) Масштабуйте вхідний факс відповідно до розміру сторінки. Paper Source  (Джерело паперу) Tray  (Лоток) [X] Multipurpose Feeder  (Багатоцільовий подавач) Auto * (Автоматично) Установіть джерело паперу для друку вхідного факсу. Sides  (Боки) On  (Увімк.) Off * (Вимк.) Друкуйте на обох боках паперу. Separator Sheets  (Аркуші-розділювачі) None * (Немає) Before Job  (Перед завданням) After Job  (Після завдання) Укажіть, чи вставляти чисті розділові аркуші під час друку. Separator Sheet Source  (Джерело аркуша-розділювача) Tray  (Лоток) [x] (1*) Multipurpose Feeder  (Багатоцільовий подавач) Укажіть джерело паперу для аркуша-розділювача Вихідний відсік Стандартний відсік Укажіть вихідний відсік для отриманих факсів. Fax Footer  (Нижній колонтитул факсу) On  (Увімк.) Off * (Вимк.) Роздрукуйте інформацію про передачу в нижній частині кожної сторінки отриманого факсу. Fax Footer Time Stamp  (Позначка часу нижнього колонтитула факсу) Receive * (Отримати) Print  (Друк) Роздрукуйте позначку часу в нижній частині кожної сторінки отриманого факсу. Holding Faxes  (Відкладення факсів) Held Fax Mode  (Режим відкладеного факсу) Off * (Вимк.) Always On  (Завжди ввімкнено) Manual  (Ручний) Scheduled  (Заплановано) Не друкуйте отримані факси доти, доки вони не вивільняться. Holding Faxes  (Відкладення факсів) Fax Holding Schedule  (Розклад відкладення факсу) Призначте розклад відкладення факсів. Це меню відображається, лише якщо для параметра  Held Fax Mode  (Режим відкладеного факсу) встановлено значення  Scheduled  (Заплановано). Admin Controls  (Елементи керування адміністратора) Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Enable Fax Receive  (Увімкнути отримання факсу) On * (Увімк.) Off  (Вимк.) Налаштуйте принтер на отримання факсу. Enable Color Fax Receive  (Увімкнути отримання кольорового факсу) On * (Увімк.) Off  (Вимк.) Налаштуйте принтер на отримання кольорового факсу. Enable Caller ID  (Увімкнути ідентифікатор абонента) On  (Увімк.) Off * (Вимк.) Відображення інформації про ідентифікатор абонента вхідного виклику на дисплеї принтера. Block No Name Fax  (Блокувати факси без імені) On  (Увімк.) Off * (Вимк.) Заблокуйте вхідні факси без ідентифікаторів факсів. Banned Fax List  (Список заборонених факсів) Add Banned Fax  (Додати заборонений факс) Вкажіть номери телефонів, які хочете заблокувати. Answer On  (Відповідь на) All Rings * (Усі дзвінки)* Single Ring Only  (Лише один дзвінок) Double Ring Only  (Тільки подвійний дзвінок) Triple Ring Only  (Тільки потрійний дзвінок) Single or Double Rings Only  (Тільки один або подвійний дзвінок) Single or Triple Rings Only  (Тільки один або потрійний дзвінок) Double or Triple Rings Only  (Тільки подвійний або потрійний дзвінок) Встановіть характерний дзвінок для вхідного факсу. Auto Answer  (Автовідповідач) On * (Увімк.) Off  (Вимк.) Налаштуйте принтер на отримання факсу автоматично. Код ручної відповіді 0–9 (9*) Вручну введіть код на цифровій клавіатурі телефону, щоб почати отримувати факс. Цей пункт меню з’являється лише тоді, коли принтер використовує спільну лінію з телефоном. Цей пункт меню з’являється лише тоді, коли принтер налаштовано на отримання факсу вручну. Fax Forwarding  (Пересилання факсів) Print * (Друк) Print and Forward  (Друкувати та переслати) Forward  (Переслати) Укажіть, чи пересилати отриманий факс. Forward To  (Переслати до) Місце призначення 1 Місце призначення 2 Укажіть, куди пересилати отриманий факс. Цей пункт меню з’являється, лише якщо для параметра  Fax Forwarding  (Пересилання факсу) встановлено значення  Print and Forward  (Друкувати та переслати) або  Forward  (Переслати). Confirmation E-mail  (Електронний лист підтвердження) Укажіть адресу електронної пошти для отримання факсів через FTP або мережеву папку. Цей пункт меню з’являється, лише якщо для параметра  Fax Forwarding  (Пересилання факсу) встановлено значення  Print and Forward  (Друкувати та переслати) або  Forward  (Переслати). Max Speed  (Максимальна швидкість) 33600* 14400 9600 4800 2400 Установіть максимальну швидкість передачі факсу. Fax Cover Page  (Титульна сторінка факсу) Елементи меню  Fax Cover Page  (Титульна сторінка факсу) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Fax Cover Page  (Титульна сторінка факсу) Off by Default * (Вимк. за замовчуванням)* On by Default  (Увімк. за замовчуванням) Never Use  (Ніколи не використовувати) Always Use  (Завжди використовувати) Налаштуйте параметри для титульної сторінки факсу. Include To field  (Додати до поля) Off * (Вимк.) On  (Увімк.) Include From field  (Додати з поля) Off * (Вимк.) On  (Увімк.) From  (З) Include Message Field  (Додати поле повідомлення) Off * (Вимк.) On  (Увімк.) Message:  (Повідомлення) Include Logo  (Додати логотип) Off * (Вимк.) On  (Увімк.) Include Footer [x]  (Додати нижній колонтитул [x]) Off * (Вимк.) On  (Увімк.) Footer [x]  (Нижній колонтитул [x]) Fax Log Settings  (Параметри журналу факсу) Елементи меню  Fax Log Settings  (Параметри журналу факсу) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Transmission Log Frequency  (Частота журналу передачі) Always * (Завжди)* Never  (Ніколи) Only for Error  (Лише для помилки) Зазначте, наскільки часто принтер створює журнал передач. Transmission Log Action  (Дія журналу передачі) Print  (Друк) Off  (Вимк.) On * (Увімк.) E‑mail  (Електронна пошта) Off * (Вимк.) On  (Увімк.) Роздрукуйте або надішліть електронною поштою журнал успішної передачі факсу чи помилки передачі. Receive Error Log  (Отримати журнал помилок) Print Never * (Ніколи не друкувати)* Print on Error  (Помилка друку) Роздрукуйте журнал помилок приймання факсу. Auto Print Logs  (Автоматичний друк журналів) On * (Увімк.) Off  (Вимк.) Роздрукуйте всі дії з факсом. Log Paper Source  (Джерело журнального паперу) Tray  (Лоток) [x] (1*) Multipurpose Feeder  (Багатоцільовий подавач) Укажіть джерело паперу для друку журналів. Logs Display  (Відображення журналів) Remote Fax Name * (Назва віддаленого факсу)* Dialed Number  (Набраний номер) Ідентифікуйте відправника за назвою віддаленого факсу або номером факсу. Enable Job Log  (Увімкнути журнал завдань) On * (Увімк.) Off  (Вимк.) Перегляньте зведення всіх факсимільних завдань. Enable Call Log  (Увімкнути журнал викликів) On * (Увімк.) Off  (Вимк.) Перегляньте зведення історії викликів факсу. Log Output Bin  (Відсік виводу журналу) Standard Bin * (Стандартний відсік)* Bin [x]  (Відсік [x]) Укажіть вихідний відсік для роздрукованих журналів. Speaker Settings  (Параметри динаміків) Елементи меню  Speaker Settings  (Параметри динаміків) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Speaker Mode  (Режим динаміка) Always Off * (Завжди вимкнено)* Always On  (Завжди ввімкнено) On until Connected  (Увімкнено до підключення) Установіть режим динаміка факсу. Speaker Volume  (Гучність динаміка) Low * (Низька)* High  (Висока) Відрегулюйте гучність динаміка факсу. Ringer Volume  (Гучність набору номера) Off * (Вимк.) On  (Увімк.) Увімкніть гучність дзвінка. VoIP Settings  (Параметри VoIP) Елементи меню  VoIP Settings  (Параметри VoIP) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. VoIP Protocol  (Протокол VoIP) SIP * H.323 Установіть протокол Voice over Internet Protocol (VoIP). STUN Server  (Сервер NTP) Укажіть сервер STUN для проходу через брандмауер. Force Fax Mode  (Примусовий режим факсу) Off  (Вимк.) On * (Увімк.) Перемкніть шлюз VoIP з аналогового на T.38 на початку факсимільного дзвінка. Force Fax Mode Delay  (Примусова затримка режиму факсу) 0–15 (7*) Установіть час затримки в секундах під час надсилання іншого запрошення в режимі  Force Fax Mode  (Примусовий режим факсу). SIP Settings  (Параметри SIP) Елементи меню  SIP Settings  (Параметри SIP) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Proxy  (Проксі-сервер) Укажіть IP-адресу системи, яка перетворює номер телефону на IP-адресу, на яку надсилається факс. Registrar  (Реєстратор) Укажіть назву або IP-адресу системи, яка обробляє реєстрацію клієнтів протоколу ініціації сеансу (SIP). User  (Користувач) Укажіть ім'я користувача для SIP. Password  (Пароль) Укажіть пароль, який використовується під час реєстрації в реєстраторі SIP. Auth ID  (ID авторизації) Ім'я користувача, яке використовується під час реєстрації. Якщо параметр ідентифікатора автентифікації не налаштовано, замість нього використовується ім’я користувача в полі  User  (Користувач). Transport For Registration  (Передача для реєстрації) UDP * TCP Установіть тип передачі SIP для реєстрації. Transport For Incoming Calls  (Передача для вхідних дзвінків) UDP * TCP UDP And TCP  (UDP і TCP) Установіть тип передачі SIP для вхідних викликів. Transport For Outgoing Calls  (Передача для вихідних дзвінків) UDP * TCP Установіть тип транспорту SIP для вихідних викликів. Outbound Proxy  (Вихідний проксі-сервер) Укажіть вихідний проксі для пересилання всього SIP-зв’язку. Contact  (Контакт) Укажіть ім'я контакту для SIP. Realm  (Область) Укажіть назву області для SIP. Якщо параметр області не налаштовано, замість нього використовується ім’я користувача в полі  Contact  (Контакт). SIP Registration Status  (Статус реєстрації SIP) Покажіть стан реєстрації SIP. H.323 Settings  (Параметри H.323) Елементи меню  H.323 Settings  (Параметри H.323) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Gateway  (Шлюз) Укажіть IP-адресу шлюзу H.323. Gatekeeper  (Контролер шлюзу) Укажіть контролера шлюзу H.323. User  (Користувач) Укажіть ім’я користувача, яке використовується зі шлюзом H.323. Password  (Пароль) Укажіть пароль для шлюзу H.323. Enable Fast Start  (Увімкніть швидкий запуск) Off * (Вимк.) On  (Увімк.) Увімкніть швидкий запуск. Disable H.245 Tunneling  (Вимкнути тунелювання H.245) Off * (Вимк.) On  (Увімк.) Вимкнути тунелювання H.323. Disable Gatekeeper Discovery  (Вимкнути Gatekeeper Discovery) Off  (Вимк.) On * (Увімк.) Вимкнути H.323 Gatekeeper Discovery. T.38 Settings  (Параметри H.38) Елементи меню  T.38 Settings  (Параметри H.38) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Indicator Redundancy  (Резервування індикатора) 0–5 (3*) Установіть кількість повторів індикатора факсу під час зв’язку T.38. Low Speed Redundancy  (Низькошвидкісне резервування) 0–5 (3*) Установіть кількість повторів низькошвидкісного передавання даних під час зв’язку T.38. High Speed Redundancy  (Високошвидкісне резервування) 0–5 (1*) Установіть кількість повторів високошвидкісного передавання даних під час зв’язку T.38. меню Fax Setup  (Налаштування факсу) меню General Fax Settings  (Загальні параметри факсу) меню HTTPS Fax Settings  (Параметри факсу HTTPS) меню Fax Send Settings  (Параметри надсилання факсу) меню Fax Receive Settings  (Параметри прийому факсу) меню Fax Cover Page  (Титульна сторінка факсу) меню Fax Log Settings  (Параметри журналу факсу) меню Speaker Settings  (Параметри динаміків) меню VoIP Settings  (Параметри VoIP) меню SIP Settings  (Параметри SIP) меню H.323 Settings  (Параметри H.323) меню T.38 Settings  (Параметри H.38)"},{"UUID":"dbee475e-e713-4f72-83de-10bca5436fd8","title":"Параметри факсу за замовчуванням","link":"fax-defaults-subgroup.html","desc":"Fax Server Setup  (Налаштування","descFull":"Fax Server Setup  (Налаштування сервера факсу) General Fax Settings  (Загальні параметри факсу) Елементи меню  General Fax Settings  (Загальні параметри факсу) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. To Format  (У формат) Вкажіть отримувача факсу. Якщо ви хочете використати номер факсу, введіть знак цифри (#) перед номером. Reply Address  (Зворотна адреса) Вкажіть зворотну адресу для надсилання факсу. Subject  (Тема) Вкажіть тему факсу та повідомлення. Message  (Повідомлення) Enable analog receive  (Увімкнути аналоговий прийом) Off * (Вимк.) On  (Увімк.) Налаштуйте принтер на прийом аналогових факсів. Fax Server E‑mail Settings  (Параметри електронних листів сервера факсу) Елементи меню  Fax Server E‑mail Settings  (Параметри електронних листів сервера факсу) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Use E‑mail SMTP Server  (Використовувати SMTP-сервер електронної пошти) On  (Увімк.) Off * (Вимк.) Використовуйте параметри протоколу SMTP (Simple Mail Transfer Protocol) для електронної пошти під час отримання та надсилання факсів. Якщо для цього параметра встановлено значення  On  (Увімк.), усі інші налаштування меню  Fax Server E‑mail Settings  (Параметри електронних листів сервера факсу) не відображаються. Primary SMTP Gateway  (Основний шлюз SMTP) Введіть IP-адресу або ім’я хоста основного SMTP-сервера. Primary SMTP Gateway Port  (Порт основного шлюзу SMTP) 1–65535 (25*) Введіть номер порту основного SMTP-сервера. Secondary SMTP Gateway  (Допоміжний шлюз SMTP-сервера) Введіть IP-адресу чи ім’я хосту додаткового чи резервного SMTP-сервера. Secondary SMTP Gateway Port  (Порт додаткового шлюзу SMTP-сервера) 1–65535 (25*) Ввести номер порту додаткового чи резервного сервера SMTP. SMTP Timeout  (Час очікування сервера SMTP). 5–30 (30*) Укажіть час до завершення роботи принтера, якщо сервер SMTP не відповідає. Reply Address  (Зворотна адреса) Вкажіть зворотну адресу для надсилання факсу. Use SSL/TLS  (Використовувати SSL/TLS) Disabled * (Вимкнено) Negotiate  (За запитом) Required  (Вимагається) Вкажіть, чи потрібно під час надсилання факсу використовувати зашифроване посилання. Require Trusted Certificate  (Вимагати довірений сертифікат) Off  (Вимк.) On * (Увімк.) Вкажіть надійний сертифікат під час доступу до SMTP-сервера. SMTP Server Authentication  (Автентифікація на сервері SMTP) No authentication required * (Автентифікація не потрібна)* Login / Plain  (Вхід/звичайний) NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Налаштувати тип автентифікації для сервера SMTP. Device‑Initiated E‑mail  (Електронний лист, ініційований пристроєм) None * (Немає) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Укажіть, чи потрібні облікові дані для електронних листів, ініційованих пристроєм. User‑Initiated E‑mail  (Електронний лист, ініційований користувачем) None * (Немає) Use Device SMTP Credentials  (Використовувати облікові дані SMTP пристрою) Use Session User ID and Password  (Використовувати ідентифікатор користувача та пароль сеансу) Use Session E‑mail address and Password  (Використовувати адресу електронної пошти сеансу та пароль) Prompt user  (Запитувати користувача) Укажіть, чи потрібні облікові дані для електронних листів, ініційованих користувачем. Use Active Directory Device Credentials  (Використовувати облікові дані пристрою Active Directory) Off * (Вимк.) On  (Увімк.) Увімкніть облікові дані користувача та призначення груп для підключення до SMTP-сервера. Device Userid  (Ідентифікатор користувача пристрою) Укажіть ідентифікатор користувача та пароль для підключення до SMTP-сервера. Device Password  (Пароль до пристрою) Kerberos 5 REALM Укажіть область для протоколу автентифікації Kerberos 5. NTLM Domain  (NTLM-домен) Укажіть доменне ім’я для протоколу безпеки NTLM. Disable \"SMTP server not set up\" error  (Усунення помилки «Сервер SMTP не налаштовано») Off* (Вимк.) On (Увімк.) Приховати повідомлення про помилку «SMTP-сервер не налаштовано». Fax Server Scan Settings  (Параметри сканування сервера факсу) Елементи меню  Fax Server Scan Settings  (Параметри сканування сервера факсу) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Image Format  (Формат зображення) TIFF (.tif) PDF (.pdf) * XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Укажіть формат файлу для відсканованого зображення. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx)  і  CSV (.csv)  відображаються, тільки якщо ви придбали та встановили рішення для оптичного розпізнавання символів (OCR). Content Type  (Тип вмісту) Text * (Текст)* Text/Photo  (Текст/фото) Photo  (Фотографія) Graphics  (Графіка) Покращте вихідний результат залежно від вмісту оригінального документа. Content Source  (Джерело вмісту) Black and White Laser * (Чорно-білий лазерний) Color Laser  (Кольоровий лазерний) Inkjet  (Струминний) Photo/Film  (Фото/фільм) Magazine  (Журнал) Newspaper  (Газета) Press  (Преса) Other  (Інше) Покращте вихідний результат залежно від джерела оригінального документа. Fax Resolution  (Роздільна здатність факсу) Standard * (Стандартна)* Fine  (Гарна) Super Fine  (Дуже гарна) Ultra Fine  (Надзвичайно гарна) Установіть роздільну здатність факсу. Sides  (Боки) Off * (Вимк.) Short Edge  (Короткий край) Long Edge  (Довгий край) Вкажіть орієнтацію оригінального документа в разі сканування з обох боків документа. Darkness  (Щільність) 1–9 (5*) Установіть рівень щільності друку оригінального документа. Orientation  (Орієнтація) Portrait * (Портретна) Landscape  (Альбомна) Вкажіть орієнтацію тексту та графічних зображень на сторінці. Original Size  (Оригінальний розмір) [Список розмірів паперу] Установіть розмір паперу оригінального документа. Заводське налаштування за замовчуванням для США —  Mixed Sizes  (Змішані розміри). A4 є міжнародним заводським налаштуванням за замовчуванням. Цей параметр може відрізнятися залежно від моделі вашого принтера. Use Multi‑Page TIFF  (Використовувати багатосторінковий TIFF) Off  (Вимк.) On * (Увімк.) Вибирайте між односторінковими або багатосторінковими файлами TIFF. меню Fax Server Setup (Налаштування сервера факсу) меню General Fax Settings  (Загальні параметри факсу) меню Fax Server E‑mail Settings  (Параметри електронних листів сервера факсу) меню Fax Server Scan Settings  (Параметри сканування сервера факсу)"},{"UUID":"d6cc4935-4a21-4d11-9a11-00658f4004aa","title":"Електронна пошта","link":"email-setup-topic.html","desc":"E‑mail Setup Пункти меню ","descFull":"E‑mail Setup Пункти меню  E‑mail Setup  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Primary SMTP Gateway Ввести IP-адресу чи ім’я хосту основного сервера SMTP для надсилання електронних листів. Primary SMTP Gateway Port 1–65535 (25*) Введіть номер порту основного SMTP-сервера. Secondary SMTP Gateway Введіть IP-адресу чи ім’я хосту додаткового чи резервного SMTP-сервера. Secondary SMTP Gateway Port 1–65535 (25*) Ввести номер порту додаткового чи резервного сервера SMTP. Час очікування сервера SMTP. 5-30 секунд (30*) Укажіть час до завершення роботи принтера, якщо сервер SMTP не відповідає. Reply Address В електронному листі вкажіть адресу для відповіді. Always use SMTP default Reply Address On Off * Завжди використовувати адресу для відповіді за замовчуванням на сервері SMTP. Use SSL/TLS Disabled * Negotiate Required Указати, чи надсилати електронний лист за допомогою зашифрованого посилання. Require Trusted Certificate Off On * Вимагати надійний сертифікат під час доступу до сервера SMTP. SMTP Server Authentication No authentication required * Login / Plain NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Налаштувати тип автентифікації для сервера SMTP. Device‑Initiated E‑mail None * Use Device SMTP Credentials Укажіть, чи потрібні облікові дані для електронних листів, ініційованих пристроєм. User‑Initiated E‑mail None * Use Device SMTP Credentials Use Session User ID and Password Use Session E‑mail address and Password Prompt user Укажіть, чи потрібні облікові дані для електронних листів, ініційованих користувачем. Use Active Directory Device Credentials Off * On Укажіть, чи потрібні облікові дані для електронних листів, ініційованих користувачем. Device Userid Укажіть ідентифікатор користувача та пароль для підключення до SMTP-сервера. Device Password Kerberos 5 REALM Укажіть область для протоколу автентифікації Kerberos 5. NTLM Domain Укажіть доменне ім’я для протоколу безпеки NTLM. Disable “SMTP server not set up” error Off * On Приховати повідомлення про помилку «SMTP-сервер не налаштовано». меню E‑mail Setup"},{"UUID":"eb01d6cb-3325-49b5-9731-3ab700888054","title":"Електронна пошта","link":"email-setup-topic.html","desc":"E‑mail Defaults  (Параметри електронної","descFull":"E‑mail Defaults  (Параметри електронної пошти за замовчуванням) Елементи меню  E‑mail Defaults  (Параметри електронної пошти за замовчуванням) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Subject:  (Тема:) Вкажіть тему листа електронної пошти та повідомлення. Message:  (Повідомлення) File Name  (назва файлу) Вкажіть назву файлу для відсканованого документа. Format  (Формат) JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Укажіть формат файлу для відсканованого документа. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx)  і  CSV (.csv)  відображаються, тільки якщо ви придбали та встановили рішення для оптичного розпізнавання символів (OCR). Global OCR Settings  (Глобальні параметри OCR) Recognized Languages  (Мови розпізнавання) Auto Rotate  (Автоматичне обертання) (Off*) (Вимк.) Despeckle  (Очищення плям) (Off*) (Вимк.) Auto Contrast Enhance  (Автоматичне коригування контрастності) (Off*) (Вимк.) Налаштуйте параметри оптичного розпізнавання символів (OCR). Цей пункт меню з’являється, лише якщо ви придбали та встановили рішення OCR. PDF Settings  (Параметри PDF) PDF Version  (Версія PDF) (1.5*) Archival Version  (Версія архіву) (A‑1a*) Highly Compressed  (Сильне стиснення) ( Off *) (Вимк.) Secure  (Безпека) ( Off *) (Вимк.) Searchable  (Доступний для пошуку)( Off *) (Вимк.) Archival (PDF/A)  (Архів (PDF/A)) ( Off *) (Вимк.) Налаштуйте параметри PDF відсканованого документа. Archival Version  (Версія архіву) і  Archival (PDF/A)  підтримуються, тільки якщо для параметра  PDF Version  (Версія PDF) встановлено значення 1.4. Меню  Highly Compressed  (Сильне стиснення) з’являється, лише якщо встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Пункт меню  Searchable  (Доступний для пошуку) з’являється, лише якщо ви придбали та встановили рішення OCR. Content Type  (Тип вмісту) Text  (Текст) Text/Photo * (Текст/фото) Photo  (Фотографія) Graphics  (Графіка) Покращте вихідний результат залежно від типу вмісту оригінального документа. Content Source  (Джерело вмісту) Black and White Laser * (Чорно-білий лазерний) Color Laser  (Кольоровий лазерний) Inkjet  (Струминний) Photo/Film  (Фото/фільм) Magazine  (Журнал) Newspaper  (Газета) Press  (Преса) Other  (Інше) Покращте вихідний результат залежно від вмісту оригінального документа. Color  (Кольоровий) Black and White  (Чорно-білий) Gray  (Сірий) Color * (Кольоровий) Auto  (Автоматично) Налаштуйте принтер на кольоровий або монохромний запис вмісту файлу. Resolution  (Роздільна здатність) 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Відрегулюйте роздільну здатність відсканованого зображення. Darkness  (Щільність) 1–9 (5*) Відрегулюйте щільність друку відсканованого зображення. Orientation  (Орієнтація) Portrait * (Портретна) Landscape  (Альбомна) Виберіть орієнтацію оригінального документа. Original Size  (Оригінальний розмір) Mixed Sizes * (Змішані розміри) Установіть розмір паперу оригінального документа. Sides  (Боки) Off * (Вимк.) Short Edge  (Короткий край) Long Edge  (Довгий край) Вкажіть орієнтацію оригінального документа в разі сканування з обох боків документа. Advanced Imaging  (Покращене зображення) Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Color Balance  (Колірний баланс) Cyan ‑ Red (0*)  (Блакитний - червоний (0*)) Magenta ‑ Green (0*)  (Пурпурний - зелений (0*)) Yellow ‑ Blue (0*)  (Жовтий - синій (0*)) Відрегулюйте інтенсивність кольору для блакитного, пурпурового та жовтого кольорів. Color Dropout  (Вилучення кольору) Color Dropout  (Вилучення кольору) ( None *) (Немає*) Default Red Threshold (128*)  (Червоний поріг за замовчуванням (128*)) Default Green Threshold (128*)  (Зелений поріг за замовчуванням (128*)) Default Blue Threshold (128*)  (Синій поріг за замовчуванням (128*)) Укажіть, який колір вилучати під час сканування, і налаштуйте параметр вилучення для цього кольору. Auto Color Detect  (Автоматичне визначення кольору) Color Sensitivity  (5*) (Чутливість кольору (5*)) Area Sensitivity (5*)  (Чутливість області (5*)) E‑mail Bit Depth  (Бітова глибина електронної пошти) (1 біт*) Minimum Scan Resolution  (Мінімальна роздільна здатність для сканування) (300 dpi*) Налаштуйте параметр автоматичного визначення кольору. JPEG Quality  (Якість JPEG) Best for content * (Найкраща для вмісту) 5–95 Відрегулюйте якість JPEG відсканованого зображення. Contrast  (Контрастність) Best for content * (Найкраща для вмісту) 0–5 Відрегулюйте контрастність відсканованого зображення. Background Removal  (Видалення фону) Background Detection ( Content‑based *) (Виявлення фону: на основі вмісту) Level   (0*) (Рівень (0*)) Видаліть фоновий колір або шум зображення з оригінального документа. Content-based  (на основі вмісту) видаляє колір фону з оригінального документа. Fixed  (Фіксований) видаляє шум із фото. Mirror Image  (Дзеркальне зображення) Off * (Вимк.) On  (Увімк.) Створити дзеркальне зображення оригінального документа. Negative Image  (Негативне зображення) Off * (Вимк.) On  (Увімк.) Створити негативне зображення оригінального документа. Shadow Detail  (Деталізація тіней) Від ‑4 до 4 (0*) Відрегулюйте деталізацію тіней відсканованого зображення. Scan Edge to Edge  (Сканувати від краю до краю) Off * (Вимк.) On  (Увімк.) Відскануйте оригінальний документ від краю до краю. Sharpness  (Різкість) 1–5 (3*) Відрегулюйте різкість відсканованого зображення. Temperature  (Температура) Від ‑4 до 4 (0*) Створення синішого або червонішого відтінку оригінального документа. Blank Pages  (Пусті сторінки) Blank Page Removal  (Видалення пустих сторінок) ( Do Not Remove * (Не видаляти)) Blank Page Sensitivity  (5*) (Чутливість пустих сторінок) (5*) Встановіть чутливість сканування щодо пустих сторінок оригінального документа. Admin Controls  (Елементи керування адміністратора) Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Max E‑mail Size  (Максимальний розмір електронного листа) 0–65535 (0*) Установіть допустимий розмір файлу для кожного електронного листа. Size Error Message  (Повідомлення про помилку розміру) Укажіть повідомлення про помилку, яке надсилатиме принтер, коли електронний лист перевищує допустимий розмір файлу. Ви можете ввести до 1024 символів. Limit Destinations  (Обмеження адресатів) Обмежити надсилання електронної пошти лише вказаним списком доменних імен. Використовуйте кому для відокремлення доменів. Send Me a Copy  (Надіслати мені копію) Never appears * (Ніколи не відображати*) On by Default  (Увімк. за замовчуванням) Off by Default  (Вимк. за замовчуванням) Always On  (Завжди ввімкнено) Надішліть копію електронного листа собі. Allow self e‑mails only  (Дозволити лише власні електронні листи Off * (Вимк.) On  (Увімк.) Налаштуйте принтер на надсилання електронних листів лише вам. Use cc:/bcc:  (Використовувати копію/приховану копію) Off * (Вимк.) On  (Увімк.) Увімкнути копіювання та приховане копіювання в електронній пошті. Use Multi‑Page TIFF  (Використовувати багатосторінковий TIFF) Off  (Вимк.) On * (Увімк.) Дозволяє сканувати кілька зображень TIFF в одному файлі TIFF. TIFF Compression  (Стиснення TIFF) JPEG LZW * Укажіть тип стиснення для файлів TIFF. Text Default  (Стандартний текст) 5–95 (75*) Установіть якість тексту у вмісті, який сканується. Text/Photo Default  (Стандартний текст/фото) 5–95 (75*) Установіть якість тексту та фото у вмісті, який сканується. Photo Default  (Стандартне фото) 5–95 (50*) Установіть якість фото у вмісті, який сканується. Adjust ADF Skew  (Коригувати перекошування пристрою АПД) Off  (Вимк.) On * (Увімк.) Налаштуйте принтер на коригування перекошених зображень із документів, які скануються з АПД. Transmission Log  (Журнал передачі) Print Log * (Журнал друку)* Do Not Print Log  (Не друкувати журнал) Print Only For Error  (друкувати тільки для помилок) Роздрукуйте журнал передачі для сканування електронної пошти. Log Paper Source  (Джерело журнального паперу) Tray  (Лоток) [x] (1*) Multipurpose Feeder  (Багатоцільовий подавач) Укажіть джерело паперу для друку журналів електронної пошти. Custom Job Scanning  (Сканування користувацького завдання) Off * (Вимк.) On  (Увімк.) Налаштуйте принтер на сканування першого набору оригінальних документів із зазначеними налаштуваннями, а потім на сканування наступного набору з тими самими або іншими налаштуваннями. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Scan Preview  (Попередній перегляд результату сканування) Off * (Вимк.) On  (Увімк.) Показати сканований попередній перегляд оригінального документа. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Allow Save as Shortcut  (Дозволити збереження як ярлика) Off  (Вимк.) On * (Увімк.) Збережіть адресу електронної пошти як ярлик. E‑mail Images Sent As  (Зображення, надіслані електронною поштою як) Attachment * (Вкладення) Web Link  (Вебпосилання) Укажіть спосіб надсилання зображень, які містяться в електронному листі. Reset E-mail Information After Sending  (Скинути інформацію електронного листа після надсилання) Off  (Вимк.) On * (Увімк.) Після надсилання електронного листа скиньте значення полів «Кому», «Тема», «Повідомлення» та «Ім’я» файлу до значень за замовчуванням. меню E‑mail Defaults  (Параметри електронної пошти за замовчуванням)"},{"UUID":"0d409867-85a9-4add-bc89-d206f7f8d9dc","title":"Електронна пошта","link":"email-setup-topic.html","desc":"Web Link Setup Пункти меню","descFull":"Web Link Setup Пункти меню  Web Link Setup  та їхній опис Елемент меню Опис Server Указати облікові дані сервера, на якому розміщено зображення, включені в електронний лист. Login Password Path File Name Web Link меню Web Link Setup"},{"UUID":"60a27330-2b9c-4074-9c8b-e2bd0a007a65","title":"FTP","link":"ftp-defaults-topic.html","desc":"FTP Defaults  (Параметри FTP","descFull":"FTP Defaults  (Параметри FTP за замовчуванням) Елементи меню  FTP Defaults  (Параметри FTP за замовчуванням) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Format  (Формат) JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Укажіть формат файлу для відсканованого зображення. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx)  і  CSV (.csv)  відображаються, тільки якщо ви придбали та встановили рішення для оптичного розпізнавання символів (OCR). Global OCR Settings  (Глобальні параметри OCR) Recognized Languages  (Мови розпізнавання) Auto Rotate  (Автоматичне обертання) ( Off *) (Вимк.) Despeckle  (Очищення плям) ( Off *) (Вимк.) Auto Contrast Enhance  (Автоматичне коригування контрастності) ( Off *) (Вимк.) Налаштуйте параметри оптичного розпізнавання символів (OCR). Цей пункт меню з’являється, лише якщо ви придбали та встановили рішення OCR. PDF Settings  (Параметри PDF) PDF Version  (Версія PDF) (1.5*) Archival Version  (Версія архіву) ( A‑1a *) Highly Compressed  (Сильне стиснення) ( Off *) (Вимк.) Secure  (Безпека) ( Off *) (Вимк.) Searchable  (Доступний для пошуку)( Off *) (Вимк.) Archival (PDF/A)  (Архів (PDF/A)) ( Off *) (Вимк.) Налаштуйте параметри PDF відсканованого зображення. Archival Version  (Версія архіву) і  Archival (PDF/A)  підтримуються, тільки якщо для параметра  PDF Version  (Версія PDF) встановлено значення 1.4. Меню  Highly Compressed  (Сильне стиснення) з’являється, лише якщо встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Пункт меню  Searchable  (Доступний для пошуку) з’являється, лише якщо ви придбали та встановили рішення OCR. Content Type  (Тип вмісту) Text  (Текст) Text/Photo * (Текст/фото) Graphics  (Графіка) Photo  (Фотографія) Покращте вихідний результат залежно від типу вмісту оригінального документа. Content Source  (Джерело вмісту) Black and White Laser * (Чорно-білий лазерний) Color Laser  (Кольоровий лазерний) Inkjet  (Струминний) Photo/Film  (Фото/фільм) Magazine  (Журнал) Newspaper  (Газета) Press  (Преса) Other  (Інше) Покращте вихідний результат залежно від вмісту оригінального документа. Color  (Кольоровий) Black and White  (Чорно-білий) Gray  (Сірий) Color * (Кольоровий) Auto  (Автоматично) Налаштуйте принтер на кольоровий або монохромний запис вмісту файлу. Resolution  (Роздільна здатність) 75 dpi 150 dpi* 200 dpi 300 dpi 400 dpi 600 dpi Відрегулюйте роздільну здатність відсканованого зображення. Darkness  (Щільність) 1–9 (5*) Відрегулюйте щільність друку відсканованого зображення. Orientation  (Орієнтація) Portrait * (Портретна) Landscape  (Альбомна) Виберіть орієнтацію оригінального документа. Original Size  (Оригінальний розмір) Mixed Sizes * (Змішані розміри) Установіть розмір паперу оригінального документа. Sides  (Боки) Off * (Вимк.) Long Edge  (Довгий край) Short Edge  (Короткий край) Вкажіть орієнтацію в разі сканування з обох боків документа. File Name  (назва файлу) Укажіть назву файлу для відсканованого зображення. Advanced Imaging  (Покращене зображення) Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Color Balance  (Колірний баланс) Cyan ‑ Red (0*)  (Блакитний - червоний (0*)) Magenta ‑ Green (0*)  (Пурпурний - зелений (0*)) Yellow ‑ Blue (0*)  (Жовтий - синій (0*)) Відрегулюйте інтенсивність кольору для блакитного, пурпурового та жовтого кольорів. Color Dropout  (Вилучення кольору) Color Dropout  (Вилучення кольору) ( None *) (Немає*) Default Red Threshold (128*)  (Червоний поріг за замовчуванням (128*)) Default Green Threshold (128*)  (Зелений поріг за замовчуванням (128*)) Default Blue Threshold (128*)  (Синій поріг за замовчуванням (128*)) Укажіть, який колір вилучати під час сканування, і налаштуйте параметр вилучення для цього кольору. Auto Color Detect  (Автоматичне визначення кольору) Color Sensitivity  (5*) (Чутливість кольору (5*)) Area Sensitivity (5*)  (Чутливість області (5*)) FTP Bit Depth  (Бітова глибина FTP) (1 біт*) Minimum Scan Resolution  (Мінімальна роздільна здатність для сканування) (300 dpi*) Налаштуйте параметр автоматичного визначення кольору. JPEG Quality  (Якість JPEG) Best for content * (Найкраща для вмісту) 5–95 Відрегулюйте якість JPEG відсканованого зображення. Contrast  (Контрастність) Best for content * (Найкраща для вмісту) 0 1 2 3 4 5 Відрегулюйте контрастність відсканованого зображення. Background Removal  (Видалення фону) Background Detection ( Content‑based *) (Виявлення фону: на основі вмісту) Level (0*)  (Рівень (0*)) Видаліть фоновий колір або шум зображення з оригінального документа. Content-based  (на основі вмісту) видаляє колір фону з оригінального документа. Fixed  (Фіксований) видаляє шум із фото. Mirror Image  (Дзеркальне зображення) Off * (Вимк.) On  (Увімк.) Створити дзеркальне зображення оригінального документа. Negative Image  (Негативне зображення) Off * (Вимк.) On  (Увімк.) Створити негативне зображення оригінального документа. Shadow Detail  (Деталізація тіней) Від ‑4 до 4 (0*) Відрегулюйте деталізацію тіней відсканованого зображення. Scan Edge to Edge  (Сканувати від краю до краю) Off * (Вимк.) On  (Увімк.) Дозволити сканування оригінального документа від краю до краю. Sharpness  (Різкість) 1–5 (3*) Відрегулюйте різкість відсканованого зображення. Temperature  (Температура) Від ‑4 до 4 (0*) Створення синішого або червонішого відтінку оригінального документа. Blank Pages  (Пусті сторінки) Blank Page Removal  (Видалення пустих сторінок) ( Do Not Remove * (Не видаляти)) Blank Page Sensitivity  (5*) (Чутливість пустих сторінок) (5*) Встановіть чутливість сканування щодо пустих сторінок оригінального документа. Admin Controls  (Елементи керування адміністратора) Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Text Default  (Стандартний текст) 5–95 (75*) Установіть якість тексту на відсканованому зображенні. Text/Photo Default  (Стандартний текст/фото) 5–95 (75*) Установіть якість тексту та фото на відсканованому зображенні. Photo Default  (Стандартне фото) 5–95 (50*) Установіть якість фото на відсканованому зображенні. Use Multi‑Page TIFF  (Використовувати багатосторінковий TIFF) On * (Увімк.) Off  (Вимк.) Дозволяє сканувати кілька зображень TIFF в одному файлі TIFF. TIFF Compression  (Стиснення TIFF) LZW * JPEG Укажіть тип стиснення для файлів TIFF. Transmission Log  (Журнал передачі) Print Log * (Журнал друку)* Do Not Print Log  (Не друкувати журнал) Print Only For Error  (Друкувати тільки для помилок) Роздрукуйте журнал передачі для сканування FTP. Log Paper Source  (Джерело журнального паперу) Tray  (Лоток) [x] (1*) Multipurpose Feeder  (Багатоцільовий подавач) Укажіть джерело паперу для друку журналів FTP. Custom Job Scanning  (Сканування користувацького завдання) Off * (Вимк.) On  (Увімк.) Налаштуйте принтер на сканування першого набору оригінальних документів із зазначеними налаштуваннями, а потім на сканування наступного набору з тими самими або іншими налаштуваннями. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Scan Preview  (Попередній перегляд результату сканування) Off * (Вимк.) On  (Увімк.) Показати попередній перегляд оригінального документа. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Allow Save as Shortcut  (Дозволити збереження як ярлика) Off  (Вимк.) On * (Увімк.) Збережіть адресу FTP як ярлик. Adjust ADF Skew  (Коригувати перекошування пристрою АПД) Off * (Вимк.) On  (Увімк.) Налаштуйте принтер на коригування перекошених зображень із документів, які скануються з АПД. Use Passive FTP  (Використовувати пасивний FTP) Off * (Вимк.) On  (Увімк.) Дозвольте FTP-серверу вказати порт даних, до якого підключається принтер. меню FTP Defaults  (Параметри FTP за замовчуванням)"},{"UUID":"4a2811be-d524-4f8d-994e-fb103106e259","title":"USB-накопичувач","link":"flash-drive-scan-topic.html","desc":"Flash Drive Scan  (Сканування","descFull":"Flash Drive Scan  (Сканування флешнакопичувача) Елементи меню  Flash Drive Scan  (Сканування флешнакопичувача) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Format  (Формат) JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Укажіть формат файлу для відсканованого зображення. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx)  і  CSV (.csv)  відображаються, тільки якщо ви придбали та встановили рішення для оптичного розпізнавання символів (OCR). Global OCR Settings  (Глобальні параметри OCR) Recognized Languages  (Мови розпізнавання) Auto Rotate  (Автоматичне обертання) ( Off *) (Вимк.) Despeckle  (Очищення плям) ( Off *) (Вимк.) Auto Contrast Enhance  (Автоматичне коригування контрастності) ( Off *) (Вимк.) Налаштуйте параметри оптичного розпізнавання символів (OCR). Цей пункт меню з’являється, лише якщо ви придбали та встановили рішення OCR. PDF Settings  (Параметри PDF) PDF Version  (Версія PDF) (1.5*) Archival Version  (Версія архіву) (A‑1a*) Highly Compressed  (Сильне стиснення) ( Off *) (Вимк.) Secure  (Безпека) ( Off *) (Вимк.) Searchable  (Доступний для пошуку)( Off *) (Вимк.) Archival (PDF/A)  (Архів (PDF/A)) ( Off *) (Вимк.) Налаштуйте параметри PDF відсканованого зображення. Archival Version  (Версія архіву) і  Archival (PDF/A)  підтримуються, тільки якщо для параметра  PDF Version  (Версія PDF) встановлено значення 1.4. Меню  Highly Compressed  (Сильне стиснення) з’являється, лише якщо встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Пункт меню  Searchable  (Доступний для пошуку) з’являється, лише якщо ви придбали та встановили рішення OCR. Content Type  (Тип вмісту) Text  (Текст) Text/Photo * (Текст/фото) Graphics  (Графіка) Photo  (Фотографія) Покращте вихідний результат залежно від типу вмісту оригінального документа. Content Source  (Джерело вмісту) Black and White Laser * (Чорно-білий лазерний) Color Laser  (Кольоровий лазерний) Inkjet  (Струминний) Photo/Film  (Фото/фільм) Magazine  (Журнал) Newspaper  (Газета) Press  (Преса) Other  (Інше) Покращте вихідний результат залежно від вмісту оригінального документа. Color  (Кольоровий) Black and White  (Чорно-білий) Gray  (Сірий) Color * (Кольоровий) Auto  (Автоматично) Налаштуйте принтер на кольоровий або монохромний запис вмісту файлу. Resolution  (Роздільна здатність) 75 dpi 150 dpi* 200 dpi 300 dpi 400 dpi 600 dpi Відрегулюйте роздільну здатність відсканованого зображення. Darkness  (Щільність) 1–9 (5*) Відрегулюйте щільність друку відсканованого зображення. Orientation  (Орієнтація) Portrait * (Портретна) Landscape  (Альбомна) Виберіть орієнтацію оригінального документа. Original Size  (Оригінальний розмір) Mixed Sizes * (Змішані розміри) Установіть розмір паперу оригінального документа. Sides  (Боки) Off * (Вимк.) Long Edge  (Довгий край) Short Edge  (Короткий край) Вкажіть орієнтацію оригінального документа в разі сканування з обох боків документа. File Name  (Назва файлу) Укажіть назву файлу для відсканованого зображення. Advanced Imaging  (Покращене зображення) Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Color Balance  (Колірний баланс) Cyan ‑ Red (0*)  (Блакитний - червоний (0*)) Magenta ‑ Green (0*)  (Пурпурний - зелений (0*)) Yellow ‑ Blue (0*)  (Жовтий - синій (0*)) Відрегулюйте інтенсивність кольору для блакитного, пурпурового та жовтого кольорів. Color Dropout  (Вилучення кольору) Color Dropout  (Вилучення кольору) ( None *) (Немає*) Default Red Threshold (128*)  (Червоний поріг за замовчуванням (128*))  Default Green Threshold (128*)  (Зелений поріг за замовчуванням (128*)) Default Blue Threshold (128*)  (Синій поріг за замовчуванням (128*)) Укажіть, який колір вилучати під час сканування, і налаштуйте параметр вилучення для цього кольору. Auto Color Detect  (Автоматичне визначення кольору) Color Sensitivity (5*)  (Чутливість кольору (5*)) Area Sensitivity (5*)  (Чутливість області (5*)) Scan Bit Depth  (Бітова глибина сканування) (1 біт*) Minimum Scan Resolution  (Мінімальна роздільна здатність для сканування) (300 dpi*) Налаштуйте параметр автоматичного визначення кольору. JPEG Quality  (Якість JPEG) Best for content * (Найкраща для вмісту) 5–95 Відрегулюйте якість JPEG відсканованого зображення. Contrast  (Контрастність) Best for content * (Найкраща для вмісту) 0–5 Відрегулюйте контрастність відсканованого зображення. Background Removal  (Видалення фону) Background Detection ( Content‑based *) (Виявлення фону: на основі вмісту) Level (0*)  (Рівень (0*)) Видаліть фоновий колір або шум зображення з оригінального документа. Content-based  (на основі вмісту) видаляє колір фону з оригінального документа. Fixed  (Фіксований) видаляє шум із фото. Mirror Image  (Дзеркальне зображення) Off * (Вимк.) On  (Увімк.) Створити дзеркальне зображення оригінального документа. Negative Image  (Негативне зображення) Off * (Вимк.) On  (Увімк.) Створити негативне зображення оригінального документа. Shadow Detail  (Деталізація тіней) Від ‑4 до 4 (0*) Відрегулюйте деталізацію тіней відсканованого зображення. Scan Edge to Edge  (Сканувати від краю до краю) Off * (Вимк.) On  (Увімк.) Відскануйте оригінальний документ від краю до краю. Sharpness  (Різкість) 1–5 (3*) Відрегулюйте різкість відсканованого зображення. Temperature  (Температура) Від ‑4 до 4 (0*) Створення синішого або червонішого відтінку оригінального документа. Blank Pages  (Пусті сторінки) Blank Page Removal  (Видалення пустих сторінок) ( Do Not Remove * (Не видаляти)) Blank Page Sensitivity  (5*) (Чутливість пустих сторінок) (5*) Встановіть чутливість сканування щодо пустих сторінок оригінального документа. Admin Controls  (Елементи керування адміністратора) Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Text Default  (Стандартний текст) 5–95 (75*) Установіть якість тексту на відсканованому зображенні. Text/Photo Default  (Стандартний текст/фото) 5–95 (75*) Установіть якість тексту та фото на відсканованому зображенні. Photo Default  (Стандартне фото) 5–95 (50*) Установіть якість фото на відсканованому зображенні. Use Multi‑Page TIFF  (Використовувати багатосторінковий TIFF) Off  (Вимк.) On * (Увімк.) Дозволяє сканувати кілька зображень TIFF в одному файлі TIFF. TIFF Compression  (Стиснення TIFF) LZW * JPEG Укажіть тип стиснення для файлів TIFF. Custom Job Scanning  (Сканування користувацького завдання) Off * (Вимк.) On  (Увімк.) Налаштуйте принтер на сканування першого набору оригінальних документів із зазначеними налаштуваннями, а потім на сканування наступного набору з тими самими або іншими налаштуваннями. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Scan Preview  (Попередній перегляд результату сканування) Off * (Вимк.) On  (Увімк.) Показати сканований попередній перегляд оригінального документа. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Adjust ADF Skew  (Коригувати перекошування пристрою АПД) Off * (Вимк.) On  (Увімк.) Налаштуйте принтер на коригування перекошених зображень із документів, які скануються з АПД. меню Flash Drive Scan  (Сканування флешнакопичувача)"},{"UUID":"3663a8d3-d0bf-4840-9a9c-2a78832f53cc","title":"USB-накопичувач","link":"flash-drive-scan-topic.html","desc":"Flash Drive Print Пункти меню","descFull":"Flash Drive Print Пункти меню  Flash Drive Print  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Number of Copies 1–9999 (1*) Вкажіть кількість копій. Paper Source Tray  [x] (1*) Multipurpose Feeder Manual Paper Manual Envelope Укажіть джерело паперу для завдання друку. Collate Off [1,1,1,2,2,2] On [1,2,1,2,1,2] * Стежте за тим, щоб сторінки завдання друку складалися послідовно, особливо під час друку кількох копій завдання. Sides 1‑Sided * 2‑Sided Указати, чи друкувати на одній чи на обох сторонах паперу. Flip Style Long Edge * Short Edge Визначте, яка сторона паперу скріплюється під час виконання двостороннього друку. Pages per Side Off * 2 pages per side 3 pages per side 4 pages per side 6 pages per side 9 pages per side 12 pages per side 16 pages per side Надрукуйте зображення кількох сторінок на одній стороні аркуша паперу. Pages per Side Ordering Horizontal * Reverse Horizontal Reverse Vertical Vertical Укажіть розташування зображень кількох сторінок під час використання меню  Pages per Side . Pages per Side Orientation Auto * Landscape Portrait Укажіть орієнтацію зображень кількох сторінок під час використання меню  Pages per Side . Pages per Side Border None * Solid Друкуйте рамку навколо кожного зображення сторінки під час використання меню  Pages per Side . Separator Sheets Off * Between Copies Between Jobs Between Pages Вставляти пусті аркуші-розділювачі під час друку. Separator Sheet Source Tray  [x] (1*) Multipurpose Feeder Укажіть джерело паперу для аркуша-розділювача Blank Pages Do Not Print * Print Друкуйте пусті сторінки у завданні друку. меню Flash Drive Print"},{"UUID":"01653a9a-fe59-40aa-80a1-f68a3bc40f3b","title":"Мережа/порти","link":"network-overview-topic.html","desc":"Network Overview  (Огляд мережі)","descFull":"Network Overview  (Огляд мережі) Елементи меню  Network Overview  (Огляд мережі) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Active Adapter  (Активний адаптер) Auto * (Автоматично) Standard Network  (Стандартна мережа) Wireless  (Бездротовий зв’язок) Указати тип з’єднання з мережею. Параметр  Wireless  (Бездротовий зв’язок) доступний тільки в тому разі, якщо принтери підключені до бездротової мережі. Network Status  (Стан мережі) Показувати стан підключення мережі принтера. Display Network Status on Printer  (Відображати стан мережі на принтері) Off  (Вимк.) On * (Увімк.) Показувати стан мережі на дисплеї. Speed, Duplex  (Швидкість, дуплекс) Показувати швидкість наразі активної мережевої плати. IPv4 Показувати адресу IPv4. All IPv6 Addresses  (Усі адреси IPv6) Показувати адреси IPv6. Reset Print Server  (Скинути сервер друку) Скинути всі активні з’єднання принтера з мережею. Цей параметр видаляє всі налаштування конфігурації мережі. Network Job Timeout  (Тайм-аут мережевого завдання) Off  (Вимк.) On * (Увімк.) (90  seconds  (90 секунд)) Укажіть час, перш ніж принтер скасує завдання мережевого друк. Banner Page  (Сторінка банера) Off * (Вимк.) On  (Увімк.) Надрукувати банерну сторінку. Scan to PC Port Range  (Діапазон портів передавання сканованого зображення на ПК) Укажіть дійсний діапазон портів для принтерів, які перебувають за брандмауером, що блокує порти. Enable Network Connections  (Увімкнути мережеві підключення) Off  (Вимк.) On * (Увімк.) Увімкніть принтер для підключення до мережі. Enable LLDP  (Увімкнути LLDP) Off * (Вимк.) On  (Увімк.) Увімкнути протокол Link Layer Discovery Protocol (LLDP) на принтері. меню Network Overview  (Огляд мережі)"},{"UUID":"2f4ebf1e-f555-45b7-9ee1-64abaadf7e20","title":"Мережа/порти","link":"network-overview-topic.html","desc":"Wireless  (Бездротовий зв’язок) Це","descFull":"Wireless  (Бездротовий зв’язок) Це меню доступне лише на принтерах, підключених до мережі Wi‑Fi, або принтерах, які мають адаптер бездротової мережі. Елементи меню  Wireless  (Бездротовий зв’язок) і їхній опис Елемент меню Опис Setup Using Mobile App  (Налаштування за допомогою мобільного додатку) Налаштуйте підключення Wi‑Fi за допомогою Lexmark Mobile Assistant. Setup On Printer Panel  (Налаштування на панелі принтера) Choose Network  (Вибрати мережу) Add Wi‑Fi Network  (Додати мережу Wi‑Fi) Network Name  (Ім’я мережі) Network Mode  (Режим мережі) Infrastructure  (Інфраструктура) Wireless Security Mode  (Режим бездротової безпеки) Disabled * (Вимкнено) WPA2/WPA - Personal  (WPA2/WPA — персональний) WPA2 - Personal  (WPA2 — персональний) WPA2/WPA3 ‑ Personal  (WPA2/WPA3 — персональний) WPA3‑ Personal  (WPA3 — персональний) 802.1x - RADIUS  (802.1x — РАДІУС) Налаштуйте підключення Wi‑Fi за допомогою панелі керування. Цей пункт меню з’являється як  Wireless Connection Setup  (Налаштування бездротового підключення) лише у Embedded Web Server. Wi‑Fi Protected Setup   (Захищене налаштування через Wi‑Fi) Start Push Button Method  (Запустити метод Push Button) Start PIN Method  (Запустити метод PIN-коду) Встановіть мережу Wi‑Fi і ввімкніть безпеку мережі. Start Push Button Method  (Запустити метод Push Button) підключає принтер до мережі Wi‑Fi, якщо протягом певного часу натиснути кнопки на принтері та точці доступу (бездротовому маршрутизаторі). Start PIN Method  (Запустити метод PIN-коду) підключає принтер до мережі Wi‑Fi, коли PIN-код принтера вводиться в налаштування бездротової мережі точки доступу. Compatibility  (Сумісність) 802,11B/g/n (2.4GHz) * (2,4 ГГц) 802.11a/b/g/n/ac (2.4GHz/5GHz)  (2,4 ГГц/5 ГГц) 802.11a/n/ac (5GHz)  (5 ГГц) Укажіть стандарт мережі Wi‑Fi. 802,11a/b/g/n/ac (2.4GHz/5GHz)  (2,4 ГГц/5 ГГц) і  802,11a/n/ac (5GHz)  (5 ГГц) відображаються тільки в разі встановленого параметра Wi‑Fi. Wireless Security Mode  (Режим бездротової безпеки) Disabled * (Вимкнено) WPA2/WPA - Personal  (WPA2/WPA — персональний) WPA2 - Personal  (WPA2 — персональний) WPA2/WPA3 ‑ Personal  (WPA2/WPA3 — персональний) WPA3‑ Personal  (WPA3 — персональний) 802.1x - RADIUS  (802.1x — РАДІУС) Установіть режим безпеки для підключення принтера до пристроїв Wi‑Fi. WPA2/WPA Personal  (WPA2/WPA — персональний) AES * Увімкніть безпеку Wi‑Fi через захищений доступ до мережі Wi-Fi (WPA). Цей пункт меню з’являється лише тоді, коли для параметра  Wireless Security Mode  (Режим бездротової безпеки) встановлено значення  WPA2/WPA-Personal  (WPA2/WPA — персональний). Set PSK  (Установити PSK) Вкажіть для безпечного підключення до мережі Wi‑Fi. WPA2 - Personal  (WPA2 — персональний) AES * Увімкніть безпеку Wi‑Fi через WPA2. Цей пункт меню з’являється лише тоді, коли для параметра  Wireless Security Mode  (Режим бездротової безпеки) встановлено значення  WPA2-Personal .(WPA2 — персональний). 802.1x Encryption Mode  (Режим шифрування 802.1x) WPA+ WPA2 * WPA2 + RADIUS * Увімкніть безпеку Wi‑Fi через стандарт 802.1x. Цей пункт меню з’являється лише тоді, коли для параметра  Wireless Security Mode  (Режим бездротової безпеки) встановлено значення  802.1x - RADIUS  (802.1x — РАДІУС). IPv4 Enable DHCP  (Увімкнути DDNS) On * (Увімк.) Off  (Вимк.) Set Static IP Address  (Установити статичну IP-адресу) IP Address  (IP-адреса) Netmask  (Маска мережі) Gateway  (Шлюз) Увімкніть і налаштуйте параметри IPv4 для принтера. IPv6 Enable Ipv6  (Увімкнути IPv6) On * (Увімк.) Off  (Вимк.) Enable DHCPv6  (Увімкнути DHCPv6) On  (Увімк.) Off * (Вимк.) Stateless Address Autoconfiguration  (Автоматична конфігурація адреси без збереження стану) On * (Увімк.) Off  (Вимк.) DNS Server Address  (Адреса сервера DNS) Manually Assigned IPv6 Address  (Адреса IPv6, призначена вручну) Manually Assigned IPv6 Router  (Призначений вручну маршрутизатор IPv6) Address Prefix  (Префікс адреси) All IPv6 Addresses  (Усі адреси IPv6) All IPv6 Router Addresses  (Усі IPv6-адреси маршрутизаторів) Увімкніть і налаштуйте параметри IPv6 для принтера. Network Address  (Адреса мережі) UAA LAA Перегляньте адреси мережі. PCL SmartSwitch On * (Увімк.) Off  (Вимк.) Налаштуйте принтер на автоматичний перехід на емуляцію PCL, коли цього вимагає завдання друку, незалежно від мови принтера за замовчуванням. Якщо параметр  PCL SmartSwitch  вимкнено, принтер не перевіряє вхідні дані та використовує мову принтера за замовчуванням, указану в меню  Setup  (Налаштування). PS SmartSwitch On * (Увімк.) Off  (Вимк.) Налаштуйте принтер на автоматичний перехід на емуляцію PS, коли цього вимагає завдання друку, незалежно від мови принтера за замовчуванням. Якщо параметр  PS SmartSwitch  вимкнено, принтер не перевіряє вхідні дані та використовує мову принтера за замовчуванням, указану в меню  Setup  (Налаштування). Job Buffering  (Буферизація завдань) On  (Увімк.) Off * (Вимк.) Тимчасово зберігайте завдання друку на жорсткому диску або інтелектуальному накопичувачі (ISD) перед друком. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Mac Binary PS  (Двійковий файл Mac PS) Auto * (Автоматично) On  (Увімк.) Off  (Вимк.) Налаштуйте принтер на обробку бінарних завдань друку Macintosh PostScript. On  (Увімкнено) обробляє необроблені бінарні завдання друку PostScript. Off  (Вимк.) фільтрує завдання друку за стандартним протоколом. меню Wireless  (Бездротовий зв’язок)"},{"UUID":"92f91fca-e0f4-404d-96cb-5caf02abb7c9","title":"Мережа/порти","link":"network-overview-topic.html","desc":"Wi‑Fi Direct Це меню доступне","descFull":"Wi‑Fi Direct Це меню доступне лише на принтерах, підключених до мережі Wi‑Fi, або принтерах, які мають адаптер бездротової мережі. Пункти меню  Wi‑Fi Direct  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Enable Wi‑Fi Direct On Off * Налаштуйте принтер на пряме підключення до пристроїв Wi-Fi. Wi‑Fi Direct Name Укажіть назву мережі Wi‑Fi Direct. Wi‑Fi Direct Password Установіть пароль для автентифікації та перевірки користувачів під час з’єднання Wi‑Fi. Show Password on Setup Page Off On * Показати  Wi‑Fi Direct Password  на  Network Setup Page . Preferred Channel Number 1–11 Auto * Установіть бажаний канал мережі Wi‑Fi. Group Owner IP Address Вкажіть IP-адресу власника групи. Auto‑Accept Push Button Requests Off * On Приймати запити на автоматичне підключення до мережі. Автоматичний прийом клієнтів не захищений. меню Wi‑Fi Direct"},{"UUID":"733b1690-b4ee-4f4d-9522-a7be770a853b","title":"Мережа/порти","link":"network-overview-topic.html","desc":"AirPrint Цей пункт меню з’являється","descFull":"AirPrint Цей пункт меню з’являється лише у вбудованому вебсервері. Пункти меню  AirPrint  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. All AirPrint Functions Показати стан AirPrint принтеру. Enable AirPrint On * Off Увімкнути функцію AirPrint. Цей пункт меню з’являється, лише якщо протокол друку через інтернет (IPP) або mDNS вимкнено. Enable iBeacon On Off * Увімкнути функцію iBeacon. Bonjour Name Визначте позначення та розташування принтера. Organization Name Organizational Unit Printer Location Printer's Latitude Printer's Longitude Printer's Altitude More Options меню AirPrint"},{"UUID":"a53f89d7-2d55-4b44-ab41-9e79b5980a14","title":"Мережа/порти","link":"network-overview-topic.html","desc":"Mobile Services Management Пункти меню","descFull":"Mobile Services Management Пункти меню  Mobile Services Management  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Enable IPP Print On * Off Дозволити друк із мобільних пристроїв за допомогою інтернет-протоколу друку (IPP). Enable IPP Fax On * Off Дозволити надсилання факсів за допомогою інтернет-протоколу друку (IPP). Enable IPP Over USB On * Off Дозволити завдання друку або сканування за допомогою USB-підключення. Enable Scan On * Off Дозволити сканування за допомогою протоколу eSCL. Enable Mopria Discovery On * Off Дозволити виявлення принтера пристроями з підтримкою Mopria. меню Mobile Services Management (Керування мобільними послугами)"},{"UUID":"39e8bb30-cc1d-4084-873a-bcc40aa5b40d","title":"Мережа/порти","link":"network-overview-topic.html","desc":"Ethernet Елементи меню  Ethernet","descFull":"Ethernet Елементи меню  Ethernet  і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Network Speed  (Швидкість мережі) Показати швидкість активного мережевого адаптера. IPv4 Enable DHCP  (Увімкнути DHCP) ( On *) (Увімк.) Set Static IP Address  (Установити статичну IP-адресу) Налаштування IPv4 параметрів. IPv6 Enable Ipv6  (Увімкнути IPv6) ( On *) (Увімк.) Enable DHCPv6  (Увімкнути DHCPv6) ( Off *) (Вимк.) Stateless Address Autoconfiguration  (Автоматична конфігурація адреси без збереження стану) ( On *) (Увімк.) DNS Server Address  (Адреса сервера DNS) Manually Assigned IPv6 Address  (Адреса IPv6, призначена вручну) Manually Assigned IPv6 Router  (Призначений вручну маршрутизатор IPv6) Address Prefix (64*)  (Префікс адреси (64*)) All IPv6 Addresses  (Усі адреси IPv6) All IPv6 Router Addresses  (Усі IPv6-адреси маршрутизаторів) Налаштування IPv6 параметрів. Network Address  (Адреса мережі) UAA LAA Вкажіть адресу мережі. PCL SmartSwitch Off  (Вимк.) On * (Увімк.) Налаштуйте принтер на автоматичний перехід на емуляцію PCL, коли цього вимагає завдання друку, незалежно від мови принтера за замовчуванням. Якщо цей параметр вимкнено, принтер не перевіряє вхідні дані та використовує мову принтера за замовчуванням, указану в меню  Setup  (Налаштування). PS SmartSwitch Off  (Вимк.) On * (Увімк.) Налаштуйте принтер на автоматичний перехід на емуляцію PostScript, коли цього вимагає завдання друку, незалежно від мови принтера за замовчуванням. Якщо цей параметр вимкнено, принтер не перевіряє вхідні дані та використовує мову принтера за замовчуванням, указану в меню  Setup  (Налаштування). Job Buffering  (Буферизація завдань) Off * (Вимк.) On  (Увімк.) Тимчасово зберігайте завдання друку на жорсткому диску або інтелектуальному накопичувачі (ISD) перед друком. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Mac Binary PS  (Двійковий файл Mac PS) Auto * (Автоматично) On  (Увімк.) Off  (Вимк.) Налаштуйте принтер на обробку бінарних завдань друку Macintosh PostScript. Параметр  Auto  (Автоматично) обробляє завдання друку з комп’ютерів, які використовують операційні системи Windows або Macintosh. Параметр  Off  (Вимк.) фільтрує завдання друку PostScript за стандартним протоколом. Energy Efficient Ethernet  (Енергоефективний Ethernet) On  (Увімк.) Off  (Вимк.) Auto * (Автоматично) Зменште споживання енергії, коли принтер не отримує дані з мережі Ethernet. меню Ethernet"},{"UUID":"0d226014-cd22-4b9a-be21-304089cdbbb1","title":"Мережа/порти","link":"network-overview-topic.html","desc":"TCP/IP Це меню відображається лише","descFull":"TCP/IP Це меню відображається лише на мережевих принтерах чи принтерах, підключених до серверів друку. Елементи меню  TCP/ IP  і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Set Hostname  (Установити ім’я хосту) Налаштувати поточне ім’я хосту TCP/IP. Domain Name  (Назва домену) Налаштуйте ім’я домену. Allow DHCP/BOOTP to update NTP server  (Дозволити DHCP/BOOTP оновлювати сервер NTP) On * (Увімк.) Off  (Вимк.) Дозволити клієнтам DHCP і BOOTP оновлювати параметри NTP принтера. Zero Configuration Name  (Назва нульової конфігурації) Указати назву служби для мережі з нульовою конфігурацією. Enable Auto IP  (Увімкнути автоматичну IP-адресу) Off  (Вимк.) On * (Увімк.) Призначити IP-адресу автоматично. DNS Server Address  (Адреса сервера DNS) Указати поточну адресу сервера системи доменних імен (DNS). Backup DNS Server Address  (Резервна адреса DNS-сервера) Указати резервні адреси серверів DNS. Backup DNS Server Address 2  (Резервна адреса DNS-сервера 2) Backup DNS Server Address 3  (Резервна адреса DNS-сервера 3) Domain Search Order  (Порядок пошуку домену) Указати список доменних імен для пошуку принтера ті його ресурсів в інших доменах мережі. Enable DDNS  (Увімкнути DDNS) Off * (Вимк.) On  (Увімк.) Оновити параметри динамічної DNS. DDNS TTL  (TTL-схема DDNS) Указати параметри поточної DDNS. Default TTL  (Стандартна TTL-схема) DDNS Refresh Time  (Час оновлення DDNS) Enable mDNS  (Увімкнути mDNS) Off  (Вимк.) On * (Увімк.) Оновити параметри багатоадресної DNS. WINS Server Address  (Адреса сервера DNS) Указати адресу сервера для Windows Internet Name Service (WINS). Enable BOOTP  (Увімкнути LLDP) Off * (Вимк.) On  (Увімк.) Дозволити BOOTP призначити IP-адресу принтера. Restricted Server List  (Перелік обмежених серверів) Указати IP-адреси, яким дозволено обмінюватися даними з принтером через TCP/IP. Використовувати кому для розділення IP-адрес. Можна додати 50 IP-адрес. Restricted Server List Options  (Параметри переліку обмежених серверів) Block All Ports * (Блокувати всі порти) Block Printing Only  (Блокувати тільки друк) Block Printing and HTTP Only  (Блокувати тільки друк і HTTP) Указати параметр доступу для IP-адрес, яких немає в списку. MTU  (Максимальна одиниця передавання) 256–1500 Ethernet  (1500*) Указати параметр максимальної одиниці передавання (MTU) для з’єднань TCP. Raw Print Port  (Порт необробленого друку) 1–65535 (9100*) Указати вихідний номер порту для принтерів, підключених до мережі. Outbound Traffic Maximum Speed  (Максимальна швидкість вихідного трафіку) Off * (Вимк.) On  (Увімк.) Установити максимальну швидкість передавання даних принтера. Якщо його ввімкнено, опція для цього параметра становить 100–1000000 кілобіт/с. TLS Support  (Підтримка TLS) Enable TLSv1.0  (Увімкнути TLSv1.0) ( Off ) (Вимк.) Увімкнути TLSv1.1 ( Off *) (Вимк.) Увімкнути TLSv1.2  ( On *) (Увімк.) Увімкнути протокол безпеки транспортного рівня. SSL Cipher List  (Список шифрів SSL) Указати алгоритми шифрування для підключень SSL або TLS. TLSv1.3 SSL Cipher List  (Список шифрів TLSv1.3 SSL) меню TCP/IP"},{"UUID":"b8ee456b-226c-4e92-8bb6-6c8308fbfbd0","title":"Мережа/порти","link":"network-overview-topic.html","desc":"SNMP Це меню відображається лише","descFull":"SNMP Це меню відображається лише на мережевих принтерах чи принтерах, підключених до серверів друку. Пункти меню  SNMP  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. SNMP Versions 1 and 2c Enabled Off On * Allow SNMP Set Off On * Enable PPM MIB Off On * SNMP Community Налаштувати протокол Simple Network Management Protocol (SNMP) версій 1 і 2c, щоб установити драйвери принтера та додатки. SNMP Version 3 Enabled Off On * Context Name Set Read/Write Credentials User Name Authentication Password Privacy Password Set Read‑only Credentials User Name Authentication Password Privacy Password Authentication Hash MD5 SHA1 * Minimum Authentication Level No Authentication, No Privacy Authentication, No Privacy Authentication, Privacy * Privacy Algorithm DES AES‑128 * Налаштувати SNMP версії 3, щоб установити й оновити засоби безпеки принтера. меню SNMP"},{"UUID":"77a3250b-8cbd-490b-8934-c0d5dd357fdd","title":"Мережа/порти","link":"network-overview-topic.html","desc":"IPSec Це меню відображається лише","descFull":"IPSec Це меню відображається лише на мережевих принтерах чи принтерах, підключених до серверів друку. Пункти меню  IPSec  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Enable IPSec Off * On Увімкнути Internet Protocol Security (IPSec). Base Configuration Default * Compatibility Secure Налаштувати базову конфігурацію IPSec. Цей пункт меню відображається, лише коли для параметра  Enable IPSec  встановлено значення  On . DH (Diffie‑Hellman) Group Proposal modp2048 (14) * modp3072 (15) modp4096 (16) modp6144 (17) Налаштувати базову конфігурацію IPSec. Цей пункт меню відображається, лише коли для параметра  Base Configuration  встановлено значення  Compatibility . Proposed Encryption Method 3DES AES * Налаштувати спосіб шифрування. Цей пункт меню відображається, лише коли для параметра  Base Configuration  встановлено значення  Compatibility . Proposed Authentication Method SHA1 SHA256 * SHA512 Налаштувати спосіб автентифікації. Цей пункт меню відображається, лише коли для параметра  Base Configuration  встановлено значення  Compatibility . IKE SA Lifetime (Hours) 1 2 4 8 24* Указати період закінчення терміну дії IKE SA. Цей пункт меню відображається, лише коли для параметра  Base Configuration  встановлено значення  Secure . IPSec SA Lifetime (Hours) 1 2 4 8* 24 Указати період закінчення терміну дії IPSec SA. Цей пункт меню відображається, лише коли для параметра  Base Configuration  встановлено значення  Secure . IPSec Device Certificate Укажіть сертифікат IPSec. Цей пункт меню відображається, лише коли для параметра  Enable IPSec  встановлено значення  On . Pre‑Shared Key Authenticated Connections Host  [x] Налаштувати авторизовані з’єднання принтера. Ці пункти меню відображаються, лише коли для параметра  Enable IPSec  встановлено значення  On . Certificate Authenticated Connections Host  [x]  Address[/subnet] меню IPSec"},{"UUID":"f97e8e4e-abfb-457e-be14-aefe287564f8","title":"Мережа/порти","link":"network-overview-topic.html","desc":"802.1x Це меню відображається лише","descFull":"802.1x Це меню відображається лише на мережевих принтерах чи принтерах, підключених до серверів друку. Елементи меню  802.1x  і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Active  (Активні) Off * (Вимк.) On  (Увімк.) Дозволити принтеру під’єднуватися до мереж, які вимагають автентифікації, перш ніж надавати доступ. 802.1x Authentication  (Автентифікація 802.1x) Device Login Name  (Ім’я для входу на пристрій) Device Login Password  (Пароль для входу на пристрій) Validate Serve Certificate  (Перевірити сертифікат обслуговування)( On *) (Увімк.) Enable Event Logging  (Увімкнути журнал подій) ( Off *) (Вимк.) 802.1x Device Certificate  (Сертифікат пристрою 802.1x) Налаштувати параметри автентифікації з’єднання 802.1x. Authentication Mechanisms  (Механізми автентифікації) EAP ‑ MD5  ( On *) (Увімк.*) EAP- MSCHAPv2  ( On *) (Увімк.*) LEAP  ( On *) (Увімк.*) PEAP  ( On *) (Увімк.*) EAP - TLS  ( On *) (Увімк.*) EAP - TTLS  ( On *) (Увімк.*) TTLS Authentication Method  (Спосіб автентифікації TTLS) ( MSCHAPv2 *) Налаштувати дозволені механізми автентифікації для з'єднання 802.1x. меню 802.1x"},{"UUID":"0502a9f0-fad0-4952-a0ad-84964f02a5a2","title":"Мережа/порти","link":"network-overview-topic.html","desc":"LPD Configuration Це меню відображається","descFull":"LPD Configuration Це меню відображається лише на мережевих принтерах чи принтерах, підключених до серверів друку. Пункти меню  LPD Configuration  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. LPD Timeout 0–65535 секунд (90*) Установити значення часу простою, щоб сервер Line Printer Daemon (LPD) не очікував нескінченно на завершення завислих або недійсних завдань друку. LPD Banner Page Off * On Надрукувати банерну сторінку для всіх завдань друку LPD. Банерна сторінка — це перша сторінка завдання друку, яка використовується як розділювач завдань друку, а також для ідентифікації ініціатора запиту на завдання друку. LPD Trailer Page Off * On Надрукувати кінцеву сторінку для всіх завдань друку LPD. Кінцева сторінка — це остання сторінка завдання друку. LPD Carriage Return Conversion Off * On Увімкнути повернення картки. Повернення каретки — це механізм, який дає принтеру команду змістити положення курсора до першої позиції в тому ж рядку. меню LPD Configuration"},{"UUID":"e5153ab8-8794-4b4b-8010-403b4c204fb1","title":"Мережа/порти","link":"network-overview-topic.html","desc":"HTTP/FTP Settings Пункти меню ","descFull":"HTTP/FTP Settings Пункти меню  HTTP/FTP Settings  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Proxy HTPP Proxy IP Address HTTP Default IP Port FTP Proxy IP Address FTP Default IP Port Authentication User Name Password Local Domains Налаштувати параметри сервера HTTP або FTP. Other Settings Enable HTTP Server  ( On *) Отримати доступ вбудованого вебсервера, щоб відстежувати принтер і керувати ним. Other Settings Enable HTPPS  ( On *) Увімкнути протокол Hypertext Transfer Protocol Secure (HTTPS), щоб зашифрувати передавання даних на сервер друку та з нього. Other Settings Force HTTPS Connections  ( Off *) Налаштувати використання принтером з’єднання HTTPS. Other Settings Enable FTP/TFTP  ( On *) Надіслати файли за допомогою протоколу FTP/TFTP. Other Settings HTTPS Device Certificate  ( default *) Переглянути сертифікат пристрою HTTP, який використовується на принтері. Other Settings Timeout for HTTP/FTP Requests  (30*) Указати проміжок часу до припинення з’єднання із сервером. Other Settings Retries for HTTP/FTP Requests  (3*) Указати кількість повторних спроб під’єднання до сервера HTTP/FTP. меню HTTP/FTP Settings"},{"UUID":"5a49ad53-4930-4a8e-8ec7-773e2c910751","title":"Мережа/порти","link":"network-overview-topic.html","desc":"ThinPrint Пункти меню  ThinPrint","descFull":"ThinPrint Пункти меню  ThinPrint  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Enable ThinPrint Off * On Друкувати за допомогою ThinPrint. Port Number 4000–4999 (4000*) Налаштувати номер порту для сервера ThinPrint. Bandwidth (bits/sec) 100–1 000 000 (0*) Налаштувати швидкість передавання даних у середовищі ThinPrint. Packet Size (kbytes) 0–64000 (0*) Налаштувати розмір пакета для передавання даних. меню ThinPrint"},{"UUID":"49a4945e-180f-432b-8d61-8bef0b27d427","title":"Мережа/порти","link":"network-overview-topic.html","desc":"USB Елементи меню  USB","descFull":"USB Елементи меню  USB  і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. PCL SmartSwitch Off  (Вимк.) On * (Увімк.) Налаштуйте принтер на емуляцію PCL, коли цього вимагає завдання друку, отримане через порт USB, незалежно від мови принтера за замовчуванням. Якщо цей параметр вимкнено, принтер не перевіряє вхідні дані та використовує мову принтера за замовчуванням, указану в меню  Setup  (Налаштування). PS SmartSwitch Off  (Вимк.) On * (Увімк.) Налаштуйте принтер на емуляцію PostScript, коли цього вимагає завдання друку, отримане через порт USB, незалежно від мови принтера за замовчуванням. Якщо цей параметр вимкнено, принтер не перевіряє вхідні дані та використовує мову принтера за замовчуванням, указану в меню  Setup  (Налаштування). Job Buffering  (Буферизація завдань) Off * (Вимк.) On  (Увімк.) Тимчасово зберігайте завдання друку на жорсткому диску або інтелектуальному накопичувачі (ISD) перед друком. Цей пункт меню з’являється лише тоді, коли встановлено жорсткий диск або інтелектуальний накопичувач (ISD). Mac Binary PS  (Двійковий файл Mac PS) Auto * (Автоматично) On  (Увімк.) Off  (Вимк.) Налаштуйте принтер на обробку бінарних завдань друку Macintosh PostScript. Параметр  Auto  (Автоматично) обробляє завдання друку з комп’ютерів, які використовують операційні системи Windows або Macintosh. Параметр  Off  (Вимк.) фільтрує завдання друку PostScript за стандартним протоколом. Enable USB Port  (Увімкнення порту USB) Off  (Вимк.) On * (Увімк.) Увімкніть передній USB-порт. меню USB"},{"UUID":"ca7d2424-8a85-4863-a0db-6681fadbf1ed","title":"Мережа/порти","link":"network-overview-topic.html","desc":"Restrict external network access Restrict","descFull":"Restrict external network access Restrict external network access  Елементи меню параметрів і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Restrict external network access Off * On Обмежити доступ до мережевих сайтів. External network address Указати мережеві адреси з обмеженим доступом. E‑mail address for notification Указати електронну адресу, щоб надіслати сповіщення про зареєстровані події. Ping frequency 1–300 (10*) Указати інтервал між запитами мережі в секундах. Subject Указати тему та повідомлення електронного листа зі сповіщенням. Message меню Restrict external network access"},{"UUID":"ad0d2d5f-5ff2-4272-a213-7745850e0dd7","title":"Способи входу","link":"login-methods-subgroup.html","desc":"Manage Permissions  (Керування дозволами)","descFull":"Manage Permissions  (Керування дозволами) Елементи меню  Manage Permissions  (Керування дозволами) і їхній опис Елемент меню Опис Function Access  (Доступ до функцій) Access Address Book in Apps  (Доступ до адресної книги в програмах) Modify Address Book  (Змінити адресну книгу) Manage Shortcuts  (Керування ярликами) Create Profiles  (Створити профілі) Manage Bookmarks  (Керування закладками) Flash Drive Print  (Друк із флешнакопичувача) Flash Drive Scan  (Сканування флешнакопичувача) Copy Function  (Функція копіювання) Color Dropout  (Вилучення кольору) E‑mail Function  (Функції електронної пошти) Fax Function  (Функція факсу) FTP Function  (Функція FTP) Release Held Faxes  (Випустити відкладені факси) Held Jobs Access  (Доступ до відкладених завдань) User Profiles  (Профілі користувача) Cancel Jobs at the Device  (Скасувати завдання на пристрої) Change Language  (Змінити мову) Internet Printing Protocol (IPP)  (Інтернет-протокол друку) Initiate Scans Remotely  (Ініціювати сканування віддалено) B/W Print  (Чорно-білий друк) Network Folder ‑ Scan  (Мережева папка – сканування) Керуйте доступом до функцій принтера. Administrative Menus  (Адміністративні меню) Security Menu  (Меню безпеки) Network/Ports Menu  (Меню «Мережа/Порти») Paper Menu  (Меню «Папір») Reports Menu  (Меню «Звіти») Function Configuration Menus  (Меню конфігурації функцій) Supplies Menu  (Меню «Витратні матеріали») Option Card Menu  (Меню додаткових карток) SE Menu  (Меню SE) Device Menu  (Меню пристрою) Керуйте доступом до параметрів меню принтера. Device Management  (Керування пристроєм) Remote Management  (Віддалене керування) Firmware Updates  (Оновлення мікропрограми) Apps Configuration  (Конфігурація програм) Operator Panel Lock  (Блокування панелі оператора) Embedded Web Server Access  (Доступ до Embedded Web Server) Import / Export All Settings  (Імпорт/експорт усіх налаштувань) Out of Service Erase   (Стирання для виведення з експлуатації) Cloud Services Enrollment  (Реєстрація в хмарних службах) Керуйте доступом до параметрів керування принтером. Apps  (Програми) New Apps  (Нові програми) Scan Center  (Центр сканування) Scan Center Custom [x]  (Налаштування центру сканування [x]) Керуйте доступом до програми принтера. меню Manage Permissions  (Керування дозволами)"},{"UUID":"a49617df-c025-4a3b-b8bd-f6d6604cd13c","title":"Способи входу","link":"login-methods-subgroup.html","desc":"Local Accounts  (Локальні облікові","descFull":"Local Accounts  (Локальні облікові записи) Елементи меню Local Accounts (Локальні облікові записи) і їхній опис Елемент меню Опис Manage Groups/Permissions  (Керування групами/дозволами) Add Group  (Додати групу) Import Access Controls  (Імпорт елементів керування доступом) Function Access  (Доступ до функцій) Administrative Menus  (Адміністративні меню) Device Management  (Керування пристроєм) All Users  (Усі користувачі) Import Access Controls  (Імпорт елементів керування доступом) Function Access  (Доступ до функцій) Administrative Menus  (Адміністративні меню) Device Management  (Керування пристроєм) Admin  (Адміністратор) Контролюйте доступ групи або користувача до функцій принтера, програм і параметрів безпеки. Add User  (Додати користувача) User Name/Password  (Ім’я користувача/пароль) User Name  (Ім’я користувача) Password  (Пароль) PIN  (PIN-код) Створіть локальні облікові записи для керування доступом до функцій принтера. User Name/Password Accounts  (Ім’я користувача/пароль облікового запису) Add User  (Додати користувача) User Name Accounts  (Облікові записи імен користувачів) Add User  (Додати користувача) Password Accounts  (Облікові записи паролів) Add User  (Додати користувача) PIN Accounts  (Облікові записи PIN-кодів) Add User  (Додати користувача) меню Local Accounts  (Локальні облікові записи)"},{"UUID":"8529a5f8-cff2-4105-ad5b-2a61382f27f8","title":"Безпека","link":"login-methods-subgroup.html","desc":"Schedule USB Devices Пункт меню","descFull":"Schedule USB Devices Пункт меню  Schedule USB Devices  і його опис Елемент меню Опис Schedules Add New Schedule Запланувати доступ до фронтального порту USB. меню Schedule USB Devices"},{"UUID":"b5dfedb1-ca3f-401a-8769-6d4c34827923","title":"Безпека","link":"login-methods-subgroup.html","desc":"Security Audit Log Пункти меню","descFull":"Security Audit Log Пункти меню  Security Audit Log  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Enable Audit Off * On Реєструвати події в надійному контрольному журналі та віддаленому системному журналі. Enable Remote Syslog Off * On Надіслати контрольні журнали на віддалений сервер. Remote Syslog Server Указати сервер віддаленого системного журналу. Remote Syslog Port 1–65535 (514*) Указати порт віддаленого системного журналу. Remote Syslog Method Normal UDP * Stunnel Указати метод системного журналу для передавання зареєстрованих подій на віддалений сервер. Remote Syslog Facility 0 ‑ Kernel Messages 1 ‑ User‑Level Messages 2 ‑ Mail System 3 ‑ System Daemons 4 ‑ Security/Authorization Messages * 5 ‑ Messages Generated Internally by Syslogs 6 ‑ Line Printer Subsystem 7 ‑ Network News Subsystem 8 ‑ UUCP Subsystem 9 ‑ Clock Daemon 10 ‑ Security/Authorization Messages 11 ‑ FTP Daemon 12 ‑ NTP Subsystem 13 ‑ Log Audit 14 ‑ Log Alert 15 ‑ Clock Daemon 16 ‑ Local Use 0 (local0) 17‑ Local Use 1 (local1) 18 ‑ Local Use 2 (local2) 19 ‑ Local Use 3 (local3) 20 ‑ Local Use 4 (local4) 21 ‑ Local Use 5 (local5) 22 ‑ Local Use 6 (local6) 23 ‑ Local Use 7 (local7) Указати код пристрою, який принтер використовує під час надсилання подій журналу на віддалений сервер. Severity of Events to Log 0 ‑ Emergency 1 ‑ Alert 2 ‑ Critical 3 ‑ Error 4 ‑ Warning * 5 ‑ Notice 6 ‑ Informational 7 ‑ Debug Указати граничний рівень пріоритету для реєстрації повідомлень і подій. Remote Syslog Non‑Logged Events Off * On Надсилати всі події, незалежно від рівня серйозності, на віддалений сервер. Admin’s E‑mail Address Надсилати адміністратору сповіщення електронною поштою про зареєстровані події. E‑mail Log Cleared Alert Off * On Надсилати адміністратору сповіщення електронною поштою, коли видаляється запис журналу. E‑mail Log Wrapped Alert Off * On Надсилати адміністратору сповіщення електронною поштою, коли журнал буде повним і почне перезаписувати старі записи. Реєстрація всієї поведінки Wrap Over Oldest Entries * E‑mail Log Then Delete All Entries Усувати проблеми зі зберіганням журналу, коли журнал заповнює виділену пам’ять. E‑mail % Full Alert Off * On Надсилати адміністратору сповіщення електронною поштою, коли журнал заповнює виділену пам’ять. % Full Alert Level 1–99 (90*) E‑mail Log Exported Alert Off * On Надсилати адміністратору сповіщення електронною поштою, коли журнал експортується. E‑mail Log Settings Changed Alert Off * On Надсилати адміністратору сповіщення електронною поштою, коли встановлено параметр  Enable Audit . Log Line Endings LF (\\n) * CR (\\r) CRLF (\\r\\n) Указати, як файл журналу завершує кінець кожного рядка. Digitally Sign Exports Off * On Додавати цифровий підпис до кожного експортованого файлу журналу. Clear Log Видалити всі контрольні журнали. Export Log Syslog (RFC 5424) Syslog (RFC 3164) CSV Експортувати журнал безпеки на флешнакопичувач. меню Security Audit Log"},{"UUID":"ec614d79-08e8-45a7-bde1-b31800e089d4","title":"Безпека","link":"login-methods-subgroup.html","desc":"Login Restrictions Пункти меню ","descFull":"Login Restrictions Пункти меню  Login Restrictions  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Login failures 1–10 (3*) Указати кількість невдалих спроб входу, перш ніж користувача буде заблоковано. Failure time frame 1–60 хвилин (5*) Указати період часу між невдалими спробами входу, перш ніж користувача буде заблоковано. Lockout time 1–60 хвилин (5*) Указати тривалість блокування. Web Login Timeout 1–120 хвилин (10*) Указати затримку для віддаленого входу, перш ніж користувача буде автоматично розблоковано. меню Login Restrictions"},{"UUID":"d803890f-6143-45de-8b2e-3e0308eea0eb","title":"Безпека","link":"login-methods-subgroup.html","desc":"Confidential Print Setup  ","descFull":"Confidential Print Setup   (Налаштування конфіденційного друку) Елементи меню  Confidential Print Setup  (Налаштування конфіденційного друку) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Max Invalid PIN  (Максимальна кількість недійсних PIN-кодів) 2–10 Установіть обмеження на введення неправильного PIN-коду. Коли межу досягнуто, завдання на друк для імені цього користувача видаляються. Confidential Job Expiration  (Термін дії конфіденційного завдання) Off * (Вимк.) 1 Hour  (1 година) 4 Hour  (4 години) 24 Hour  (24 години) 1 Week  (1 тиждень) Встановіть окремий термін дії для кожного відкладеного завдання, перш ніж його буде автоматично видалено з жорсткого диска чи інтелектуального накопичувача. Відкладене завдання є  Confidential  (Конфіденційно),  Repeat  (Повтор),  Reserve  (Резервування) або  Verify  (Перевірка). Repeat Job Expiration  (Термін дії завдання повтору) Off * (Вимк.) 1 Hour  (1 година) 4 Hour  (4 години) 24 Hour  (24 години) 1 Week  (1 тиждень) Встановіть термін дії для завдання друку, які потрібно повторити. Verify Job Expiration  (Термін дії завдання перевірки) Off * (Вимк.) 1 Hour  (1 година) 4 Hour  (4 години) 24 Hour  (24 години) 1 Week  (1 тиждень) Установіть термін дії друку копії завдання, щоб перевірити її якість перед друком решти копій. Reserve Job Expiration  (Термін дії завдання резервування) Off * (Вимк.) 1 Hour  (1 година) 4 Hour  (4 години) 24 Hour  (24 години) 1 Week  (1 тиждень) Встановіть термін дії для завдань, які ви хочете зберегти на принтері для друку пізніше. Require All Jobs to be Held  (Вимагати відкладення всіх завдань) Off * (Вимк.) On  (Увімк.) Налаштуйте принтер на відкладення всіх завдань друку. Keep duplicate documents  (Зберігати копії документів) Off * (Вимк.) On  (Увімк.) Налаштуйте принтер на збереження всіх документів з однаковою назвою файлу. меню Confidential Print Setup   (Налаштування конфіденційного друку)"},{"UUID":"fee3f886-71a3-4b99-9390-a21fd583b577","title":"Безпека","link":"login-methods-subgroup.html","desc":"Disk Encryption  (Шифрування диска)","descFull":"Disk Encryption  (Шифрування диска) Цей пункт меню з’являється, лише якщо встановлено жорсткий диск або інтелектуальний накопичувач. Елементи меню  Disk Encryption  (Шифрування диска) і їхній опис Елемент меню Опис Hard Disk  (Жорсткий диск) Показати стан шифрування жорсткого диска або інтелектуального накопичувача. Intelligent Storage Drive  (Інтелектуальний накопичувач) меню Disk Encryption  (Шифрування диска)"},{"UUID":"6685e5e5-46e1-4f45-bdc5-68ed759e13dc","title":"Безпека","link":"login-methods-subgroup.html","desc":"Erase Temporary Data Files Пункти","descFull":"Erase Temporary Data Files Пункти меню  Erase Temporary Data Files  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Stored in onboard memory Off * On Видалити всі файли, збережені в пам’яті принтера. меню Erase Temporary Data Files"},{"UUID":"eabb199c-4677-4962-bc36-d9c81cc6d008","title":"Безпека","link":"login-methods-subgroup.html","desc":"Solutions LDAP Settings Пункти меню","descFull":"Solutions LDAP Settings Пункти меню  Solutions LDAP Settings  та їхній опис Елемент меню Опис Follow LDAP Referrals Off * On Знайти різні сервери в домені для облікового запису користувача, у який здійснено вхід. LDAP Certificate Verification Yes No * Увімкнути перевірку сертифікатів LDAP. меню Solutions LDAP Settings"},{"UUID":"cd82e0b3-a603-4fd4-939d-2b7d4616145d","title":"Безпека","link":"login-methods-subgroup.html","desc":"Miscellaneous  (Різне) Елементи меню","descFull":"Miscellaneous  (Різне) Елементи меню  Miscellaneous  (Різне) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Protected Features  (Захищені функції) Show * (Показати*) Hide  (Приховати) Показати всі функції, які захищає функція контролю доступу (FAC), незалежно від дозволу безпеки, який має користувач. Hide  (Приховати) відображає тільки захищені FAC функції, до яких користувач має доступ. Print Permission  (Дозвіл друку) Off * (Вимк.) On  (Увімк.) Дозволити користувачу ввійти в систему перед тим, як друкувати. Default Print Permission Login  (Вхід із дозволом друку за замовчуванням) PIN * (PIN-код)* User Name/Password  (Ім’я користувача/пароль) User Name  (Ім’я користувача) Установити вхід замовчуванням для  Print Permission  (Дозвіл друку). Security Reset Jumper  (Перемичка захисту від скидання) Enable “Guest” access * (Увімкнути доступ «Гість»)* No Effect  (Немає ефекту) Вкажіть доступ користувача до принтера. Параметр  Enable \"Guest\" access  (Увімкнути доступ «Гість») дозволяє відновити пристрій, якщо пароль адміністратора втрачено. Якщо ця проблема виникає, зверніться до служби підтримки клієнтів. Меню  No effect  (Немає ефекту) перешкоджає використанню перемички захисту для відновлення пристрою. Цей пункт меню з’являється лише тоді, коли встановлено перемичку захисту. Use Intelligent Storage Drive for User Data  (Використовувати інтелектуальний накопичувач для даних користувача) Off  (Вимк.) On * (Увімк.) Увімкніть інтелектуальний накопичувач для зберігання даних користувача. Цей пункт меню з’являється, лише якщо встановлено інтелектуальний накопичувач. Minimum Password Length  (Мінімальна довжина пароля) 0–32 (0*) Вкажіть довжину пароля. Enable Password/PIN Reveal  (Увімкнути відображення пароля/PIN-коду) Off * (Вимк.) On  (Увімк.) Покажіть пароль або персональний ідентифікаційний номер. меню Miscellaneous  (Різне)"},{"UUID":"74ef63e4-88a1-40df-8eff-784b67af7734","title":"Хмарні служби","link":"cloud-services-enrollment-topic.html","desc":"Cloud Services Enrollment Пункти меню","descFull":"Cloud Services Enrollment Пункти меню  Cloud Services Enrollment  та їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. View More Information Переглянути додаткову інформацію про використання хмарних служб Lexmark. Enable communication with Lexmark Cloud Services Off * On Увімкнути на принтері зв’язок із хмарними службами Lexmark. View Current Status Переглянути статус підключення між принтером і хмарними службами Lexmark. меню Cloud Services Enrollment"},{"UUID":"7d2aeefe-95b7-456a-a2fa-44e984ea0f8a","title":"Звіти","link":"menu-settings-page-topic.html","desc":"Menu Settings Page Пункт меню","descFull":"Menu Settings Page Пункт меню  Menu Settings Page  і його опис Елемент меню Опис Menu Settings Page Надрукувати звіт, який містить меню принтера. меню Menu Settings Page"},{"UUID":"2f8c29b6-ff51-4887-af01-81d92ea42abb","title":"Звіти","link":"menu-settings-page-topic.html","desc":"Пристрій Device Пункти меню ","descFull":"Пристрій Device Пункти меню  Device  та їхній опис Елемент меню Опис Device Information Надрукувати звіт з інформацією про принтер. Device Statistics Надрукувати звіт про використання принтера та стан витратних матеріалів. Profiles List Надрукувати список профілів, що зберігаються на принтері. Asset Report Надрукувати діагностичний інструмент для виявлення проблем друку. Щоб уникнути обрізання вмісту, надрукуйте звіт на поштовому папері чи паперу формату A4. меню Device"},{"UUID":"a3b3564a-52c4-4ffc-b0d3-6c23e9804a6b","title":"Звіти","link":"menu-settings-page-topic.html","desc":"Print  (Друк) Елементи меню","descFull":"Print  (Друк) Елементи меню  Print  (Друк) і їхній опис Елемент меню Опис Print Fonts  (Шрифти друку) PCL Fonts  (Шрифти PCL) PS Fonts  (Шрифти PCL) Друк зразків та інформації про шрифти, доступні для кожної мови принтера. Print Demo  (Демонстраційний друк) Demo Page  (Демонстраційна сторінка) Друк сторінки, яка показує можливості принтера та підтримувані рішення. Print Directory  (Друк каталогу) Друк ресурсів, які зберігаються на флешнакопичувачі, жорсткому диску або інтелектуальному накопичувачі (ISD). Цей пункт меню з’являється, лише якщо встановлено флешнакопичувач, жорсткий диск або ISD. меню Print  (Друк)"},{"UUID":"573d2ce7-1aef-49b1-be34-996ebd6cdae6","title":"Звіти","link":"menu-settings-page-topic.html","desc":"Shortcuts Пункти меню  Shortcuts","descFull":"Shortcuts Пункти меню  Shortcuts  та їхній опис Елемент меню Опис All Shortcuts Надрукувати звіт, у якому перелічено ярлики, що зберігаються на принтері. Fax Shortcuts Copy Shortcuts E‑mail Shortcuts FTP Shortcuts Network Folder Shortcuts меню Shortcuts"},{"UUID":"dedee138-f94d-4d71-a8f7-d74306e1840f","title":"Звіти","link":"menu-settings-page-topic.html","desc":"Fax  (Факс) Це меню","descFull":"Fax  (Факс) Це меню з’являється, лише якщо налаштовано факс, а для параметрів  Enable Job Log  (Увімкнути журнал завдань) і  Enable Call Log  (Увімкнути журнал викликів) встановлено значення  On  (Увімк). Елементи меню  Fax  (Факс) і їхній опис Елемент меню Опис Fax Job Log  (Журнал завдань факсу) Друкувати звіт про 200 останніх завершених завдань факсу. Fax Call Log  (Журнал факсимільних викликів) Друкувати звіт про 100 останніх спроб виклику, отриманих і заблокованих викликів. меню Факс"},{"UUID":"a2bf9f7b-9fae-457a-aa4e-b434e85a340d","title":"Звіти","link":"menu-settings-page-topic.html","desc":"Network Пункт меню  Network","descFull":"Network Пункт меню  Network  і його опис Елемент меню Опис Network Setup Page Надрукувати сторінку, на якій показано параметри мережі та бездротового зв’язку на принтері. Цей пункт меню відображається лише на мережевих принтерах чи принтерах, підключених до серверів друку. Wi‑Fi Direct Connected Clients Надрукувати сторінку, на якій показано список пристроїв, які підключено до принтера за допомогою Wi‑Fi Direct. Цей пункт меню відображається, лише коли для параметра  Enable Wi‑Fi Direct  встановлено значення  On . меню Network"},{"UUID":"90526e2d-cbc5-4382-bc05-fe318eac4bca","title":"Використання меню принтера","link":"troubleshooting-menu-topic.html","desc":"Troubleshooting Пункти меню для усунення","descFull":"Troubleshooting Пункти меню для усунення проблем та їхній їх опис Елемент меню Опис Print Quality Test Pages Надрукувати пробні сторінки, щоб виявити й виправити дефекти якості друку. Cleaning the Scanner Вказівки щодо очищення сканера. меню Troubleshooting Print Quality Test Pages Cleaning the Scanner"},{"UUID":"9ad0392a-0c5f-4502-9431-5a317f5133dd","title":"Використання меню принтера","link":"forms-merge-topic.html","desc":"Forms Merge  (Злиття форм)","descFull":"Forms Merge  (Злиття форм) Це меню з’являється, лише якщо встановлено жорсткий диск або інтелектуальний накопичувач. Елементи меню  Forms Merge  (Злиття форм) і їхній опис Елемент меню Опис Зірочка (*) біля значення вказує на заводські налаштування за замовчуванням. Merge Mode  (Режим злиття) Print * (Друк) Data Capture  (Отримання даних) Disabled  (Вимкнено) Вкажіть режим роботи для злиття форм. Data Capture Target  (Ціль отримання даних) Flash*  (Флешнакопичувач) Установіть цільове місце призначення, куди пересилаються отримані дані. Цей пункт меню з’являється лише тоді, коли для параметра Merge Mode (Режим злиття)встановлено значення Data Capture (Отримання даних). Print Port and Filter Settings  (Налаштування порту друку та фільтра) Network Port  (Порт мережі) On * (Увімк.) Off  (Вимк.) Увімкніть злиття форм для обробки всіх даних, які надсилаються до мережевого порту. Print Port and Filter Settings  (Налаштування порту друку та фільтра) Network Filter  (Мережевий фільтр) Disabled * (Вимкнено) NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF Укажіть мережевий фільтр для всіх даних, що надсилаються на принтер. Print Port and Filter Settings  (Налаштування порту друку та фільтра) USB Port  (Порт USB) On * (Увімк.) Off  (Вимк.) Увімкніть злиття форм для обробки всіх даних, які надсилаються до USB-порту. Print Port and Filter Settings  (Налаштування порту друку та фільтра) USB Filter  (USB-фільтр) Disabled * (Вимкнено) NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF Укажіть USB-фільтр для всіх даних, що надсилаються на принтер. Print Port and Filter Settings  (Налаштування порту друку та фільтра) Local Port Timeout  (Час очікування локального порту) 1–100 (10*) Укажіть значення часу очікування для завдань злиття форм, які надсилаються на локальний порт. Miscellaneous  (Різне) Print All Forms  (Друк усіх форм) Друкуйте всі набори форм, що зберігаються на інтелектуальному накопичувачі або жорсткому диску принтера. Miscellaneous  (Різне) Error Page Print  (Друк сторінки помилки) On * (Увімк.) Off  (Вимк.) Увімкніть друк сторінки помилки, якщо в завданні злиття форм виявлено помилку. меню Forms Merge  (Злиття форм)"},{"UUID":"a9ff9b44-6d68-41e5-87d5-3f63417bde5b","title":"Використання меню принтера","link":"printing-menu-settings-page-topic.html","desc":"Друк  Menu Settings Page","descFull":"Друк  Menu Settings Page На головному екрані торкніться меню  Settings Reports  Menu Settings Page . друк Menu Settings Page Menu Settings Page друк меню принтера"},{"UUID":"2f10f095-b613-4780-ab0d-0fd45e2e28e5","title":"Технічне обслуговування принтера","link":"checking-status-of-parts-and-supplies-topic.html","desc":"Перевірка стану деталей і витратних","descFull":"Перевірка стану деталей і витратних матеріалів На головному екрані торкніться параметра  Status/Supplies . Виберіть деталі чи витратні матеріали, які потрібно перевірити. Доступ до цього параметра можна також отримати, торкнувшись верхньої частини головного екрана. перевірка стану деталей і витратних матеріалів стан витратних матеріалів перевірка стан деталей перевірка"},{"UUID":"26e9672a-bb9c-4c4d-af3c-b34b33bf4925","title":"Технічне обслуговування принтера","link":"configuring-supply-notifications-topic.html","desc":"Налаштування сповіщень про витратні матеріали","descFull":"Налаштування сповіщень про витратні матеріали Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані принтера. IP-адреса відображається як чотири набори цифр, розділених крапкою, як-от 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Settings Device Notifications . У меню витратних матеріалів натисніть  Custom Supply Notifications . Виберіть сповіщення для кожного витратного матеріалу. Застосуйте зміни. сповіщення про витратні матеріали налаштування налаштування сповіщень про витратні матеріали"},{"UUID":"27244b18-622f-4325-a0c3-22086e01878d","title":"Технічне обслуговування принтера","link":"setting-up-e-mail-alert-topic.html","desc":"Налаштування сповіщень електронною поштою Налаштуйте","descFull":"Налаштування сповіщень електронною поштою Налаштуйте принтер на надсилання сповіщень електронною поштою, коли запасні матеріали закінчуються, коли потрібно замінити або додати папір або коли папір зминається. Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані принтера. IP-адреса відображається у вигляді чотирьох наборів чисел, розділених крапками, наприклад 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Торкніться  Settings Device Notifications E‑mail Alert Setup  і налаштуйте параметри. Щоб дізнатися більше про параметри SMTP, зверніться до свого постачальника послуг електронної пошти. Застосуйте всі зміни. Торкніться  Setup E-mail Lists and Alerts  і налаштуйте параметри. Застосуйте всі зміни. сповіщення електронною поштою налаштування налаштування сповіщень електронною поштою"},{"UUID":"4392b83e-48f9-4613-a0ca-88967b7f9089","title":"Технічне обслуговування принтера","link":"viewing-reports-topic.html","desc":"Перегляд звітів На головному екрані","descFull":"Перегляд звітів На головному екрані торкніться параметра  Settings Reports . Виберіть звіт, який потрібно переглянути. перегляд звітів звіти стан принтера звіти використання принтера"},{"UUID":"80956f68-15b0-4f4c-83e7-8772bcfa13b9","title":"Замовлення запчастин і матеріалів","link":"ordering-supplies-group.html","desc":"Щоб замовити витратні матеріали в","descFull":"Щоб замовити витратні матеріали в США, зателефонуйте в компанію Lexmark за номером 1-800-539-6275, щоб отримати інформацію про авторизованих дистриб’юторів витратних матеріалів у вашому регіоні. В інших країнах і регіонах перейдіть на сторінку  www.lexmark.com  або зверніться в місце, де ви придбали принтер. Щоб замовити витратні матеріали, зверніться в місце, де ви придбали принтер. Усі показники терміну служби витратних матеріалів розраховані на друк на поштовому папері або простому папері формату A4. Якщо не дотримуватися правил щодо оптимальної роботи принтера або запасних частин і витратних матеріалів, принтер може бути пошкоджено. оригінальні деталі й матеріали"},{"UUID":"5d3f9619-e189-42fb-bbc3-0aa4deda7f92","title":"Замовлення запчастин і матеріалів","link":"ordering-supplies-group.html","desc":"Використання оригінальних деталей і витратних","descFull":"Використання оригінальних деталей і витратних матеріалів Lexmark Ваш принтер Lexmark створено для оптимальної роботи з оригінальними витратними матеріалами та деталями Lexmark. Використання сторонніх витратних матеріалів або деталей може вплинути на роботу, надійність чи термін служби принтера, а також на його компоненти відображення. Це також може вплинути на дію гарантії. Шкода, завдана використанням сторонніх деталей чи витратних матеріалів, не покривається гарантією. Усі індикатори терміну служби призначені для роботи з деталями та витратними матеріалами Lexmark і можуть показувати неочікувані результати, якщо застосовуються сторонні деталі або витратні матеріали. Використання компонентів відображення понад їх очікуваний термін служби може пошкодити ваш принтер Lexmark чи пов’язані компоненти. Витратні матеріали чи частини, на які не поширюються умови угоди про програму повернення, може бути скинуто та відновлено. Однак гарантія виробника не поширюється на шкоду, завдану неоригінальними витратними матеріалами чи деталями. Скидання лічильників витратних матеріалів чи деталей без належного відновлення може пошкодити принтер. Після скидання лічильника витратних матеріалів чи деталей ваш принтер може відображати повідомлення про помилку, де буде вказано про наявність скинутого елемента. використання оригінальних деталей і витратних матеріалів Lexmark оригінальні деталі та витратні матеріали Lexmark"},{"UUID":"cbb2c776-1222-49b3-8ab3-c036db795cde","title":"Замовлення запчастин і матеріалів","link":"ordering-supplies-group.html","desc":"Замовлення картриджа з тонером Приблизний","descFull":"Замовлення картриджа з тонером Приблизний ресурс картриджа базується на стандарті ISO/IEC 19752. Надзвичайно низьке покриття друку протягом тривалого часу може негативно вплинути на фактичний ресурс. Щоб замовити картридж із тонером, зверніться до місця купівлі принтер. Програма повернення картриджів із тонером Lexmark MX532 Елемент США або Канада Європейська економічна зона, Ісландія, Ліхтенштейн і Норвегія Решта Азіатсько-Тихоокеанського регіону Латинська Америка Решта європейських країн, Близького захід, Африки Програма повернення картриджа з тонером 66S1000 66S2000 66S3000 66S4000 66S5000 Картридж із тонером великої ємності за програмою повернення 66S1H00 66S2H00 66S3H00 66S4H00 66S5H00 Звичайний картридж із тонером Lexmark MX532 Елемент По всьому світу Звичайний картридж із тонером великої ємності 66S0HA0 Програма повернення картриджів із тонером Lexmark MX632 Елемент США або Канада Європейська економічна зона, Ісландія, Ліхтенштейн і Норвегія Решта Азіатсько-Тихоокеанського регіону Латинська Америка Решта європейських країн, Близького захід, Африки Програма повернення картриджа з тонером 66S1000 66S2000 66S3000 66S4000 66S5000 Картридж із тонером надзвичайно великої ємності за програмою повернення 66S1X00 66S2X00 66S3X00 66S4X00 66S5X00 Звичайний картридж із тонером Lexmark MX632 Елемент По всьому світу Звичайний картридж із тонером надзвичайно великої ємності 66S0XA0 Програма повернення картриджів із тонером Lexmark XM3350 Елемент США або Канада Європейська економічна зона, Ісландія, Ліхтенштейн і Норвегія Решта країн світу Картридж із тонером надзвичайно великої ємності за програмою повернення 24B7541 24B7542 24B7543 замовлення витратних матеріалів картридж із тонером картридж із тонером замовлення"},{"UUID":"4b71a329-e35e-417e-b86d-7d044987393f","title":"Замовлення запчастин і матеріалів","link":"ordering-supplies-group.html","desc":"Замовлення блоку формування зображень Надзвичайно","descFull":"Замовлення блоку формування зображень Надзвичайно низьке покриття друку протягом тривалих періодів часу може призвести до виходу з ладу деталей блоку формування зображення до того, як закінчиться тонер. Щоб замовити блок формування зображень, зверніться до місця купівлі принтера. Поставка принтера та номер деталі Елемент Номер деталі Звичайний блок формування зображення 66S0ZA0 блок формування зображень замовлення замовлення витратних матеріалів блок формування зображень"},{"UUID":"b5b6baf1-98cd-42e9-936c-16a6dff73ee2","title":"Заміна запчастин і матеріалів","link":"replacing-toner-cartridge-topic.html","desc":"Заміна картриджа з тонером Відкрийте","descFull":"Заміна картриджа з тонером Відкрийте дверцята А. Вийміть використаний картридж із тонером. Розпакуйте новий картридж із тонером. Струсіть картридж з тонером, щоб перерозподілити тонер. Вставте новий картридж із тонером. Закрийте дверцята A. картридж із тонером заміна заміна матеріалів картридж із тонером"},{"UUID":"4d994cdb-1c67-47b3-bea6-73b95f826fcb","title":"Заміна запчастин і матеріалів","link":"replacing-toner-cartridge-topic.html","desc":"Заміна блоку формування зображення Відкрийте","descFull":"Заміна блоку формування зображення Відкрийте дверцята А. Вийміть картридж із тонером. Зніміть використаний блок формування зображення. Розпакуйте новий блок формування зображення. Струсіть блок формування зображення, щоб розподілити тонер. Не піддавайте блок формування зображення впливу прямого світла упродовж понад 10 хвилин. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся барабана фотокондуктора. Це може вплинути на якість майбутніх завдань друку. Вставте новий блок формування зображення. Вставте картридж із тонером. Закрийте дверцята A. блок формування зображень заміна заміна матеріалів блок формування зображень"},{"UUID":"28891089-6e62-4fe1-bdb3-3de7414aa0e6","title":"Заміна запчастин і матеріалів","link":"replacing-toner-cartridge-topic.html","desc":"Заміна наповнювача скоб Відкрийте дверцята","descFull":"Заміна наповнювача скоб Відкрийте дверцята доступу до напівавтоматичного степлера. Вийміть картридж зі скобами. Вийміть порожній наповнювач скоб. Вставте новий наповнювач скоб на місце до клацання. Вставте картридж зі скобами, а потім закрийте дверцята доступу до напівавтоматичного степлера. Перевірте стан світлодіодного індикатора. Напівавтоматичний степлер готовий до використання, коли засвітиться синій індикатор. наповнювач скоб заміна заміна наповнювача скоб"},{"UUID":"8b445fec-7d34-4244-9175-720cb38ebcf9","title":"Заміна запчастин і матеріалів","link":"replacing-toner-cartridge-topic.html","desc":"Заміна блока живлення напівавтоматичного степлера","descFull":"Заміна блока живлення напівавтоматичного степлера Вимкніть принтер. Від’єднайте кабель живлення від електричної розетки, а потім від принтера. Від’єднайте блок живлення від електричної розетки. Зніміть кришку стійки та від’єднайте кабель блока живлення. Вийміть напівавтоматичний степлер. Від’єднайте використаний блок живлення. Розпакуйте новий блок живлення. Установіть новий блок живлення, протягнувши його кабель через роз’єм у принтері, і під’єднайте його до напівавтоматичного степлера. Установіть напівавтоматичний степлер. Розташуйте блок живлення належним чином. Приєднайте кришку стійки. Зафіксуйте блок живлення належним чином. Під’єднайте один кінець кабелю живлення степлера до блока живлення, а інший кінець — до електричної розетки. Під’єднайте один кінець кабелю живлення принтера до принтера, а інший кінець — до електричної розетки. Щоб уникнути ризику пожежі чи електричного ураження, підключіть кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. Увімкніть принтер. блок живлення заміна заміна блока живлення"},{"UUID":"e82dbe71-d492-4ec7-b9c8-6ef69481ae38","title":"Заміна запчастин і матеріалів","link":"replacing-toner-cartridge-topic.html","desc":"Заміна сервера бездротового друку ","descFull":"Заміна сервера бездротового друку  MarkNet  N8450 Щоб уникнути ризику ураження електричним струмом, якщо ви отримуєте доступ до плати контролера чи встановлення додаткового необов’язкового апаратного забезпечення або пристроїв пам’яті через деякий час після налаштування принтера, вимкніть принтер і вийміть кабель живлення з електричної розетки, перш ніж продовжувати. Якщо до принтера підключені інші пристрої, вимкніть їх і від’єднайте всі кабелі, що ведуть до принтера. Для виконання цього завдання потрібна викрутка з плоскою головкою. Вимкніть принтер. Від’єднайте кабель живлення від електричної розетки, а потім від принтера. Відкрийте кришку доступу до плати контролера. Електронні компоненти плати контролера легко пошкоджуються статичною електрикою. Перш ніж торкатися будь-яких компонентів плати контролера або роз’ємів, торкніться металевої поверхні принтера. Зніміть кришку із сервера бездротового друку. Вийміть факсимільну карту. Вийміть використаний сервер бездротового друку. Розпакуйте новий сервер бездротового друку. Установіть новий сервер бездротового друку до  клацання . Установіть факсимільну карту, а потім закріпіть її гвинтом. Приєднайте до сервера бездротового друку кришку, а потім закріпіть її гвинтом. Закрийте кришку доступу до плати контролера, а потім закріпіть її гвинтом. Підключіть шнур живлення до принтера, а потім до електричної розетки. Щоб уникнути ризику пожежі чи електричного ураження, підключіть кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. Увімкніть принтер. сервер бездротового друку заміна заміна сервера бездротового друку Сервер бездротового друку MarkNet N8450"},{"UUID":"aff0d442-4967-45bb-906f-d15735ee7dfa","title":"Заміна запчастин і матеріалів","link":"replacing-toner-cartridge-topic.html","desc":"Заміна шин захвату Вимкніть принтер.","descFull":"Заміна шин захвату Вимкніть принтер. Від’єднайте кабель живлення від електричної розетки, а потім від принтера. Зніміть лоток. Зніміть використані шини захвату. Розпакуйте нові шини захвату. Вставте нові шини захвату. Вставте лоток. Підключіть шнур живлення до принтера, а потім до електричної розетки. Щоб уникнути ризику пожежі чи електричного ураження, підключіть кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. Увімкніть принтер. вибір шини заміна заміна деталей шини захвату"},{"UUID":"9b643d54-984e-4b12-bd8e-e262040fcb17","title":"Заміна запчастин і матеріалів","link":"replacing-toner-cartridge-topic.html","desc":"Заміна скляної панелі сканера Відкрийте","descFull":"Заміна скляної панелі сканера Відкрийте кришку сканера. Зніміть використану скляну панель сканера. Розпакуйте нову скляну панель сканера. Вирівняйте нову скляну панель сканера відносно скла сканера. Закрийте кришку сканера, щоб прикріпити нову скляну панель сканера. Відкрийте кришку сканера. Натисніть на скляну панель сканера, щоб закріпити її. Закрийте кришку сканера. скляна панель сканера заміна заміна деталей скляна панель сканера"},{"UUID":"04ba81b9-c5ce-4888-96e5-1baf508f9056","title":"Заміна запчастин і матеріалів","link":"replacing-toner-cartridge-topic.html","desc":"Заміна роликів АПД Відкрийте дверцята","descFull":"Заміна роликів АПД Відкрийте дверцята C. Зніміть використаний захоплювальний ролик пристрою АПД. Зніміть використаний ролик роздільника пристрою АПД. Розпакуйте новий захоплювальний ролик і ролик роздільника пристрою АПД. Вставте новий ролик роздільника пристрою АПД до  клацання . Вставте новий захоплювальний ролик пристрою АПД на місце до  клацання . Закрийте дверцята C. заміна деталей ролики пристрою АПД ролики пристрою АПД заміна заміна деталей захоплювальний ролик пристрою АПД захоплювальний ролик пристрою АПД заміна заміна деталей ролик роздільника пристрою АПД ролик роздільника пристрою АПД заміна"},{"UUID":"c14c81f3-d6b6-4449-a762-296ce7a366e8","title":"Заміна запчастин і матеріалів","link":"replacing-toner-cartridge-topic.html","desc":"Скидання лічильників використання матеріалів На","descFull":"Скидання лічильників використання матеріалів На головному екрані торкніться  Settings  (Параметри) Device  (Пристрій) Maintenance  (Обслуговування) Configuration Menu  (Меню конфігурації) Supply Usage And Counters  (Використання витратних матеріалів і лічильники). Виберіть лічильник, який потрібно скинути. Витратні матеріали чи частини, на які не поширюються умови угоди про програму повернення, може бути скинуто та відновлено. Однак гарантія виробника не поширюється на шкоду, завдану неоригінальними витратними матеріалами чи деталями. Скидання лічильників витратних матеріалів чи деталей без належного відновлення може пошкодити принтер. Після скидання лічильника витратних матеріалів чи деталей ваш принтер може відображати повідомлення про помилку, де буде вказано про наявність скинутого елемента. Витратні матеріали чи деталі, на які не поширюються умови угоди про програму використання й повернення, може бути скинуто та відновлено. Однак гарантія виробника не поширюється на шкоду, завдану неоригінальними витратними матеріалами чи деталями. Скидання лічильників витратних матеріалів чи деталей без належного відновлення може пошкодити принтер. Після скидання лічильника витратних матеріалів чи деталей ваш принтер може відображати повідомлення про помилку, де буде вказано про наявність скинутого елемента. лічильники використання матеріалів скидання скидання лічильників використання матеріалів"},{"UUID":"f9f5709e-f4f3-4366-98aa-b0227b7e1c45","title":"Очищення деталей принтера","link":"cleaning-printer-topic.html","desc":"Очищення принтера Щоб уникнути ризику","descFull":"Очищення принтера Щоб уникнути ризику ураження електричним струмом під час очищення зовнішньої частини принтера, перш ніж продовжувати, вийміть кабель живлення з електричної розетки й від’єднайте всі кабелі від принтера. Виконуйте цю процедуру раз на кілька місяців. Пошкодження принтера, завдані внаслідок неналежного користування ним, не покриваються гарантією. Вимкніть принтер, а тоді вийміть кабель живлення з розетки. Вийміть папір зі стандартного відсіку та багатоцільового подавача. Видаліть пил, волокна та клаптики паперу навколо принтера, використовуючи м’яку щітку чи пилосос. Витріть принтер зовні вологою, м’якою, неворсистою тканиною. Не використовуйте побутові засоби очищення чи мийні засоби, які можуть пошкодити покриття принтера. Переконайтеся, що після очищення всі частини принтера сухі. Увімкніть кабель живлення в розетку, а тоді ввімкніть принтер. Щоб уникнути ризику пожежі чи ураження електричним струмом, під’єднайте кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. очищення принтера очищення внутрішня частина принтера очищення зовнішня частина принтера"},{"UUID":"c28b3c30-61d2-407a-865f-bad73f4014e2","title":"Очищення деталей принтера","link":"cleaning-printer-topic.html","desc":"Очищення сенсорного екрана Щоб уникнути","descFull":"Очищення сенсорного екрана Щоб уникнути ризику ураження електричним струмом під час очищення зовнішньої частини принтера, перш ніж продовжувати, вийміть кабель живлення з електричної розетки й від’єднайте всі кабелі від принтера. Вимкніть принтер, а тоді вийміть кабель живлення з розетки. Протріть сенсорний екран, використовуючи вологу, м’яку, безворсову тканину. Не використовуйте побутові засоби очищення чи мийні засоби, оскільки вони можуть пошкодити сенсорний екран. Переконайтеся, що після очищення сенсорний екран сухий. Увімкніть кабель живлення в розетку, а тоді ввімкніть принтер. Щоб уникнути ризику пожежі чи електричного ураження, підключіть кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. сенсорний екран очищення очищення сенсорного екрана"},{"UUID":"ef753278-8e3a-40f7-b447-2c6d74df386f","title":"Очищення деталей принтера","link":"cleaning-printer-topic.html","desc":"Очищення сканера Відкрийте кришку сканера.","descFull":"Очищення сканера Відкрийте кришку сканера. Вологою м’якою тканиною без ворсу протріть такі частини Скляна панель пристрою АПД Скляна панель сканера Скло пристрою АПД Скло сканера Закрийте кришку сканера. Відкрийте дверцята C. Вологою м’якою тканиною без ворсу протріть такі частини Скляна панель пристрою АПД у дверцятах C Скло пристрою АПД у дверцятах C Закрийте дверцята C. сканер очищення очищення сканера"},{"UUID":"7e30e83b-0e33-4480-a24a-95053fcc4c6a","title":"Очищення деталей принтера","link":"cleaning-printer-topic.html","desc":"Очищення роликів АПД Відкрийте дверцята","descFull":"Очищення роликів АПД Відкрийте дверцята C. Зніміть захоплювальний ролик пристрою АПД. Зніміть ролик роздільника пристрою АПД. Нанесіть ізопропіловий спирт на м’яку тканину без ворсу, а потім протріть захоплювальний ролик АПД і ролик роздільника пристрою АПД. Вставте ролик роздільника пристрою АПД на місце до  клацання . Вставте захоплювальний ролик пристрою АПД на місце до  клацання . Закрийте дверцята C. очищення захоплювального ролика пристрою АПД захоплювальний ролик пристрою АПД очищення очищення ролика роздільника пристрою АПД ролик роздільника пристрою АПД очищення очищення роликів АПД ролики пристрою АПД очищення"},{"UUID":"fba8a0c3-3864-4c4d-b817-08702b33fc70","title":"Економія енергії та паперу","link":"configuring-power-save-mode-settings-topic.html","desc":"Налаштування параметрів енергозбереження Режим сну","descFull":"Налаштування параметрів енергозбереження Режим сну На головному екрані торкніться меню  Settings Device Power Management Timeouts Sleep Mode . Укажіть час, протягом якого принтер перебуває в режимі очікування, перш ніж буде активовано  Sleep Mode . Режим гібернації На головному екрані торкніться меню  Settings Device Power Management Timeouts Hibernate Timeout . Укажіть час, протягом якого принтер перебуває в режимі очікування, перш ніж буде активовано режим гібернації. Для роботи функції  Hibernate Timeout  налаштуйте для параметра  Hibernate Timeout on Connection  значення  Hibernate . Вбудований вебсервер вимкнено, коли принтер перебуває в режимі  Hibernate . Режим сну налаштування Режим гібернації налаштування параметри середовища режими енергозбереження налаштування"},{"UUID":"6ae8bc2b-0011-4d92-96dd-662d9abc3886","title":"Економія енергії та паперу","link":"configuring-power-save-mode-settings-topic.html","desc":"Коригування яскравості дисплея На головному","descFull":"Коригування яскравості дисплея На головному екрані торкніться меню  Settings Device Preferences . У меню  Screen Brightness  змініть параметр. яскравість дисплея коригування регулювання яскравості дисплея"},{"UUID":"70a6cff2-71b0-4ad5-9747-01f85ccbe852","title":"Економія енергії та паперу","link":"configuring-power-save-mode-settings-topic.html","desc":"Заощадження витратних матеріалів Друкуйте на","descFull":"Заощадження витратних матеріалів Друкуйте на обох сторонах паперу. Двосторонній друк – налаштування драйвера принтера за замовчуванням. Друкуйте кілька сторінок на одному аркуші паперу. Використовуйте функцію попереднього перегляду, щоб перевірити вигляд документа перед друком. Надрукуйте одну копію документа, щоб перевірити його зміст і формат для точності. заощадження витратних матеріалів витратні матеріали заощадження"},{"UUID":"f15457e8-c994-44c4-9efc-a64f8e8b2eb9","title":"Технічне обслуговування принтера","link":"moving-printer-topic.html","desc":"Переміщення принтера в інше місце","descFull":"Переміщення принтера в інше місце Переміщення принтера в інше місце Якщо вага принтера перевищує 20 кг (44 фунти), щоб безпечно підняти його, може знадобитися двоє або більше людей. Щоб уникнути ризику пожежі чи ураження електричним струмом, використовуйте лише кабель живлення, що постачався в комплекті з цим виробом або авторизовану виробником заміну. Переміщаючи принтер, дотримуйтеся рекомендацій нижче, щоб уникнути травмування чи пошкодження принтера. Переконайтеся, що всі дверцята й лотки зачинені. Вимкніть принтер, а тоді вийміть кабель живлення з розетки. Від’єднайте від принтера всі проводи та кабелі. Якщо принтер має окрема необов’язкові лотки, розміщені на підлозі, чи прикріплені до нього вихідні лотки, від’єднайте їх, перш ніж переміщувати принтер. Якщо принтер має підставку з коліщатками, тоді обережно відкотіть його в нове місце. Будьте обережні, рухаючись через пороги та розриви в підлозі. Якщо принтер не має підставки на коліщатках, але має додаткові лотки, зніміть їх і підніміть принтер без лотків. Не намагайтеся піднімати принтер разом із лотками. Завжди використовуйте ручки на принтері, піднімаючи його. Будь-який візок, що використовується для переміщення принтера, повинен мати поверхню, яка здатна втримати всю площу дня принтера. Будь-який візок, що використовується для переміщення додаткового апаратного забезпечення, повинен мати поверхню, яка здатна втримати габарити приладдя. Зберігайте принтер у вертикальному положенні. Уникайте різких рухів. Переконайтеся, що під принтером немає ваших пальців під час його встановлення. Переконайтеся, що навколо принтера достатньо вільного місця. Пошкодження принтера, завдані внаслідок неналежного переміщення, не покриваються гарантією. переміщення принтера"},{"UUID":"0aca49d6-0fd2-4a05-a03b-996b09c5babc","title":"Технічне обслуговування принтера","link":"shipping-printer-topic.html","desc":"Транспортування принтера Щоб отримати вказівки","descFull":"Транспортування принтера Щоб отримати вказівки щодо транспортування, перейдіть на сторінку  https://support.lexmark.com  або зверніться в службу підтримки клієнтів. Під час транспортування принтера використовуйте оригінальне пакування чи зверніться в місце, де ви придбали принтер. принтер транспортування транспортування принтера"},{"UUID":"1f337c12-9e0b-4002-a898-cafcb92df9cf","title":"Усунення несправностей","link":"print-quality-problems-picker-topic.html","desc":"Проблема з якістю друку Знайдіть","descFull":"Проблема з якістю друку Знайдіть зображення, яке нагадує проблему з якістю друку, яка виникає у вас, а тоді натисніть посилання нижче, щоб прочитати дії для вирішення проблеми. проблеми з якістю друку усунення проблем проблеми з якістю друку усунення проблем із друком проблеми з якістю друку"},{"UUID":"b012147d-4599-48a6-82f3-23f7c1e212ef","title":"Усунення несправностей","link":"printer-error-codes-topic.html","desc":"Коди помилок принтера Коди помилок","descFull":"Коди помилок принтера Коди помилок принтера Коли помилок та інформація про їх вирішення Коли помилок Повідомлення про помилку Рішення 8.01 Close front door A  (Закрийте передні дверцята A) Тримайте всі двері закритими, якщо не виконуєте технічне обслуговування. 9.00 Printer had to restart (Довелося перезапустити принтер). Last job may be incomplete.  (Останнє завдання може бути незавершеним). Торкніться  Continue  (Продовжити), щоб очистити повідомлення та продовжити друк. 11,11, 11,21, 11,31, 11,41 Load <source/> with <type/> <size/>.  (Завантажте <джерело/> з <типом/> <розміром/>.) Відкрийте вказаний лоток і завантажте папір. Щоб дізнатися більше, див.  . 11,12, 11,22, 11,32, 11,42 Load <source/> with <type/> <size/> <orientation/>.  (Завантажте <джерело/> з <типом/> <розміром/> <орієнтацією/>.) 11,91 Load multipurpose feeder with <type/> <size/>.  (Завантажте в багатоцільовий подавач папір <типу/> <розміру/>.) Відкрийте багатоцільовий подавач та завантажте папір. Щоб дізнатися більше, див.  . 11.92 Load multipurpose feeder with <type/> <size/> <orientation/>.  (Завантажте в багатоцільовий подавач папір <типу/> <розміру/> <орієнтації/>.) 12,11, 12,21, 12,31, 12,41 Change <source/> to <type/> <size/>.  (Змініть <джерело/> на <тип/> <розмір/>.) Відкрийте вказаний лоток, вийміть папір, а потім завантажте папір потрібного типу та розміру. Щоб дізнатися більше, див.  . 12,12, 12,22, 12,32, 12,42 Change <source/> to <type/> <size/> <orientation/>.  (Змініть <джерело/> на <тип/> <розмір/> <орієнтацію/>.) 12,91 Change multipurpose feeder to <type/> <size/>.  (Змініть багатоцільовий подавач на < тип/>< розмір/>.) Вийміть папір, а потім завантажте папір потрібного типу та розміру. Щоб дізнатися більше, див.  . 12.92 Change multipurpose feeder to <type/> <size/> <orientation/>.  (Завантажте багатоцільовий подавач на <тип/> <розмір/> <орієнтацію/>.) 29,08 Remove packing material  (Зніміть пакувальний матеріал). Відкрийте дверцята А. Вийміть картридж із тонером. Вийміть блок формування зображення. Зніміть пакувальний матеріал. Не піддавайте блок фотокондуктора впливу прямого світла протягом більш ніж 10 хвилин. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся блискучого барабана фотокондуктора під блоком формування зображення. Це може вплинути на якість майбутніх завдань друку. Вставте блок формування зображення. Вставте картридж із тонером. Закрийте дверцята A. Зніміть усі лотки, а потім видаліть увесь пакувальний матеріал. Вставте всі лотки. 31.40z Reinstall missing or unresponsive cartridge  (Перевстановіть картридж, який відсутній або не відповідає). Відкрийте дверцята А. Вийміть картридж із тонером. Вставте картридж із тонером. Закрийте дверцята A. 31.60z Reinstall missing or unresponsive imaging unit.  (Повторно встановіть відсутній блок формування зображення або блок, який не реагує). Відкрийте дверцята А. Вийміть картридж із тонером. Вийміть блок формування зображення. Не піддавайте блок фотокондуктора впливу прямого світла протягом більш ніж 10 хвилин. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся блискучого барабана фотокондуктора під блоком формування зображення. Це може вплинути на якість майбутніх завдань друку. Вставте блок формування зображення. Вставте картридж із тонером. Закрийте дверцята A. 32.40z Replace unsupported cartridge  (Замініть непідтримуваний картридж) Див.  . 32.60z Replace unsupported imaging unit  (Замініть непідтримуваний блок формування зображення) Див.  . 33.40 Non-Lexmark cartridge, see User's Guide.  (Картридж не виробництва Lexmark, див. Посібник користувача). Див.  . 33.60 Non-Lexmark imaging unit, see User's Guide  (Блок формування зображень не виробництва Lexmark, див. Посібник користувача). 37,1 Insufficient memory to collate job  (Недостатньо пам’яті для завдання розбирання за копіями). Спробуйте одну або декілька з наведених нижче дій. Торкніться  Continue  (Продовжити, щоб надрукувати збережену частину завдання та почати розбирати за копіями решту завдання друку). Скасуйте поточне завдання друку. 37,3 Insufficient memory, some held jobs were deleted.  (Недостатньо пам’яті, деякі відкладені завдання видалено). Торкніться  Continue  (Продовжити), щоб очистити повідомлення та продовжити друк. 38,1 Memory full  (Пам’ять заповнено). Спробуйте одну або декілька з наведених нижче дій. Торкніться  Cancel job  (Скасувати завдання), щоб очистити повідомлення. Роздрукуйте документ кількома частинами або надішліть його на інший принтер. Установіть додаткову пам’ять принтера. 39.1 Complex page, some data may not have printed.  (Складна сторінка, деякі дані можуть не надрукуватися) Спробуйте одну або декілька з наведених нижче дій. Торкніться  Continue  (Продовжити), щоб очистити повідомлення та продовжити друк. Скасуйте поточне завдання друку. Установіть додаткову пам’ять принтера. Зменште складність і розмір завдання друку, перш ніж надсилати його на друк знову. Зменште кількість сторінок у завданні друку. Зменшіть кількість і розмір будь-яких завантажених шрифтів. Видаліть усі непотрібні шрифти чи макроси із завдання друку. Зменште кількість графічних зображень у завданні друку. 42.yy Replace cartridge, printer region mismatch.  (Замініть картридж, невідповідність регіону принтера) Див.  . 43.40z Reinstall cartridge  (Перевстановіть картридж). Див.  . 44,40 Replace cartridge, printer mismatch  (Замініть картридж, невідповідність принтера) Див.  . 55,1 Error reading USB drive (Помилка читання USB-накопичувача).Remove USB  (Витягніть USB-накопичувач). Вийміть флешнакопичувач, щоб продовжити. 55.2 Error reading USB hub (Помилка читання концентратора USB).Remove hub  (Видаліть концентратор). Вийміть концентратор USB, щоб продовжити. 58 Too many trays attached (Прикріплено забагато лотків). Only <x/> tray/s can be supported  (Може підтримуватися тільки така кількість лотків: <x/>) Вимкніть принтер, а тоді вийміть кабель живлення з розетки. Видаліть один або кілька лотків. Увімкніть кабель живлення в розетку, а тоді ввімкніть принтер. Щоб уникнути ризику пожежі чи електричного ураження, підключіть кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. 59 Incompatible tray [x]  (Несумісний лоток) Вимкніть принтер, а тоді вийміть кабель живлення з розетки. Зніміть указаний лоток. Увімкніть кабель живлення в розетку, а тоді ввімкніть принтер. Щоб уникнути ризику пожежі чи електричного ураження, підключіть кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. 61 Remove defective disk  (Зніміть несправний диск). Замініть несправний накопичувач. 62 Disk full  (Диск заповнений). Спробуйте одну або декілька з наведених нижче дій. Торкніться  Continue  (Продовжити), щоб очистити повідомлення. Видаліть шрифти, макроси та інші дані, що зберігаються на інтелектуальному накопичувачі. Установка інтелектуального накопичувача. 63 Format the disk  (Форматування диску). Форматування тепер видаляє всю інформацію з накопичувача. Щоб відформатувати диск, виконайте наведені кроки. На головному екрані торкніться  Settings  (Параметри) Device  (Пристрій) Maintenance  (Обслуговування) Out of Service Erase  (Стирання для виведення з експлуатації). Торкніться  Sanitize all information on hard disk  (Очистити всю інформацію на жорсткому диску) або  Erase Intelligent Storage Drive  (Стерти дані інтелектуального накопичувача), а потім натисніть  ERASE  (СТЕРТИ). 71.01 Fax Station Name not set up. Contact system administrator.  (Назву станції факсу не налаштовано. Зверніться до системного адміністратора.) Див.  . 71.02 Fax Station Number not set up. Contact system administrator.  (Номер станції факсу не налаштовано. Зверніться до системного адміністратора.) 71.03 No analog phone line connected to modem, fax is disabled  (Немає аналогової телефонної лінії, підключеної до модема, факс вимкнено). Перевірте з’єднання та лінію на наявність сигналу. Щоб дізнатися більше, див.  . 71.06 Unable to connect to HTTPS Fax Server  (Неможливо підключитися до сервера факсу HTTPS). Підключення до сервера факсу HTTPS розірвано. Перевірте підключення принтера до інтернету. 71.12 Memory full, cannot print faxes  (Пам’ять заповнена, неможливо надрукувати факси). Торкніться  Print All  (Друкувати все), щоб надрукувати стільки факсів, скільки було збережено. 71,13 Memory full. Cannot send faxes  (Пам’ять заповнено. Неможливо надіслати факси). Спробуйте одну або декілька з наведених нижче дій. Продовжте та спробуйте надіслати факс ще раз. Відскануйте одну сторінку оригінального документу за раз, наберіть номер факсу, а потім відскануйте документ. 71,4 Incorrect printer time  (Неправильний час принтера) Щоб установити правильний час принтера, виконайте наведені кроки: Торкніться  Settings  (Параметри) Device  (Пристрій) Preferences  (Налаштування) Торкніться  Date and Time  (Дата й час) і встановіть правильний час. 72.01 E-mail SMTP server not set up. Contact system administrator.  (SMTP-сервер електронної пошти не налаштовано. Зверніться до системного адміністратора). Спробуйте одну з наведених дій Налаштуйте функцію електронної пошти. Щоб дізнатися більше, див.  . Вимкніть повідомлення про помилку. Щоб дізнатися більше, див.  . 80.01, 80.03, 80.09 Maintenance kit nearly low  (Набір для обслуговування майже закінчився). Торкніться  Continue  (Продовжити), щоб очистити повідомлення. 80.11, 80.13, 80.19 Maintenance kit low  (Набір для обслуговування закінчився). 80.21, 80.23, 80.29 Maintenance kit nearly low  (Набір для обслуговування у дуже малій кількості). 84.00, 84.01, 84.02, 84.03, 84.09 Imaging unit nearly low  (Блок формування зображення майже порожній). Торкніться  Continue  (Продовжити), щоб очистити повідомлення. 84.11, 84.12, 84.13, 84.19 Imaging unit low  (Блок формування зображення порожній). 84.21, 84.22, 84.23, 84.29 Imaging unit very low  (Блок формування зображення має дуже низький запас). 84.31, 84.32, 84.33 Replace imaging unit, recommended life exceeded  (Замініть блок формування зображення, рекомендований термін служби перевищено). Див.  . 84.41, 84.42, 84.43 Replace imaging unit to resume printing  (Замініть блок формування зображення, щоб продовжити друк). 88.00, 88.08, 88.09 Cartridge nearly low  (Картридж майже порожній). Торкніться  Continue  (Продовжити), щоб очистити повідомлення. 88.10, 88.18, 88.19 Cartridge low  (Картридж порожній). 88.20, 88.28, 88.29 Cartridge very low  (Картридж має дуже низький запас). 88.30, 88.38 Replace cartridge, <num/> estimated pages remain.  (Замініть картридж, залишилося приблизно <num/> стор.) Див.  . 88.30, 88.38 Replace cartridge  (Замініть картридж). 88.40, 88.48 Replace cartridge, 0 pages remain  (Замініть картридж, залишилося 0 сторінок). 200,03 Paper jam, [jam header] (Зминання паперу, [заголовок зминання]). [xxx.yy] Див.  . 200.04, 200.05, 200.14, 200.24, 200.25, 200.34, 200.35, 200.44, 200.45, 202.05, 202.15, 202.25, 202.35, 202.45, 230.03, 230.13, 230.23, 230.33, 230.43 Paper jam, [jam header] (Зминання паперу, [заголовок зминання]). [xxx.yy] Див.  . 200.12, 200.15, 200.22, 200.32, 200.33, 200.42, 200.91, 202.03, 200.13, 202.33, 202.43, 202.93 Paper jam, [jam header] (Зминання паперу, [заголовок зминання]). [xxx.yy] Див.  . 200.13, 200.23, 200.33, 200.43, 241.86 Paper jam, [jam header] (Зминання паперу, [заголовок зминання]). [xxx.yy] Див.  . 230.15, 230.25, 230.33, 230.45, 232.13, 232.23, 232.33, 232.43, 232.53, 232.93 Paper jam, [jam header] (Зминання паперу, [заголовок зминання]). [xxx.yy] Див.  . 24x.x6, 24x.8y, 602.x9 66x.x3, 66x.8y Paper jam, [jam header (Помилка завантаження паперу, [заголовок зминання]). [xxx.yy] Див.  . 280.11, 280.13, 280.15, 280.91, 280.93, 280.95, 284.11, 284.13, 284.15, 284.91, 284.93, 284.95, 295.01, 680.10, 680.20, 680.40 Scanner jam (Застрягання сканера). [xxx.yy] Див.  . коди помилок принтера коди помилок повідомлення про помилки принтера повідомлення про помилки"},{"UUID":"bc36bbe9-555f-4c71-8e9a-5d69918ccbb7","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Пусті чи білі сторінки Перш","descFull":"Пусті чи білі сторінки Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Принтер друкує пусті чи білі сторінки? Проблему усунено. Зніміть із блока формування зображення будь-який залишковий пакувальний матеріал. Вийміть картридж із тонером, а потім вийміть блок формування зображення. Не піддавайте блок формування зображення впливу прямого світла упродовж понад 10 хвилин. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся барабана фотокондуктора під блоком формування зображення. Це може вплинути на якість майбутніх завдань друку. Перевірте блок формування зображення на наявність ознак пошкодження та замініть його, якщо це потрібно. Переконайтеся, що контакт барабана фотокондуктора не погнутий і не зміщений. Ретельно струсіть блок формування зображення, щоб розподілити тонер. Установіть блок формування зображення, а потім установіть картридж із тонером. Надрукуйте документ. Принтер друкує пусті чи білі сторінки? Проблему усунено. Перевірте стан картриджа з тонером і замініть його, якщо це потрібно. На головному екрані торкніться  Status/Supplies  (Стан / Витратні матеріали) Supplies  (Витратні матеріали). Надрукуйте документ. Принтер друкує пусті чи білі сторінки? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку пусті сторінки проблема з якістю друку білі сторінки білі сторінки пусті сторінки"},{"UUID":"a5ce6c75-bb63-4b8a-a42f-3ddae71d6b13","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Темний друк Перш ніж усувати","descFull":"Темний друк Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Надрукований документ темний? Проблему усунено. Вимкніть принтер, зачекайте 10 секунд, а тоді ввімкніть принтер. Зменште щільність тонера. На головному екрані торкніться  Settings  (Параметри) Print  (Друк) Quality  (Якість) Toner Darkness  (Щільність тонера). Надрукуйте документ. Надрукований документ темний? Проблему усунено. Залежно від операційної системи вкажіть тип паперу в діалоговому вікні Printing Preferences (Параметри друку) чи Print (Друк). Переконайтеся, що налаштування відповідають завантаженому паперу. Цей параметр також можна змінити на панелі керування принтера. На головному екрані торкніться  Settings  (Параметри) Paper  (Папір) Tray Configuration  (Конфігурація лотка) Paper Size/Type  (Розмір/тип паперу). Надрукуйте документ. Надрукований документ темний? Проблему усунено. Перевірте, чи папір не текстурований і не жорсткий. Ви друкуєте на текстурованому чи жорсткому папері? Перейдіть до кроку 6. Замініть текстурований папір простим. Надрукуйте документ. Надрукований документ темний? Проблему усунено. Завантажте папір із нової пачки. Папір поглинає вологу через високу вологість. Зберігайте папір в оригінальному пакуванні, доки не будете готові його використовувати. Надрукуйте документ. Надрукований документ темний? Проблему усунено. Витягніть, а потім вставте блок формування зображення. Не піддавайте блок формування зображення впливу прямого світла упродовж понад 10 хвилин. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся барабана фотокондуктора під блоком формування зображення. Це може вплинути на якість майбутніх завдань друку. Надрукуйте документ. Надрукований документ темний? Проблему усунено. Замініть блок формування зображення. Надрукуйте документ. Надрукований документ темний? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку темний друк темний друк"},{"UUID":"b8135f26-c83c-404d-8f70-a23fa3c2ab89","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Тонкі лінії друкуються неправильно Перш","descFull":"Тонкі лінії друкуються неправильно Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Тонкі лінії друкуються правильно? Проблему усунено. Відкоригуйте параметри якості друку. На головному екрані торкніться  Settings  (Параметри) Print  (Друк) Quality  (Якість) Pixel Boost  (Підсилення пікселів) Fonts  (Шрифти). Відрегулюйте щільність тонера на 7. На головному екрані торкніться  Settings  (Параметри) Print  (Друк) Quality  (Якість) Toner Darkness  (Щільність тонера). Надрукуйте документ. Тонкі лінії друкуються правильно? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . проблема з якістю друку тонкі лінії друкуються неправильно тонкі лінії друкуються неправильно"},{"UUID":"6d42fef8-341c-4f2b-99ec-b1ee0113b7cf","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Складений або зім’ятий папір Перш","descFull":"Складений або зім’ятий папір Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Папір складений чи зім’ятий? Проблему усунено. Завантажте папір із нової пачки. Папір поглинає вологу через високу вологість. Зберігайте папір в оригінальному пакуванні, доки не будете готові його використовувати. Надрукуйте документ. Папір складений чи зім’ятий? Проблему усунено. Залежно від операційної системи вкажіть тип паперу в діалоговому вікні Printing Preferences (Параметри друку) чи Print (Друк). Переконайтеся, що налаштування відповідають завантаженому паперу. Цей параметр також можна змінити на панелі керування принтера. На головному екрані торкніться  Settings  (Параметри) Paper  (Папір) Tray Configuration  (Конфігурація лотка) Paper Size/Type  (Розмір/тип паперу). Надрукуйте документ. Папір складений чи зім’ятий? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку складений папір проблема з якістю друку зім’ятий папір папір з папки зім’ятий папір"},{"UUID":"cdb84ab1-ab79-4b9e-8ee5-06aa3402d0fc","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Сіре тло Перш ніж усувати","descFull":"Сіре тло Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Вимкніть принтер, зачекайте 10 секунд, а тоді ввімкніть принтер. Зменште щільність тонера. На головному екрані торкніться  Settings  (Параметри) Print  (Друк) Quality  (Якість) Toner Darkness  (Щільність тонера). Надрукуйте документ. На надрукованих аркушах з’являється сіре тло? Проблему усунено. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. На надрукованих аркушах з’являється сіре тло? Проблему усунено. Залежно від операційної системи вкажіть тип паперу в діалоговому вікні Printing Preferences (Параметри друку) чи Print (Друк). Переконайтеся, що налаштування відповідають завантаженому паперу. Цей параметр також можна змінити на панелі керування принтера. На головному екрані торкніться  Settings  (Параметри) Paper  (Папір) Tray Configuration  (Конфігурація лотка) Paper Size/Type  (Розмір/тип паперу). Надрукуйте документ. На надрукованих аркушах з’являється сіре тло? Проблему усунено. Витягніть, а потім вставте блок формування зображення. Не піддавайте блок формування зображення впливу прямого світла. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся барабана фотокондуктора. Це може вплинути на якість майбутніх завдань друку. Надрукуйте документ. На надрукованих аркушах з’являється сіре тло? Проблему усунено. Оновіть мікропрограму принтера. Щоб дізнатися більше, див.  . Надрукуйте документ. На надрукованих аркушах з’являється сіре тло? Проблему усунено. Замініть блок формування зображення. Надрукуйте документ. На надрукованих аркушах з’являється сіре тло? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку сіре тло на надрукованих аркушах сіре тло на надрукованих аркушах"},{"UUID":"b31d4af7-981a-4039-baa0-7d68ca04c424","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Неправильні поля Неправильні поля Перш","descFull":"Неправильні поля Неправильні поля Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Скоригуйте механізми скерування паперу в лотку в правильне положення для завантаженого паперу. Надрукуйте документ. Поля правильні? Проблему усунено. Залежно від операційної системи, укажіть розмір паперу в діалоговому вікні «Параметри друку» чи «Друк». Переконайтеся, що налаштування відповідають завантаженому паперу. Цей параметр також можна змінити на панелі керування принтера. На головному екрані торкніться  Settings  (Параметри) Paper  (Папір) Tray Configuration  (Конфігурація лотка) Paper Size/Type  (Розмір/тип паперу). Надрукуйте документ. Поля правильні? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . неправильні поля проблема з якістю друку неправильні поля"},{"UUID":"88ad92b8-e6ec-4ddb-9246-b2d7ddf372fc","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Світлий друк Перш ніж усувати","descFull":"Світлий друк Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings (Параметри) Troubleshooting (Усунення несправностей) Print Quality Test Pages (Тестові сторінки якості друку) . Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Надрукований аркуш світлий? Проблему усунено. Вимкніть принтер, зачекайте 10 секунд, а тоді ввімкніть принтер. Збільште щільність тонера. На головному екрані торкніться  Settings  (Параметри) Print  (Друк) Quality  (Якість) Toner Darkness  (Щільність тонера). Надрукуйте документ. Надрукований аркуш світлий? Проблему усунено. Залежно від операційної системи вкажіть тип паперу в діалоговому вікні Printing Preferences (Параметри друку) чи Print (Друк). Переконайтеся, що налаштування відповідають завантаженому паперу. Цей параметр також можна змінити на панелі керування принтера. На головному екрані торкніться  Settings  (Параметри) Paper  (Папір) Tray Configuration  (Конфігурація лотка) Paper Size/Type  (Розмір/тип паперу). Надрукуйте документ. Надрукований аркуш світлий? Проблему усунено. Залежно від операційної системи вкажіть роздільну здатність друку в діалоговому вікні Printing Preferences (Параметри друку) чи Print (Друк). Установіть роздільну здатність на  600 dpi . Надрукуйте документ. Надрукований аркуш світлий? Проблему усунено. Вийміть блок формування зображення. Не піддавайте блок формування зображення впливу прямого світла. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся барабана фотокондуктора. Це може вплинути на якість майбутніх завдань друку. Ретельно струсіть блок формування зображення, щоб розподілити тонер. Вставте блок формування зображення. Вимкніть принтер, зачекайте 10 секунд, а тоді ввімкніть принтер. Надрукуйте документ. Надрукований аркуш світлий? Проблему усунено. Перевірте статус картриджа з тонером. На головній сторінці торкніться  Settings  (Параметри) Reports  (Звіти) Device  (Пристрій) Device Statistics  (Статистика пристрою). У розділі «Інформація про витратні матеріали» надрукованих сторінок перевірте стан блока формування зображення. Термін служби картриджа з тонером наближається до завершення? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Замініть картридж із тонером. Надрукуйте документ. Надрукований аркуш світлий? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку світлий друк світлий друк"},{"UUID":"aeca6946-eae4-48f0-9ebd-2f82ddb2f6a3","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Друк із плямами Перш ніж","descFull":"Друк із плямами Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Надрукований аркуш строкатий? Проблему усунено. Перевірте наявність протікання тонера всередині принтера. Чи немає в принтері тонера, який протік? Перейдіть до кроку 4. Замініть картридж із тонером. Надрукуйте документ. Надрукований аркуш строкатий? Проблему усунено. Перевірте стан блока формування зображення. На головному екрані торкніться  Status/Supplies  (Стан / Витратні матеріали) Supplies  (Витратні матеріали). Термін служби блока формування зображення наближається до завершення? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Замініть блок формування зображення. Надрукуйте документ. Надрукований аркуш строкатий? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку друк із плямами проблема з якістю друку цятки на надрукованому аркуші друк із плямами цятки на надрукованому аркуші"},{"UUID":"3b703f02-4e03-4674-9f69-9c9a1916f4bb","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Скручування паперу Кроки для усунення","descFull":"Скручування паперу Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Папір скручений? Проблему усунено. Скоригуйте механізми скерування в лотку в правильне положення для завантаженого паперу. Надрукуйте документ. Папір скручений? Проблему усунено. Залежно від операційної системи вкажіть розмір і тип паперу в діалоговому вікні Printing Preferences (Параметри друку) чи Print (Друк). Переконайтеся, що значення параметрів відповідає типу завантаженого паперу. Ці параметри також можна змінити за допомогою панелі керування принтера. Надрукуйте документ. Папір скручений? Проблему усунено. Вийміть папір із лотка та вставте його іншим боком. Надрукуйте документ. Папір скручений? Проблему усунено. Завантажте папір із нової пачки. Папір поглинає вологу через високу вологість. Зберігайте папір в оригінальному пакуванні, доки не будете готові його використовувати. Надрукуйте документ. Папір скручений? Проблему усунено. Перевірте, чи підтримується завантажений папір. Якщо папір не підтримується, завантажте сумісний папір. Надрукуйте документ. Папір скручений? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку скручування паперу скручування паперу"},{"UUID":"e4bc90c4-1721-43f5-bb85-8f0f9a667a93","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Надрукований аркуш перекошений чи похилий","descFull":"Надрукований аркуш перекошений чи похилий Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Витягніть лоток. Вийміть папір, а тоді завантажте папір із нової пачки. Папір поглинає вологу через високу вологість. Зберігайте папір в оригінальному пакуванні, доки не будете готові його використовувати. Стисніть і зсуньте механізм спрямування паперу в правильне положення з урахуванням розміру паперу, який ви завантажуєте. Вставте лоток. Надрукуйте документ. Надрукований аркуш перекошений чи похилий? Проблему усунено. Перевірте, чи підтримується папір, на якому ви друкуєте. Надрукуйте документ. Надрукований аркуш перекошений чи похилий? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. похилий друк перекошений друк проблема з якістю друку похилий друк проблема з якістю друку перекошений друк похилий друк перекошений друк"},{"UUID":"be1a291b-6cba-44e6-8379-99562e5c6528","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Суцільні чорні сторінки Перш ніж","descFull":"Суцільні чорні сторінки Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings (Параметри) Troubleshooting (Усунення несправностей) Print Quality Test Pages (Тестові сторінки якості друку) . Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Принтер друкує суцільні чорні сторінки? Проблему усунено. Вийміть блок формування зображення. Не піддавайте блок формування зображення впливу прямого світла упродовж понад 10 хвилин. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся барабана фотокондуктора під блоком формування зображення. Це може вплинути на якість майбутніх завдань друку. Видаліть із блока формування зображення будь-який застряглий пакувальний матеріал. Обов’язково усуньте будь-які перешкоди між роликом заряджання та барабаном фотокондуктора. Вставте блок формування зображення. Надрукуйте документ. Принтер друкує суцільні чорні сторінки? Проблему усунено. Перевірте блок формування зображення щодо ознак пошкодження. Чи не пошкоджено блок формування зображення? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Замініть блок формування зображення. Надрукуйте документ. Принтер друкує суцільні чорні сторінки? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку суцільні чорні сторінки суцільні чорні сторінки чорні сторінки"},{"UUID":"97e99715-f656-41c5-b5cc-75ac28010980","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Обрізання тексту або зображень Перш","descFull":"Обрізання тексту або зображень Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Текст або зображення обрізані? Проблему усунено. Вийміть блок формування зображення. Не піддавайте блок формування зображення впливу прямого світла упродовж понад 10 хвилин. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся барабана фотокондуктора під блоком формування зображення. Це може вплинути на якість майбутніх завдань друку. Видаліть із блока формування зображення будь-який застряглий пакувальний матеріал. Обов’язково усуньте будь-які перешкоди між роликом заряджання та барабаном фотокондуктора. Вставте блок формування зображення. Надрукуйте документ. Текст або зображення обрізані? Проблему усунено. Замініть блок формування зображення. Надрукуйте документ. Текст або зображення обрізані? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку обрізання тексту або зображень обрізання тексту під час друку обрізання зображення під час друку"},{"UUID":"ddc5aa0e-13d2-4090-9e77-e19ebb629518","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Тонер легко стирається Перш ніж","descFull":"Тонер легко стирається Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Тонер легко стирається? Проблему усунено. Залежно від операційної системи вкажіть тип паперу в діалоговому вікні Printing Preferences (Параметри друку) чи Print (Друк). Переконайтеся, що налаштування відповідають завантаженому паперу. Цей параметр також можна змінити на панелі керування принтера. На головному екрані торкніться  Settings  (Параметри) Paper  (Папір) Tray Configuration  (Конфігурація лотка) Paper Size/Type  (Розмір/тип паперу). Надрукуйте документ. Тонер легко стирається? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку тонер легко стирається тонер легко стирається"},{"UUID":"0a895b67-c4d2-4932-85b9-27676ca67285","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Горизонтальні світлі смуги Перш ніж","descFull":"Горизонтальні світлі смуги Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Чи з’являються горизонтальні світлі смуги на надрукованих документах? Проблему усунено. Витягніть, а потім вставте блок формування зображення. Не піддавайте блок формування зображення впливу прямого світла. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся барабана фотокондуктора. Це може вплинути на якість майбутніх завдань друку. Надрукуйте документ. Чи з’являються горизонтальні світлі смуги на надрукованих документах? Проблему усунено. Замініть блок формування зображення. Надрукуйте документ. Чи з’являються горизонтальні світлі смуги на надрукованих документах? Проблему усунено. Вимкніть принтер, зачекайте 10 секунд, а тоді ввімкніть принтер. Надрукуйте документ. Чи з’являються горизонтальні світлі смуги на надрукованих документах? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку горизонтальні світлі смуги горизонтальні світлі смуги"},{"UUID":"2275ae33-184f-4a0b-9ad1-d650430e4ccf","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Вертикальні світлі смуги Перш ніж","descFull":"Вертикальні світлі смуги Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Чи з’являються вертикальні світлі смуги на надрукованих документах? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку вертикальні світлі смуги вертикальні світлі смуги"},{"UUID":"bef1de45-e2d2-4c2e-bf56-383f4e6403fa","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Вертикальні білі смуги Перш ніж","descFull":"Вертикальні білі смуги Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Чи з'являються вертикальні білі смуги на надрукованих документах? Проблему усунено. Залежно від операційної системи вкажіть тип паперу в діалоговому вікні Printing Preferences (Параметри друку) чи Print (Друк). Переконайтеся, що налаштування відповідають завантаженому паперу. Цей параметр також можна змінити на панелі керування принтера. На головному екрані торкніться  Settings  (Параметри) Paper  (Папір) Tray Configuration  (Конфігурація лотка) Paper Size/Type  (Розмір/тип паперу). Надрукуйте документ. Чи з'являються вертикальні білі смуги на надрукованих документах? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку вертикальні білі смуги вертикальні білі смуги"},{"UUID":"5e25ef8e-e3c4-48be-ba6a-a7a136992569","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Вертикальні темні смуги Перш ніж","descFull":"Вертикальні темні смуги Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Чи з’являються вертикальні темні смуги на надрукованих документах? Проблему усунено. Вийміть картридж із тонером, а потім вийміть блок формування зображення. Не піддавайте блок формування зображення впливу прямого світла упродовж понад 10 хвилин. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся барабана фотокондуктора під блоком формування зображення. Це може вплинути на якість майбутніх завдань друку. Установіть блок формування зображення, а потім установіть картридж. Надрукуйте документ. Чи з’являються вертикальні темні смуги на надрукованих документах? Проблему усунено. Вийміть блок формування зображення. Не піддавайте блок формування зображення впливу прямого світла упродовж понад 10 хвилин. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся барабана фотокондуктора під блоком формування зображення. Це може вплинути на якість майбутніх завдань друку. Видаліть із блока формування зображення будь-який застряглий пакувальний матеріал. Обов’язково усуньте будь-які перешкоди між роликом заряджання та барабаном фотокондуктора. Вставте блок формування зображення. Надрукуйте документ. Чи з’являються вертикальні темні смуги на надрукованих документах? Проблему усунено. Перевірте, чи не потрапляє на праву частину принтера яскраве світло, і пересуньте принтер, якщо це потрібно. Надрукуйте документ. Чи з’являються вертикальні темні смуги на надрукованих документах? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку вертикальні темні смуги вертикальні темні смуги на надрукованих документах"},{"UUID":"8a67524b-ca5a-4931-b530-faeeb22eda67","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Вертикальні темні смуги або лінії","descFull":"Вертикальні темні смуги або лінії Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Cleaning the Scanner  (Очищення сканера). Надрукуйте документ. Чи з’являються вертикальні темні смуги чи лінії на надрукованих документах? Перейдіть до кроку 3. Очистьте сканер, використовуючи вологу м’яку, безворсову тканину. Щоб дізнатися більше, див.  . Скопіюйте документ за допомогою пристрою АПД. Чи з’являються вертикальні темні смуги чи лінії на надрукованих документах? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Чи з’являються вертикальні темні смуги чи лінії на надрукованих документах? Проблему усунено. Витягніть, а потім вставте блок формування зображення. Не піддавайте блок формування зображення впливу прямого світла упродовж понад 10 хвилин. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся барабана фотокондуктора під блоком формування зображення. Це може вплинути на якість майбутніх завдань друку. Надрукуйте документ. Чи з’являються вертикальні темні смуги чи лінії на надрукованих документах? Проблему усунено. Замініть блок формування зображення. Надрукуйте документ. Чи з’являються вертикальні темні смуги чи лінії на надрукованих документах? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку вертикальні темні смуги або лінії вертикальні темні лінії на надрукованих документах вертикальні смуги на надрукованих документах"},{"UUID":"dcfe3e10-32cd-44ba-a7e6-dc540eeca965","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Вертикальні темні смуги з відсутнім","descFull":"Вертикальні темні смуги з відсутнім відбитком Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером Lexmark. Перевірте, чи принтер використовує оригінальний і сумісний картридж із тонером. Якщо картридж не підтримується, установіть сумісний. Надрукуйте документ. Чи з’являються на відбитках вертикальні темні смуги з відсутніми зображеннями? Проблему усунено. Вийміть блок формування зображення. Не піддавайте блок формування зображення впливу прямого світла упродовж понад 10 хвилин. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся барабана фотокондуктора під блоком формування зображення. Це може вплинути на якість майбутніх завдань друку. Видаліть із блока формування зображення будь-який застряглий пакувальний матеріал. Обов’язково усуньте будь-які перешкоди між роликом заряджання та барабаном фотокондуктора. Вставте блок формування зображення. Надрукуйте документ. Чи з’являються на відбитках вертикальні темні смуги з відсутніми зображеннями? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. вертикальні темні смуги відсутній друк проблема з якістю друку вертикальні темні смуги з відсутнім відбитком"},{"UUID":"4306ee37-c7a7-4d30-9e01-02a1b67e4839","title":"Низька якість друку","link":"solving-printing-problems.html","desc":"Повторювані дефекти Перш ніж усувати","descFull":"Повторювані дефекти Перш ніж усувати цю проблему, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Кроки для усунення проблеми Дія Так Ні Використовуючи тестові сторінки якості друку, перевірте, чи дорівнює відстань між повторюваними дефектами будь-якому з наведеного нижче. 97 мм (3,82 дюйма) 47 мм (1,85 дюйма) 38 мм (1,5 дюйма) Відстань між повторюваними дефектами відповідає будь-яким вказаним значенням? Запишіть відстань, а потім зверніться в  службу підтримки клієнтів . Запишіть відстань, а потім зверніться в  службу технічної підтримки . Запишіть відстань, а потім зверніться до свого  дилера . Замініть блок формування зображення. Надрукуйте документ. Чи з'являються повторювані дефекти? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю друку повторювані дефекти повторювані дефекти друку"},{"UUID":"ff8b6a6a-6d71-484f-b8c8-c4cc72001837","title":"Проблеми з друком","link":"solving-printing-problems.html","desc":"Завдання друку не друкуються Кроки","descFull":"Завдання друку не друкуються Кроки для усунення проблеми Дія Так Ні У документів, який ви намагаєтеся надрукувати, відкрийте діалогове вікно «Друк», а тоді перевірте, чи вибрано правильно принтер. Надрукуйте документ. Документ надруковано? Проблему усунено. Перевірте, чи принтер увімкнено. Усуньте повідомлення про помилку, які відображаються на дисплеї. Надрукуйте документ. Документ надруковано? Проблему усунено. Перевірте, чи працюють порти й чи кабелі надійно підключено до комп’ютера та принтера. Щоб дізнатися більше, див. документацію щодо налаштування, яка постачалася разом із принтером. Надрукуйте документ. Документ надруковано? Проблему усунено. Вимкніть принтер, зачекайте 10 секунд, а тоді ввімкніть принтер. Надрукуйте документ. Документ надруковано? Проблему усунено. Видаліть, а потім знову встановіть драйвер принтера. Надрукуйте документ. Документ надруковано? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . проблема з друком завдання друку не друкуються завдання друку не виконано"},{"UUID":"d96191bb-9237-4bd1-8dd9-240ff0917c29","title":"Проблеми з друком","link":"solving-printing-problems.html","desc":"Конфіденційні й інші відкладені документи","descFull":"Конфіденційні й інші відкладені документи не друкуються Кроки для усунення проблеми Дія Так Ні На панелі керування перевірте, чи документи відображаються в списку  Held Jobs  (Відкладені завдання). Якщо документів немає в списку, надрукуйте документи за допомогою опцій «Друкувати й відкласти». Надрукуйте документи. Документи надруковано? Проблему усунено. Завдання друку може містити помилку форматування чи недійсні дані. Видаліть завдання друку, а тоді надішліть його знову. Для файлів PDF створіть новий файл, а тоді надрукуйте документи. Документи надруковано? Проблему усунено. Якщо ви друкуєте з інтернету, принтер може зчитувати кілька назв завдань як дублікати. Для користувачів Windows Відкрийте діалогове вікно «Параметри друку». На вкладці Print and Hold (Друк і відкладення) клацніть  Use Print and Hold  (Використовувати друк і відкладення), а потім натисніть  Keep duplicate documents  (Зберігати копії документів). Введіть PIN-код, а тоді збережіть зміни. Надішліть завдання друку. Для користувачів Macintosh Збережіть і назвіть кожне завдання по-іншому. Надсилайте завдання окремо. Документи надруковано? Проблему усунено. Видаліть деякі відкладені завдання, щоб звільнити пам’ять. Надрукуйте документи. Документи надруковано? Проблему усунено. Додайте пам’ять принтера. Надрукуйте документи. Документи надруковано? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем, друк конфіденційні й інші відкладені документи не друкуються усунення проблем із друком конфіденційні й інші відкладені документи не друкуються конфіденційні документи не друкуються відкладені документи не друкуються"},{"UUID":"a14488b5-8351-4e78-8d25-46dced547142","title":"Проблеми з друком","link":"solving-printing-problems.html","desc":"Завдання друкується з неправильного лотка","descFull":"Завдання друкується з неправильного лотка чи на неправильному папері Кроки для усунення проблеми Дія Так Ні Перевірте, чи ви друкуєте на правильному папері. Надрукуйте документ. Документ надруковано на правильному папері? Завантажте правильний розмір і тип паперу. Залежно від операційної системи вкажіть розмір і тип паперу в діалоговому вікні Printing Preferences (Параметри друку) чи Print (Друк). Параметри також можна змінити на панелі керування принтера. На головному екрані торкніться  Settings  (Параметри) Paper  (Папір) Tray Configuration  (Конфігурація лотка) Paper Size/Type  (Розмір/тип паперу). Переконайтеся, що значення параметрів відповідає типу завантаженого паперу. Надрукуйте документ. Документ надруковано на правильному папері? Проблему усунено. Перевірте, чи лотки пов’язано. Щоб дізнатися більше, див.  . Надрукуйте документ. Документ надруковано з правильного лотка? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем із друком завдання друкується з неправильного лотка усунення проблем із друком завдання друкується на неправильному папері усунення проблем, друк завдання друкується з неправильного лотка усунення проблем, друк завдання друкується на неправильному папері завдання друкується з неправильного лотка завдання друкується на неправильному папері"},{"UUID":"3fa3d507-f8b1-43f0-a4f1-dee8c3706950","title":"Проблеми з друком","link":"solving-printing-problems.html","desc":"Низька швидкість друку Кроки для","descFull":"Низька швидкість друку Кроки для усунення проблеми Дія Так Ні Переконайтеся, що кабель принтера надійно під’єднано до принтера та комп’ютера, сервера друку, додаткового пристрою чи іншого мережевого пристрою. Принтер друкує повільно? Проблему усунено. Переконайтеся, що принтер не перебуває в тихому режимі На головному екрані торкніться  Settings  (Параметри) Device  (Пристрій) Maintenance  (Обслуговування) Configuration Menu  (Меню конфігурацій) Device Operations  (Робота пристрою) Quiet Mode  (Тихий режим). Надрукуйте документ. Принтер друкує повільно? Проблему усунено. Залежно від операційної системи вкажіть роздільну здатність друку в діалоговому вікні Printing Preferences (Параметри друку) чи Print (Друк). Установіть роздільну здатність на  600 dpi . Надрукуйте документ. Принтер друкує повільно? Проблему усунено. На головному екрані торкніться  Settings  (Параметри) Print  (Друк) Quality  (Якість) Print Resolution  (Роздільна здатність друку). Установіть роздільну здатність на  600 dpi . Надрукуйте документ. Принтер друкує повільно? Проблему усунено. Залежно від операційної системи вкажіть тип паперу в діалоговому вікні Printing Preferences (Параметри друку) чи Print (Друк). Переконайтеся, що налаштування відповідають завантаженому паперу. Цей параметр також можна змінити на панелі керування принтера. На більш щільному папері друк виконується повільніше. Папір вужчий за Letter, A4 і Legal може друкуватися повільніше. Надрукуйте документ. Принтер друкує повільно? Проблему усунено. Переконайтеся, що параметри принтера для текстури та щільності відповідають паперу, який завантажується. На головному екрані торкніться  Settings  (Параметри) Paper  (Папір) Media Configuration  (Конфігурація носія) Media Types  (Типи носія). Жорстка текстура паперу та цупкий папір можуть уповільнювати друк. Надрукуйте документ. Принтер друкує повільно? Проблему усунено. Видаліть відкладені завдання. Принтер друкує повільно? Проблему усунено. Переконайтеся, що принтер не перегрітий. Дайте принтеру охолонути після тривалого друку. Дотримуйтеся рекомендованої температури навколишнього середовища для принтера. Щоб дізнатися більше, див.  . Надрукуйте документ. Принтер друкує повільно? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з друком низька швидкість друку низька швидкість друку"},{"UUID":"3acba542-5633-43e0-880c-0b37cc5673c0","title":"Усунення несправностей","link":"trb-printer-not-responding-topic.html","desc":"Принтер не відповідає Кроки для","descFull":"Принтер не відповідає Кроки для усунення проблеми Дія Так Ні Перевірте, чи кабель живлення підключено до розетки. Щоб уникнути ризику пожежі чи ураження електричним струмом, під’єднайте кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. Принтер відповідає? Проблему усунено. Перевірте, чи електричну розетку не вимкнено перемикачем або вимикачем. Електричну розетку вимкнено перемикачем або автоматичним вимикачем? Увімкніть перемикач або скиньте автоматичний вимикач. Перевірте, чи принтер увімкнено. Принтер увімкнено? Увімкніть принтер. Перевірте, чи принтер не перебуває в режимі сну або гібернації. Принтер перебуває в режимі сну або гібернації? Натисніть кнопку живлення, щоб активувати принтер. Перевірте, чи кабелі, які з'єднують принтер і комп’ютер, вставлені в правильні порти. Кабелі вставлені в правильні порти? Вставте кабелі в правильні порти. Вимкніть принтер, установіть засоби апаратного забезпечення, а потім увімкніть принтер. Щоб дізнатися більше, див. документацію, яка постачалася разом із засобом. Принтер відповідає? Проблему усунено. Установіть правильний драйвер принтера. Принтер відповідає? Проблему усунено. Вимкніть принтер, зачекайте 10 секунд, а тоді ввімкніть принтер. Принтер відповідає? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем принтер не відповідає принтер не відповідає"},{"UUID":"3f85ebed-9503-4a12-b60f-a1b18de2f738","title":"Усунення несправностей","link":"trb-unable-to-read-flash-drive-topic.html","desc":"Не вдається зчитати флешнакопичувач Не","descFull":"Не вдається зчитати флешнакопичувач Не вдається зчитати флешнакопичувач Кроки для усунення проблеми Дія Так Ні Переконайтеся, що принтер не зайнятий обробкою іншого завдання на друк, копіювання, сканування чи надсилання факсу. Чи готовий принтер? Перейдіть до кроку 3. Зачекайте, поки принтер завершить обробку іншого завдання. Витягніть, а потім вставте флешнакопичувач. Чи розпізнає принтер флешнакопичувач? Проблему усунено. Перевірте, чи флешнакопичувач вставлений у передній порт USB. флешнакопичувач не працює, якщо він вставлений у задній порт USB. флешнакопичувач вставлений у потрібний порт? Перейдіть до кроку 5. Вставте флешнакопичувач в потрібний порт. Чи розпізнає принтер флешнакопичувач? Проблему усунено. Перевірте, чи підтримується флешнакопичувач. Щоб дізнатися більше, див.  . Чи підтримується флешнакопичувач? Перейдіть до кроку 7. Вставте підтримуваний флешнакопичувач. Чи розпізнає принтер флешнакопичувач? Проблему усунено. Витягніть, а потім вставте флешнакопичувач. Чи розпізнає принтер флешнакопичувач? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . не вдається зчитати флешнакопичувач усунення проблем, друк усунення проблем із друком не вдається зчитати флешнакопичувач"},{"UUID":"3e4ac4e7-390e-427d-b6e1-bb7a69bdd07f","title":"Усунення несправностей","link":"enabling-usb-port-topic.html","desc":"Увімкнення порту USB На головному","descFull":"Увімкнення порту USB На головному екрані торкніться меню  Settings Network/Ports USB Enable USB Port . порт USB увімкнення увімкнення порту USB"},{"UUID":"3f7605e1-1a35-4fb9-a91f-ea90df8d662a","title":"Усування зминання","link":"clearing-jams.html","desc":"Уникнення заминання Належно завантажте папір","descFull":"Уникнення заминання Належно завантажте папір Переконайтеся, що папір лежить рівно в лотку. Правильне та неправильне завантаження паперу Правильне завантаження паперу Неправильне завантаження паперу Не завантажуйте й не виймайте лоток під час друку. Не завантажуйте забагато паперу. Переконайтеся, що висота стосу нижча за індикатор максимального заповнення папером. Не засовуйте папір у лоток. Завантажте папір, як показано на ілюстрації. Переконайтеся, що механізми спрямування паперу розташовані правильно й не тиснуть на папір і конверти. Щільно засуньте лоток у принтер після завантаження паперу. Використання рекомендованого паперу Використовуйте лише рекомендований папір чи спеціальний носій. Не завантажуйте зім’ятий, складений, вологий, зігнутий чи покручений папір. Відігніть, розгорніть і вирівняйте кути паперу перед завантаженням. Не використовуйте папір, який був розрізаний або обрізаний вручну. Не змішуйте папір різного розміру, ваги й типу в одному лотку. Переконайтеся, що розмір і типу паперу налаштовано правильно на комп’ютері чи панелі керування принтера. Зберігайте папір відповідно до рекомендацій виробника. зминання паперу уникнення заминання, папір уникнення уникнення зминання паперу"},{"UUID":"720a71c0-2f36-47e5-a972-62f1a9b47c26","title":"Усування зминання","link":"clearing-jams.html","desc":"Визначення місць зминань Якщо для","descFull":"Визначення місць зминань Якщо для параметра  Jam Assist  (Помічник зі зминання) встановлено значення  On  (Увімк.), принтер очищає порожні сторінки або сторінки з частковими відбитками після видалення зім’ятої сторінки. Перевірте, чи немає порожніх сторінок. Коли для параметру  Jam Recovery  (Відновлення після зминання) встановлено значення  On  (Увімк.) або  Auto  (Автоматично), принтер передруковує зім’яті сторінки. Розташування зминання Розташування зминання 1 Автоматичний подавач паперу 2 Багатоцільовий подавач 3 Лотки 4 Дверцята A 5 Дуплексний блок 6 Дверцята B розташування зминання зминання зминання паперу розташування визначення розташування зминання паперу"},{"UUID":"12b2b120-06eb-4582-b210-93ef8fdaf77f","title":"Усування зминання","link":"clearing-jams.html","desc":"Зминання паперу у дверцятах A","descFull":"Зминання паперу у дверцятах A Відкрийте дверцята А. Вийміть картридж із тонером. Вийміть блок формування зображення. Не піддавайте блок формування зображення впливу прямого світла упродовж понад 10 хвилин. Тривалий вплив світла може спричинити проблеми з якістю друку. Не торкайтеся барабана фотокондуктора. Це може вплинути на якість майбутніх завдань друку. Видаліть зім’ятий папір. Внутрішня частина принтера може бути гарячою. Щоб зменшити ризик отримання травм гарячим компонентом, дайте поверхні охолонути, перш ніж торкатися до неї. Переконайтеся, що всі фрагменти паперу видалено. Вставте блок формування зображення. Дотримуйтеся стрілок усередині принтера як указівників. Вставте картридж із тонером. Дотримуйтеся стрілок усередині принтера як указівників. Закрийте дверцята A. усування зминання у дверцятах A видалення зминання паперу у дверцятах A зминання паперу у дверцятах A"},{"UUID":"1653d817-36e6-4e46-a195-9490274324b9","title":"Усування зминання","link":"clearing-jams.html","desc":"Зминання паперу у дверцятах B","descFull":"Зминання паперу у дверцятах B Відкрийте дверцята B. Внутрішня частина принтера може бути гарячою. Щоб зменшити ризик отримання травм гарячим компонентом, дайте поверхні охолонути, перш ніж торкатися до неї. Видаліть зім’ятий папір. Переконайтеся, що всі фрагменти паперу видалено. Закрийте дверцята B. усування зминання у дверцятах B видалення зминання паперу у дверцятах B зминання паперу у дверцятах B"},{"UUID":"a4c0b0a1-f32c-4fc5-98e6-fb14c856a8dd","title":"Усування зминання","link":"clearing-jams.html","desc":"Зминання паперу в дуплексному блоці","descFull":"Зминання паперу в дуплексному блоці Зніміть лоток. Натисніть на засув дуплексного блоку, щоб відкрити дуплексний блок. Видаліть зім’ятий папір. Переконайтеся, що всі фрагменти паперу видалено. Вставте лоток. усування зминання у дуплексному блоці видалення зминання паперу у дуплексному блоці зминання паперу в дуплексному блоці"},{"UUID":"2ae4000e-94ec-42ab-9312-5814fc3285c6","title":"Усування зминання","link":"clearing-jams.html","desc":"Зминання паперу в лотках Зніміть","descFull":"Зминання паперу в лотках Зніміть лоток. Щоб запобігти пошкодженню від електростатичного розряду, торкніться будь-якої відкритої металевої рами принтера, перш ніж торкатися внутрішніх частин принтера. Видаліть зім’ятий папір. Переконайтеся, що всі фрагменти паперу видалено. Вставте лоток. усування зминання у лотках видалення зминання паперу у лотках зминання паперу в лотках"},{"UUID":"8c55902f-0632-44fa-91d8-ef4a7582da97","title":"Усування зминання","link":"clearing-jams.html","desc":"Зминання паперу в багатоцільовому подавачі","descFull":"Зминання паперу в багатоцільовому подавачі Видаліть папір із багатоцільового подавача. Видаліть зім’ятий папір. Переконайтеся, що всі фрагменти паперу видалено. Повторно завантажте папір і відкоригуйте напрямну для паперу. усування зминання у багатоцільовому подавачі видалення зминання паперу у багатоцільовому подавачі зминання паперу в багатоцільовому подавачі"},{"UUID":"865418b9-acec-4818-b503-5bb1b7779660","title":"Усування зминання","link":"clearing-jams.html","desc":"Зминання паперу в автоматичному подавачі","descFull":"Зминання паперу в автоматичному подавачі паперу Зминання паперу під верхньою кришкою АПД Вийміть усі оригінальні документи з лотка АПД. Відкрийте дверцята C. Видаліть зім’ятий папір. Переконайтеся, що всі фрагменти паперу видалено. Закрийте дверцята C. Зминання паперу під вихідним лотком АПД Вийміть усі оригінальні документи з лотка АПД. Підніміть лоток АПД й видаліть зім’ятий папір. Переконайтеся, що всі фрагменти паперу видалено. Установіть лоток АПД на місце. усування зминання в автоматичному подавачі паперу видалення зминання паперу в автоматичному подавачі паперу зминання паперу в автоматичному подавачі паперу"},{"UUID":"19826d91-7e8a-4339-8591-a2ba176f6caf","title":"Проблеми підключення до мережі","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Не вдається відкрити Embedded Web","descFull":"Не вдається відкрити Embedded Web Server Кроки для усунення проблеми Дія Так Ні Перевірте, чи принтер увімкнено. Доступ до Embedded Web Server принтера (EWS). Ви можете відкрити EWS? Проблему усунено. Переконайтеся, що правильно вказано IP-адресу. Перегляньте IP-адресу принтера на головному екрані. IP-адреса відображається у вигляді чотирьох наборів цифр, розділених крапками, наприклад 123.123.123.123. Доступ до EWS. Ви можете відкрити EWS? Проблему усунено. Переконайтеся, що ви встановили підтримуваний браузер: Internet Explorer версії 11 або новішої Microsoft Edge Internet Explorer версії 6 або новішої Google Chrome  версії 32 або новішої Mozilla Firefox версії 24 або новішої Доступ до EWS. Ви можете відкрити EWS? Проблему усунено. Перевірте, чи працює підключення до мережі. Якщо підключення не працює, зверніться до адміністратора. Доступ до EWS. Ви можете відкрити EWS? Проблему усунено. Переконайтеся, що кабельні підключення до принтера та сервера друку надійні. Щоб отримати додаткові відомості, перегляньте документацію, що надається разом із сервером друку. Доступ до EWS. Ви можете відкрити EWS? Проблему усунено. Перевірте, чи веб-проксі-сервери вимкнено. Якщо сервери не працюють, зверніться до адміністратора. Доступ до EWS. Ви можете відкрити EWS? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . не вдається відкрити Embedded Web Server усунення проблем не вдається відкрити Embedded Web Server"},{"UUID":"a4f9fa76-419f-4cce-b592-aa93cbc84e6f","title":"Проблеми підключення до мережі","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Не вдається підключити принтер до","descFull":"Не вдається підключити принтер до мережі Wi‑Fi Кроки для усунення проблеми Дія Так Ні Переконайтеся, що для параметра  Active Adapter  (Активний адаптер) установлено значення  Auto  (Автоматично). На головному екрані натисніть  Settings  (Параметри) Network/Ports  (Мережі/порти) Network Overview  (Огляд мережі) Active Adapter  (Активний адаптер) Auto  (Автоматично). Принтер може підключатися до мережі Wi‑Fi? Проблему усунено. Перевірте, чи вибрано правильну мережу Wi‑Fi. Деякі маршрутизатори можуть мати однаковий ідентифікатор SSID за замовчуванням. Ви підключаєтеся до правильної мережі Wi‑Fi? Перейдіть до кроку 4. Підключіться до правильної мережі Wi‑Fi. Щоб дізнатися більше, див.  . Принтер може підключатися до мережі Wi‑Fi? Проблему усунено. Перевірте режим бездротової безпеки. На головному екрані торкніться меню  Settings  (Параметри) Network/Ports  (Мережа/порти) Wireless  (Бездротовий зв’язок) Wireless Security Mode  (Режим бездротової безпеки). Вибрано правильний режим бездротової безпеки? Перейдіть до кроку 6. Виберіть правильний режим бездротової безпеки. Принтер може підключатися до мережі Wi‑Fi? Проблему усунено. Переконайтеся, що ви ввели правильний пароль мережі. Звертайте увагу на пробіли, цифри та капіталізацію в паролі. Принтер може підключатися до мережі Wi‑Fi? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . не вдається підключити принтер до мережі Wi‑Fi усунення проблем не вдається підключити принтер до мережі Wi‑Fi"},{"UUID":"37153326-3ee0-406a-a995-f4fe7110cfcf","title":"Проблеми параметрів апаратного забезпечення","link":"trb-cannot-detect-internal-option-topic.html","desc":"Не вдається виявити внутрішню опцію","descFull":"Не вдається виявити внутрішню опцію Кроки для усунення проблеми Дія Так Ні Вимкніть принтер, зачекайте 10 секунд, а тоді ввімкніть принтер. Чи виявляє принтер внутрішню опцію? Проблему усунено. Роздрукуйте сторінку налаштувань меню, а потім перевірте, чи внутрішня опція відображається в списку встановлених функцій. Чи вказана в списку внутрішня опція? Перейдіть до кроку 4. Перевірте, чи внутрішню опцію правильно встановлено на платі контролера. Вимкніть принтер, а тоді вийміть кабель живлення з розетки. Переконайтеся, що внутрішню опцію встановлено у відповідний роз’єм на платі контролера. Увімкніть кабель живлення в розетку, а тоді ввімкніть принтер. Щоб уникнути ризику пожежі чи електричного ураження, підключіть кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. Чи виявляє принтер внутрішню опцію? Проблему усунено. Перевірте, чи доступна внутрішня опція в драйвері принтера. Якщо потрібно, вручну додайте внутрішню опцію в драйвер принтера, щоб зробити її доступною для завдань друку. Щоб дізнатися більше, див.  . Надрукуйте документ. Чи виявляє принтер внутрішню опцію? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем, параметри друку не вдається виявити внутрішню опцію усунення проблем з опціями принтера не вдається виявити внутрішню опцію не вдається виявити внутрішню опцію"},{"UUID":"5277cd84-703e-43a6-a8ee-334961ed4aa8","title":"Проблеми параметрів апаратного забезпечення","link":"trb-cannot-detect-internal-option-topic.html","desc":"Виявлено несправний флешнакопичувач Спробуйте одну","descFull":"Виявлено несправний флешнакопичувач Спробуйте одну або декілька з наведених нижче дій. Замініть несправний інтелектуальний накопичувач. На головному екрані торкніться  Continue  (Продовжити), щоб проігнорувати повідомлення та продовжити друк. Скасуйте поточне завдання друку. Зверніться до свого  дилера . повідомлення принтера Виявлено несправний флешнакопичувач несправний інтелектуальний накопичувач"},{"UUID":"3c7aa4c6-f285-4fd0-bf2b-43b3b067030c","title":"Проблеми параметрів апаратного забезпечення","link":"trb-cannot-detect-internal-option-topic.html","desc":"Недостатньо вільного місця у флешпам'яті","descFull":"Недостатньо вільного місця у флешпам'яті для ресурсів Спробуйте одну або декілька з наведених нижче дій. Торкніться  Continue  (Продовжити), щоб очистити повідомлення та продовжити друк. Видаліть шрифти, макроси та інші дані, що зберігаються у флеш-пам’яті. Установіть жорсткий диск. Завантажені штифти й макроси, які не було попередньо збережено у флеш-пам’яті, буде видалено. Зверніться до свого  дилера . повідомлення принтера Недостатньо вільного місця у флешпам'яті для ресурсів Недостатньо вільного місця у флешпам'яті для ресурсів"},{"UUID":"9c6e4e13-6eff-4553-9b5b-a488aec52431","title":"Проблеми параметрів апаратного забезпечення","link":"trb-cannot-detect-internal-option-topic.html","desc":"Червоне світло на напівавтоматичному степлері","descFull":"Червоне світло на напівавтоматичному степлері Спробуйте одну або декілька з наведених нижче дій. Закрийте дверцята доступу до скоб. Видаліть незакріплені скоби. Після видалення незакріплених скоб необхідно виконати два цикли заправлення перед скріпленням. Вставте стос паперу в степлер тричі. Скріплення починається з третього вставлення. Замініть картридж зі скобами. червоний світловий індикатор на напівавтоматичному степлері напівавтоматичний степлер червоний світловий індикатор"},{"UUID":"5714ed43-03b1-44b9-887c-ab42ce6664cd","title":"Проблеми з витратними матеріалами","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Замініть картридж, невідповідність регіону принтера","descFull":"Замініть картридж, невідповідність регіону принтера Щоб вирішити цю проблему, придбайте картридж із відповідним регіоном, який відповідає регіону принтера, або придбайте міжнародний картридж. Перша цифра в повідомленні після 42 вказує на регіон принтера. Друга цифра в повідомленні після 42 вказує на регіон картриджа. Встановіть правильний картридж із тонером Регіони принтера та картриджа з тонером Регіон Цифровий код Всесвітній або невизначений регіон 0 Північна Америка (Сполучені Штати Америки, Канада), Австралія, Нова Зеландія 1 Європейська економічна зона, Ісландія, Ліхтенштейн і Норвегія 2 Азіатсько-Тихоокеанський регіон 3 Латинська Америка 4 Решта європейських країн, Середній захід, Африка 5 Недійсний регіон 9 Щоб знайти регіональні налаштування принтера та картриджа з тонером, надрукуйте сторінки перевірки якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). повідомлення принтера Замініть картридж, невідповідність регіону принтера Замініть картридж, невідповідність регіону принтера"},{"UUID":"9ac27144-6b6e-437e-aa76-537cb0bf3431","title":"Проблеми з витратними матеріалами","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Non‑Lexmark supply  (Не є","descFull":"Non‑Lexmark supply  (Не є витратним матеріалом Lexmark)  Non‑Dell supply  (Не є витратним матеріалом Dell)  Non‑Printer Manufacturer supply  (Не є витратним матеріалом виробника принтера) Принтер виявив, що встановлено витратний матеріал або деталь іншого виробника (не Lexmark). Принтер виявив, що встановлено витратний матеріал або деталь іншого виробника (не Dell). Принтер виявив, що встановлено нерозпізнаний витратний матеріал або деталь. Ваш принтер Lexmark створено для оптимальної роботи з оригінальними витратними матеріалами та деталями Lexmark. Використання сторонніх витратних матеріалів або деталей може вплинути на роботу, надійність чи термін служби принтера, а також на його компоненти відображення. Ваш принтер Dell створено для оптимальної роботи з оригінальними витратними матеріалами та деталями Dell. Використання сторонніх витратних матеріалів або деталей може вплинути на роботу, надійність чи термін служби принтера, а також на його компоненти відображення. Ваш принтер створено для оптимальної роботи з оригінальними витратними матеріалами та деталями, виготовленими виробником принтера. Використання сторонніх витратних матеріалів або деталей може вплинути на роботу, надійність чи термін служби принтера, а також на його компоненти відображення. Усі індикатори терміну служби призначені для роботи з витратними матеріалами та деталями Lexmark і можуть показувати неточні результати, якщо застосовуються сторонні витратні матеріали або деталі. Використання компонентів відображення понад їх очікуваний термін служби може пошкодити ваш принтер Lexmark чи пов’язані компоненти. Усі індикатори терміну служби призначені для роботи з витратними матеріалами та деталями Dell і можуть показувати неточні результати, якщо застосовуються сторонні витратні матеріали або деталі. Використання компонентів відображення понад їх очікуваний термін служби може пошкодити ваш принтер Dell чи пов’язані компоненти. Усі індикатори терміну служби призначені для роботи з витратними матеріалами та деталями виробника принтера й можуть показувати неточні результати, якщо застосовуються сторонні витратні матеріали або деталями. Використання компонентів відображення понад їх очікуваний термін служби може пошкодити ваш принтер чи пов’язані компоненти. Використання сторонніх витратних матеріалів або деталей може вплинути на покриття гарантією. Шкода, завдана використанням сторонніх витратних матеріалів чи деталей, може не покриватися гарантією. Щоб прийняти ці ризики та продовжити використовувати неоригінальні витратні матеріали чи деталі у своєму принтері, двома пальцями торкніться й утримуйте повідомлення про помилку на дисплеї протягом 15 секунд. Коли з’явиться діалогове вікно підтвердження, торкніться пункту  Continue  (Продовжити). Якщо ви не хочете приймати ці ризики, тоді вийміть сторонній витратний матеріал чи деталь із принтера й установіть оригінальний витратний матеріал чи деталь Lexmark. Щоб дізнатися більше, див.  . Якщо ви не хочете приймати ці ризики, тоді вийміть сторонній витратний матеріал чи деталь із принтера й установіть оригінальний витратний матеріал чи деталь Dell. Якщо ви не хочете приймати ці ризики, тоді вийміть сторонній витратний матеріал чи деталь із принтера й установіть оригінальний витратний матеріал чи деталь від виробника принтера. Якщо принтер не друкує після зникнення повідомлення про помилку, скиньте лічильник витратних матеріалів. На головному екрані торкніться  Settings  (Параметри) Device  (Пристрій) Maintenance  (Обслуговування) Configuration Menu  (Меню конфігурації) Supply Usage And Counters  (Використання витратних матеріалів і лічильники). Виберіть компонент чи витратний матеріал, кількість якого хочете скинути, і торкніться параметра  Start  (Розпочати). Прочитайте застереження, а тоді торкніться параметра  Continue  (Продовжити). Двома пальцями торкніться дисплея й утримуйте протягом 15 секунд, щоб очистити повідомлення. Якщо ви не можете скинути лічильники використання витратних матеріалів, поверніть витратний матеріал і місце продажу. повідомлення принтера Витратний матеріал стороннього виробника (не Lexmark) Витратний матеріал стороннього виробника (не Lexmark) повідомлення принтера Витратний матеріал стороннього виробника (не Dell) Витратний матеріал стороннього виробника (не Dell) повідомлення принтера Витратний матеріал виробника, що не виготовляє принтери Витратний матеріал виробника, що не виготовляє принтери скидання лічильники використання матеріалів лічильники використання матеріалів скидання скидання лічильників використання матеріалів"},{"UUID":"c9e61785-2f24-427e-a926-3a6454793a71","title":"Проблеми з подачею паперу","link":"trb-envelope-seals-when-printing-topic.html","desc":"Заклеювання конвертів під час друку","descFull":"Заклеювання конвертів під час друку Кроки для усунення проблеми Дія Так Ні Використовуйте конверт, який зберігався в сухому середовищі. Друк на конвертах із високим вмістом вологи може заклеїти клапани. Надішліть завдання друку. Заклеювання конвертів сталося під час друку? Проблему усунено. Переконайтеся, що тип паперу встановлено на «Конверт». На головному екрані торкніться  Settings  (Параметри) Paper  (Папір) Tray Configuration  (Конфігурація лотка) Paper Size/Type  (Розмір/тип паперу). Надішліть завдання друку. Заклеювання конвертів сталося під час друку? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. усунення проблем, друк заклеювання конвертів під час друку усунення проблем із друком заклеювання конвертів під час друку заклеювання конвертів під час друку"},{"UUID":"9eecbeb7-128c-439e-8028-2fd2769fed0e","title":"Проблеми з подачею паперу","link":"trb-envelope-seals-when-printing-topic.html","desc":"Друк із pозбиранням за копіями","descFull":"Друк із pозбиранням за копіями не працює Кроки для усунення проблеми Дія Так Ні На головному екрані торкніться  Settings  (Параметри) Print  (Друк) Layout  (Макет) Collate  (Розбирання за копіями). Торкніться  On [1,2,1,2,1,2]  (Увімк. [1,2,1,2,1,2]). Надрукуйте документ. Чи правильно документ розібрано за копіями? Проблему усунено. У документі, який ви намагаєтеся надрукувати, відкрийте діалогове вікно Print (Друк), а потім натисніть  Collate . (Розбирання за копіями). Надрукуйте документ. Чи правильно документ розібрано за копіями? Проблему усунено. Зменште кількість сторінок для друку. Надрукуйте документ. Чи правильно сторінки розібрано за копіями? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем із друком друк із pозбиранням за копіями не працює усунення проблем, друк друк із pозбиранням за копіями не працює друк із pозбиранням за копіями не працює"},{"UUID":"ff5b9faf-de57-4932-969f-8df0c78b8724","title":"Проблеми з подачею паперу","link":"trb-envelope-seals-when-printing-topic.html","desc":"Пов’язування лотка не працює Кроки","descFull":"Пов’язування лотка не працює Кроки для усунення проблеми Дія Так Ні Перевірте, чи лоток містить папір того самого розміру й типу. Перевірте, чи механізм спрямування паперу розташовано правильно. Надрукуйте документ. Лотки пов’язані правильно? Проблему усунено. На головному екрані торкніться  Settings  (Параметри) Paper  (Папір) Tray Configuration  (Конфігурація лотка) Paper Size/Type  (Розмір/тип паперу). Налаштуйте розмір і тип паперу так, щоб вони збігалися з папером, завантаженим у пов’язані лотки. Надрукуйте документ. Лотки пов’язані правильно? Проблему усунено. Переконайтеся, що для параметра  Tray Linking  (Пов’язування лотка) установлено значення  Automatic  (Автоматично). Щоб дізнатися більше, див.  . Надрукуйте документ. Лотки пов’язані правильно? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем, друк пов’язування лотка не працює усунення проблем із друком пов’язування лотка не працює"},{"UUID":"087b5fd8-518c-4606-a1db-596bfc688ac5","title":"Проблеми з подачею паперу","link":"trb-envelope-seals-when-printing-topic.html","desc":"Часте зминання паперу Кроки для","descFull":"Часте зминання паперу Кроки для усунення проблеми Дія Так Ні Зніміть лоток. Перевірте, чи правильно завантажено папір. Переконайтеся, що напрямні паперу розташовані правильно. Переконайтеся, що висота стосу нижча за індикатор максимального заповнення папером. Друкуйте на папері рекомендованого розміру та типу. Вставте лоток. Надрукуйте документ. Зминання паперу трапляється часто? Проблему усунено. На головному екрані торкніться  Settings  (Параметри) Paper  (Папір) Tray Configuration  (Конфігурація лотка) Paper Size/Type  (Розмір/тип паперу). Встановіть папір правильного розміру та типу. Надрукуйте документ. Зминання паперу трапляється часто? Проблему усунено. Завантажте папір із нової пачки. Папір поглинає вологу через високу вологість. Зберігайте папір в оригінальному пакуванні, доки не будете готові його використовувати. Надрукуйте документ. Зминання паперу трапляється часто? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. усунення проблем, друк часте зминання паперу усунення проблем із друком часте зминання паперу часте зминання паперу"},{"UUID":"97425087-872f-4d0e-895a-f31006e7b0b3","title":"Проблеми з подачею паперу","link":"trb-envelope-seals-when-printing-topic.html","desc":"Зам’яті сторінки на друкуються повторно","descFull":"Зам’яті сторінки на друкуються повторно Крок для усунення проблеми Дія Так Ні На головному екрані торкніться  Settings  (Параметри) Device  (Пристрій) Notifications  (Сповіщення) Jam Content Recovery  (Відновлення зім’ятого вмісту). У меню Jam Recovery (Відновлення після зминання) торкніться  On  (Увімк.) або  Auto  (Автоматично). Надрукуйте документ. Чи передруковуються зім’яті сторінки? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем, друк зам’яті сторінки на друкуються повторно зам’яті сторінки на друкуються повторно"},{"UUID":"aa4ec653-6896-44ee-88d6-c5b8f2615532","title":"Проблеми з електронною поштою","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Вимкнення повідомлення про помилку «Сервер","descFull":"Вимкнення повідомлення про помилку «Сервер SMTP не налаштовано» На головному екрані торкніться меню  Settings E‑mail E‑mail Setup Disable “SMTP Server not set up” error On . Щоб запобігти повторній появі повідомлення про помилку, виконайте одну з дій нижче. Оновіть мікропрограму принтера. Щоб дізнатися більше, див.  . Налаштуйте параметри електронної пошти SMTP. Щоб дізнатися більше, див.  . помилка «Сервер SMTP не налаштовано» вимкнення усунення проблем помилка «Сервер SMTP не налаштовано» усунення помилки «Сервер SMTP не налаштовано»"},{"UUID":"6a0318aa-6e8e-4056-b26e-e79600d500b1","title":"Проблеми з електронною поштою","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Не вдається надсилати електронні листи","descFull":"Не вдається надсилати електронні листи Кроки для усунення проблеми Дія Так Ні Переконайтеся, що параметри електронної пошти SMTP налаштовано правильно. Щоб дізнатися більше, див.  . Ви можете надіслати електронний лист? Проблему усунено. Переконайтеся, що ви ввели правильний пароль. Залежно від вашого постачальника послуги електронної пошти, використовуйте пароль облікового запису, пароль додатка чи пароль для автентифікації. Щоб дізнатися більше, див.  . Ви можете надіслати електронний лист? Проблему усунено. Переконайтеся, що принтер підключено до мережі, а мережа під’єднана до інтернету. Ви можете надіслати електронний лист? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем електронної пошти не вдається надсилати електронні листи вирішення проблем, електронна пошта не вдається надсилати електронні листи не вдається надсилати електронні листи"},{"UUID":"9a44bc55-2de3-4eb7-8f31-a251ef46f1f1","title":"Проблеми з надсиланням факсу","link":"trb-caller-id-not-shown-topic.html","desc":"Ідентифікатор абонента не відображається Ці","descFull":"Ідентифікатор абонента не відображається Ці вказівки застосовуються лише до принтерів, що підтримують аналоговий факс. Додаткову інформацію див. у розділі  Налаштування передавання факсів на принтері . Кроки для усунення проблеми Дія Так Ні Увімкніть ідентифікатора абонента. На головному екрані торкніться  Settings  (Параметри) Fax  (Факс) Fax Setup  (Налаштування факсу) Fax Receive Settings  (Параметри отримання факсів) Admin Controls  (Елементи керування адміністратора) Enable Caller ID  (Увімкнути ідентифікатор абонента). Ідентифікатор абонента відображається? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем, факс ідентифікатор абонента не відображається усунення проблем із факсом ідентифікатор абонента не відображається ідентифікатор абонента не відображається"},{"UUID":"b41031bb-b400-4b86-b655-e340c96a3c90","title":"Проблеми з надсиланням факсу","link":"trb-caller-id-not-shown-topic.html","desc":"Не вдається надсилати або отримувати","descFull":"Не вдається надсилати або отримувати факси за допомогою аналогового факсу Кроки для усунення проблеми Дія Так Ні Усуньте повідомлення про помилку, які відображаються на дисплеї. Ви можете надіслати або отримати факс? Проблему усунено. Переконайтеся, що для наведеного нижче обладнання надійно закріплено кабелі. Телефон Навушники Автовідповідач Ви можете надіслати або отримати факс? Проблему усунено. Перевірте наявність звуку гудка. Зателефонуйте на номер факсу, щоб перевірити, чи він працює належним чином. Якщо ви використовуєте функцію «Набір без зняття слухавки», збільште гучність, щоб перевірити, чи чутно звук гудка. Ви чуєте звук гудка? Перейдіть до кроку 5. Перевірте телефонний роз’єм. Підключіть аналоговий телефон безпосередньо в телефонний роз’єм. Перевірте наявність звуку гудка. Якщо ви не чуєте звук гудка, скористайтесь іншим телефоном. Якщо ви все одно не чуєте звук гудка, підключіть аналоговий телефон до іншого телефонного роз’єму. Якщо ви чуєте звук гудка, підключіть принтер до цього телефонного роз’єму. Ви можете надіслати або отримати факс? Проблему усунено. Перевірте, чи принтер підключено до аналогової телефонної служби чи до правильного цифрового з’єднувача. Якщо ви використовуєте телефонну службу «Інтегровані служби для цифрової мережі» (ISDN), під’єднайтеся до порту аналогового телефону адаптера терміналу ISDN. Щоб дізнатися більше, зверніться до постачальника послуг ISDN. Якщо ви використовуєте DSL, підключіться до фільтра чи маршрутизатора DSL, який підтримує аналоговий зв’язок. Щоб дізнатися більше, зверніться до постачальника послуг DSL. Якщо ви використовуєте приватну телефонну станцію (ПТС), тоді переконайтеся, що підключаєтеся до аналогового з’єднання ПТС, Якщо такої немає, установіть аналогову телефонну лінію для факсу. Ви можете надіслати або отримати факс? Проблему усунено. Тимчасово від’єднайте інше обладнання й вимкніть інші телефонні служби. Від’єднайте інше обладнання (як-от автовідповідачі, комп’ютери, модеми чи розділювачі телефонних ліній) між принтером і телефонною лінією. Вимкніть очікування дзвінка та голосову пошту. Щоб дізнатися більше, зверніться до своєї телефонної компанії. Ви можете надіслати або отримати факс? Проблему усунено. Скануйте оригінальний документ по одній сторінці за раз. Наберіть номер факсу. Відскануйте документ. Ви можете надіслати або отримати факс? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем із факсом не вдається надсилати або отримувати факси за допомогою аналогового факсу усунення проблем, факс не вдається надсилати або отримувати факси за допомогою аналогового факсу не вдається надсилати або отримувати факси за допомогою аналогового факсу"},{"UUID":"12785edf-357e-4779-b590-1fe2ffa8db6a","title":"Проблеми з надсиланням факсу","link":"trb-caller-id-not-shown-topic.html","desc":"Ви можете отримувати, але не","descFull":"Ви можете отримувати, але не надсилати факс за допомогою аналогового факсу? Кроки для усунення проблеми Дія Так Ні Правильно вставте оригінальний документ у лоток АПД або на скло сканера. Ви можете надсилати факс? Проблему усунено. Правильно налаштуйте ярлик номера. Перевірте, чи ярлик номера встановлено для номера телефона, який потрібно набрати. Наберіть номер телефону вручну. Ви можете надсилати факс? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем із факсом не вдається надсилати факси за допомогою аналогового факсу усунення проблем, факс не вдається надсилати факси за допомогою аналогового факсу"},{"UUID":"d55f3dd9-654f-4465-af25-a4aa04195de8","title":"Проблеми з надсиланням факсу","link":"trb-caller-id-not-shown-topic.html","desc":"Можна надсилати, але не отримувати","descFull":"Можна надсилати, але не отримувати факси за допомогою аналогового факсу Кроки для усунення проблеми Дія Так Ні Переконайтеся, що джерело паперу не порожнє. Ви можете отримувати факс? Проблему усунено. Перевірте параметри затримки підрахунку дзвінків. На головному екрані торкніться  Settings  (Параметри) Fax  (Факс) Fax Setup  (Налаштування факсу) Fax Receive Settings  (Параметри отримання факсів) Rings to Answer  (Дзвінки для відповіді). Ви можете отримувати факс? Проблему усунено. Якщо принтер друкує пусті сторінки, див.  . Ви можете отримувати факс? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем із факсом можна надсилати, але не отримувати факси за допомогою аналогового факсу усунення проблем, факс можна надсилати, але не отримувати факси за допомогою аналогового факсу не вдається отримувати факси за допомогою аналогового факсу"},{"UUID":"bf186bef-abd4-4dd5-b6d9-08f68a8b32dd","title":"Проблеми з надсиланням факсу","link":"trb-caller-id-not-shown-topic.html","desc":"Не вдається налаштувати etherFAX Кроки","descFull":"Не вдається налаштувати etherFAX Кроки для усунення проблеми Дія Так Ні Перевірте підключення принтера. Надрукуйте  Network Setup Page . На головному екрані торкніться меню  Settings Reports Network Network Setup Page . Перевірте статус мережі. Чи підключено принтер до мережі? Перейдіть до кроку 3. Переконайтеся, що принтер підключено до мережі, а мережа під’єднана до інтернету. Ви можете налаштувати etherFAX? Проблему усунено. Переконайтеся, що etherFAX Налаштовано правильно. Щоб дізнатися більше, див.  . Ви можете налаштувати etherFAX? Проблему усунено. Перейдіть на сторінку  https://www.etherfax.net/lexmark . усунення проблем із факсом не вдається налаштувати etherFAX усунення проблем, факс не вдається налаштувати etherFAX"},{"UUID":"902dfde3-9ec2-4555-bf8b-924e729cdcba","title":"Проблеми з надсиланням факсу","link":"trb-caller-id-not-shown-topic.html","desc":"Не вдається надіслати або отримати","descFull":"Не вдається надіслати або отримати факс за допомогою etherFAX Кроки для усунення проблеми Дія Так Ні Переконайтеся, що принтер підключено до мережі, а мережа під’єднана до інтернету. Ви можете надіслати або отримати факс за допомогою etherFAX? Проблему усунено. Переконайтеся, що etherFAX Налаштовано правильно. На головному екрані торкніться меню  Settings Fax Fax Setup General Fax Settings . Переконайтеся, що ви вказали правильний номер факсу. Переконайтеся, що для параметра  Fax Transport  налаштовано значення  etherFAX . Це меню відображається, лише коли доступно кілька передавань факсу. Якщо на принтері встановлено лише etherFAX, тоді його налаштовано автоматично. Ви можете надіслати або отримати факс за допомогою etherFAX? Проблему усунено. Розділіть великі документи на менші за розміром файли. Ви можете надіслати або отримати факс за допомогою etherFAX? Проблему усунено. Перейдіть на сторінку  https://www.etherfax.net/lexmark . усунення проблем із факсом не вдається надіслати або отримати факс за допомогою etherFAX усунення проблем, факс не вдається надіслати або отримати факс за допомогою etherFAX не вдається надіслати або отримати факс за допомогою etherFAX"},{"UUID":"1fdc0c8a-0901-4490-9331-752d76e7e593","title":"Проблеми з надсиланням факсу","link":"trb-caller-id-not-shown-topic.html","desc":"Низька якість друку факсу Кроки","descFull":"Низька якість друку факсу Кроки для усунення проблеми Дія Так Ні Переконайтеся, що немає дефектів якості друку. На головному екрані торкніться  Settings  (Параметри) Troubleshooting  (Усунення несправностей) Print Quality Test Pages  (Тестові сторінки якості друку). Виправте будь-які дефекти якості друку. Щоб дізнатися більше, див.  . Чи задовільна якість друку факсу? Проблему усунено. Якщо ви використовуєте аналоговий факс, зменште швидкість передачі вхідного факсу. На головному екрані торкніться  Settings  (Параметри) Fax  (Факс) Fax Setup  (Налаштування факсу) Fax Receive Settings  (Параметри отримання факсів) Admin Controls  (Елементи керування адміністратора). У меню Max Speed (Макс. швидкість) виберіть нижчу швидкість передачі. Чи задовільна якість друку факсу? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем із факсом низька якість друку низька якість друку факсу усунення проблем, факс низька якість друку"},{"UUID":"cec72031-1195-40bc-be7e-21794e008125","title":"Проблеми з надсиланням факсу","link":"trb-caller-id-not-shown-topic.html","desc":"Немає інформації на сторінці обкладинки","descFull":"Немає інформації на сторінці обкладинки факсу Кроки для усунення проблеми Дія Ні Так Вимкніть принтер, зачекайте 10 секунд, а тоді ввімкніть принтер. Надішліть або отримайте факс. Немає інформації на сторінці обкладинки факсу? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем із факсом немає інформації на сторінці обкладинки факсу усунення проблем, факс немає інформації на сторінці обкладинки факсу немає інформації на сторінці обкладинки факсу"},{"UUID":"561a5539-bbcc-42f7-9ab5-f32ef271167a","title":"Проблеми з надсиланням факсу","link":"trb-caller-id-not-shown-topic.html","desc":"Не вдається надіслати сторінку обкладинки","descFull":"Не вдається надіслати сторінку обкладинки факсу з комп’ютера Кроки для усунення проблеми Дія Так Ні Переконайтеся, що драйвер принтера оновлено. Щоб дізнатися більше, див.  . Надішліть факс. Ви можете надіслати сторінку обкладинки факсу? Проблему усунено. У документі, який ви намагаєтеся надіслати факсом, відкрийте діалогове вікно  Print  (Друк). Виберіть принтер і натисніть  Properties  (Властивості),  Preferences  (Параметри),  Options  (Опції) або  Setup  (Налаштування). Натисніть  Fax  (Факс) і очистьте параметр  Always display settings prior to faxing  (Завжди відображати налаштування перед надсиланням факсу). Надішліть факс. Ви можете надіслати сторінку обкладинки факсу? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем із факсом не вдається надіслати сторінку обкладинки факсу з комп’ютера усунення проблем, факс не вдається надіслати сторінку обкладинки факсу з комп’ютера не вдається надіслати сторінку обкладинки факсу з комп’ютера"},{"UUID":"bfe3b456-c3bd-4216-9309-241c50151088","title":"Проблеми сканування","link":"trb-cannot-scan-to-computer-topic.html","desc":"Не вдається сканувати на комп’ютер","descFull":"Не вдається сканувати на комп’ютер Кроки для усунення проблеми Дія Так Ні Виконайте копіювання. Копіювання успішне? Перейдіть до кроку 3. Вимкніть принтер, зачекайте приблизно 10 секунд, а потім увімкніть його знову. Відскануйте документ. Чи можна сканувати документ на комп’ютері? Проблему усунено. Перевірте підключення принтера. Друк  Network Setup Page  (Сторінки налаштування мережі). На головній сторінці торкніться  Settings  (Параметри) Reports  (Звіти) Network  (Мережа) Network Setup Page  (Сторінка налаштування мережі). Перевірте стан мережі. Чи підключено принтер до мережі? Перейдіть до кроку 5. Підключіть принтер до мережі. Відскануйте документ. Чи можна сканувати документ на комп’ютері? Проблему усунено. Переконайтеся, що принтер і комп’ютер підключено до однієї мережі. Відскануйте документ. Чи можна сканувати документ на комп’ютері? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . усунення проблем зі скануванням не вдається сканувати на комп’ютер усунення проблем, сканування не вдається сканувати на комп’ютер не вдається сканувати на комп’ютер"},{"UUID":"446258e3-c96b-436d-9e12-08f300d22f87","title":"Проблеми сканування","link":"trb-cannot-scan-to-computer-topic.html","desc":"Неможливо сканувати в мережеву папку","descFull":"Неможливо сканувати в мережеву папку Кроки для усунення проблеми Дія Так Ні Створіть ярлик мережевої папки. Відскануйте документ за допомогою ярлика. Щоб дізнатися більше, див.  . Ви можете відсканувати документ і зберегти його в мережеву папку? Проблему усунено. Переконайтеся, що шлях до мережевої папки та формат правильні. Наприклад,  // server_hostname /foldername/path , where  server_hostname  — повністю кваліфікований домен (FQDN) чи IP-адреса. Шлях до мережевої папки та формат правильні? Перейдіть до кроку 4. Переконайтеся, що ви маєте дозвіл на записування в мережеву папку. Ви можете відсканувати документ і зберегти його в мережеву папку? Проблему усунено. Оновіть ярлик мережевої папки. Відкрийте вебпереглядач і введіть IP-адресу принтера в адресному рядку. Перегляньте IP-адресу принтера на головному екрані. IP-адреса відображається у вигляді чотирьох наборів цифр, розділених крапками, наприклад 123.123.123.123. Якщо ви використовуєте проксі-сервер, тимчасово вимкніть його, щоб вебсторінка завантажилася правильно. Натисніть  Shortcuts  (Ярлики), а тоді виберіть ярлик. Якщо у вас є кілька типів ярликів, виберіть  Network Folder  (Мережева папка). У полі  Share Path  (Шлях до спільної папки) введіть шлях до мережевої папки. Якщо ваша спільна папка —  \\\\server_hostname\\foldername\\path , введіть  //server_hostname/foldername/path . Переконайтеся, що ви використовуєте косі риски під час друку спільного шляху. У меню  Authentication  (Автентифікація) виберіть спосіб автентифікації. Якщо для параметра  Authentication  (Автентифікація) встановлено значення  Use assigned username and password  (Використовувати призначені ім’я користувача та пароль), тоді в полях  User Name  (Ім’я користувача) та  Password  (Пароль) введіть свої облікові дані. Натисніть  Save  (Зберегти). Ви можете відсканувати документ і зберегти його в мережеву папку? Проблему усунено. Переконайтеся, що принтер і мережева папка підключені до однієї мережі. Ви можете відсканувати документ і зберегти його в мережеву папку? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . неможливо сканувати в мережеву папку усунення проблем, сканування неможливо сканувати в мережеву папку усунення проблем зі скануванням неможливо сканувати в мережеву папку"},{"UUID":"f04b8454-33aa-4c94-9011-badf23b8e488","title":"Проблеми сканування","link":"trb-cannot-scan-to-computer-topic.html","desc":"Часткові копії документа чи фотографії","descFull":"Часткові копії документа чи фотографії Кроки для усунення проблеми Дія Так Ні Переконайтеся, що документ чи фотографію завантажено зображенням униз у верхньому лівому куті скла сканера. Зробіть копію документа чи фотографії. Документ або фотографія скопіювалися правильно? Проблему усунено. Налаштований розмір паперу має відповідати фактичному розміру паперу, завантаженого в лоток. Зробіть копію документа чи фотографії. Документ або фотографія скопіювалися правильно? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . проблема з якістю копії часткові копії документів проблема з якістю копії часткові копії фотографій проблема з якістю сканування часткові копії документів проблема з якістю сканування часткові копії фотографій часткові копії документів часткові копії фотографій"},{"UUID":"cf965a92-72db-4eba-b4fb-d9dbca2bfee9","title":"Проблеми сканування","link":"trb-cannot-scan-to-computer-topic.html","desc":"Погана якість копіювання Кроки для","descFull":"Погана якість копіювання Кроки для усунення проблеми Дія Так Ні Витріть скло сканера та скло АПД вологою, м’якою, безворсовою тканиною. Якщо принтер має друге скло АПД усередині АПД, протріть і його. Щоб дізнатися більше, див.  . Переконайтеся, що документ чи фотографію завантажено зображенням униз у верхньому лівому куті скла сканера. Зробіть копію документа чи фотографії. Якість копіювання задовільна? Проблему усунено. Перевірте якість оригінального документа чи фотографії. Відкоригуйте параметри якості сканування. Зробіть копію документа чи фотографії. Якість копіювання задовільна? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . проблема з якістю копії погана якість копіювання проблема з якістю сканування погана якість копіювання погана якість копіювання"},{"UUID":"4083a04b-0bf2-44a2-b240-b4113ac4fe34","title":"Проблеми сканування","link":"trb-cannot-scan-to-computer-topic.html","desc":"Вертикальні темні смуги на виході","descFull":"Вертикальні темні смуги на виході під час сканування з АПД Вертикальні темні смуги на виході під час сканування з АПД Кроки для усунення проблеми Дія Так Ні Відкрийте кришку сканера. Протріть скло та скляний блок АПД вологою, м’якою, безворсовою тканиною. Закрийте кришку сканера. Відскануйте документ. На відсканованих документах з’являються вертикальні смуги? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю сканування вертикальні темні смуги проблема з якістю копії вертикальні темні смуги вертикальні темні смуги під час сканування з пристрою АПД сканування з пристрою АПД вертикальні темні смуги"},{"UUID":"d0c6da67-140b-4cff-a70a-367245007889","title":"Проблеми сканування","link":"trb-cannot-scan-to-computer-topic.html","desc":"Зображення чи текст із нерівними","descFull":"Зображення чи текст із нерівними краями під час сканування з пристрою АПД Кроки для усунення проблеми Дія Так Ні Завантажте 50 аркушів чистого звичайного паперу в пристрій АПД. Звичайний папір допомагає очистити або видалити пил та інше покриття з роликів подачі пристрою АПД. На головному екрані торкніться  . Завантажте оригінальний документ у пристрій АПД. Відскануйте документ. Чи з’являються на виході зображення або текст із нерівними краями? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема з якістю сканування зображення з нерівними краями проблема з якістю сканування текст із нерівними краями зображення з нерівними краями сканування з пристрою АПД текст із нерівними краями сканування з пристрою АПД"},{"UUID":"635e4ebd-09e7-4075-b3fe-227de56cfac0","title":"Проблеми сканування","link":"trb-cannot-scan-to-computer-topic.html","desc":"Завдання сканування неуспішне Кроки для","descFull":"Завдання сканування неуспішне Кроки для усунення проблеми Дія Так Ні Перевірте, чи підключено кабелі. Переконайтеся, що кабель Ethernet або USB надійно підключено до комп’ютера та принтера. Відскануйте документ. Завдання сканування успішне? Проблему усунено. Перевірте файл, який потрібно зісканувати. Переконайтеся, що назва файлу ще не використовується в цільовій папці. Переконайтеся, що документ або фотографію, які потрібно зісканувати, не відкрито в іншій програмі. Відскануйте документ. Завдання сканування успішне? Проблему усунено. Переконайтеся, що в параметрах конфігурації адресату біля опції Append time stamp (Додати позначку часу) або Overwrite existing file (Перезаписати наявний файл) установлено прапорець. Відскануйте документ. Завдання сканування успішне? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . завдання сканування неуспішне проблема зі скануванням завдання сканування неуспішне"},{"UUID":"21b3a1a2-0054-4ab6-9b3b-e0d0d0fd8eb6","title":"Проблеми сканування","link":"trb-cannot-scan-to-computer-topic.html","desc":"Сканер не закривається Крок для","descFull":"Сканер не закривається Крок для усунення проблеми Дія Так Ні Видаліть перешкоди, через які кришка сканера залишається відкритою. Кришка сканера закрилася належним чином? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . проблема з копіюванням сканер не закривається проблема зі скануванням сканер не закривається сканер не закривається"},{"UUID":"f8d855f1-d00b-4edf-8234-1f44c05803f0","title":"Проблеми сканування","link":"trb-cannot-scan-to-computer-topic.html","desc":"Сканування триває задовго або комп’ютер","descFull":"Сканування триває задовго або комп’ютер зависає Кроки для усунення проблеми Дія Так Ні Закрийте всі програми, які заважають скануванню. Сканування триває задовго або комп’ютер зависає? Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . Проблему усунено. проблема зі скануванням сканування триває задовго проблема зі скануванням під час сканування комп’ютер зависає"},{"UUID":"71506fe9-591b-4524-9860-3f5e04d9901e","title":"Проблеми сканування","link":"trb-cannot-scan-to-computer-topic.html","desc":"Сканер не відповідає Кроки для","descFull":"Сканер не відповідає Кроки для усунення проблеми Дія Так Ні Перевірте, чи кабель живлення належно підключено до принтера й електричної розетки. Щоб уникнути ризику пожежі чи ураження електричним струмом, під’єднайте кабель живлення до належно заземленої розетки з відповідним номіналом, що розташована й доступна поблизу виробу. Скопіюйте або відскануйте документ. Сканер відповідає? Проблему усунено. Перевірте, чи принтер увімкнено. Усуньте повідомлення про помилку, які відображаються на дисплеї. Скопіюйте або відскануйте документ. Сканер відповідає? Проблему усунено. Вимкніть принтер, зачекайте 10 секунд, а тоді знову ввімкніть принтер. Скопіюйте або відскануйте документ. Сканер відповідає? Проблему усунено. Зверніться в  службу підтримки клієнтів . Зверніться в  службу технічної підтримки . Зверніться до свого  дилера . проблема з копіюванням сканер не відповідає проблема зі скануванням сканер не відповідає сканер не відповідає"},{"UUID":"d24409a7-9a64-4e78-87f1-f9aaf1ab7339","title":"Проблеми сканування","link":"trb-cannot-scan-to-computer-topic.html","desc":"Коригування реєстрації сканера На головному","descFull":"Коригування реєстрації сканера На головному екрані торкніться меню  Settings Device Maintenance Configuration Menu Scanner Configuration Scanner Manual Registration . У меню «Швидкий тест друку» торкніться пункту  Start . Розмістіть сторінку «Швидкий тест друку» на склі сканера, а тоді торкніться параметра  Flatbed Registration . У меню «Швидкий тест копіювання» торкніться пункту  Start . Порівняйте сторінку «Швидкий тест копіювання» з оригінальним документом. Якщо поля тестової сторінки відрізняються від оригінального документа, відкоригуйте ліве та верхнє поля. Повторіть   і  , доки поля сторінки «Швидкий тест копіювання» не збігатиметься з оригінальним документом. коригування реєстрація сканера"},{"UUID":"2b653b04-2e00-46ba-8765-82f7c4c90356","title":"Проблеми сканування","link":"trb-cannot-scan-to-computer-topic.html","desc":"Коригування реєстрації АПД На головному","descFull":"Коригування реєстрації АПД На головному екрані торкніться меню  Settings Device Maintenance Configuration Menu Scanner Configuration Scanner Manual Registration . У меню «Швидкий тест друку» торкніться пункту  Start . Розмістіть сторінку «Швидкий тест друку» на лотку АПД. Торкніться пункту  Front ADF Registration  або  Rear ADF Registration . Щоб вирівняти реєстрацію переднього АПД, розмістіть тестову сторінку лицевою стороною догори та коротким краєм уперед в АПД. Щоб вирівняти реєстрацію заднього АПД, розмістіть тестову сторінку лицевою стороною донизу та коротким краєм уперед в АПД. У меню «Швидкий тест копіювання» торкніться пункту  Start . Порівняйте сторінку «Швидкий тест копіювання» з оригінальним документом. Якщо поля тестової сторінки відрізняються від оригінального документа, відкоригуйте горизонтальне положення та верхнє поле. Повторіть   і  , доки поля сторінки «Швидкий тест копіювання» не збігатиметься з оригінальним документом. реєстрація АПД коригування коригування реєстрації АПД"},{"UUID":"1559af96-444a-413f-b456-5f5045a1a121","title":"Усунення несправностей","link":"trb-contacting-customer-support-topic.html","desc":"Зверніться до служби підтримки клієнтів","descFull":"Зверніться до служби підтримки клієнтів Перш ніж звертатися до служби підтримки клієнтів, переконайтеся, що маєте таку інформацію. Проблема з принтером Повідомлення про помилку Тип моделі принтера та серійний номер Перейдіть на сторінку  http://support.lexmark.com , щоб отримати підтримку електронною поштою чи в чаті, або перегляньте бібліотеку посібників, допоміжної документації, драйверів та інших завантажень. Також доступна технічна підтримка по телефону. У США чи Канаді телефонуйте за номером 1-800-539-6275. Для інших країн або регіонів перейдіть до  каталогу контактів міжнародної служби підтримки . Відвідайте місце, де ви придбали свій принтер. звернення до служби підтримки клієнтів служба підтримки клієнтів звернення"},{"UUID":"ec6df19f-835a-447e-914b-e0aedcf62003","title":"Усунення несправностей","link":"troubleshooting-chapter.html","desc":"Звернення в службу технічної підтримки","descFull":"Звернення в службу технічної підтримки Телефонуючи в службу технічної підтримки, опишіть проблему, повідомлення на дисплеї принтера, а також дії для усунення несправності, які ви вже виконали. Подивіться на етикетку всередині верхньої передньої кришки або на задній панелі принтера, а тоді зверніть увагу на такі дані: модель принтера; номер етикетки обслуговування чи код експрес-обслуговування. Щоб дізнатися більше, перейдіть на сторінку  www.dell.com/support . усунення проблем звернення в службу технічної підтримки звернення в службу технічної підтримки"},{"UUID":"b934c669-653d-4dc0-9515-6fbeefe76877","title":"Усунення несправностей","link":"troubleshooting-chapter.html","desc":"Звернення до свого дилера Перш","descFull":"Звернення до свого дилера Перш ніж звертатися до дилера, переконайтеся, що маєте наведену нижче інформацію. Проблема з принтером Повідомлення про помилку Тип моделі принтера та серійний номер звернення до свого дилера дилер принтера"},{"UUID":"1b9391ba-c75c-4ab6-9eb6-f7f5c1a00b87","title":"Переробка й утилізація","link":"recycling-lexmark-products-topic.html","desc":"Переробка виробів Lexmark Щоб повернути","descFull":"Переробка виробів Lexmark Щоб повернути вироби Lexmark для переробки: Перейдіть на сторінку  www.lexmark.com/recycle . Виберіть країну або регіон. Виберіть програму переробки. Дотримуйтеся вказівок на екрані. переробка виробів Lexmark"},{"UUID":"9384883d-19b6-4ee0-a48a-f8226a675431","title":"Переробка й утилізація","link":"recycling-lexmark-packaging-topic.html","desc":"Переробка пакування Lexmark Lexmark постійно","descFull":"Переробка пакування Lexmark Lexmark постійно намагається звести до мінімуму пакування. Менша кількість пакування дозволяє гарантувати, що принтери Lexmark транспортуються максимально ефективно й екологічно, і потрібно викидати менше пакування. Наслідком цього є менша кількість парникових газів, заощадження енергії та природних ресурсів. У деяких країнах і регіонах Lexmark також пропонує переробку компонентів пакування. Щоб дізнатися більше, перейдіть на сторінку  www.lexmark.com/recycle  і виберіть свою країну чи регіон. Інформація про доступні програми переробки пакування міститься у відомостях про переробку виробу. Коробки Lexmark на 100% підлягають переробці в місцях, де є заводи з переробки гофрованого картону. У вашому регіоні може не бути таких заводів. Піна, яка використовується в пакуванні Lexmark, підлягає переробці в місцях, де є заводи з переробки піни. У вашому регіоні може не бути таких заводів. Коли ви повертаєте картридж у Lexmark, ви можете повторно використати коробку, у якому постачався картридж. Lexmark переробляє коробки. переробка пакування Lexmark"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"БФП MX532, MX632, XM3350"}},[_vm._v("\n    БФП MX532, MX632, XM3350\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_uk","title":"Інформація про безпеку"}},[_vm._v("\n    Інформація про безпеку\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e23","title":"Умовні позначення"}},[_vm._v("\n     Умовні позначення\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e40","title":"Заяви щодо виробу"}},[_vm._v("\n     Заяви щодо виробу\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_uk","title":"Докладніше про принтер"}},[_vm._v("\n    Докладніше про принтер\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e175"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_uk","title":"Пошук інформації про принтер"}},[_vm._v("\n     Пошук інформації про принтер\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_uk","title":"Пошук серійного номера принтера"}},[_vm._v("\n     Пошук серійного номера принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_uk","title":"Налаштування принтера"}},[_vm._v("\n     Налаштування принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_uk","title":"Використання панелі керування"}},[_vm._v("\n     Використання панелі керування\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_uk","title":"Розуміння статусу світлового індикатора"}},[_vm._v("\n     Розуміння статусу світлового індикатора\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-paper-group.html#d0e500","title":"Вибір паперу"}},[_vm._v("\n     Вибір паперу\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_uk","title":"Налаштування, установлення та конфігурування"}},[_vm._v("\n    Налаштування, установлення та конфігурування\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1569"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_uk","title":"Вибір місця розташування для принтера"}},[_vm._v("\n     Вибір місця розташування для принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"attaching-cables-topic.html#attaching-cables_uk","title":"Приєднання кабелів"}},[_vm._v("\n     Приєднання кабелів\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-home-screen-topic.html#d0e1764","title":"Налаштування та використання програм головного екрана"}},[_vm._v("\n     Налаштування та використання програм головного екрана\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e2411","title":"Налаштування та використання спеціальних можливостей"}},[_vm._v("\n     Налаштування та використання спеціальних можливостей\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e2717","title":"Налаштування передавання факсів на принтері"}},[_vm._v("\n     Налаштування передавання факсів на принтері\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_uk","title":"Налаштування параметрів SMTP електронної пошти"}},[_vm._v("\n     Налаштування параметрів SMTP електронної пошти\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-paper-size-and-type-topic.html#d0e4576","title":"Завантаження паперу та спеціальних носіїв"}},[_vm._v("\n     Завантаження паперу та спеціальних носіїв\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e4742","title":"Установлення та оновлення програмного забезпечення, драйверів та мікропрограм"}},[_vm._v("\n     Установлення та оновлення програмного забезпечення, драйверів та мікропрограм\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"available-internal-options-topic.html#d0e5023","title":"Установлення апаратних опцій"}},[_vm._v("\n     Установлення апаратних опцій\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"wireless-support-topic.html#d0e5332","title":"Мережа"}},[_vm._v("\n     Мережа\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_uk","title":"Захист принтера"}},[_vm._v("\n    Захист принтера\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5757"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_uk","title":"Розташування гнізда безпеки"}},[_vm._v("\n     Розташування гнізда безпеки\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_uk","title":"Стирання пам'яті принтера"}},[_vm._v("\n     Стирання пам'яті принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_uk","title":"Стирання накопичувача принтера"}},[_vm._v("\n     Стирання накопичувача принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_uk","title":"Відновлення заводських параметрів за замовчуванням"}},[_vm._v("\n     Відновлення заводських параметрів за замовчуванням\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_uk","title":"Заява про енергозалежність"}},[_vm._v("\n     Заява про енергозалежність\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_uk","title":"Друк"}},[_vm._v("\n    Друк\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5950"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-h2-topic.html#printing-from-computer-h2_uk","title":"Друк із комп&rsquo;ютера"}},[_vm._v("\n     Друк із комп’ютера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-topic.html#d0e5976","title":"Друк із мобільного пристрою"}},[_vm._v("\n     Друк із мобільного пристрою\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_uk","title":"Друк із флешнакопичувача"}},[_vm._v("\n     Друк із флешнакопичувача\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_uk","title":"Підтримувані флешнакопичувачі та типи файлів"}},[_vm._v("\n     Підтримувані флешнакопичувачі та типи файлів\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_uk","title":"Налаштування конфіденційних завдань"}},[_vm._v("\n     Налаштування конфіденційних завдань\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_uk","title":"Друк конфіденційних та інших відкладених завдань"}},[_vm._v("\n     Друк конфіденційних та інших відкладених завдань\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_uk","title":"Друк списку зразків шрифтів"}},[_vm._v("\n     Друк списку зразків шрифтів\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-directory-list-h2-topic.html#printing-directory-list-h2_uk","title":"Друк списку каталогів"}},[_vm._v("\n     Друк списку каталогів\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-topic.html#placing-separator-sheets_uk","title":"Розміщення аркушів-розділювачів між копіями"}},[_vm._v("\n     Розміщення аркушів-розділювачів між копіями\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_uk","title":"Скасування завдання друку"}},[_vm._v("\n     Скасування завдання друку\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_uk","title":"Коригування щільності тонера"}},[_vm._v("\n     Коригування щільності тонера\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying.html#copying_uk","title":"Копіювання"}},[_vm._v("\n    Копіювання\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e6566"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_uk","title":"Використання автоматичного подавача документів і скла сканера"}},[_vm._v("\n     Використання автоматичного подавача документів і скла сканера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_uk","title":"Виготовлення копій"}},[_vm._v("\n     Виготовлення копій\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_uk","title":"Копіювання фотографій"}},[_vm._v("\n     Копіювання фотографій\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_uk","title":"Копіювання на фірмовому бланку"}},[_vm._v("\n     Копіювання на фірмовому бланку\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_uk","title":"Копіювання на обох сторонах паперу"}},[_vm._v("\n     Копіювання на обох сторонах паперу\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-enlarging-copies-topic.html#reducing-enlarging-copies_uk","title":"Зменшення або збільшення розміру копії"}},[_vm._v("\n     Зменшення або збільшення розміру копії\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_uk","title":"Розбирання за копіями"}},[_vm._v("\n     Розбирання за копіями\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_uk","title":"Розміщення аркушів-розділювачів між копіями"}},[_vm._v("\n     Розміщення аркушів-розділювачів між копіями\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"saving-paper-topic.html#saving-paper_uk","title":"Копіювання кількох сторінок на один аркуш"}},[_vm._v("\n     Копіювання кількох сторінок на один аркуш\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_uk","title":"Копіювання карток"}},[_vm._v("\n     Копіювання карток\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_uk","title":"Створення ярлика копіювання"}},[_vm._v("\n     Створення ярлика копіювання\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"E-mailing.html#E-mailing_uk","title":"Електронна пошта"}},[_vm._v("\n    Електронна пошта\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e6877"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_uk","title":"Використання автоматичного подавача документів і скла сканера"}},[_vm._v("\n     Використання автоматичного подавача документів і скла сканера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_uk","title":"Надсилання електронної пошти"}},[_vm._v("\n     Надсилання електронної пошти\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_uk","title":"Створення ярлика електронного листа"}},[_vm._v("\n     Створення ярлика електронного листа\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"Faxing.html#Faxing_uk","title":"Факс"}},[_vm._v("\n    Факс\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e6971"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_uk","title":"Використання автоматичного подавача документів і скла сканера"}},[_vm._v("\n     Використання автоматичного подавача документів і скла сканера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_uk","title":"Надсилання факсу"}},[_vm._v("\n     Надсилання факсу\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_uk","title":"Планування факсу"}},[_vm._v("\n     Планування факсу\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_uk","title":"Створення ярлика адресата факсу"}},[_vm._v("\n     Створення ярлика адресата факсу\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_uk","title":"Зміна роздільної здатності факсу"}},[_vm._v("\n     Зміна роздільної здатності факсу\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_uk","title":"Регулювання затемнення факсу"}},[_vm._v("\n     Регулювання затемнення факсу\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_uk","title":"Друк журналу факсів"}},[_vm._v("\n     Друк журналу факсів\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_uk","title":"Блокування не6ажаних факсів"}},[_vm._v("\n     Блокування не6ажаних факсів\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_uk","title":"Відкладення факсів"}},[_vm._v("\n     Відкладення факсів\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_uk","title":"Пересилання факсу"}},[_vm._v("\n     Пересилання факсу\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"FTP.html#FTP_uk","title":"Сканування"}},[_vm._v("\n    Сканування\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e7336"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_uk","title":"Використання автоматичного подавача документів і скла сканера"}},[_vm._v("\n     Використання автоматичного подавача документів і скла сканера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_uk","title":"Сканування на комп&rsquo;ютер"}},[_vm._v("\n     Сканування на комп’ютер\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_uk","title":"Сканування на сервер FTP"}},[_vm._v("\n     Сканування на сервер FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_uk","title":"Створення ярлика FTP"}},[_vm._v("\n     Створення ярлика FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_uk","title":"Сканування в мережеву папку"}},[_vm._v("\n     Сканування в мережеву папку\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_uk","title":"Створення ярлика мережевої папки"}},[_vm._v("\n     Створення ярлика мережевої папки\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_uk","title":"Сканування на флешнакопичувач"}},[_vm._v("\n     Сканування на флешнакопичувач\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_uk","title":"Використання меню принтера"}},[_vm._v("\n    Використання меню принтера\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e7638"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-mfp-topic.html#menu-map-mfp_uk","title":"Карта меню"}},[_vm._v("\n     Карта меню\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e8019","title":"Пристрій"}},[_vm._v("\n     Пристрій\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e10354","title":"Друк"}},[_vm._v("\n     Друк\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e11517","title":"Папір"}},[_vm._v("\n     Папір\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e11877","title":"Копіювання"}},[_vm._v("\n     Копіювання\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e12449","title":"Факс"}},[_vm._v("\n     Факс\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e14877","title":"Електронна пошта"}},[_vm._v("\n     Електронна пошта\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e15893","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e16539","title":"USB-накопичувач"}},[_vm._v("\n     USB-накопичувач\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e17340","title":"Мережа/порти"}},[_vm._v("\n     Мережа/порти\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e19484","title":"Безпека"}},[_vm._v("\n     Безпека\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e20634","title":"Хмарні служби"}},[_vm._v("\n     Хмарні служби\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e20691","title":"Звіти"}},[_vm._v("\n     Звіти\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_uk","title":"Troubleshooting"}},[_vm._v("\n     Troubleshooting\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forms-merge-topic.html#forms-merge_uk","title":"Forms Merge (Злиття форм)"}},[_vm._v("\n     Forms Merge (Злиття форм)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_uk","title":"Друк Menu Settings Page"}},[_vm._v("\n     Друк Menu Settings Page\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_uk","title":"Технічне обслуговування принтера"}},[_vm._v("\n    Технічне обслуговування принтера\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e21235"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_uk","title":"Перевірка стану деталей і витратних матеріалів"}},[_vm._v("\n     Перевірка стану деталей і витратних матеріалів\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_uk","title":"Налаштування сповіщень про витратні матеріали"}},[_vm._v("\n     Налаштування сповіщень про витратні матеріали\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_uk","title":"Налаштування сповіщень електронною поштою"}},[_vm._v("\n     Налаштування сповіщень електронною поштою\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-reports-topic.html#viewing-reports_uk","title":"Перегляд звітів"}},[_vm._v("\n     Перегляд звітів\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-supplies-group.html#ordering-supplies-group_uk","title":"Замовлення запчастин і матеріалів"}},[_vm._v("\n     Замовлення запчастин і матеріалів\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e21568","title":"Заміна запчастин і матеріалів"}},[_vm._v("\n     Заміна запчастин і матеріалів\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e21911","title":"Очищення деталей принтера"}},[_vm._v("\n     Очищення деталей принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e22058","title":"Економія енергії та паперу"}},[_vm._v("\n     Економія енергії та паперу\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_uk","title":"Переміщення принтера в інше місце"}},[_vm._v("\n     Переміщення принтера в інше місце\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"shipping-printer-topic.html#shipping-printer_uk","title":"Транспортування принтера"}},[_vm._v("\n     Транспортування принтера\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_uk","title":"Усунення несправностей"}},[_vm._v("\n    Усунення несправностей\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e22212"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-picker-topic.html#print-quality-problems-picker_uk","title":"Проблема з якістю друку"}},[_vm._v("\n     Проблема з якістю друку\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_uk","title":"Коди помилок принтера"}},[_vm._v("\n     Коди помилок принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"solving-printing-problems.html#solving-printing-problems_uk","title":"Проблеми з друком"}},[_vm._v("\n     Проблеми з друком\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_uk","title":"Принтер не відповідає"}},[_vm._v("\n     Принтер не відповідає\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_uk","title":"Не вдається зчитати флешнакопичувач"}},[_vm._v("\n     Не вдається зчитати флешнакопичувач\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_uk","title":"Увімкнення порту USB"}},[_vm._v("\n     Увімкнення порту USB\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-jams.html#clearing-jams_uk","title":"Усування зминання"}},[_vm._v("\n     Усування зминання\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e25884","title":"Проблеми підключення до мережі"}},[_vm._v("\n     Проблеми підключення до мережі\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e26112","title":"Проблеми параметрів апаратного забезпечення"}},[_vm._v("\n     Проблеми параметрів апаратного забезпечення\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-replace-cartridge-printer-region-mismatch-topic.html#d0e26260","title":"Проблеми з витратними матеріалами"}},[_vm._v("\n     Проблеми з витратними матеріалами\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-envelope-seals-when-printing-topic.html#d0e26383","title":"Проблеми з подачею паперу"}},[_vm._v("\n     Проблеми з подачею паперу\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e26749","title":"Проблеми з електронною поштою"}},[_vm._v("\n     Проблеми з електронною поштою\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e26843","title":"Проблеми з надсиланням факсу"}},[_vm._v("\n     Проблеми з надсиланням факсу\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e27488","title":"Проблеми сканування"}},[_vm._v("\n     Проблеми сканування\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_uk","title":"Зверніться до служби підтримки клієнтів"}},[_vm._v("\n     Зверніться до служби підтримки клієнтів\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_uk","title":"Переробка й утилізація"}},[_vm._v("\n    Переробка й утилізація\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e28268"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_uk","title":"Переробка виробів Lexmark"}},[_vm._v("\n     Переробка виробів Lexmark\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_uk","title":"Переробка пакування Lexmark"}},[_vm._v("\n     Переробка пакування Lexmark\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_uk","title":"Сповіщення"}},[_vm._v("\n    Сповіщення\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e28305"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28308","title":"Інформація про виріб"}},[_vm._v("\n     Інформація про виріб\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28325","title":"Сповіщення про випуск"}},[_vm._v("\n     Сповіщення про випуск\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_uk","title":"Торгові марки"}},[_vm._v("\n     Торгові марки\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_uk","title":"Сповіщення про ліцензію"}},[_vm._v("\n     Сповіщення про ліцензію\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_uk","title":"Рівні шуму"}},[_vm._v("\n     Рівні шуму\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#weee-directive_uk","title":"Директива щодо відпрацьованого електричного й електронного обладнання (WEEE)"}},[_vm._v("\n     Директива щодо відпрацьованого електричного й електронного обладнання (WEEE)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28431","title":"Літій-іонний акумулятор із перезарядкою"}},[_vm._v("\n     Літій-іонний акумулятор із перезарядкою\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#eu-battery-directive-2023-1542_uk","title":"Регламент (ЄС) 2023/1542"}},[_vm._v("\n     Регламент (ЄС) 2023/1542\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28469","title":"Environmental labeling for packaging"}},[_vm._v("\n     Environmental labeling for packaging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_uk","title":"Утилізація виробу"}},[_vm._v("\n     Утилізація виробу\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_uk","title":"Сповіщення про статичну чутливість"}},[_vm._v("\n     Сповіщення про статичну чутливість\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_uk","title":"ENERGY STAR"}},[_vm._v("\n     ENERGY STAR\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_uk","title":"Інформація про температуру"}},[_vm._v("\n     Інформація про температуру\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser-notice_uk","title":"Сповіщення про лазер"}},[_vm._v("\n     Сповіщення про лазер\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_uk","title":"Споживання електроенергії"}},[_vm._v("\n     Споживання електроенергії\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_uk","title":"Повідомлення про нормативні вимоги до телекомунікаційного термінального обладнання"}},[_vm._v("\n     Повідомлення про нормативні вимоги до телекомунікаційного термінального обладнання\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28716","title":"Сповіщення про нормативні вимоги до бездротових виробів"}},[_vm._v("\n     Сповіщення про нормативні вимоги до бездротових виробів\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#modular-component-notice_uk","title":"Повідомлення про модульний компонент"}},[_vm._v("\n     Повідомлення про модульний компонент\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#exposure-to-radio-frequency-radiation_uk","title":"Потрапляння під вплив радіочастотного випромінювання"}},[_vm._v("\n     Потрапляння під вплив радіочастотного випромінювання\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28741","title":"Відповідність директивам Європейського співтовариства (ЄС)"}},[_vm._v("\n     Відповідність директивам Європейського співтовариства (ЄС)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#european-community-ec-directives-conformity-class-a_uk","title":"Відповідність директивам Європейського співтовариства (ЄС)"}},[_vm._v("\n     Відповідність директивам Європейського співтовариства (ЄС)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_uk","title":"Повідомлення про радіоперешкоди"}},[_vm._v("\n     Повідомлення про радіоперешкоди\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js